import * as i0 from '@angular/core';
import { inject, ElementRef, Directive, input, Renderer2, effect, TemplateRef, booleanAttribute, untracked, NgModule, computed, Injectable, Component, afterNextRender, linkedSignal, output, signal, contentChildren, numberAttribute, DestroyRef, DOCUMENT, PLATFORM_ID, RendererFactory2, forwardRef, NgZone, ChangeDetectorRef, contentChild, afterEveryRender, viewChild, ViewContainerRef, model, afterRenderEffect, Pipe, ViewChild, HostBinding, Input, ContentChildren, ChangeDetectionStrategy, HostListener, Injector, runInInjectionContext } from '@angular/core';
import { NgTemplateOutlet, NgClass, isPlatformServer, isPlatformBrowser, NgStyle } from '@angular/common';
import { animation, animate, style, AnimationBuilder, useAnimation, trigger, state, transition, group, query, animateChild } from '@angular/animations';
import { takeUntilDestroyed, toSignal, toObservable } from '@angular/core/rxjs-interop';
import { fromEvent, Subject, BehaviorSubject, merge, takeWhile } from 'rxjs';
import * as i1 from '@angular/router';
import { RouterModule, Router, ActivatedRoute, NavigationEnd, RouterLink } from '@angular/router';
import { filter, tap, finalize, zipWith, withLatestFrom, debounceTime } from 'rxjs/operators';
import { createPopper } from '@popperjs/core';
import * as i1$1 from '@angular/cdk/a11y';
import { FocusKeyManager, FocusMonitor, A11yModule } from '@angular/cdk/a11y';
import { BreakpointObserver } from '@angular/cdk/layout';
import { IconDirective } from '@coreui/icons-angular';
const _c0 = ["*"];
const _c1 = () => ({
  display: "none"
});
const _c2 = ["*", "*"];
function AccordionItemComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AccordionItemComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AccordionItemComponent_ng_template_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AccordionItemComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function AccordionItemComponent_ng_template_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleItem());
    });
    i0.ɵɵtemplate(1, AccordionItemComponent_ng_template_6_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultAccordionHeaderContentTemplate_r3 = i0.ɵɵreference(9);
    const tmpl_r4 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("collapsed", !ctx_r1.itemVisible());
    i0.ɵɵattribute("aria-controls", ctx_r1.contentId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tmpl_r4["accordionHeader"] || defaultAccordionHeaderContentTemplate_r3)("ngTemplateOutletContext", ctx_r1.itemContext);
  }
}
function AccordionItemComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function AccordionItemComponent_ng_template_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AccordionItemComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, AccordionItemComponent_ng_template_10_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultAccordionBodyContentTemplate_r5 = i0.ɵɵreference(13);
    const tmpl_r4 = i0.ɵɵreadContextLet(0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tmpl_r4["accordionBody"] || defaultAccordionBodyContentTemplate_r5)("ngTemplateOutletContext", ctx_r1.itemContext);
  }
}
function AccordionItemComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function AlertComponent_Conditional_0_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AlertComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AlertComponent_Conditional_0_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 1);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const defaultAlertButtonCloseTemplate_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngTemplateOutlet", ((tmp_3_0 = ctx_r0.templates()) == null ? null : tmp_3_0["alertButtonCloseTemplate"]) || defaultAlertButtonCloseTemplate_r2);
  }
}
function AlertComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AlertComponent_Conditional_0_Conditional_0_Template, 1, 1, "ng-container");
    i0.ɵɵprojection(1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.dismissible ? 0 : -1);
  }
}
function AlertComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function AlertComponent_ng_template_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.visible = false);
    });
    i0.ɵɵelementEnd();
  }
}
function AvatarComponent_ProjectionFallback_0_Conditional_0_Defer_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("src", i0.ɵɵinterpolate(ctx_r0.src() ?? ""), i0.ɵɵsanitizeUrl)("alt", i0.ɵɵinterpolate(ctx_r0.alt()));
  }
}
function AvatarComponent_ProjectionFallback_0_Conditional_0_DeferPlaceholder_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 2);
    i0.ɵɵelement(1, "rect", 3);
    i0.ɵɵelementEnd();
  }
}
function AvatarComponent_ProjectionFallback_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomTemplate(0, AvatarComponent_ProjectionFallback_0_Conditional_0_Defer_0_Template, 1, 4)(1, AvatarComponent_ProjectionFallback_0_Conditional_0_DeferPlaceholder_1_Template, 2, 0);
    i0.ɵɵdefer(2, 0, null, null, 1);
    i0.ɵɵdeferPrefetchOnIdle();
    i0.ɵɵdeferOnIdle();
  }
}
function AvatarComponent_ProjectionFallback_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AvatarComponent_ProjectionFallback_0_Conditional_0_Template, 4, 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.src() ? 0 : -1);
  }
}
function AvatarComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.statusClass());
  }
}
const _c3 = () => ({});
function BreadcrumbItemComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BreadcrumbItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵtemplate(1, BreadcrumbItemComponent_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    let tmp_5_0;
    let tmp_6_0;
    let tmp_7_0;
    let tmp_8_0;
    let tmp_9_0;
    let tmp_10_0;
    let tmp_11_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultBreadcrumbItemContentTemplate_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("routerLink", ctx_r0.url())("cHtmlAttr", ctx_r0.attribs() ?? i0.ɵɵpureFunction0(11, _c3))("target", (tmp_4_0 = ctx_r0.attribs()) == null ? null : tmp_4_0["target"])("queryParams", ((tmp_5_0 = ctx_r0.linkProps()) == null ? null : tmp_5_0.queryParams) ?? null)("fragment", (tmp_6_0 = ctx_r0.linkProps()) == null ? null : tmp_6_0.fragment)("queryParamsHandling", ((tmp_7_0 = ctx_r0.linkProps()) == null ? null : tmp_7_0.queryParamsHandling) ?? null)("preserveFragment", ((tmp_8_0 = ctx_r0.linkProps()) == null ? null : tmp_8_0.preserveFragment) ?? false)("skipLocationChange", ((tmp_9_0 = ctx_r0.linkProps()) == null ? null : tmp_9_0.skipLocationChange) ?? false)("replaceUrl", ((tmp_10_0 = ctx_r0.linkProps()) == null ? null : tmp_10_0.replaceUrl) ?? false)("state", ((tmp_11_0 = ctx_r0.linkProps()) == null ? null : tmp_11_0.state) ?? i0.ɵɵpureFunction0(12, _c3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultBreadcrumbItemContentTemplate_r2);
  }
}
function BreadcrumbItemComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function BreadcrumbItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtemplate(1, BreadcrumbItemComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultBreadcrumbItemContentTemplate_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("cHtmlAttr", ctx_r0.attribs() ?? i0.ɵɵpureFunction0(2, _c3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultBreadcrumbItemContentTemplate_r2);
  }
}
function BreadcrumbItemComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function BreadcrumbRouterComponent_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "c-breadcrumb-item", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const breadcrumb_r2 = ctx_r0.$implicit;
    const ɵ$index_3_r3 = ctx_r0.$index;
    const ɵ$count_3_r4 = ctx_r0.$count;
    i0.ɵɵproperty("active", ɵ$index_3_r3 === ɵ$count_3_r4 - 1)("url", breadcrumb_r2 == null ? null : breadcrumb_r2.url)("attribs", breadcrumb_r2 == null ? null : breadcrumb_r2.attributes)("linkProps", breadcrumb_r2 == null ? null : breadcrumb_r2.linkProps);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", breadcrumb_r2 == null ? null : breadcrumb_r2.label, " ");
  }
}
function BreadcrumbRouterComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, BreadcrumbRouterComponent_For_2_Conditional_0_Template, 2, 5, "c-breadcrumb-item", 1);
  }
  if (rf & 2) {
    const breadcrumb_r2 = ctx.$implicit;
    const ɵ$index_3_r3 = ctx.$index;
    const ɵ$count_3_r4 = ctx.$count;
    i0.ɵɵconditional((breadcrumb_r2 == null ? null : breadcrumb_r2.label) && ((breadcrumb_r2 == null ? null : breadcrumb_r2.url == null ? null : breadcrumb_r2.url.slice(-1)) === "/" || ɵ$index_3_r3 === ɵ$count_3_r4 - 1) ? 0 : -1);
  }
}
function CarouselControlComponent_ProjectionFallback_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElement(0, "span");
    i0.ɵɵdomElementStart(1, "span", 0);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.carouselControlIconClass());
    i0.ɵɵattribute("aria-hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.caption());
  }
}
const _c4 = (a0, a1) => ({
  $implicit: a0,
  active: a1
});
const _c5 = a0 => ({
  active: a0
});
function CarouselIndicatorsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CarouselIndicatorsComponent_ng_template_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function CarouselIndicatorsComponent_ng_template_1_For_1_Template_button_click_0_listener() {
      const ɵ$index_8_r2 = i0.ɵɵrestoreView(_r1).$index;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onClick(ɵ$index_8_r2));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_8_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(4, _c5, ctx_r2.active === ɵ$index_8_r2));
    i0.ɵɵattribute("data-coreui-target", ɵ$index_8_r2)("aria-current", ctx_r2.active === ɵ$index_8_r2);
  }
}
function CarouselIndicatorsComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, CarouselIndicatorsComponent_ng_template_1_For_1_Template, 1, 6, "button", 2, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.items);
  }
}
function CarouselItemComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function HeaderComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.headerClasses());
  }
}
function HeaderComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function NavbarComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NavbarComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.containerClass());
  }
}
function NavbarComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
const _c6 = ["modalContentRef"];
const _c7 = "[_nghost-%COMP%]{display:list-item;text-align:-webkit-match-parent;text-align:match-parent}";
const _c8 = ["popoverTemplate"];
const _c9 = a0 => ({
  "popover-arrow": a0
});
function ProgressComponent_Conditional_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ProgressComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ProgressComponent_Conditional_0_ng_container_0_Template, 1, 0, "ng-container", 2);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const defaultContent_r1 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", defaultContent_r1);
  }
}
function ProgressComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ProgressComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "c-progress-bar", 1);
    i0.ɵɵtemplate(1, ProgressComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultContent_r1 = i0.ɵɵreference(3);
    const pbd_r3 = ctx_r1.progressBarDirective;
    i0.ɵɵproperty("animated", pbd_r3 == null ? null : pbd_r3.animated())("variant", pbd_r3 == null ? null : pbd_r3.variant())("color", pbd_r3 == null ? null : pbd_r3.color())("value", ctx_r1.barValue());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultContent_r1);
  }
}
function ProgressComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function SidebarBrandComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cHtmlAttr", ctx_r0.brandFull())("ngClass", "sidebar-brand-full");
  }
}
function SidebarBrandComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cHtmlAttr", ctx_r0.brandNarrow())("ngClass", "sidebar-brand-narrow");
  }
}
function SidebarBrandComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 0);
    i0.ɵɵconditionalCreate(1, SidebarBrandComponent_Conditional_0_Conditional_1_Template, 1, 2, "img", 1);
    i0.ɵɵconditionalCreate(2, SidebarBrandComponent_Conditional_0_Conditional_2_Template, 1, 2, "img", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r0.routerLink());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.brandFull() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.brandNarrow() ? 2 : -1);
  }
}
function SidebarBrandComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function SidebarNavLinkContentComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵdomElementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const itemLinkContent_r1 = i0.ɵɵreadContextLet(0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((itemLinkContent_r1 == null ? null : itemLinkContent_r1.name) ?? "");
  }
}
const _c10 = a0 => ({
  $implicit: a0
});
const _c11 = () => ({
  exact: false
});
function SidebarNavLinkComponent_Case_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarNavLinkComponent_Case_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵpipe(1, "cSidebarNavBadge");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const linkItem_r1 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 2, linkItem_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(linkItem_r1.badge == null ? null : linkItem_r1.badge.text);
  }
}
function SidebarNavLinkComponent_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵpipe(1, "cSidebarNavLink");
    i0.ɵɵtemplate(2, SidebarNavLinkComponent_Case_1_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelement(3, "c-sidebar-nav-link-content", 5);
    i0.ɵɵconditionalCreate(4, SidebarNavLinkComponent_Case_1_Conditional_4_Template, 3, 4, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const iconTemplate_r2 = i0.ɵɵreference(5);
    const linkItem_r1 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("cHtmlAttr", linkItem_r1.attributes ?? i0.ɵɵpureFunction0(8, _c3))("ngClass", i0.ɵɵpipeBind1(1, 6, linkItem_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", iconTemplate_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c10, linkItem_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("item", linkItem_r1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(linkItem_r1.badge ? 4 : -1);
  }
}
function SidebarNavLinkComponent_Case_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarNavLinkComponent_Case_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵpipe(1, "cSidebarNavBadge");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const linkItem_r1 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 2, linkItem_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(linkItem_r1.badge == null ? null : linkItem_r1.badge.text);
  }
}
function SidebarNavLinkComponent_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵpipe(1, "cSidebarNavLink");
    i0.ɵɵlistener("click", function SidebarNavLinkComponent_Case_2_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.linkClicked());
    });
    i0.ɵɵtemplate(2, SidebarNavLinkComponent_Case_2_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelement(3, "c-sidebar-nav-link-content", 5);
    i0.ɵɵconditionalCreate(4, SidebarNavLinkComponent_Case_2_Conditional_4_Template, 3, 4, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const iconTemplate_r2 = i0.ɵɵreference(5);
    const linkItem_r1 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("cHtmlAttr", linkItem_r1.attributes ?? i0.ɵɵpureFunction0(9, _c3))("href", ctx_r3.href, i0.ɵɵsanitizeUrl)("ngClass", i0.ɵɵpipeBind1(1, 7, linkItem_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", iconTemplate_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c10, linkItem_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("item", linkItem_r1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(linkItem_r1.badge ? 4 : -1);
  }
}
function SidebarNavLinkComponent_Case_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarNavLinkComponent_Case_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵpipe(1, "cSidebarNavBadge");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const linkItem_r1 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 2, linkItem_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(linkItem_r1.badge == null ? null : linkItem_r1.badge.text);
  }
}
function SidebarNavLinkComponent_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵpipe(1, "cSidebarNavLink");
    i0.ɵɵlistener("click", function SidebarNavLinkComponent_Case_3_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.linkClicked());
    });
    i0.ɵɵtemplate(2, SidebarNavLinkComponent_Case_3_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelement(3, "c-sidebar-nav-link-content", 5);
    i0.ɵɵconditionalCreate(4, SidebarNavLinkComponent_Case_3_Conditional_4_Template, 3, 4, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const iconTemplate_r2 = i0.ɵɵreference(5);
    const linkItem_r1 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("cHtmlAttr", linkItem_r1.attributes ?? i0.ɵɵpureFunction0(18, _c3))("fragment", linkItem_r1.linkProps == null ? null : linkItem_r1.linkProps.fragment)("ngClass", i0.ɵɵpipeBind1(1, 16, linkItem_r1))("preserveFragment", (linkItem_r1.linkProps == null ? null : linkItem_r1.linkProps.preserveFragment) ?? false)("queryParamsHandling", linkItem_r1.linkProps == null ? null : linkItem_r1.linkProps.queryParamsHandling)("queryParams", (linkItem_r1.linkProps == null ? null : linkItem_r1.linkProps.queryParams) ?? null)("replaceUrl", (linkItem_r1.linkProps == null ? null : linkItem_r1.linkProps.replaceUrl) ?? false)("routerLinkActiveOptions", (linkItem_r1.linkProps == null ? null : linkItem_r1.linkProps.routerLinkActiveOptions) ?? i0.ɵɵpureFunction0(19, _c11))("routerLink", linkItem_r1.url)("skipLocationChange", (linkItem_r1.linkProps == null ? null : linkItem_r1.linkProps.skipLocationChange) ?? false)("state", (linkItem_r1.linkProps == null ? null : linkItem_r1.linkProps.state) ?? i0.ɵɵpureFunction0(20, _c3))("target", linkItem_r1.attributes == null ? null : linkItem_r1.attributes["target"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", iconTemplate_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(21, _c10, linkItem_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("item", linkItem_r1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(linkItem_r1.badge ? 4 : -1);
  }
}
function SidebarNavLinkComponent_ng_template_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵelement(1, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", item_r6.icon ?? "");
  }
}
function SidebarNavLinkComponent_ng_template_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 10);
    i0.ɵɵpipe(1, "cSidebarNavIcon");
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cIcon", item_r6.iconComponent == null ? null : item_r6.iconComponent.content)("customClasses", i0.ɵɵpipeBind1(1, 3, item_r6))("name", item_r6.iconComponent == null ? null : item_r6.iconComponent.name);
  }
}
function SidebarNavLinkComponent_ng_template_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 6);
    i0.ɵɵpipe(1, "cSidebarNavIcon");
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 1, item_r6));
  }
}
function SidebarNavLinkComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SidebarNavLinkComponent_ng_template_4_Conditional_0_Template, 2, 1, "span", 9);
    i0.ɵɵconditionalCreate(1, SidebarNavLinkComponent_ng_template_4_Conditional_1_Template, 2, 5, ":svg:svg", 10);
    i0.ɵɵconditionalCreate(2, SidebarNavLinkComponent_ng_template_4_Conditional_2_Template, 2, 3, "span", 6);
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵconditional((item_r6 == null ? null : item_r6.icon) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r6 == null ? null : item_r6.iconComponent) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(item_r6 == null ? null : item_r6.icon) && !(item_r6 == null ? null : item_r6.iconComponent) ? 2 : -1);
  }
}
function SidebarNavLabelComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.labelIconClass());
  }
}
function SidebarNavLabelComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵpipe(1, "cSidebarNavBadge");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const labelItem_r2 = i0.ɵɵreadContextLet(0);
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 2, labelItem_r2));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((labelItem_r2.badge == null ? null : labelItem_r2.badge.text) ?? "");
  }
}
function SidebarNavGroupComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarNavGroupComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵpipe(1, "cSidebarNavBadge");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 2, ctx_r1.item));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.item.badge.text);
  }
}
function SidebarNavGroupComponent_ng_template_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵelement(1, "span", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", item_r3.icon ?? "");
  }
}
function SidebarNavGroupComponent_ng_template_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 6);
    i0.ɵɵpipe(1, "cSidebarNavIcon");
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cIcon", item_r3.iconComponent == null ? null : item_r3.iconComponent.content)("customClasses", i0.ɵɵpipeBind1(1, 3, item_r3))("name", item_r3.iconComponent == null ? null : item_r3.iconComponent.name);
  }
}
function SidebarNavGroupComponent_ng_template_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
    i0.ɵɵpipe(1, "cSidebarNavIcon");
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 1, item_r3));
  }
}
function SidebarNavGroupComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SidebarNavGroupComponent_ng_template_6_Conditional_0_Template, 2, 1, "span", 5);
    i0.ɵɵconditionalCreate(1, SidebarNavGroupComponent_ng_template_6_Conditional_1_Template, 2, 5, ":svg:svg", 6);
    i0.ɵɵconditionalCreate(2, SidebarNavGroupComponent_ng_template_6_Conditional_2_Template, 2, 3, "span", 3);
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵconditional((item_r3 == null ? null : item_r3.icon) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((item_r3 == null ? null : item_r3.iconComponent) ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(item_r3 == null ? null : item_r3.icon) && !(item_r3 == null ? null : item_r3.iconComponent) ? 2 : -1);
  }
}
const _c12 = () => ({
  exact: true
});
function SidebarNavComponent_For_1_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-sidebar-nav-group", 1, 0);
    i0.ɵɵpipe(2, "cSidebarNavItemClass");
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dropdownMode", ctx_r1.dropdownMode)("item", item_r1)("ngClass", i0.ɵɵpipeBind1(2, 5, item_r1))("routerLinkActiveOptions", i0.ɵɵpureFunction0(7, _c12))("compact", ctx_r1.compact);
  }
}
function SidebarNavComponent_For_1_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-sidebar-nav-divider", 2);
    i0.ɵɵpipe(1, "cSidebarNavItemClass");
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cHtmlAttr", item_r1.attributes ?? i0.ɵɵpureFunction0(5, _c3))("item", item_r1)("ngClass", i0.ɵɵpipeBind1(1, 3, item_r1));
  }
}
function SidebarNavComponent_For_1_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-sidebar-nav-title", 2);
    i0.ɵɵpipe(1, "cSidebarNavItemClass");
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cHtmlAttr", item_r1.attributes ?? i0.ɵɵpureFunction0(5, _c3))("item", item_r1)("ngClass", i0.ɵɵpipeBind1(1, 3, item_r1));
  }
}
function SidebarNavComponent_For_1_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "c-sidebar-nav-label", 3);
    i0.ɵɵpipe(1, "cSidebarNavItemClass");
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("item", item_r1)("ngClass", i0.ɵɵpipeBind1(1, 2, item_r1));
  }
}
function SidebarNavComponent_For_1_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function SidebarNavComponent_For_1_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "c-sidebar-nav-link", 4);
    i0.ɵɵpipe(1, "cSidebarNavItemClass");
    i0.ɵɵlistener("linkClick", function SidebarNavComponent_For_1_Case_5_Template_c_sidebar_nav_link_linkClick_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.hideMobile());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("item", item_r1)("ngClass", i0.ɵɵpipeBind1(1, 2, item_r1));
  }
}
function SidebarNavComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SidebarNavComponent_For_1_Case_0_Template, 3, 8, "c-sidebar-nav-group", 1)(1, SidebarNavComponent_For_1_Case_1_Template, 2, 6, "c-sidebar-nav-divider", 2)(2, SidebarNavComponent_For_1_Case_2_Template, 2, 6, "c-sidebar-nav-title", 2)(3, SidebarNavComponent_For_1_Case_3_Template, 2, 4, "c-sidebar-nav-label", 3)(4, SidebarNavComponent_For_1_Case_4_Template, 1, 0, "ng-container")(5, SidebarNavComponent_For_1_Case_5_Template, 2, 4, "c-sidebar-nav-link", 3);
  }
  if (rf & 2) {
    let tmp_10_0;
    const item_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_10_0 = ctx_r1.helper.itemType(item_r1)) === "group" ? 0 : tmp_10_0 === "divider" ? 1 : tmp_10_0 === "title" ? 2 : tmp_10_0 === "label" ? 3 : tmp_10_0 === "empty" ? 4 : 5);
  }
}
function SpinnerComponent_ProjectionFallback_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span", 0);
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label());
  }
}
const _c13 = () => ({
  outline: 0
});
function ToastHeaderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(3, _c13));
    i0.ɵɵproperty("cToastClose", ctx_r0.toast());
  }
}
function ToasterComponent_ng_template_0_Template(rf, ctx) {}
const _c14 = ["tooltipTemplate"];
const _c15 = [[["", 8, "chart-wrapper"]], "*"];
const _c16 = [".chart-wrapper", "*"];
function WidgetStatAComponent_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatAComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, WidgetStatAComponent_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultWidgetValueTemplate_r2 = i0.ɵɵreference(10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r0.templates == null ? null : ctx_r0.templates["widgetValueTemplate"]) || defaultWidgetValueTemplate_r2);
  }
}
function WidgetStatAComponent_Conditional_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatAComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, WidgetStatAComponent_Conditional_4_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultWidgetTitleTemplate_r3 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r0.templates == null ? null : ctx_r0.templates["widgetTitleTemplate"]) || defaultWidgetTitleTemplate_r3);
  }
}
function WidgetStatAComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatAComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatAComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title(), "\n");
  }
}
function WidgetStatAComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.value(), "\n");
  }
}
function WidgetStatAComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function WidgetStatAComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function WidgetStatBComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value());
  }
}
function WidgetStatBComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title());
  }
}
function WidgetStatBComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.inverse() ? "text-white text-opacity-75" : "text-body-secondary");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.text(), " ");
  }
}
function WidgetStatCComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatCComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, WidgetStatCComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultWidgetIconTemplate_r2 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngClass", ctx_r0.iconClasses());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r0.templates == null ? null : ctx_r0.templates["widgetIconTemplate"]) || defaultWidgetIconTemplate_r2);
  }
}
function WidgetStatCComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.valueClasses());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.value(), " ");
  }
}
function WidgetStatCComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.titleClasses());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title(), " ");
  }
}
function WidgetStatCComponent_Conditional_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatCComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WidgetStatCComponent_Conditional_4_ng_container_0_Template, 1, 0, "ng-container", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultWidgetProgressTemplate_r3 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r0.templates == null ? null : ctx_r0.templates["widgetProgressTemplate"]) || defaultWidgetProgressTemplate_r3);
  }
}
function WidgetStatCComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.icon(), "\n");
  }
}
function WidgetStatCComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function WidgetStatDComponent_For_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
  }
}
function WidgetStatDComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, WidgetStatDComponent_For_4_Conditional_0_Template, 1, 0, "div", 2);
    i0.ɵɵelementStart(1, "c-col")(2, "div", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ɵ$index_6_r2 = ctx.$index;
    i0.ɵɵconditional(ɵ$index_6_r2 % 2 !== 0 ? 0 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r1.value);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r1.title);
  }
}
function WidgetStatEComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.titleClasses());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title());
  }
}
function WidgetStatEComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.value());
  }
}
function WidgetStatFComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatFComponent_Conditional_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function WidgetStatFComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "c-card-footer");
    i0.ɵɵtemplate(1, WidgetStatFComponent_Conditional_9_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultFooterIconTemplate_r2 = i0.ɵɵreference(13);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", (ctx_r0.templates == null ? null : ctx_r0.templates["widgetFooterTemplate"]) || defaultFooterIconTemplate_r2);
  }
}
function WidgetStatFComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.icon());
  }
}
function WidgetStatFComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.footer());
  }
}
var BreakpointInfix;
(function (BreakpointInfix) {
  BreakpointInfix["xs"] = "xs";
  BreakpointInfix["sm"] = "sm";
  BreakpointInfix["md"] = "md";
  BreakpointInfix["lg"] = "lg";
  BreakpointInfix["xl"] = "xl";
  BreakpointInfix["xxl"] = "xxl";
})(BreakpointInfix || (BreakpointInfix = {}));
class ElementRefDirective {
  elementRef = inject(ElementRef);
  static ɵfac = function ElementRefDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ElementRefDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ElementRefDirective,
    selectors: [["", "cElementRef", ""]],
    exportAs: ["cElementRef"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ElementRefDirective, [{
    type: Directive,
    args: [{
      selector: '[cElementRef]',
      exportAs: 'cElementRef'
    }]
  }], null, null);
})();
class HtmlAttributesDirective {
  cHtmlAttr = input(...(ngDevMode ? [undefined, {
    debugName: "cHtmlAttr"
  }] : []));
  #renderer = inject(Renderer2);
  #elementRef = inject(ElementRef);
  #attrEffect = effect(() => {
    const attribs = this.cHtmlAttr();
    for (const attr in attribs) {
      if (attr === 'style' && typeof attribs[attr] === 'object') {
        this.setStyle(attribs[attr]);
      } else if (attr === 'class') {
        this.addClass(attribs[attr]);
      } else {
        this.setAttrib(attr, attribs[attr]);
      }
    }
  }, ...(ngDevMode ? [{
    debugName: "#attrEffect"
  }] : []));
  setStyle(styles) {
    for (const style in styles) {
      if (style) {
        this.#renderer.setStyle(this.#elementRef.nativeElement, style, styles[style]);
      }
    }
  }
  addClass(classes) {
    const classArray = Array.isArray(classes) ? classes : classes.split(' ');
    classArray.filter(element => element.length > 0).forEach(element => {
      this.#renderer.addClass(this.#elementRef.nativeElement, element);
    });
  }
  setAttrib(key, value) {
    value !== null ? this.#renderer.setAttribute(this.#elementRef.nativeElement, key, value) : this.#renderer.removeAttribute(this.#elementRef.nativeElement, key);
  }
  static ɵfac = function HtmlAttributesDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HtmlAttributesDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: HtmlAttributesDirective,
    selectors: [["", "cHtmlAttr", ""]],
    inputs: {
      cHtmlAttr: [1, "cHtmlAttr"]
    },
    exportAs: ["cHtmlAttr"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HtmlAttributesDirective, [{
    type: Directive,
    args: [{
      selector: '[cHtmlAttr]',
      exportAs: 'cHtmlAttr'
    }]
  }], null, {
    cHtmlAttr: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cHtmlAttr",
        required: false
      }]
    }]
  });
})();
class TemplateIdDirective {
  templateRef = inject(TemplateRef);
  cTemplateId = input.required(...(ngDevMode ? [{
    debugName: "cTemplateId"
  }] : []));
  get id() {
    return this.cTemplateId();
  }
  static ɵfac = function TemplateIdDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TemplateIdDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TemplateIdDirective,
    selectors: [["", "cTemplateId", ""]],
    inputs: {
      cTemplateId: [1, "cTemplateId"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplateIdDirective, [{
    type: Directive,
    args: [{
      selector: '[cTemplateId]'
    }]
  }], null, {
    cTemplateId: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTemplateId",
        required: true
      }]
    }]
  });
})();
class ThemeDirective {
  #hostElement = inject(ElementRef);
  #renderer = inject(Renderer2);
  /**
   * Add dark theme attribute.
   * @return 'dark' | 'light' | undefined
   */
  colorScheme = input(...(ngDevMode ? [undefined, {
    debugName: "colorScheme"
  }] : []));
  #colorSchemeChange = effect(() => {
    const colorScheme = this.colorScheme();
    colorScheme ? this.setTheme(colorScheme) : this.unsetTheme();
  }, ...(ngDevMode ? [{
    debugName: "#colorSchemeChange"
  }] : []));
  dark = input(false, ...(ngDevMode ? [{
    debugName: "dark",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  #darkChange = effect(() => {
    const darkTheme = this.dark() || untracked(this.colorScheme) === 'dark';
    darkTheme ? this.setTheme('dark') : this.unsetTheme();
  }, ...(ngDevMode ? [{
    debugName: "#darkChange"
  }] : []));
  setTheme(theme) {
    if (theme) {
      this.#renderer.setAttribute(this.#hostElement.nativeElement, 'data-coreui-theme', theme);
    }
  }
  unsetTheme() {
    this.#renderer.removeAttribute(this.#hostElement.nativeElement, 'data-coreui-theme');
  }
  static ɵfac = function ThemeDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ThemeDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ThemeDirective,
    selectors: [["", "cTheme", ""]],
    inputs: {
      colorScheme: [1, "colorScheme"],
      dark: [1, "dark"]
    },
    exportAs: ["cTheme"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ThemeDirective, [{
    type: Directive,
    args: [{
      selector: '[cTheme]',
      exportAs: 'cTheme'
    }]
  }], null, {
    colorScheme: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "colorScheme",
        required: false
      }]
    }],
    dark: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "dark",
        required: false
      }]
    }]
  });
})();
class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule
    };
  }
  static ɵfac = function SharedModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SharedModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SharedModule,
    imports: [ElementRefDirective, HtmlAttributesDirective, TemplateIdDirective, ThemeDirective],
    exports: [ElementRefDirective, HtmlAttributesDirective, TemplateIdDirective, ThemeDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedModule, [{
    type: NgModule,
    args: [{
      imports: [ElementRefDirective, HtmlAttributesDirective, TemplateIdDirective, ThemeDirective],
      exports: [ElementRefDirective, HtmlAttributesDirective, TemplateIdDirective, ThemeDirective]
    }]
  }], null, null);
})();
class AccordionButtonDirective {
  /**
   * Toggles an accordion button collapsed state. Use in accordionHeaderTemplate. [docs]
   * @type boolean
   */
  collapsed = input(undefined, ...(ngDevMode ? [{
    debugName: "collapsed"
  }] : []));
  /**
   * Default type for cAccordionButton. [docs]
   * @type string
   * @default 'button'
   */
  type = input('button', ...(ngDevMode ? [{
    debugName: "type"
  }] : []));
  hostClasses = computed(() => {
    return {
      'accordion-button': true,
      collapsed: this.collapsed()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  ariaExpanded = computed(() => !this.collapsed(), ...(ngDevMode ? [{
    debugName: "ariaExpanded"
  }] : []));
  static ɵfac = function AccordionButtonDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccordionButtonDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AccordionButtonDirective,
    selectors: [["", "cAccordionButton", ""]],
    hostVars: 4,
    hostBindings: function AccordionButtonDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("type", ctx.type())("aria-expanded", ctx.ariaExpanded());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      collapsed: [1, "collapsed"],
      type: [1, "type"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionButtonDirective, [{
    type: Directive,
    args: [{
      selector: '[cAccordionButton]',
      host: {
        '[class]': 'hostClasses()',
        '[attr.type]': 'type()',
        '[attr.aria-expanded]': 'ariaExpanded()'
      }
    }]
  }], null, {
    collapsed: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "collapsed",
        required: false
      }]
    }],
    type: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "type",
        required: false
      }]
    }]
  });
})();
class AccordionService {
  items = [];
  alwaysOpen = false;
  addItem(item) {
    this.items.push(item);
  }
  removeItem(item) {
    const index = this.items.indexOf(item);
    if (index !== -1) {
      this.items.splice(index, 1);
    }
  }
  toggleItem(item) {
    item.itemVisible.update(value => !value);
    this.closeOtherItems(item);
  }
  closeOtherItems(openItem) {
    if (!this.alwaysOpen) {
      this.items.forEach(item => {
        if (item !== openItem) {
          item.itemVisible.set(false);
        }
      });
    }
  }
  static ɵfac = function AccordionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccordionService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccordionService,
    factory: AccordionService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionService, [{
    type: Injectable
  }], null, null);
})();
class AccordionComponent {
  #accordionService = inject(AccordionService);
  /**
   * Removes the default background-color, some borders, and some rounded corners to render accordions edge-to-edge with their parent container.
   * @type boolean
   */
  flush = input(false, ...(ngDevMode ? [{
    debugName: "flush",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Make accordion items stay open when another item is opened
   * @type boolean
   */
  alwaysOpen = input(false, ...(ngDevMode ? [{
    debugName: "alwaysOpen",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  #alwaysOpenEffect = effect(() => {
    this.#accordionService.alwaysOpen = this.alwaysOpen();
  }, ...(ngDevMode ? [{
    debugName: "#alwaysOpenEffect"
  }] : []));
  hostClasses = computed(() => ({
    accordion: true,
    'accordion-flush': this.flush()
  }), ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function AccordionComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccordionComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AccordionComponent,
    selectors: [["c-accordion"]],
    hostVars: 2,
    hostBindings: function AccordionComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      flush: [1, "flush"],
      alwaysOpen: [1, "alwaysOpen"]
    },
    exportAs: ["cAccordionItem"],
    features: [i0.ɵɵProvidersFeature([AccordionService])],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function AccordionComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionComponent, [{
    type: Component,
    args: [{
      selector: 'c-accordion',
      template: '<ng-content />',
      exportAs: 'cAccordionItem',
      providers: [AccordionService],
      host: {
        '[class]': 'hostClasses()'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, {
    flush: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "flush",
        required: false
      }]
    }],
    alwaysOpen: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "alwaysOpen",
        required: false
      }]
    }]
  });
})();
const expandAnimation = animation([animate('{{ time }} {{ easing }}')]);
const collapseAnimation = animation([style({
  height: '*',
  minHeight: '*'
}), animate('{{ time }} {{ easing }}', style({
  height: 0,
  minHeight: 0
}))]);
const expandHorizontalAnimation = animation([animate('{{ time }} {{ easing }}')]);
const collapseHorizontalAnimation = animation([animate('{{ time }} {{ easing }}')]);
class CollapseDirective {
  #animationBuilder = inject(AnimationBuilder);
  #hostElement = inject(ElementRef);
  #renderer = inject(Renderer2);
  #player = undefined;
  constructor() {
    afterNextRender({
      read: () => {
        this.#initialized.set(true);
      }
    });
  }
  /**
   * @ignore
   */
  animateInput = input(true, ...(ngDevMode ? [{
    debugName: "animateInput",
    transform: booleanAttribute,
    alias: 'animate'
  }] : [{
    transform: booleanAttribute,
    alias: 'animate'
  }]));
  animate = linkedSignal(...(ngDevMode ? [{
    debugName: "animate",
    source: this.animateInput,
    computation: value => value
  }] : [{
    source: this.animateInput,
    computation: value => value
  }]));
  /**
   * Set horizontal collapsing to transition the width instead of height.
   * @type boolean
   * @default false
   */
  horizontal = input(false, ...(ngDevMode ? [{
    debugName: "horizontal",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Toggle the visibility of collapsible element.
   * @type boolean
   * @default false
   */
  visibleInput = input(false, ...(ngDevMode ? [{
    debugName: "visibleInput",
    transform: booleanAttribute,
    alias: 'visible'
  }] : [{
    transform: booleanAttribute,
    alias: 'visible'
  }]));
  visibleChange = output();
  visible = linkedSignal(...(ngDevMode ? [{
    debugName: "visible",
    source: this.visibleInput,
    computation: value => value
  }] : [{
    source: this.visibleInput,
    computation: value => value
  }]));
  #initialized = signal(false, ...(ngDevMode ? [{
    debugName: "#initialized"
  }] : []));
  #visibleEffect = effect(() => {
    const visible = this.visible();
    if (this.#initialized()) {
      this.createPlayer(visible);
    }
  }, ...(ngDevMode ? [{
    debugName: "#visibleEffect"
  }] : []));
  /**
   * Add `navbar` prop for grouping and hiding navbar contents by a parent breakpoint.
   * @type boolean
   * @default false
   */
  navbar = input(false, ...(ngDevMode ? [{
    debugName: "navbar",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * @ignore
   */
  duration = input('350ms', ...(ngDevMode ? [{
    debugName: "duration"
  }] : []));
  /**
   * @ignore
   */
  transition = input('ease', ...(ngDevMode ? [{
    debugName: "transition"
  }] : []));
  /**
   * Event emitted on visibility change. [docs]
   * @type string
   */
  collapseChange = output();
  hostClasses = computed(() => {
    return {
      'navbar-collapse': this.navbar(),
      'collapse-horizontal': this.horizontal()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  ngOnDestroy() {
    this.destroyPlayer();
  }
  toggle(visible = !this.visible()) {
    this.visible.set(visible);
  }
  destroyPlayer() {
    this.#player?.destroy();
    this.#player = undefined;
  }
  createPlayer(visible = this.visible()) {
    if (this.#player?.hasStarted()) {
      this.destroyPlayer();
    }
    const host = this.#hostElement.nativeElement;
    if (visible) {
      this.#renderer.removeStyle(host, 'display');
    }
    const duration = this.animate() ? this.duration() : '0ms';
    const expand = this.horizontal() ? expandHorizontalAnimation : expandAnimation;
    const collapse = this.horizontal() ? collapseHorizontalAnimation : collapseAnimation;
    const dimension = this.horizontal() ? 'width' : 'height';
    const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
    const scrollSize = `scroll${capitalizedDimension}`;
    const animationFactory = this.#animationBuilder?.build(useAnimation(visible ? expand : collapse, {
      params: {
        time: duration,
        easing: this.transition()
      }
    }));
    this.#player = animationFactory.create(host);
    !visible && host.offsetHeight && host.style[dimension] && host.scrollHeight;
    this.#renderer.setStyle(host, dimension, visible ? 0 : `${host.getBoundingClientRect()[dimension]}px`);
    this.#player.onStart(() => {
      this.setMaxSize();
      this.#renderer.removeClass(host, 'collapse');
      this.#renderer.addClass(host, 'collapsing');
      this.#renderer.removeClass(host, 'show');
      this.#renderer.setStyle(host, dimension, visible ? `${host[scrollSize]}px` : '');
      if (this.#player) {
        this.collapseChange?.emit(visible ? 'opening' : 'collapsing');
      }
    });
    this.#player.onDone(() => {
      this.#renderer.removeClass(host, 'collapsing');
      this.#renderer.addClass(host, 'collapse');
      if (visible) {
        this.#renderer.addClass(host, 'show');
        this.#renderer.setStyle(host, dimension, '');
      } else {
        this.#renderer.removeClass(host, 'show');
      }
      if (this.#player) {
        this.collapseChange?.emit(visible ? 'open' : 'collapsed');
        this.visibleChange?.emit(visible);
      }
      this.destroyPlayer();
    });
    this.#player?.play();
  }
  setMaxSize() {
    const host = this.#hostElement.nativeElement;
    if (this.horizontal()) {
      host.scrollWidth > 0 && this.#renderer.setStyle(host, 'maxWidth', `${host.scrollWidth}px`);
      // } else {
      //   host.scrollHeight > 0 && this.#renderer.setStyle(host, 'maxHeight', `${host.scrollHeight}px`);
    }
  }
  static ɵfac = function CollapseDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CollapseDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CollapseDirective,
    selectors: [["", "cCollapse", ""]],
    hostVars: 5,
    hostBindings: function CollapseDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(4, _c1));
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      animateInput: [1, "animate", "animateInput"],
      horizontal: [1, "horizontal"],
      visibleInput: [1, "visible", "visibleInput"],
      navbar: [1, "navbar"],
      duration: [1, "duration"],
      transition: [1, "transition"]
    },
    outputs: {
      visibleChange: "visibleChange",
      collapseChange: "collapseChange"
    },
    exportAs: ["cCollapse"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapseDirective, [{
    type: Directive,
    args: [{
      selector: '[cCollapse]',
      exportAs: 'cCollapse',
      host: {
        '[class]': 'hostClasses()',
        '[style]': '{ display: "none" }'
      }
    }]
  }], () => [], {
    animateInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "animate",
        required: false
      }]
    }],
    horizontal: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "horizontal",
        required: false
      }]
    }],
    visibleInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    visibleChange: [{
      type: i0.Output,
      args: ["visibleChange"]
    }],
    navbar: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "navbar",
        required: false
      }]
    }],
    duration: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "duration",
        required: false
      }]
    }],
    transition: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "transition",
        required: false
      }]
    }],
    collapseChange: [{
      type: i0.Output,
      args: ["collapseChange"]
    }]
  });
})();
class CollapseModule {
  static forRoot() {
    return {
      ngModule: CollapseModule,
      providers: []
    };
  }
  static ɵfac = function CollapseModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CollapseModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CollapseModule,
    imports: [CollapseDirective],
    exports: [CollapseDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapseModule, [{
    type: NgModule,
    args: [{
      exports: [CollapseDirective],
      imports: [CollapseDirective]
    }]
  }], null, null);
})();
let nextId$2 = 0;
class AccordionItemComponent {
  #accordionService = inject(AccordionService);
  /**
   * Toggle an accordion item programmatically
   * @return boolean
   * @default false
   */
  visibleInput = input(false, ...(ngDevMode ? [{
    debugName: "visibleInput",
    transform: booleanAttribute,
    alias: 'visible'
  }] : [{
    transform: booleanAttribute,
    alias: 'visible'
  }]));
  itemVisible = signal(false, ...(ngDevMode ? [{
    debugName: "itemVisible"
  }] : []));
  #visibleInputChange = effect(() => {
    this.visible = this.visibleInput();
  }, ...(ngDevMode ? [{
    debugName: "#visibleInputChange"
  }] : []));
  set visible(value) {
    this.itemVisible.set(value);
  }
  get visible() {
    return this.itemVisible();
  }
  contentId = `accordion-item-${nextId$2++}`;
  get itemContext() {
    return {
      $implicit: this.itemVisible()
    };
  }
  contentTemplates = contentChildren(TemplateIdDirective, ...(ngDevMode ? [{
    debugName: "contentTemplates",
    descendants: true
  }] : [{
    descendants: true
  }]));
  templates = computed(() => {
    return this.contentTemplates().reduce((acc, child) => {
      acc[child.id] = child.templateRef;
      return acc;
    }, {});
  }, ...(ngDevMode ? [{
    debugName: "templates"
  }] : []));
  ngOnInit() {
    this.#accordionService.addItem(this);
  }
  ngOnDestroy() {
    this.#accordionService.removeItem(this);
  }
  toggleItem() {
    this.#accordionService.toggleItem(this);
  }
  static ɵfac = function AccordionItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccordionItemComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AccordionItemComponent,
    selectors: [["c-accordion-item"]],
    contentQueries: function AccordionItemComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "accordion-item"],
    inputs: {
      visibleInput: [1, "visible", "visibleInput"]
    },
    exportAs: ["cAccordionItem"],
    ngContentSelectors: _c2,
    decls: 14,
    vars: 8,
    consts: [["defaultAccordionHeaderTemplate", ""], ["defaultAccordionHeaderContentTemplate", ""], ["defaultAccordionBodyTemplate", ""], ["defaultAccordionBodyContentTemplate", ""], [1, "accordion-header"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["cCollapse", "", 1, "accordion-collapse", 3, "visible", "id"], ["cAccordionButton", "", 3, "click", "collapsed"], [1, "accordion-body"]],
    template: function AccordionItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c2);
        i0.ɵɵdeclareLet(0);
        i0.ɵɵelementContainerStart(1);
        i0.ɵɵelementStart(2, "div", 4);
        i0.ɵɵtemplate(3, AccordionItemComponent_ng_container_3_Template, 1, 0, "ng-container", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 6);
        i0.ɵɵtemplate(5, AccordionItemComponent_ng_container_5_Template, 1, 0, "ng-container", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(6, AccordionItemComponent_ng_template_6_Template, 2, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(8, AccordionItemComponent_ng_template_8_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(10, AccordionItemComponent_ng_template_10_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(12, AccordionItemComponent_ng_template_12_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const defaultAccordionHeaderTemplate_r6 = i0.ɵɵreference(7);
        const defaultAccordionBodyTemplate_r7 = i0.ɵɵreference(11);
        const tmpl_r8 = i0.ɵɵstoreLet(ctx.templates());
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngTemplateOutlet", tmpl_r8["accordionHeaderTemplate"] || defaultAccordionHeaderTemplate_r6)("ngTemplateOutletContext", ctx.itemContext);
        i0.ɵɵadvance();
        i0.ɵɵproperty("visible", ctx.itemVisible())("id", ctx.contentId);
        i0.ɵɵattribute("aria-expanded", ctx.itemVisible());
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngTemplateOutlet", tmpl_r8["accordionBodyTemplate"] || defaultAccordionBodyTemplate_r7)("ngTemplateOutletContext", ctx.itemContext);
      }
    },
    dependencies: [AccordionButtonDirective, NgTemplateOutlet, CollapseDirective],
    styles: ["[_nghost-%COMP%]{display:block;overflow:hidden}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionItemComponent, [{
    type: Component,
    args: [{
      selector: 'c-accordion-item',
      exportAs: 'cAccordionItem',
      imports: [AccordionButtonDirective, NgTemplateOutlet, CollapseDirective],
      host: {
        class: 'accordion-item'
      },
      template: "@let tmpl = templates();\n<ng-container>\n  <div class=\"accordion-header\">\n    <ng-container *ngTemplateOutlet=\"tmpl['accordionHeaderTemplate'] || defaultAccordionHeaderTemplate; context: itemContext\" />\n  </div>\n  <div class=\"accordion-collapse\" cCollapse [visible]=\"itemVisible()\" [attr.aria-expanded]=\"itemVisible()\" [id]=\"contentId\">\n    <ng-container *ngTemplateOutlet=\"tmpl['accordionBodyTemplate'] || defaultAccordionBodyTemplate; context: itemContext\" />\n  </div>\n</ng-container>\n\n<ng-template #defaultAccordionHeaderTemplate>\n  <button cAccordionButton [collapsed]=\"!itemVisible()\" [attr.aria-controls]=\"contentId\" (click)=\"toggleItem()\">\n    <ng-container\n      *ngTemplateOutlet=\"tmpl['accordionHeader'] || defaultAccordionHeaderContentTemplate; context: itemContext\">\n    </ng-container>\n  </button>\n</ng-template>\n\n<ng-template #defaultAccordionHeaderContentTemplate>\n  <ng-content />\n</ng-template>\n\n<ng-template #defaultAccordionBodyTemplate>\n  <div class=\"accordion-body\">\n    <ng-container\n      *ngTemplateOutlet=\"tmpl['accordionBody'] || defaultAccordionBodyContentTemplate; context: itemContext\">\n    </ng-container>\n  </div>\n</ng-template>\n\n<ng-template #defaultAccordionBodyContentTemplate>\n  <ng-content />\n</ng-template>\n",
      styles: [":host{display:block;overflow:hidden}\n"]
    }]
  }], null, {
    visibleInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    contentTemplates: [{
      type: i0.ContentChildren,
      args: [i0.forwardRef(() => TemplateIdDirective), {
        ...{
          descendants: true
        },
        isSignal: true
      }]
    }]
  });
})();
class AccordionModule {
  static ɵfac = function AccordionModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccordionModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: AccordionModule,
    imports: [AccordionButtonDirective, AccordionComponent, AccordionItemComponent],
    exports: [AccordionComponent, AccordionButtonDirective, AccordionItemComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [AccordionService]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionModule, [{
    type: NgModule,
    args: [{
      imports: [AccordionButtonDirective, AccordionComponent, AccordionItemComponent],
      exports: [AccordionComponent, AccordionButtonDirective, AccordionItemComponent],
      providers: [AccordionService]
    }]
  }], null, null);
})();
class AlertHeadingDirective {
  static ɵfac = function AlertHeadingDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AlertHeadingDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AlertHeadingDirective,
    selectors: [["", "cAlertHeading", ""]],
    hostAttrs: [1, "alert-heading"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertHeadingDirective, [{
    type: Directive,
    args: [{
      selector: '[cAlertHeading]',
      host: {
        class: 'alert-heading'
      }
    }]
  }], null, null);
})();
class AlertLinkDirective {
  static ɵfac = function AlertLinkDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AlertLinkDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AlertLinkDirective,
    selectors: [["", "cAlertLink", ""]],
    hostAttrs: [1, "alert-link"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertLinkDirective, [{
    type: Directive,
    args: [{
      selector: '[cAlertLink]',
      host: {
        class: 'alert-link'
      }
    }]
  }], null, null);
})();
class ButtonDirective {
  static ngAcceptInputType_active;
  static ngAcceptInputType_disabled;
  /**
   * Toggle the active state for the component. [docs]
   * @type InputSignalWithTransform<boolean, unknown>
   */
  active = input(false, ...(ngDevMode ? [{
    debugName: "active",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors. [docs]
   * @type InputSignal<Colors>
   */
  color = input('primary', ...(ngDevMode ? [{
    debugName: "color"
  }] : []));
  /**
   * Toggle the disabled state for the component.
   * @type InputSignalWithTransform<boolean, unknown>
   */
  disabled = input(false, ...(ngDevMode ? [{
    debugName: "disabled",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Select the shape of the component.
   * @return Shapes
   */
  shape = input(...(ngDevMode ? [undefined, {
    debugName: "shape"
  }] : []));
  /**
   * Size the component small or large.
   * @return  sm' | 'lg' | ''
   */
  size = input('', ...(ngDevMode ? [{
    debugName: "size"
  }] : []));
  /**
   * The tabindex attribute specifies the tab order of an element (when the "tab" button is used for navigating).
   */
  tabindex = input(undefined, ...(ngDevMode ? [{
    debugName: "tabindex",
    transform: numberAttribute
  }] : [{
    transform: numberAttribute
  }]));
  /**
   * Specifies the type of button. Always specify the type attribute for the `<button>` element.
   * Different browsers may use different default types for the `<button>` element.
   * @type InputSignal<ButtonType>
   * @default 'button'
   */
  type = input('button', ...(ngDevMode ? [{
    debugName: "type"
  }] : []));
  /**
   * Set the button variant to an outlined button or a ghost button.
   * @type InputSignal<'ghost' | 'outline' | undefined>
   */
  variant = input(...(ngDevMode ? [undefined, {
    debugName: "variant"
  }] : []));
  hostClasses = computed(() => {
    const color = this.color();
    const variant = this.variant();
    const size = this.size();
    const shape = this.shape();
    return {
      btn: true,
      [`btn-${color}`]: !!color && !variant,
      [`btn-${variant}`]: !!variant && !color,
      [`btn-${variant}-${color}`]: !!variant && !!color,
      [`btn-${size}`]: !!size,
      [`${shape}`]: !!shape,
      active: this.active(),
      disabled: this._disabled()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  _disabled = computed(() => this.disabled(), ...(ngDevMode ? [{
    debugName: "_disabled"
  }] : []));
  ariaDisabled = computed(() => {
    return this._disabled() ? true : null;
  }, ...(ngDevMode ? [{
    debugName: "ariaDisabled"
  }] : []));
  attrDisabled = computed(() => {
    return this._disabled() ? '' : null;
  }, ...(ngDevMode ? [{
    debugName: "attrDisabled"
  }] : []));
  tabIndex = computed(() => {
    return this._disabled() ? '-1' : this.tabindex() ?? null;
  }, ...(ngDevMode ? [{
    debugName: "tabIndex"
  }] : []));
  isActive = computed(() => {
    return this.active() || null;
  }, ...(ngDevMode ? [{
    debugName: "isActive"
  }] : []));
  static ɵfac = function ButtonDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ButtonDirective,
    selectors: [["", "cButton", ""]],
    hostAttrs: [1, "btn"],
    hostVars: 7,
    hostBindings: function ButtonDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-disabled", ctx.ariaDisabled())("aria-pressed", ctx.isActive())("disabled", ctx.attrDisabled())("tabindex", ctx.tabIndex())("type", ctx.type());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      active: [1, "active"],
      color: [1, "color"],
      disabled: [1, "disabled"],
      shape: [1, "shape"],
      size: [1, "size"],
      tabindex: [1, "tabindex"],
      type: [1, "type"],
      variant: [1, "variant"]
    },
    exportAs: ["cButton"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonDirective, [{
    type: Directive,
    args: [{
      selector: '[cButton]',
      exportAs: 'cButton',
      host: {
        class: 'btn',
        '[class]': 'hostClasses()',
        '[attr.aria-disabled]': 'ariaDisabled()',
        '[attr.aria-pressed]': 'isActive()',
        '[attr.disabled]': 'attrDisabled()',
        '[attr.tabindex]': 'tabIndex()',
        '[attr.type]': 'type()'
      }
    }]
  }], null, {
    active: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "active",
        required: false
      }]
    }],
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    disabled: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "disabled",
        required: false
      }]
    }],
    shape: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "shape",
        required: false
      }]
    }],
    size: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "size",
        required: false
      }]
    }],
    tabindex: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "tabindex",
        required: false
      }]
    }],
    type: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "type",
        required: false
      }]
    }],
    variant: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "variant",
        required: false
      }]
    }]
  });
})();
class ButtonCloseDirective extends ButtonDirective {
  /**
   * Change the default color to white.
   * @type boolean
   * @deprecated 5.0.0. Use `cButtonClose.dark` instead.
   */
  white = input(false, ...(ngDevMode ? [{
    debugName: "white",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  hostClasses = computed(() => {
    const size = this.size();
    return {
      btn: true,
      'btn-close': true,
      'btn-close-white': this.white(),
      [`btn-${size}`]: !!size,
      active: this.active(),
      disabled: this._disabled()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = /* @__PURE__ */(() => {
    let ɵButtonCloseDirective_BaseFactory;
    return function ButtonCloseDirective_Factory(__ngFactoryType__) {
      return (ɵButtonCloseDirective_BaseFactory || (ɵButtonCloseDirective_BaseFactory = i0.ɵɵgetInheritedFactory(ButtonCloseDirective)))(__ngFactoryType__ || ButtonCloseDirective);
    };
  })();
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ButtonCloseDirective,
    selectors: [["", "cButtonClose", ""]],
    hostAttrs: [1, "btn", "btn-close"],
    hostVars: 7,
    hostBindings: function ButtonCloseDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-disabled", ctx.ariaDisabled())("aria-pressed", ctx.isActive())("disabled", ctx.attrDisabled())("tabindex", ctx.tabIndex())("type", ctx.type());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      white: [1, "white"]
    },
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: ThemeDirective,
      inputs: ["dark", "dark"]
    }]), i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonCloseDirective, [{
    type: Directive,
    args: [{
      selector: '[cButtonClose]',
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['dark']
      }],
      host: {
        class: 'btn btn-close',
        '[class]': 'hostClasses()',
        '[attr.aria-disabled]': 'ariaDisabled()',
        '[attr.aria-pressed]': 'isActive()',
        '[attr.disabled]': 'attrDisabled()',
        '[attr.tabindex]': 'tabIndex()',
        '[attr.type]': 'type()'
      }
    }]
  }], null, {
    white: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "white",
        required: false
      }]
    }]
  });
})();
class ButtonModule {
  static ɵfac = function ButtonModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ButtonModule,
    imports: [ButtonDirective, ButtonCloseDirective],
    exports: [ButtonDirective, ButtonCloseDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonModule, [{
    type: NgModule,
    args: [{
      imports: [ButtonDirective, ButtonCloseDirective],
      exports: [ButtonDirective, ButtonCloseDirective]
    }]
  }], null, null);
})();
class AlertComponent {
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @return Colors
   * @default 'primary'
   */
  color = input('primary', ...(ngDevMode ? [{
    debugName: "color"
  }] : []));
  /**
   * Default role for alert. [docs]
   * @return string
   * @default 'alert'
   */
  role = input('alert', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  /**
   * Set the alert variant to a solid.
   * @return string
   */
  variant = input(...(ngDevMode ? [undefined, {
    debugName: "variant"
  }] : []));
  /**
   * Optionally adds a close button to alert and allow it to self dismiss.
   * @return boolean
   * @default false
   */
  dismissibleInput = input(false, ...(ngDevMode ? [{
    debugName: "dismissibleInput",
    transform: booleanAttribute,
    alias: 'dismissible'
  }] : [{
    transform: booleanAttribute,
    alias: 'dismissible'
  }]));
  #dismissible = linkedSignal(...(ngDevMode ? [{
    debugName: "#dismissible",
    source: this.dismissibleInput,
    computation: value => {
      return value;
    }
  }] : [{
    source: this.dismissibleInput,
    computation: value => {
      return value;
    }
  }]));
  set dismissible(value) {
    this.#dismissible.set(value);
  }
  get dismissible() {
    return this.#dismissible();
  }
  /**
   * Adds animation for dismissible alert.
   * @return boolean
   */
  fade = input(false, ...(ngDevMode ? [{
    debugName: "fade",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Toggle the visibility of alert component.
   * @return boolean
   */
  visibleInput = input(true, ...(ngDevMode ? [{
    debugName: "visibleInput",
    transform: booleanAttribute,
    alias: 'visible'
  }] : [{
    transform: booleanAttribute,
    alias: 'visible'
  }]));
  #visible = linkedSignal(...(ngDevMode ? [{
    debugName: "#visible",
    source: this.visibleInput,
    computation: value => {
      return value;
    }
  }] : [{
    source: this.visibleInput,
    computation: value => {
      return value;
    }
  }]));
  set visible(value) {
    if (this.#visible() !== value) {
      this.#visible.set(value);
      this.visibleChange?.emit(value);
    }
  }
  get visible() {
    return this.#visible();
  }
  hide = signal(false, ...(ngDevMode ? [{
    debugName: "hide"
  }] : []));
  /**
   * Event triggered on the alert dismiss.
   */
  visibleChange = output();
  contentTemplates = contentChildren(TemplateIdDirective, ...(ngDevMode ? [{
    debugName: "contentTemplates",
    descendants: true
  }] : [{
    descendants: true
  }]));
  templates = computed(() => {
    return this.contentTemplates().reduce((acc, child) => {
      acc[child.id] = child.templateRef;
      return acc;
    }, {});
  }, ...(ngDevMode ? [{
    debugName: "templates"
  }] : []));
  get animateType() {
    return this.visible ? 'show' : 'hide';
  }
  hostClasses = computed(() => {
    const color = this.color();
    const variant = this.variant();
    return {
      alert: true,
      'alert-dismissible': this.dismissible,
      fade: this.fade(),
      show: !this.hide(),
      [`alert-${color}`]: !!color && variant !== 'solid',
      [`bg-${color}`]: !!color && variant === 'solid',
      'text-white': !!color && variant === 'solid'
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  onAnimationStart($event) {
    this.onAnimationEvent($event);
  }
  onAnimationDone($event) {
    this.onAnimationEvent($event);
  }
  onAnimationEvent(event) {
    this.hide.set(event.phaseName === 'start' && event.toState === 'show');
    if (event.phaseName === 'done') {
      this.hide.set(event.toState === 'hide' || event.toState === 'void');
      if (event.toState === 'show') {
        this.hide.set(false);
      }
    }
  }
  static ɵfac = function AlertComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AlertComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AlertComponent,
    selectors: [["c-alert"]],
    contentQueries: function AlertComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 5,
    hostBindings: function AlertComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵsyntheticHostListener("@fadeInOut.start", function AlertComponent_animation_fadeInOut_start_HostBindingHandler($event) {
          return ctx.onAnimationStart($event);
        })("@fadeInOut.done", function AlertComponent_animation_fadeInOut_done_HostBindingHandler($event) {
          return ctx.onAnimationDone($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵsyntheticHostProperty("@.disabled", !ctx.fade())("@fadeInOut", ctx.animateType);
        i0.ɵɵattribute("role", ctx.role());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      color: [1, "color"],
      role: [1, "role"],
      variant: [1, "variant"],
      dismissibleInput: [1, "dismissible", "dismissibleInput"],
      fade: [1, "fade"],
      visibleInput: [1, "visible", "visibleInput"]
    },
    outputs: {
      visibleChange: "visibleChange"
    },
    exportAs: ["cAlert"],
    ngContentSelectors: _c0,
    decls: 3,
    vars: 1,
    consts: [["defaultAlertButtonCloseTemplate", ""], [4, "ngTemplateOutlet"], ["aria-label", "Close", "cButtonClose", "", 3, "click"]],
    template: function AlertComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵconditionalCreate(0, AlertComponent_Conditional_0_Template, 2, 1);
        i0.ɵɵtemplate(1, AlertComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.visible || !ctx.hide() ? 0 : -1);
      }
    },
    dependencies: [NgTemplateOutlet, ButtonCloseDirective],
    styles: ["[_nghost-%COMP%]{display:block;overflow:hidden}"],
    data: {
      animation: [trigger('fadeInOut', [state('show', style({
        opacity: 1,
        height: '*',
        padding: '*',
        border: '*',
        margin: '*'
      })), state('hide', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), state('void', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), transition('show => hide', [animate('.3s ease-out')]), transition('hide => show', [animate('.3s ease-in')]), transition('show => void', [animate('.3s ease-out')]), transition('void => show', [animate('.3s ease-in')])])]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertComponent, [{
    type: Component,
    args: [{
      selector: 'c-alert',
      exportAs: 'cAlert',
      imports: [NgTemplateOutlet, ButtonCloseDirective],
      animations: [trigger('fadeInOut', [state('show', style({
        opacity: 1,
        height: '*',
        padding: '*',
        border: '*',
        margin: '*'
      })), state('hide', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), state('void', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), transition('show => hide', [animate('.3s ease-out')]), transition('hide => show', [animate('.3s ease-in')]), transition('show => void', [animate('.3s ease-out')]), transition('void => show', [animate('.3s ease-in')])])],
      host: {
        '[@.disabled]': '!fade()',
        '[@fadeInOut]': 'animateType',
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()',
        '(@fadeInOut.start)': 'onAnimationStart($event)',
        '(@fadeInOut.done)': 'onAnimationDone($event)'
      },
      template: "@if (visible || !hide()) {\n  @if (dismissible) {\n    <ng-container *ngTemplateOutlet=\"templates()?.['alertButtonCloseTemplate'] || defaultAlertButtonCloseTemplate\" />\n  }\n  <ng-content />\n}\n<ng-template #defaultAlertButtonCloseTemplate>\n  <button (click)=\"visible=false\" aria-label=\"Close\" cButtonClose></button>\n</ng-template>\n",
      styles: [":host{display:block;overflow:hidden}\n"]
    }]
  }], null, {
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }],
    variant: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "variant",
        required: false
      }]
    }],
    dismissibleInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "dismissible",
        required: false
      }]
    }],
    fade: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "fade",
        required: false
      }]
    }],
    visibleInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    visibleChange: [{
      type: i0.Output,
      args: ["visibleChange"]
    }],
    contentTemplates: [{
      type: i0.ContentChildren,
      args: [i0.forwardRef(() => TemplateIdDirective), {
        ...{
          descendants: true
        },
        isSignal: true
      }]
    }]
  });
})();
class AlertModule {
  static ɵfac = function AlertModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AlertModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: AlertModule,
    imports: [AlertComponent, AlertHeadingDirective, AlertLinkDirective],
    exports: [AlertComponent, AlertHeadingDirective, AlertLinkDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlertModule, [{
    type: NgModule,
    args: [{
      imports: [AlertComponent, AlertHeadingDirective, AlertLinkDirective],
      exports: [AlertComponent, AlertHeadingDirective, AlertLinkDirective]
    }]
  }], null, null);
})();
class AlignDirective {
  /**
   * Set vertical alignment of inline, inline-block, inline-table, and table cell elements
   * @return Alignment
   */
  align = input(undefined, ...(ngDevMode ? [{
    debugName: "align",
    alias: 'cAlign'
  }] : [{
    alias: 'cAlign'
  }]));
  hostClasses = computed(() => {
    const align = this.align();
    return {
      [`align-${align}`]: !!align
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function AlignDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AlignDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: AlignDirective,
    selectors: [["", "cAlign", ""]],
    hostVars: 2,
    hostBindings: function AlignDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      align: [1, "cAlign", "align"]
    },
    exportAs: ["cAlign"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlignDirective, [{
    type: Directive,
    args: [{
      selector: '[cAlign]',
      exportAs: 'cAlign',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    align: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cAlign",
        required: false
      }]
    }]
  });
})();
class BgColorDirective {
  /**
   * Set the background of an element to any contextual class
   */
  cBgColor = input('', ...(ngDevMode ? [{
    debugName: "cBgColor"
  }] : []));
  /**
   * Add linear gradient as background image to the backgrounds.
   * @return boolean
   */
  gradient = input(...(ngDevMode ? [undefined, {
    debugName: "gradient"
  }] : []));
  hostClasses = computed(() => {
    const color = this.cBgColor();
    return {
      [`bg-${color}`]: !!color,
      'bg-gradient': this.gradient()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function BgColorDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BgColorDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: BgColorDirective,
    selectors: [["", "cBgColor", ""]],
    hostVars: 2,
    hostBindings: function BgColorDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      cBgColor: [1, "cBgColor"],
      gradient: [1, "gradient"]
    },
    exportAs: ["cBgColor"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BgColorDirective, [{
    type: Directive,
    args: [{
      selector: '[cBgColor]',
      exportAs: 'cBgColor',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    cBgColor: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cBgColor",
        required: false
      }]
    }],
    gradient: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "gradient",
        required: false
      }]
    }]
  });
})();
class BorderDirective {
  /**
   * Add or remove an element’s borders
   * @return Border
   */
  cBorder = input(true, ...(ngDevMode ? [{
    debugName: "cBorder"
  }] : []));
  hostClasses = computed(() => {
    const border = this.cBorder();
    if (typeof border === 'boolean') {
      return {
        border: border
      };
    }
    if (typeof border === 'number' || typeof border === 'string') {
      return {
        border: true,
        [`border-${border}`]: true
      };
    }
    if (typeof border === 'object') {
      const borderObj = {
        top: undefined,
        end: undefined,
        bottom: undefined,
        start: undefined,
        color: undefined,
        ...border
      };
      // @ts-ignore
      const keys = Object.keys(borderObj).filter(key => borderObj[key] !== undefined);
      const classes = {};
      keys.forEach(key => {
        // @ts-ignore
        const val = borderObj[key];
        if (typeof val === 'boolean') {
          // @ts-ignore
          classes[`border-${key}`] = true;
        } else if (typeof val === 'number' || typeof val === 'string') {
          // @ts-ignore
          classes[`border-${key}-${val}`] = true;
        } else if (typeof val === 'object') {
          if ('color' in val) {
            // @ts-ignore
            classes[`border-${key}-${val.color}`] = true;
          }
          if ('width' in val) {
            // @ts-ignore
            classes[`border-${key}-${val.width}`] = true;
          }
        }
      });
      return Object.entries(classes).length === 0 ? {
        border: false
      } : classes;
    }
    return {
      border: false
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function BorderDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BorderDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: BorderDirective,
    selectors: [["", "cBorder", ""]],
    hostVars: 2,
    hostBindings: function BorderDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      cBorder: [1, "cBorder"]
    },
    exportAs: ["cBorder"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BorderDirective, [{
    type: Directive,
    args: [{
      selector: '[cBorder]',
      exportAs: 'cBorder',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    cBorder: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cBorder",
        required: false
      }]
    }]
  });
})();
class RoundedDirective {
  /**
   * Set border radius variant and radius size
   * @type Rounded
   */
  cRounded = input(true, ...(ngDevMode ? [{
    debugName: "cRounded"
  }] : []));
  hostClasses = computed(() => {
    const rounded = this.cRounded();
    if (typeof rounded === 'boolean') {
      return {
        rounded: rounded
      };
    }
    if (typeof rounded === 'number' || typeof rounded === 'string') {
      return {
        [`rounded-${rounded}`]: true
      };
    }
    if (typeof rounded === 'object') {
      const roundedObj = {
        top: undefined,
        end: undefined,
        bottom: undefined,
        start: undefined,
        circle: undefined,
        pill: undefined,
        size: undefined,
        ...rounded
      };
      // @ts-ignore
      const keys = Object.keys(roundedObj).filter(key => roundedObj[key] !== undefined);
      const classes = {};
      keys.forEach(key => {
        // @ts-ignore
        const val = roundedObj[key];
        if (typeof val === 'boolean') {
          // @ts-ignore
          classes[`rounded-${key}`] = val;
        } else {
          // @ts-ignore
          classes[`rounded-${val}`] = true;
        }
      });
      // console.log('rounded keys', keys, classes);
      return Object.entries(classes).length === 0 ? {
        rounded: false
      } : classes;
    }
    return {
      rounded: false
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function RoundedDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RoundedDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: RoundedDirective,
    selectors: [["", "cRounded", ""]],
    hostVars: 2,
    hostBindings: function RoundedDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      cRounded: [1, "cRounded"]
    },
    exportAs: ["cRounded"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RoundedDirective, [{
    type: Directive,
    args: [{
      selector: '[cRounded]',
      exportAs: 'cRounded',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    cRounded: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cRounded",
        required: false
      }]
    }]
  });
})();
class ShadowOnScrollDirective {
  #destroyRef = inject(DestroyRef);
  #document = inject(DOCUMENT);
  #elementRef = inject(ElementRef);
  #scrolled = signal(false, ...(ngDevMode ? [{
    debugName: "#scrolled"
  }] : []));
  #scrollEffect = effect(() => {
    this.#elementRef.nativeElement.classList.toggle(this.#shadowClass, this.#scrolled());
  }, ...(ngDevMode ? [{
    debugName: "#scrollEffect"
  }] : []));
  #observable;
  #shadowClass = 'shadow-sm';
  constructor() {
    this.#destroyRef.onDestroy(() => {
      this.#scrollEffect?.destroy();
    });
  }
  cShadowOnScroll = input(true, ...(ngDevMode ? [{
    debugName: "cShadowOnScroll"
  }] : []));
  #shadowOnScrollEffect = effect(() => {
    const value = this.cShadowOnScroll();
    untracked(() => {
      this.#scrolled.set(false);
      if (value) {
        this.#shadowClass = value === true ? 'shadow' : `shadow-${value}`;
        this.#observable = fromEvent(this.#document, 'scroll').pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(scrolled => {
          this.#scrolled.set(this.#document.documentElement.scrollTop > 0);
        });
      } else {
        this.#observable?.unsubscribe();
      }
    });
  }, ...(ngDevMode ? [{
    debugName: "#shadowOnScrollEffect"
  }] : []));
  static ɵfac = function ShadowOnScrollDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ShadowOnScrollDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ShadowOnScrollDirective,
    selectors: [["", "cShadowOnScroll", ""]],
    inputs: {
      cShadowOnScroll: [1, "cShadowOnScroll"]
    },
    exportAs: ["cShadowOnScroll"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShadowOnScrollDirective, [{
    type: Directive,
    args: [{
      selector: '[cShadowOnScroll]',
      exportAs: 'cShadowOnScroll'
    }]
  }], () => [], {
    cShadowOnScroll: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cShadowOnScroll",
        required: false
      }]
    }]
  });
})();
class TextColorDirective {
  /**
   * Set text-color of element
   * @type TextColors
   */
  color = input('', ...(ngDevMode ? [{
    debugName: "color",
    alias: 'cTextColor'
  }] : [{
    alias: 'cTextColor'
  }]));
  hostClasses = computed(() => {
    const color = this.color();
    return {
      [`text-${color}`]: !!color
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function TextColorDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TextColorDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TextColorDirective,
    selectors: [["", "cTextColor", ""]],
    hostVars: 2,
    hostBindings: function TextColorDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      color: [1, "cTextColor", "color"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextColorDirective, [{
    type: Directive,
    args: [{
      selector: '[cTextColor]',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTextColor",
        required: false
      }]
    }]
  });
})();
class TextBgColorDirective {
  /**
   * Set text-bg-color of element
   * @type Colors
   */
  textBgColor = input('', ...(ngDevMode ? [{
    debugName: "textBgColor",
    alias: 'cTextBgColor'
  }] : [{
    alias: 'cTextBgColor'
  }]));
  hostClasses = computed(() => {
    const color = this.textBgColor();
    return {
      [`text-bg-${color}`]: !!color
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function TextBgColorDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TextBgColorDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TextBgColorDirective,
    selectors: [["", "cTextBgColor", ""]],
    hostVars: 2,
    hostBindings: function TextBgColorDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      textBgColor: [1, "cTextBgColor", "textBgColor"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextBgColorDirective, [{
    type: Directive,
    args: [{
      selector: '[cTextBgColor]',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    textBgColor: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTextBgColor",
        required: false
      }]
    }]
  });
})();
const UTILITY_DIRECTIVES = [AlignDirective, BgColorDirective, BorderDirective, RoundedDirective, ShadowOnScrollDirective, TextColorDirective, TextBgColorDirective];
class UtilitiesModule {
  static ɵfac = function UtilitiesModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UtilitiesModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: UtilitiesModule,
    imports: [AlignDirective, BgColorDirective, BorderDirective, RoundedDirective, ShadowOnScrollDirective, TextColorDirective, TextBgColorDirective],
    exports: [AlignDirective, BgColorDirective, BorderDirective, RoundedDirective, ShadowOnScrollDirective, TextColorDirective, TextBgColorDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtilitiesModule, [{
    type: NgModule,
    args: [{
      imports: [...UTILITY_DIRECTIVES],
      exports: [...UTILITY_DIRECTIVES]
    }]
  }], null, null);
})();
class AvatarComponent {
  /**
   * Sets the background color context of the component to one of CoreUI’s themed colors.
   * @type Colors
   */
  color = input(...(ngDevMode ? [undefined, {
    debugName: "color"
  }] : []));
  /**
   * Select the shape of the component.
   * @type Shapes
   */
  shape = input(...(ngDevMode ? [undefined, {
    debugName: "shape"
  }] : []));
  /**
   * Size the component small, large, or extra large.
   * @default 'md'
   */
  size = input('', ...(ngDevMode ? [{
    debugName: "size"
  }] : []));
  /**
   * The alt attribute for the img element alternate text.
   * @type string
   */
  alt = input('', ...(ngDevMode ? [{
    debugName: "alt"
  }] : []));
  /**
   * The src attribute for the img element.
   * @type string
   */
  src = input(...(ngDevMode ? [undefined, {
    debugName: "src"
  }] : []));
  /**
   * Sets the color context of the status indicator to one of CoreUI’s themed colors.
   * @type Colors
   */
  status = input(...(ngDevMode ? [undefined, {
    debugName: "status"
  }] : []));
  /**
   * Sets the text color of the component to one of CoreUI’s themed colors.
   * via TextColorDirective
   * @type TextColors
   */
  textColor = input(...(ngDevMode ? [undefined, {
    debugName: "textColor"
  }] : []));
  statusClass = computed(() => {
    return {
      'avatar-status': true,
      [`bg-${this.status()}`]: !!this.status()
    };
  }, ...(ngDevMode ? [{
    debugName: "statusClass"
  }] : []));
  hostClasses = computed(() => {
    const size = this.size();
    const color = this.color();
    const shape = this.shape();
    return {
      avatar: true,
      [`avatar-${size}`]: !!size,
      [`bg-${color}`]: !!color,
      [`${shape}`]: !!shape
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function AvatarComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AvatarComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AvatarComponent,
    selectors: [["c-avatar"]],
    hostAttrs: [1, "avatar"],
    hostVars: 2,
    hostBindings: function AvatarComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      color: [1, "color"],
      shape: [1, "shape"],
      size: [1, "size"],
      alt: [1, "alt"],
      src: [1, "src"],
      status: [1, "status"],
      textColor: [1, "textColor"]
    },
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: TextColorDirective,
      inputs: ["cTextColor", "textColor"]
    }])],
    ngContentSelectors: _c0,
    decls: 3,
    vars: 1,
    consts: [[3, "ngClass"], [1, "avatar-img", 3, "src", "alt"], ["aria-label", "Avatar placeholder", "focusable", "false", "preserveAspectRatio", "xMidYMid slice", "role", "img", "xmlns", "http://www.w3.org/2000/svg", 1, "avatar-img", 2, "position", "absolute", "width", "100%", "height", "100%", "inset", "0"], ["fill", "#868e96", "height", "100%", "width", "100%"]],
    template: function AvatarComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0, 0, null, AvatarComponent_ProjectionFallback_0_Template, 1, 1);
        i0.ɵɵconditionalCreate(2, AvatarComponent_Conditional_2_Template, 1, 1, "span", 0);
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!!ctx.status() ? 2 : -1);
      }
    },
    dependencies: [NgClass],
    styles: ["[_nghost-%COMP%]   .avatar-img[_ngcontent-%COMP%]{object-fit:cover}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AvatarComponent, [{
    type: Component,
    args: [{
      selector: 'c-avatar',
      imports: [NgClass],
      hostDirectives: [{
        directive: TextColorDirective,
        inputs: ['cTextColor: textColor']
      }],
      host: {
        class: 'avatar',
        '[class]': 'hostClasses()'
      },
      template: "<ng-content>\n  @if (src()) {\n    @defer (prefetch on idle) {\n      <img src=\"{{src() ?? ''}}\" class=\"avatar-img\" alt=\"{{alt()}}\" />\n    } @placeholder () {\n      <svg aria-label=\"Avatar placeholder\"\n           focusable=\"false\"\n           preserveAspectRatio=\"xMidYMid slice\"\n           role=\"img\"\n           xmlns=\"http://www.w3.org/2000/svg\"\n           class=\"avatar-img\"\n           style=\"position: absolute; width: 100%; height: 100%; inset: 0;\">\n        <rect fill=\"#868e96\" height=\"100%\" width=\"100%\"></rect>\n      </svg>\n    }\n  }\n</ng-content>\n@if (!!status()) {\n  <span [ngClass]=\"statusClass()\"></span>\n}\n\n",
      styles: [":host .avatar-img{object-fit:cover}\n"]
    }]
  }], null, {
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    shape: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "shape",
        required: false
      }]
    }],
    size: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "size",
        required: false
      }]
    }],
    alt: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "alt",
        required: false
      }]
    }],
    src: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "src",
        required: false
      }]
    }],
    status: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "status",
        required: false
      }]
    }],
    textColor: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "textColor",
        required: false
      }]
    }]
  });
})();
class AvatarModule {
  static ɵfac = function AvatarModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AvatarModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: AvatarModule,
    imports: [AvatarComponent],
    exports: [AvatarComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AvatarModule, [{
    type: NgModule,
    args: [{
      imports: [AvatarComponent],
      exports: [AvatarComponent]
    }]
  }], null, null);
})();
class BadgeComponent {
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @type Colors
   */
  color = input(...(ngDevMode ? [undefined, {
    debugName: "color"
  }] : []));
  /**
   * Position badge in one of the corners of a link or button.
   * @type BadgePositions
   */
  position = input(...(ngDevMode ? [undefined, {
    debugName: "position"
  }] : []));
  /**
   * Select the shape of the component.
   * @type Shapes
   */
  shape = input(...(ngDevMode ? [undefined, {
    debugName: "shape"
  }] : []));
  /**
   * Size the component small.
   */
  size = input(...(ngDevMode ? [undefined, {
    debugName: "size"
  }] : []));
  /**
   * Sets the text color of the component to one of CoreUI’s themed colors.
   * via TextColorDirective
   * @type TextColors
   */
  textColor = input(...(ngDevMode ? [undefined, {
    debugName: "textColor"
  }] : []));
  /**
   * Sets the component's color scheme to one of CoreUI's themed colors, ensuring the text color contrast adheres to the WCAG 4.5:1 contrast ratio standard for accessibility.
   * via TextBgColorDirective
   * @type Colors
   * @since 5.0.0
   */
  textBgColor = input(...(ngDevMode ? [undefined, {
    debugName: "textBgColor"
  }] : []));
  hostClasses = computed(() => {
    const position = this.position();
    const positionClasses = {
      'position-absolute': !!position,
      'translate-middle': !!position,
      'top-0': position?.includes('top'),
      'top-100': position?.includes('bottom'),
      'start-100': position?.includes('end'),
      'start-0': position?.includes('start')
    };
    const color = this.color();
    const size = this.size();
    const shape = this.shape();
    return Object.assign({
      badge: true,
      [`bg-${color}`]: !!color,
      [`badge-${size}`]: !!size,
      [`${shape}`]: !!shape
    }, !!position ? positionClasses : {});
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function BadgeComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BadgeComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: BadgeComponent,
    selectors: [["c-badge"]],
    hostAttrs: [1, "badge"],
    hostVars: 2,
    hostBindings: function BadgeComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      color: [1, "color"],
      position: [1, "position"],
      shape: [1, "shape"],
      size: [1, "size"],
      textColor: [1, "textColor"],
      textBgColor: [1, "textBgColor"]
    },
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: TextColorDirective,
      inputs: ["cTextColor", "textColor"]
    }, {
      directive: TextBgColorDirective,
      inputs: ["cTextBgColor", "textBgColor"]
    }])],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function BadgeComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BadgeComponent, [{
    type: Component,
    args: [{
      selector: 'c-badge',
      template: '<ng-content />',
      hostDirectives: [{
        directive: TextColorDirective,
        inputs: ['cTextColor: textColor']
      }, {
        directive: TextBgColorDirective,
        inputs: ['cTextBgColor: textBgColor']
      }],
      host: {
        class: 'badge',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    position: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "position",
        required: false
      }]
    }],
    shape: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "shape",
        required: false
      }]
    }],
    size: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "size",
        required: false
      }]
    }],
    textColor: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "textColor",
        required: false
      }]
    }],
    textBgColor: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "textBgColor",
        required: false
      }]
    }]
  });
})();
class BadgeModule {
  static ɵfac = function BadgeModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BadgeModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: BadgeModule,
    imports: [BadgeComponent],
    exports: [BadgeComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BadgeModule, [{
    type: NgModule,
    args: [{
      imports: [BadgeComponent],
      exports: [BadgeComponent]
    }]
  }], null, null);
})();
class BackdropService {
  #backdropClick = new Subject();
  backdropClick$ = this.#backdropClick.asObservable();
  #document = inject(DOCUMENT);
  activeBackdrop;
  get #scrollbarWidth() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = this.#document.documentElement.clientWidth;
    const scrollbarWidth = Math.abs((this.#document.defaultView?.innerWidth ?? documentWidth) - documentWidth);
    return `${scrollbarWidth}px`;
  }
  scrollbarWidth = this.#scrollbarWidth;
  setBackdrop(type = 'modal') {
    const backdropElement = this.#document.createElement('div');
    backdropElement.classList.add(`${type}-backdrop`);
    backdropElement.classList.add('fade');
    this.#document.body.appendChild(backdropElement);
    const clickHandler = () => {
      this.onClickHandler();
    };
    backdropElement.__backdropClickHandler = clickHandler;
    backdropElement.addEventListener('click', clickHandler);
    this.scrollbarWidth = this.#scrollbarWidth;
    setTimeout(() => {
      backdropElement.classList.add('show');
      // this.hideScrollbar();
    });
    this.activeBackdrop = backdropElement;
    return backdropElement;
  }
  clearBackdrop(backdropElement) {
    if (backdropElement) {
      const storedHandler = backdropElement.__backdropClickHandler;
      if (storedHandler) {
        backdropElement.removeEventListener('click', storedHandler);
        delete backdropElement.__backdropClickHandler;
      }
      backdropElement.classList.remove('show');
      setTimeout(() => {
        if (this.activeBackdrop === backdropElement) {
          this.resetScrollbar();
        }
        this.#document.body.removeChild(backdropElement);
      }, 300);
    }
    return undefined;
  }
  get #isRTL() {
    return [this.#document.documentElement.dir, this.#document.body.dir].includes('rtl');
  }
  get #padding() {
    return `padding-${this.#isRTL ? 'left' : 'right'}`;
  }
  #scrollBarVisible = true;
  hideScrollbar() {
    if (this.#scrollBarVisible) {
      this.#document.body.style.setProperty('overflow', 'hidden');
      this.#document.body.style.setProperty(this.#padding, this.scrollbarWidth);
      this.#scrollBarVisible = false;
    }
  }
  resetScrollbar() {
    this.#document.body.style.removeProperty('overflow');
    this.#document.body.style.removeProperty(this.#padding);
    this.#scrollBarVisible = true;
  }
  onClickHandler() {
    this.#backdropClick.next(true);
  }
  static ɵfac = function BackdropService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BackdropService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BackdropService,
    factory: BackdropService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BackdropService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class BreadcrumbItemComponent {
  /**
   * Toggle the active state for the component. [docs]
   * @return boolean
   */
  active = input(undefined, ...(ngDevMode ? [{
    debugName: "active",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * The `url` prop for the inner `[routerLink]` directive. [docs]
   * @return string
   */
  url = input(...(ngDevMode ? [undefined, {
    debugName: "url"
  }] : []));
  /**
   * Additional html attributes for link. [docs]
   * @return INavAttributes
   */
  attribs = input(...(ngDevMode ? [undefined, {
    debugName: "attribs"
  }] : []));
  _attributes = input(undefined, ...(ngDevMode ? [{
    debugName: "_attributes",
    alias: 'attributes'
  }] : [{
    alias: 'attributes'
  }]));
  #attributesEffect = effect(() => {
    if (this._attributes()) {
      console.error('c-breadcrumb-item: [attributes] prop is removed, use [attribs] instead:', this._attributes());
    }
  }, ...(ngDevMode ? [{
    debugName: "#attributesEffect"
  }] : []));
  /**
   * Some `NavigationExtras` props for the inner `[routerLink]` directive and `routerLinkActiveOptions`. [docs]
   * @return INavLinkProps
   */
  linkProps = input(...(ngDevMode ? [undefined, {
    debugName: "linkProps"
  }] : []));
  ariaCurrent = computed(() => {
    return this.active() ? 'page' : null;
  }, ...(ngDevMode ? [{
    debugName: "ariaCurrent"
  }] : []));
  hostClasses = computed(() => {
    return {
      'breadcrumb-item': true,
      active: this.active()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function BreadcrumbItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BreadcrumbItemComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: BreadcrumbItemComponent,
    selectors: [["c-breadcrumb-item"]],
    hostVars: 3,
    hostBindings: function BreadcrumbItemComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-current", ctx.ariaCurrent());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      active: [1, "active"],
      url: [1, "url"],
      attribs: [1, "attribs"],
      _attributes: [1, "attributes", "_attributes"],
      linkProps: [1, "linkProps"]
    },
    exportAs: ["breadcrumbItem"],
    ngContentSelectors: _c0,
    decls: 4,
    vars: 1,
    consts: [["defaultBreadcrumbItemContentTemplate", ""], [3, "routerLink", "cHtmlAttr", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state"], [3, "cHtmlAttr"], [4, "ngTemplateOutlet"]],
    template: function BreadcrumbItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵconditionalCreate(0, BreadcrumbItemComponent_Conditional_0_Template, 2, 13, "a", 1)(1, BreadcrumbItemComponent_Conditional_1_Template, 2, 3, "span", 2);
        i0.ɵɵtemplate(2, BreadcrumbItemComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵconditional(!ctx.active() ? 0 : 1);
      }
    },
    dependencies: [RouterModule, i1.RouterLink, NgTemplateOutlet, HtmlAttributesDirective],
    styles: ["[_nghost-%COMP%]{display:list-item;text-align:-webkit-match-parent;text-align:match-parent}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbItemComponent, [{
    type: Component,
    args: [{
      selector: 'c-breadcrumb-item',
      imports: [RouterModule, NgTemplateOutlet, HtmlAttributesDirective],
      exportAs: 'breadcrumbItem',
      host: {
        '[attr.aria-current]': 'ariaCurrent()',
        '[class]': 'hostClasses()'
      },
      template: "@if (!active()) {\n  <a [routerLink]=\"url()\"\n     [cHtmlAttr]=\"attribs() ?? {}\"\n     [target]=\"attribs()?.['target']\"\n     [queryParams]=\"linkProps()?.queryParams ?? null\"\n     [fragment]=\"linkProps()?.fragment\"\n     [queryParamsHandling]=\"linkProps()?.queryParamsHandling ?? null\"\n     [preserveFragment]=\"linkProps()?.preserveFragment ?? false\"\n     [skipLocationChange]=\"linkProps()?.skipLocationChange ?? false\"\n     [replaceUrl]=\"linkProps()?.replaceUrl ?? false\"\n     [state]=\"linkProps()?.state ?? {}\"\n  >\n    <ng-container *ngTemplateOutlet=\"defaultBreadcrumbItemContentTemplate\" />\n  </a>\n} @else {\n  <span [cHtmlAttr]=\"attribs() ?? {}\">\n      <ng-container *ngTemplateOutlet=\"defaultBreadcrumbItemContentTemplate\" />\n  </span>\n}\n\n<ng-template #defaultBreadcrumbItemContentTemplate>\n  <ng-content />\n</ng-template>\n",
      styles: [":host{display:list-item;text-align:-webkit-match-parent;text-align:match-parent}\n"]
    }]
  }], null, {
    active: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "active",
        required: false
      }]
    }],
    url: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "url",
        required: false
      }]
    }],
    attribs: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "attribs",
        required: false
      }]
    }],
    _attributes: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "attributes",
        required: false
      }]
    }],
    linkProps: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "linkProps",
        required: false
      }]
    }]
  });
})();
class BreadcrumbComponent {
  /**
   * Default aria-label for breadcrumb. [docs]
   * @return string
   * @default 'breadcrumb'
   */
  ariaLabel = input('breadcrumb', ...(ngDevMode ? [{
    debugName: "ariaLabel"
  }] : []));
  /**
   * Default role for breadcrumb. [docs]
   * @return string
   * @default 'navigation'
   */
  role = input('navigation', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  static ɵfac = function BreadcrumbComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BreadcrumbComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: BreadcrumbComponent,
    selectors: [["c-breadcrumb"]],
    hostAttrs: [1, "breadcrumb"],
    hostVars: 2,
    hostBindings: function BreadcrumbComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-label", ctx.ariaLabel())("role", ctx.role());
      }
    },
    inputs: {
      ariaLabel: [1, "ariaLabel"],
      role: [1, "role"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function BreadcrumbComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbComponent, [{
    type: Component,
    args: [{
      selector: 'c-breadcrumb',
      template: '<ng-content />',
      host: {
        class: 'breadcrumb',
        '[attr.aria-label]': 'ariaLabel()',
        '[attr.role]': 'role()'
      }
    }]
  }], null, {
    ariaLabel: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "ariaLabel",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class BreadcrumbRouterService {
  #router = inject(Router);
  #activatedRoute = inject(ActivatedRoute);
  outlet = 'primary';
  #breadcrumbsBehaviorSubject = new BehaviorSubject(new Array());
  breadcrumbs$ = this.#breadcrumbsBehaviorSubject.asObservable();
  constructor() {
    this.#router.events.pipe(takeUntilDestroyed(), filter(event => event instanceof NavigationEnd)).subscribe(event => {
      const breadcrumbs = [];
      let currentRoute = this.#activatedRoute.root;
      let url = '';
      do {
        const childrenRoutes = currentRoute.children;
        currentRoute = null;
        childrenRoutes.forEach(childRoute => {
          // console.log('breadcrumb event', event, 'route', route);
          if (childRoute.outlet === this.outlet) {
            const routeSnapshot = childRoute.snapshot;
            url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
            breadcrumbs.push({
              label: routeSnapshot.data['title'] ?? routeSnapshot.title ?? '',
              url,
              queryParams: routeSnapshot.queryParams
            });
            currentRoute = childRoute;
          }
        });
      } while (currentRoute);
      this.#breadcrumbsBehaviorSubject.next(Object.assign([], breadcrumbs));
      return breadcrumbs;
    });
  }
  static ɵfac = function BreadcrumbRouterService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BreadcrumbRouterService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BreadcrumbRouterService,
    factory: BreadcrumbRouterService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbRouterService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class BreadcrumbRouterComponent {
  #breadcrumbRouterService = inject(BreadcrumbRouterService);
  /**
   * Optional array of IBreadcrumbItem to override default BreadcrumbRouter behavior. [docs]
   * @return IBreadcrumbItem[]
   */
  items = input(...(ngDevMode ? [undefined, {
    debugName: "items"
  }] : []));
  #breadcrumbs = toSignal(this.#breadcrumbRouterService.breadcrumbs$);
  breadcrumbs = computed(() => {
    return this.items() ?? this.#breadcrumbs() ?? [];
  }, ...(ngDevMode ? [{
    debugName: "breadcrumbs"
  }] : []));
  static ɵfac = function BreadcrumbRouterComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BreadcrumbRouterComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: BreadcrumbRouterComponent,
    selectors: [["c-breadcrumb-router"], ["", "cBreadcrumbRouter", ""]],
    inputs: {
      items: [1, "items"]
    },
    decls: 3,
    vars: 0,
    consts: [[1, "m-0"], [3, "active", "url", "attribs", "linkProps"]],
    template: function BreadcrumbRouterComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "c-breadcrumb", 0);
        i0.ɵɵrepeaterCreate(1, BreadcrumbRouterComponent_For_2_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.breadcrumbs());
      }
    },
    dependencies: [BreadcrumbComponent, BreadcrumbItemComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbRouterComponent, [{
    type: Component,
    args: [{
      selector: 'c-breadcrumb-router, [cBreadcrumbRouter]',
      imports: [BreadcrumbComponent, BreadcrumbItemComponent],
      template: "<c-breadcrumb class=\"m-0\">\n  @for (breadcrumb of breadcrumbs(); track breadcrumb; let last = $last) {\n    @if (breadcrumb?.label && (breadcrumb?.url?.slice(-1) === '/' || last)) {\n      <c-breadcrumb-item\n        [active]=\"last\"\n        [url]=\"breadcrumb?.url\"\n        [attribs]=\"breadcrumb?.attributes\"\n        [linkProps]=\"breadcrumb?.linkProps\"\n      >\n        {{ breadcrumb?.label }}\n      </c-breadcrumb-item>\n    }\n  }\n</c-breadcrumb>\n"
    }]
  }], null, {
    items: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "items",
        required: false
      }]
    }]
  });
})();
class BreadcrumbModule {
  static ɵfac = function BreadcrumbModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BreadcrumbModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: BreadcrumbModule,
    imports: [BreadcrumbComponent, BreadcrumbItemComponent, BreadcrumbRouterComponent],
    exports: [BreadcrumbComponent, BreadcrumbItemComponent, BreadcrumbRouterComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [BreadcrumbRouterService],
    imports: [BreadcrumbItemComponent, BreadcrumbRouterComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbModule, [{
    type: NgModule,
    args: [{
      imports: [BreadcrumbComponent, BreadcrumbItemComponent, BreadcrumbRouterComponent],
      exports: [BreadcrumbComponent, BreadcrumbItemComponent, BreadcrumbRouterComponent],
      providers: [BreadcrumbRouterService]
    }]
  }], null, null);
})();
class ButtonGroupComponent {
  /**
   * Size the component small or large.
   * @return { 'sm' | 'lg' }
   */
  size = input(...(ngDevMode ? [undefined, {
    debugName: "size"
  }] : []));
  /**
   * Create a set of buttons that appear vertically stacked rather than horizontally. Split button dropdowns are not supported here.
   * @type boolean
   */
  vertical = input(false, ...(ngDevMode ? [{
    debugName: "vertical",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Default role attr for ButtonGroup. [docs]
   * @return string
   * @default 'group'
   */
  role = input('group', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  hostClasses = computed(() => {
    const size = this.size();
    const vertical = this.vertical();
    return {
      'btn-group': !vertical,
      'btn-group-vertical': vertical,
      [`btn-group-${size}`]: !!size
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function ButtonGroupComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonGroupComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ButtonGroupComponent,
    selectors: [["c-button-group"]],
    hostVars: 3,
    hostBindings: function ButtonGroupComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      size: [1, "size"],
      vertical: [1, "vertical"],
      role: [1, "role"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ButtonGroupComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonGroupComponent, [{
    type: Component,
    args: [{
      selector: 'c-button-group',
      template: '<ng-content />',
      host: {
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    size: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "size",
        required: false
      }]
    }],
    vertical: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "vertical",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class ButtonToolbarComponent {
  /**
   * Default role attr for ButtonToolbar. [docs]
   * @type InputSignal<string>
   * @default 'toolbar'
   */
  role = input('toolbar', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  static ɵfac = function ButtonToolbarComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonToolbarComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ButtonToolbarComponent,
    selectors: [["c-button-toolbar"]],
    hostAttrs: [1, "btn-toolbar"],
    hostVars: 1,
    hostBindings: function ButtonToolbarComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
      }
    },
    inputs: {
      role: [1, "role"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ButtonToolbarComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonToolbarComponent, [{
    type: Component,
    args: [{
      selector: 'c-button-toolbar',
      template: '<ng-content />',
      host: {
        class: 'btn-toolbar',
        '[attr.role]': 'role()'
      }
    }]
  }], null, {
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class ButtonGroupModule {
  static ɵfac = function ButtonGroupModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ButtonGroupModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ButtonGroupModule,
    imports: [ButtonGroupComponent, ButtonToolbarComponent],
    exports: [ButtonGroupComponent, ButtonToolbarComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonGroupModule, [{
    type: NgModule,
    args: [{
      imports: [ButtonGroupComponent, ButtonToolbarComponent],
      exports: [ButtonGroupComponent, ButtonToolbarComponent]
    }]
  }], null, null);
})();
class CalloutComponent {
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @type Colors
   */
  color = input(...(ngDevMode ? [undefined, {
    debugName: "color"
  }] : []));
  hostClasses = computed(() => {
    const color = this.color();
    return {
      callout: true,
      [`callout-${color}`]: !!color
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function CalloutComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalloutComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CalloutComponent,
    selectors: [["c-callout"], ["", "cCallout", ""]],
    hostAttrs: [1, "callout"],
    hostVars: 2,
    hostBindings: function CalloutComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      color: [1, "color"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CalloutComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalloutComponent, [{
    type: Component,
    args: [{
      selector: 'c-callout, [cCallout]',
      template: '<ng-content />',
      host: {
        class: 'callout',
        '[class]': 'hostClasses()'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, {
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }]
  });
})();
class CalloutModule {
  static ɵfac = function CalloutModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CalloutModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CalloutModule,
    imports: [CalloutComponent],
    exports: [CalloutComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalloutModule, [{
    type: NgModule,
    args: [{
      exports: [CalloutComponent],
      imports: [CalloutComponent]
    }]
  }], null, null);
})();
class CardComponent {
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @type Colors
   */
  color = input(...(ngDevMode ? [undefined, {
    debugName: "color"
  }] : []));
  /**
   * Sets the text color context of the component to one of CoreUI’s themed colors.
   * via TextColorDirective
   * @type TextColors
   */
  textColor = input(...(ngDevMode ? [undefined, {
    debugName: "textColor"
  }] : []));
  /**
   * Sets the component's color scheme to one of CoreUI themed colors, ensuring the text color contrast adheres to the WCAG 4.5:1 contrast ratio standard for accessibility.
   * via TextBgColorDirective
   * @type Colors
   * @since 5.0.0
   */
  textBgColor = input(...(ngDevMode ? [undefined, {
    debugName: "textBgColor"
  }] : []));
  hostClasses = computed(() => {
    const color = this.color();
    return {
      card: true,
      [`bg-${color}`]: !!color
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function CardComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CardComponent,
    selectors: [["c-card"], ["", "c-card", ""]],
    hostAttrs: [1, "card"],
    hostVars: 2,
    hostBindings: function CardComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      color: [1, "color"],
      textColor: [1, "textColor"],
      textBgColor: [1, "textBgColor"]
    },
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: TextColorDirective,
      inputs: ["cTextColor", "textColor"]
    }, {
      directive: TextBgColorDirective,
      inputs: ["cTextBgColor", "textBgColor"]
    }])],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CardComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardComponent, [{
    type: Component,
    args: [{
      selector: 'c-card, [c-card]',
      template: '<ng-content />',
      hostDirectives: [{
        directive: TextColorDirective,
        inputs: ['cTextColor: textColor']
      }, {
        directive: TextBgColorDirective,
        inputs: ['cTextBgColor: textBgColor']
      }],
      host: {
        class: 'card',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    textColor: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "textColor",
        required: false
      }]
    }],
    textBgColor: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "textBgColor",
        required: false
      }]
    }]
  });
})();
class CardBodyComponent {
  static ɵfac = function CardBodyComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardBodyComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CardBodyComponent,
    selectors: [["c-card-body"], ["", "c-card-body", ""]],
    hostAttrs: [1, "card-body"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CardBodyComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardBodyComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-body, [c-card-body]',
      template: '<ng-content />',
      host: {
        class: 'card-body'
      }
    }]
  }], null, null);
})();
class CardFooterComponent {
  static ɵfac = function CardFooterComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardFooterComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CardFooterComponent,
    selectors: [["c-card-footer"], ["", "c-card-footer", ""]],
    hostAttrs: [1, "card-footer"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CardFooterComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardFooterComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-footer, [c-card-footer]',
      template: '<ng-content />',
      host: {
        class: 'card-footer'
      }
    }]
  }], null, null);
})();
class CardGroupComponent {
  static ɵfac = function CardGroupComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardGroupComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CardGroupComponent,
    selectors: [["c-card-group"], ["", "c-card-group", ""]],
    hostAttrs: [1, "card-group"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CardGroupComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardGroupComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-group, [c-card-group]',
      template: '<ng-content />',
      host: {
        class: 'card-group'
      }
    }]
  }], null, null);
})();
class CardHeaderComponent {
  static ɵfac = function CardHeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardHeaderComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CardHeaderComponent,
    selectors: [["c-card-header"], ["", "c-card-header", ""]],
    hostAttrs: [1, "card-header"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CardHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-header, [c-card-header]',
      template: '<ng-content />',
      host: {
        class: 'card-header'
      }
    }]
  }], null, null);
})();
class CardHeaderActionsComponent {
  static ɵfac = function CardHeaderActionsComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardHeaderActionsComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CardHeaderActionsComponent,
    selectors: [["c-card-header-actions"], ["", "c-card-header-actions", ""]],
    hostAttrs: [1, "card-header-actions"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CardHeaderActionsComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardHeaderActionsComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-header-actions, [c-card-header-actions]',
      template: '<ng-content />',
      host: {
        class: 'card-header-actions'
      }
    }]
  }], null, null);
})();
class CardImgDirective {
  /**
   * Optionally orientate the image to the top, bottom, or make it overlaid across the card.
   * @type {'top | 'bottom'}
   */
  orientation = input(undefined, ...(ngDevMode ? [{
    debugName: "orientation",
    alias: 'cCardImg'
  }] : [{
    alias: 'cCardImg'
  }]));
  hostClasses = computed(() => {
    const orientation = this.orientation();
    const suffix = !!orientation ? `-${orientation}` : '';
    const horizontal = ['start', 'end'].includes(orientation ?? '-') ? orientation : undefined;
    return {
      [`card-img${suffix}`]: !horizontal,
      'img-fluid': !!horizontal,
      [`rounded-${horizontal}`]: !!horizontal
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function CardImgDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardImgDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CardImgDirective,
    selectors: [["", "cCardImg", ""]],
    hostVars: 2,
    hostBindings: function CardImgDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      orientation: [1, "cCardImg", "orientation"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardImgDirective, [{
    type: Directive,
    args: [{
      selector: '[cCardImg]',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    orientation: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cCardImg",
        required: false
      }]
    }]
  });
})();
class CardImgOverlayComponent {
  static ɵfac = function CardImgOverlayComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardImgOverlayComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CardImgOverlayComponent,
    selectors: [["c-card-img-overlay"]],
    hostAttrs: [1, "card-img-overlay"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CardImgOverlayComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardImgOverlayComponent, [{
    type: Component,
    args: [{
      selector: 'c-card-img-overlay',
      template: '<ng-content />',
      host: {
        class: 'card-img-overlay'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class CardLinkDirective {
  static ɵfac = function CardLinkDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardLinkDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CardLinkDirective,
    selectors: [["", "cCardLink", ""]],
    hostAttrs: [1, "card-link"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardLinkDirective, [{
    type: Directive,
    args: [{
      selector: '[cCardLink]',
      host: {
        class: 'card-link'
      }
    }]
  }], null, null);
})();
class CardSubtitleDirective {
  static ɵfac = function CardSubtitleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardSubtitleDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CardSubtitleDirective,
    selectors: [["", "cCardSubtitle", ""]],
    hostAttrs: [1, "card-subtitle"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardSubtitleDirective, [{
    type: Directive,
    args: [{
      selector: '[cCardSubtitle]',
      host: {
        class: 'card-subtitle'
      }
    }]
  }], null, null);
})();
class CardTextDirective {
  static ɵfac = function CardTextDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardTextDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CardTextDirective,
    selectors: [["", "cCardText", ""]],
    hostAttrs: [1, "card-text"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardTextDirective, [{
    type: Directive,
    args: [{
      selector: '[cCardText]',
      host: {
        class: 'card-text'
      }
    }]
  }], null, null);
})();
class CardTitleDirective {
  static ɵfac = function CardTitleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardTitleDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CardTitleDirective,
    selectors: [["", "cCardTitle", ""]],
    hostAttrs: [1, "card-title"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardTitleDirective, [{
    type: Directive,
    args: [{
      selector: '[cCardTitle]',
      host: {
        class: 'card-title'
      }
    }]
  }], null, null);
})();
class CardModule {
  static ɵfac = function CardModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CardModule,
    imports: [CardComponent, CardBodyComponent, CardFooterComponent, CardGroupComponent, CardHeaderComponent, CardHeaderActionsComponent, CardImgDirective, CardImgOverlayComponent, CardLinkDirective, CardSubtitleDirective, CardTextDirective, CardTitleDirective],
    exports: [CardComponent, CardBodyComponent, CardFooterComponent, CardGroupComponent, CardHeaderComponent, CardHeaderActionsComponent, CardImgDirective, CardImgOverlayComponent, CardLinkDirective, CardSubtitleDirective, CardTextDirective, CardTitleDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardModule, [{
    type: NgModule,
    args: [{
      imports: [CardComponent, CardBodyComponent, CardFooterComponent, CardGroupComponent, CardHeaderComponent, CardHeaderActionsComponent, CardImgDirective, CardImgOverlayComponent, CardLinkDirective, CardSubtitleDirective, CardTextDirective, CardTitleDirective],
      exports: [CardComponent, CardBodyComponent, CardFooterComponent, CardGroupComponent, CardHeaderComponent, CardHeaderActionsComponent, CardImgDirective, CardImgOverlayComponent, CardLinkDirective, CardSubtitleDirective, CardTextDirective, CardTitleDirective]
    }]
  }], null, null);
})();
class IntersectionService {
  platformId = inject(PLATFORM_ID);
  #intersecting = new BehaviorSubject({
    isIntersecting: false
  });
  intersecting$ = this.#intersecting.asObservable();
  defaultObserverOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2
  };
  hostElementRefs = new Map();
  createIntersectionObserver(hostElement, observerOptions = this.defaultObserverOptions) {
    if (isPlatformServer(this.platformId)) {
      this.#intersecting.next({
        isIntersecting: true,
        hostElement
      });
      return;
    }
    const options = {
      ...this.defaultObserverOptions,
      ...observerOptions
    };
    const handleIntersect = (entries, observer) => {
      entries.forEach(entry => {
        this.#intersecting.next({
          isIntersecting: entry.isIntersecting,
          hostElement
        });
      });
    };
    this.hostElementRefs.set(hostElement, new IntersectionObserver(handleIntersect, options));
    this.hostElementRefs.get(hostElement)?.observe(hostElement.nativeElement);
  }
  unobserve(elementRef) {
    this.hostElementRefs.get(elementRef)?.unobserve(elementRef.nativeElement);
    this.hostElementRefs.set(elementRef, null);
    this.hostElementRefs.delete(elementRef);
  }
  ngOnDestroy() {
    this.hostElementRefs.forEach((observer, elementRef) => {
      observer?.unobserve(elementRef.nativeElement);
    });
  }
  static ɵfac = function IntersectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IntersectionService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntersectionService,
    factory: IntersectionService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IntersectionService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class ListenersService {
  renderer = inject(Renderer2);
  listeners = new Map();
  setListeners({
    hostElement,
    trigger,
    callbackOn,
    callbackOff,
    callbackToggle
  }) {
    const host = hostElement.nativeElement;
    const triggers = Array.isArray(trigger) ? trigger : trigger?.split(' ') ?? [];
    if (triggers?.includes('click')) {
      typeof callbackToggle === 'function' && this.listeners.set('click', this.renderer.listen(host, 'click', callbackToggle));
    }
    if (triggers?.includes('focus')) {
      typeof callbackOn === 'function' && this.listeners.set('focus', this.renderer.listen(host, 'focus', callbackOn));
    }
    if (triggers?.includes('focusin')) {
      typeof callbackOff === 'function' && this.listeners.set('focusout', this.renderer.listen(host, 'focusout', callbackOff));
      typeof callbackOn === 'function' && this.listeners.set('focusin', this.renderer.listen(host, 'focusin', callbackOn));
    }
    if (triggers?.includes('click') || triggers?.includes('focus')) {
      typeof callbackOff === 'function' && this.listeners.set('blur', this.renderer.listen(host, 'blur', callbackOff));
    }
    if (triggers?.includes('hover')) {
      typeof callbackOn === 'function' && this.listeners.set('mouseenter', this.renderer.listen(host, 'mouseenter', callbackOn));
      typeof callbackOff === 'function' && this.listeners.set('mouseleave', this.renderer.listen(host, 'mouseleave', callbackOff));
    }
  }
  clearListeners() {
    this.listeners.forEach((unListen, key) => {
      unListen();
    });
    this.listeners.forEach((unListen, key) => {
      // @ts-ignore
      this.listeners.set(key, null);
    });
    this.listeners.clear();
  }
  static ɵfac = function ListenersService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListenersService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ListenersService,
    factory: ListenersService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListenersService, [{
    type: Injectable
  }], null, null);
})();
class ClassToggleService {
  #document = inject(DOCUMENT);
  #rendererFactory = inject(RendererFactory2);
  #renderer;
  constructor() {
    this.#renderer = this.#rendererFactory.createRenderer(null, null);
  }
  toggle(selector, className) {
    const element = this.#document.querySelector(selector);
    if (element) {
      element.classList.contains(className) ? this.#renderer.removeClass(element, className) : this.#renderer.addClass(element, className);
    }
  }
  static ɵfac = function ClassToggleService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ClassToggleService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ClassToggleService,
    factory: ClassToggleService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClassToggleService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class InMemoryStorageService {
  #storage = new Map();
  setItem(key, data) {
    this.#storage.set(key, JSON.stringify(data));
  }
  getItem(key) {
    return this.#storage.has(key) ? JSON.parse(this.#storage.get(key) ?? 'null') : undefined;
  }
  removeItem(key) {
    this.#storage.delete(key);
  }
  clear() {
    this.#storage.clear();
  }
  get length() {
    return this.#storage.size;
  }
  key(index) {
    return Array.from(this.#storage.keys())[index];
  }
  static ɵfac = function InMemoryStorageService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InMemoryStorageService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InMemoryStorageService,
    factory: InMemoryStorageService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InMemoryStorageService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class LocalStorageService {
  platformId = inject(PLATFORM_ID);
  document = inject(DOCUMENT);
  constructor() {
    this.#localStorage = isPlatformBrowser(this.platformId) && this.document.defaultView ? this.document.defaultView?.localStorage : new InMemoryStorageService();
  }
  #localStorage;
  #data$ = new BehaviorSubject(null);
  data$ = this.#data$.asObservable();
  setItem(key, data) {
    this.#localStorage.setItem(key, JSON.stringify(data));
    this.#data$.next({
      key,
      data
    });
  }
  getItem(key) {
    const data = JSON.parse(this.#localStorage.getItem(key) || 'null');
    this.#data$.next({
      key,
      data
    });
    return data;
  }
  removeItem(key) {
    this.#localStorage.removeItem(key);
    this.#data$.next({
      key,
      data: null
    });
  }
  clear() {
    this.#localStorage.clear();
    this.#data$.next(null);
  }
  static ɵfac = function LocalStorageService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LocalStorageService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LocalStorageService,
    factory: LocalStorageService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocalStorageService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class ColorModeService {
  #destroyRef = inject(DestroyRef);
  #document = inject(DOCUMENT);
  #localStorage = inject(LocalStorageService);
  eventName = signal('ColorSchemeChange', ...(ngDevMode ? [{
    debugName: "eventName"
  }] : []));
  localStorageItemName = signal(undefined, ...(ngDevMode ? [{
    debugName: "localStorageItemName"
  }] : []));
  localStorageItemName$ = toObservable(this.localStorageItemName);
  colorMode = signal(undefined, ...(ngDevMode ? [{
    debugName: "colorMode"
  }] : []));
  #colorModeEffect = effect(() => {
    const colorMode = this.colorMode();
    if (colorMode) {
      const localStorageItemName = this.localStorageItemName();
      localStorageItemName && this.setStoredTheme(localStorageItemName, colorMode);
      this.#setTheme(colorMode);
    }
  }, ...(ngDevMode ? [{
    debugName: "#colorModeEffect"
  }] : []));
  constructor() {
    afterNextRender({
      read: () => {
        this.localStorageItemName$.pipe(tap(params => {
          this.colorMode.set(this.getDefaultScheme(params));
        }), takeUntilDestroyed(this.#destroyRef)).subscribe();
      }
    });
  }
  getStoredTheme(localStorageItemName) {
    return this.#localStorage.getItem(localStorageItemName);
  }
  setStoredTheme(localStorageItemName, colorMode) {
    return this.#localStorage.setItem(localStorageItemName, colorMode);
  }
  removeStoredTheme(localStorageItemName) {
    this.#localStorage.removeItem(localStorageItemName);
  }
  getDefaultScheme(localStorageItemName) {
    if (this.#document.defaultView === undefined) {
      return this.getDatasetTheme();
    }
    const storedTheme = localStorageItemName && this.getStoredTheme(localStorageItemName);
    return storedTheme ?? this.getDatasetTheme();
  }
  getPrefersColorScheme() {
    return this.#document.defaultView?.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : this.#document.defaultView?.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : undefined;
  }
  getDatasetTheme() {
    return this.#document.documentElement.dataset['coreuiTheme'];
  }
  #setTheme(colorMode) {
    this.#document.documentElement.dataset['coreuiTheme'] = colorMode === 'auto' ? this.getPrefersColorScheme() : colorMode;
    const event = new Event(this.eventName());
    this.#document.documentElement.dispatchEvent(event);
  }
  static ɵfac = function ColorModeService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ColorModeService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ColorModeService,
    factory: ColorModeService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColorModeService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class UIDService {
  #document = inject(DOCUMENT);
  getUID(prefix = 'random-id') {
    let uid = prefix;
    do {
      uid = `${prefix}-${Math.floor(Math.random() * 1000000).toString(10)}`;
    } while (this.#document.getElementById(uid));
    return uid;
  }
  static ɵfac = function UIDService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || UIDService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UIDService,
    factory: UIDService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UIDService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class RtlService {
  #document = inject(DOCUMENT);
  isRTL(element) {
    if (element) {
      return element.closest('[dir="rtl"]') !== null || this.#document.defaultView?.getComputedStyle(element).direction === 'rtl';
    }
    return [this.#document?.documentElement?.dir, this.#document?.body?.dir].includes('rtl');
  }
  static ɵfac = function RtlService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RtlService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RtlService,
    factory: RtlService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RtlService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class CarouselService {
  #carouselIndex = new BehaviorSubject({});
  carouselIndex$ = this.#carouselIndex.asObservable();
  setIndex(index) {
    this.#carouselIndex.next(index);
  }
  static ɵfac = function CarouselService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CarouselService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CarouselService,
    factory: CarouselService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselService, [{
    type: Injectable
  }], null, null);
})();
class CarouselState {
  #carouselService = inject(CarouselService);
  #state = {
    activeItemIndex: -1,
    animate: true,
    items: [],
    direction: 'next',
    transition: 'slide',
    interval: 0
  };
  get state() {
    return this.#state;
  }
  set state(state) {
    const prevState = {
      ...this.#state
    };
    const nextState = {
      ...this.#state,
      ...state
    };
    this.#state = nextState;
    if (prevState.activeItemIndex !== nextState.activeItemIndex) {
      const activeItemIndex = this.state.activeItemIndex || 0;
      const itemInterval = this.state.items && this.state.items[activeItemIndex]?.interval() || -1;
      this.#carouselService.setIndex({
        active: nextState.activeItemIndex,
        interval: itemInterval,
        lastItemIndex: (nextState.items?.length ?? 0) - 1
      });
    }
  }
  setItems(newItems) {
    if (newItems.length) {
      const itemsArray = newItems;
      itemsArray.forEach((item, i) => {
        item.index = i;
      });
      this.state = {
        items: [...itemsArray]
      };
    } else {
      this.reset();
    }
  }
  setNextIndex(nextIndex) {
    this.#carouselService.setIndex(nextIndex);
  }
  direction(direction = 'next') {
    this.state = {
      direction
    };
    const {
      activeItemIndex = -1,
      items
    } = this.state;
    const itemsCount = items?.length ?? 0;
    if (itemsCount > 0) {
      return direction === 'next' ? activeItemIndex === itemsCount - 1 ? 0 : activeItemIndex + 1 : activeItemIndex === 0 ? itemsCount - 1 : activeItemIndex - 1;
    } else {
      return 0;
    }
  }
  reset() {
    this.state = {
      activeItemIndex: -1,
      animate: true,
      items: [],
      direction: 'next',
      transition: 'slide',
      interval: 0
    };
  }
  static ɵfac = function CarouselState_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CarouselState)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CarouselState,
    factory: CarouselState.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselState, [{
    type: Injectable
  }], null, null);
})();
class CarouselConfig {
  /* Animate transition of slides */
  activeIndex = 0;
  /* Animate transition of slides */
  animate = true;
  /* Default direction of auto changing of slides */
  direction = 'next';
  /* Default interval of auto changing of slides */
  interval;
  static ɵfac = function CarouselConfig_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CarouselConfig)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CarouselConfig,
    factory: CarouselConfig.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class CarouselComponent {
  config = inject(CarouselConfig);
  #hostElement = inject(ElementRef);
  #carouselService = inject(CarouselService);
  #carouselState = inject(CarouselState);
  #intersectionService = inject(IntersectionService);
  #listenersService = inject(ListenersService);
  constructor() {
    this.loadConfig();
  }
  loadConfig() {
    this.activeIndex.update(activeIndex => this.config?.activeIndex ?? activeIndex);
    this.animate.update(animate => this.config?.animate ?? animate);
    this.direction.update(direction => this.config?.direction ?? direction);
    this.interval.update(interval => this.config?.interval ?? interval);
  }
  /**
   * Index of the active item.
   * @return number
   */
  activeIndexInput = input(0, ...(ngDevMode ? [{
    debugName: "activeIndexInput",
    alias: 'activeIndex',
    transform: numberAttribute
  }] : [{
    alias: 'activeIndex',
    transform: numberAttribute
  }]));
  activeIndex = linkedSignal(...(ngDevMode ? [{
    debugName: "activeIndex",
    source: this.activeIndexInput,
    computation: value => value
  }] : [{
    source: this.activeIndexInput,
    computation: value => value
  }]));
  /**
   * Carousel automatically starts cycle items.
   * @return boolean
   */
  animateInput = input(true, ...(ngDevMode ? [{
    debugName: "animateInput",
    alias: 'animate'
  }] : [{
    alias: 'animate'
  }]));
  animate = linkedSignal(...(ngDevMode ? [{
    debugName: "animate",
    source: this.animateInput,
    computation: value => value
  }] : [{
    source: this.animateInput,
    computation: value => value
  }]));
  /**
   * Carousel direction. [docs]
   * @return {'next' | 'prev'}
   */
  directionInput = input('next', ...(ngDevMode ? [{
    debugName: "directionInput",
    alias: 'direction'
  }] : [{
    alias: 'direction'
  }]));
  direction = linkedSignal(...(ngDevMode ? [{
    debugName: "direction",
    source: this.directionInput,
    computation: value => value
  }] : [{
    source: this.directionInput,
    computation: value => value
  }]));
  /**
   * The amount of time to delay between automatically cycling an item. If false, carousel will not automatically cycle.
   * @return number
   * @default 0
   */
  intervalInput = input(-1, ...(ngDevMode ? [{
    debugName: "intervalInput",
    alias: 'interval',
    transform: numberAttribute
  }] : [{
    alias: 'interval',
    transform: numberAttribute
  }]));
  interval = linkedSignal(...(ngDevMode ? [{
    debugName: "interval",
    source: this.intervalInput,
    computation: value => value
  }] : [{
    source: this.intervalInput,
    computation: value => value
  }]));
  #intervalEffect = effect(() => {
    const interval = this.interval();
    this.#carouselState.state = {
      interval: interval
    };
    interval ? this.setTimer() : this.resetTimer();
  }, ...(ngDevMode ? [{
    debugName: "#intervalEffect"
  }] : []));
  /**
   * Sets which event handlers you’d like provided to your pause prop. You can specify one trigger or an array of them.
   * @return {'hover' | 'focus' | 'click'}
   */
  pause = input('hover', ...(ngDevMode ? [{
    debugName: "pause"
  }] : []));
  /**
   * Support left/right swipe interactions on touchscreen devices.
   * @return boolean
   * @default true
   */
  touch = input(true, ...(ngDevMode ? [{
    debugName: "touch"
  }] : []));
  /**
   * Set type of the transition.
   * @return {'slide' | 'crossfade'}
   * @default 'slide'
   */
  transition = input('slide', ...(ngDevMode ? [{
    debugName: "transition"
  }] : []));
  /**
   * Set whether the carousel should cycle continuously or have hard stops.
   * @return boolean
   * @default true
   */
  wrap = input(true, ...(ngDevMode ? [{
    debugName: "wrap"
  }] : []));
  /**
   * Event emitted on carousel item change. [docs]
   * @return number
   */
  itemChange = output();
  timerId;
  activeItemInterval = 0;
  swipeSubscription;
  #destroyRef = inject(DestroyRef);
  ngOnInit() {
    this.carouselStateSubscribe();
  }
  ngOnDestroy() {
    this.resetTimer();
    this.clearListeners();
    this.swipeSubscribe(false);
  }
  ngAfterContentInit() {
    this.intersectionServiceSubscribe();
    this.#carouselState.state = {
      activeItemIndex: this.activeIndex(),
      animate: this.animate(),
      interval: this.interval(),
      transition: this.transition()
    };
    this.setListeners();
    this.swipeSubscribe();
  }
  setListeners() {
    const config = {
      hostElement: this.#hostElement,
      trigger: this.pause() || [],
      callbackOff: () => {
        this.setTimer();
      },
      callbackOn: () => {
        this.resetTimer();
      }
    };
    this.#listenersService.setListeners(config);
  }
  clearListeners() {
    this.#listenersService.clearListeners();
  }
  set visible(value) {
    this.#visible = value;
  }
  get visible() {
    return this.#visible;
  }
  #visible = true;
  setTimer() {
    const interval = this.activeItemInterval || this.interval();
    const direction = this.direction();
    this.resetTimer();
    if (interval > 0) {
      this.timerId = setTimeout(() => {
        const nextIndex = this.#carouselState.direction(direction);
        this.#carouselState.state = {
          activeItemIndex: nextIndex
        };
      }, interval);
    }
  }
  resetTimer() {
    clearTimeout(this.timerId);
    this.timerId = undefined;
  }
  carouselStateSubscribe() {
    this.#carouselService.carouselIndex$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(nextItem => {
      if ('active' in nextItem && typeof nextItem.active === 'number') {
        this.itemChange?.emit(nextItem.active);
      }
      this.activeItemInterval = typeof nextItem.interval === 'number' && nextItem.interval > -1 ? nextItem.interval : this.interval();
      const direction = this.direction();
      const isLastItem = nextItem.active === nextItem.lastItemIndex && direction === 'next' || nextItem.active === 0 && direction === 'prev';
      !this.wrap() && isLastItem ? this.resetTimer() : this.setTimer();
    });
  }
  intersectionServiceSubscribe() {
    this.#intersectionService.createIntersectionObserver(this.#hostElement);
    this.#intersectionService.intersecting$.pipe(filter(next => next.hostElement === this.#hostElement), finalize(() => {
      this.#intersectionService.unobserve(this.#hostElement);
    }), takeUntilDestroyed(this.#destroyRef)).subscribe(next => {
      this.visible = next.isIntersecting;
      next.isIntersecting ? this.setTimer() : this.resetTimer();
    });
  }
  swipeSubscribe(subscribe = true) {
    if (this.touch() && subscribe) {
      const carouselElement = this.#hostElement.nativeElement;
      const touchStart$ = fromEvent(carouselElement, 'touchstart');
      const touchEnd$ = fromEvent(carouselElement, 'touchend');
      const touchMove$ = fromEvent(carouselElement, 'touchmove');
      this.swipeSubscription = touchStart$.pipe(zipWith(touchEnd$.pipe(withLatestFrom(touchMove$))), takeUntilDestroyed(this.#destroyRef)).subscribe(([touchstart, [touchend, touchmove]]) => {
        touchstart.stopPropagation();
        touchmove.stopPropagation();
        const distanceX = touchstart.touches[0]?.clientX - touchmove.touches[0]?.clientX || 0;
        if (Math.abs(distanceX) > 0.3 * carouselElement.clientWidth && touchstart.timeStamp <= touchmove.timeStamp) {
          const nextIndex = this.#carouselState.direction(distanceX > 0 ? 'next' : 'prev');
          this.#carouselState.state = {
            activeItemIndex: nextIndex
          };
        }
      });
    } else {
      this.swipeSubscription?.unsubscribe();
    }
  }
  static ɵfac = function CarouselComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CarouselComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CarouselComponent,
    selectors: [["c-carousel"]],
    hostAttrs: [1, "carousel", "slide"],
    hostVars: 2,
    hostBindings: function CarouselComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("carousel-fade", ctx.transition() === "crossfade" && ctx.animate());
      }
    },
    inputs: {
      activeIndexInput: [1, "activeIndex", "activeIndexInput"],
      animateInput: [1, "animate", "animateInput"],
      directionInput: [1, "direction", "directionInput"],
      intervalInput: [1, "interval", "intervalInput"],
      pause: [1, "pause"],
      touch: [1, "touch"],
      transition: [1, "transition"],
      wrap: [1, "wrap"]
    },
    outputs: {
      itemChange: "itemChange"
    },
    exportAs: ["cCarousel"],
    features: [i0.ɵɵProvidersFeature([CarouselService, CarouselState, ListenersService]), i0.ɵɵHostDirectivesFeature([{
      directive: ThemeDirective,
      inputs: ["dark", "dark"]
    }])],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CarouselComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel',
      template: '<ng-content />',
      providers: [CarouselService, CarouselState, ListenersService],
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['dark']
      }],
      exportAs: 'cCarousel',
      host: {
        class: 'carousel slide',
        '[class.carousel-fade]': 'transition() === "crossfade" && animate()'
      },
      styles: [":host{display:block}\n"]
    }]
  }], () => [], {
    activeIndexInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "activeIndex",
        required: false
      }]
    }],
    animateInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "animate",
        required: false
      }]
    }],
    directionInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "direction",
        required: false
      }]
    }],
    intervalInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "interval",
        required: false
      }]
    }],
    pause: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "pause",
        required: false
      }]
    }],
    touch: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "touch",
        required: false
      }]
    }],
    transition: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "transition",
        required: false
      }]
    }],
    wrap: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "wrap",
        required: false
      }]
    }],
    itemChange: [{
      type: i0.Output,
      args: ["itemChange"]
    }]
  });
})();
class CarouselCaptionComponent {
  static ɵfac = function CarouselCaptionComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CarouselCaptionComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CarouselCaptionComponent,
    selectors: [["c-carousel-caption"]],
    hostVars: 2,
    hostBindings: function CarouselCaptionComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("carousel-caption", true);
      }
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CarouselCaptionComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselCaptionComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel-caption',
      template: '<ng-content />',
      host: {
        '[class.carousel-caption]': 'true'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class CarouselControlComponent {
  #carouselState = inject(CarouselState);
  /**
   * Carousel control caption. [docs]
   * @return string
   */
  captionInput = input(undefined, ...(ngDevMode ? [{
    debugName: "captionInput",
    alias: 'caption'
  }] : [{
    alias: 'caption'
  }]));
  caption = linkedSignal(...(ngDevMode ? [{
    debugName: "caption",
    source: this.captionInput,
    computation: value => {
      return !!value ? value : this.direction() === 'prev' ? 'Previous' : 'Next';
    }
  }] : [{
    source: this.captionInput,
    computation: value => {
      return !!value ? value : this.direction() === 'prev' ? 'Previous' : 'Next';
    }
  }]));
  /**
   * Carousel control direction.
   * @return {'next' | 'prev'}
   */
  direction = input('next', ...(ngDevMode ? [{
    debugName: "direction"
  }] : []));
  /**
   * Carousel control role.
   * @return string
   */
  role = input('button', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  hostClasses = computed(() => {
    return `carousel-control-${this.direction()}`;
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  carouselControlIconClass = computed(() => {
    return `carousel-control-${this.direction()}-icon`;
  }, ...(ngDevMode ? [{
    debugName: "carouselControlIconClass"
  }] : []));
  onKeyUp($event) {
    if ($event.key === 'Enter') {
      this.#play();
    }
    if ($event.key === 'ArrowLeft') {
      this.#play('prev');
    }
    if ($event.key === 'ArrowRight') {
      this.#play('next');
    }
  }
  onClick($event) {
    this.#play();
  }
  #play(direction = this.direction()) {
    const nextIndex = this.#carouselState.direction(direction);
    this.#carouselState.state = {
      activeItemIndex: nextIndex
    };
  }
  static ɵfac = function CarouselControlComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CarouselControlComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CarouselControlComponent,
    selectors: [["c-carousel-control"]],
    hostVars: 3,
    hostBindings: function CarouselControlComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keyup", function CarouselControlComponent_keyup_HostBindingHandler($event) {
          return ctx.onKeyUp($event);
        })("click", function CarouselControlComponent_click_HostBindingHandler($event) {
          return ctx.onClick($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      captionInput: [1, "caption", "captionInput"],
      direction: [1, "direction"],
      role: [1, "role"]
    },
    exportAs: ["cCarouselControl"],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [[1, "visually-hidden"]],
    template: function CarouselControlComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0, 0, null, CarouselControlComponent_ProjectionFallback_0_Template, 3, 4);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselControlComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel-control',
      exportAs: 'cCarouselControl',
      host: {
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()',
        '(keyup)': 'onKeyUp($event)',
        '(click)': 'onClick($event)'
      },
      template: "<ng-content>\n  <span [attr.aria-hidden]=\"true\" [class]=\"carouselControlIconClass()\"></span>\n  <span class=\"visually-hidden\">{{ caption() }}</span>\n</ng-content>\n"
    }]
  }], null, {
    captionInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "caption",
        required: false
      }]
    }],
    direction: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "direction",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class CarouselIndicatorsComponent {
  #destroyRef = inject(DestroyRef);
  #carouselService = inject(CarouselService);
  #carouselState = inject(CarouselState);
  items = [];
  active = 0;
  contentTemplates = contentChildren(TemplateIdDirective, ...(ngDevMode ? [{
    debugName: "contentTemplates",
    descendants: true
  }] : [{
    descendants: true
  }]));
  templates = computed(() => {
    return this.contentTemplates().reduce((acc, child) => {
      acc[child.id] = child.templateRef;
      return acc;
    }, {});
  }, ...(ngDevMode ? [{
    debugName: "templates"
  }] : []));
  ngOnInit() {
    this.#carouselService.carouselIndex$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(nextIndex => {
      this.items = this.#carouselState?.state?.items?.map(item => item.index) ?? [];
      if ('active' in nextIndex) {
        this.active = nextIndex.active ?? 0;
      }
    });
  }
  onClick(index) {
    if (index !== this.active) {
      const direction = index < this.active ? 'prev' : 'next';
      this.#carouselState.state = {
        direction,
        activeItemIndex: index
      };
    }
  }
  static ɵfac = function CarouselIndicatorsComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CarouselIndicatorsComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CarouselIndicatorsComponent,
    selectors: [["c-carousel-indicators"]],
    contentQueries: function CarouselIndicatorsComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "carousel-indicators"],
    exportAs: ["cCarouselIndicators"],
    decls: 3,
    vars: 5,
    consts: [["defaultCarouselIndicatorsTemplate", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "button", 3, "class"], ["type", "button", 3, "click"]],
    template: function CarouselIndicatorsComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CarouselIndicatorsComponent_ng_container_0_Template, 1, 0, "ng-container", 1)(1, CarouselIndicatorsComponent_ng_template_1_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const defaultCarouselIndicatorsTemplate_r4 = i0.ɵɵreference(2);
        const tmpl_r5 = ctx.templates();
        i0.ɵɵproperty("ngTemplateOutlet", tmpl_r5["carouselIndicatorsTemplate"] || defaultCarouselIndicatorsTemplate_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c4, ctx.items, ctx.active));
      }
    },
    dependencies: [NgTemplateOutlet],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselIndicatorsComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel-indicators',
      exportAs: 'cCarouselIndicators',
      imports: [NgTemplateOutlet],
      host: {
        class: 'carousel-indicators'
      },
      template: "@let tmpl = templates();\n<ng-container *ngTemplateOutlet=\"tmpl['carouselIndicatorsTemplate'] || defaultCarouselIndicatorsTemplate; context: {$implicit: items, active: active}\" />\n\n<ng-template #defaultCarouselIndicatorsTemplate>\n  @for (item of items; track item; let i = $index) {\n    <button\n      [attr.data-coreui-target]=\"i\"\n      type=\"button\"\n      (click)=\"onClick(i)\"\n      [class]=\"{ active: active === i }\"\n      [attr.aria-current]=\"active === i\">\n    </button>\n  }\n</ng-template>\n"
    }]
  }], null, {
    contentTemplates: [{
      type: i0.ContentChildren,
      args: [i0.forwardRef(() => TemplateIdDirective), {
        ...{
          descendants: true
        },
        isSignal: true
      }]
    }]
  });
})();
class CarouselItemComponent {
  #destroyRef = inject(DestroyRef);
  #carouselService = inject(CarouselService);
  index;
  /**
   * @ignore
   */
  activeInput = input(false, ...(ngDevMode ? [{
    debugName: "activeInput",
    transform: booleanAttribute,
    alias: 'active'
  }] : [{
    transform: booleanAttribute,
    alias: 'active'
  }]));
  active = linkedSignal(...(ngDevMode ? [{
    debugName: "active",
    source: this.activeInput,
    computation: value => {
      return value;
    }
  }] : [{
    source: this.activeInput,
    computation: value => {
      return value;
    }
  }]));
  /**
   * Time delay before cycling to next item. If -1, uses carousel interval value.
   * @return number
   * @default -1
   */
  interval = input(-1, ...(ngDevMode ? [{
    debugName: "interval"
  }] : []));
  /**
   * Carousel item role.
   * @return string
   * @default 'group'
   */
  role = input('group', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  constructor() {
    this.#carouselService.carouselIndex$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(nextIndex => {
      if ('active' in nextIndex) {
        this.active.set(nextIndex.active === this.index);
      }
    });
  }
  static ɵfac = function CarouselItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CarouselItemComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CarouselItemComponent,
    selectors: [["c-carousel-item"]],
    hostAttrs: [1, "carousel-item"],
    hostVars: 3,
    hostBindings: function CarouselItemComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
        i0.ɵɵclassProp("active", ctx.active());
      }
    },
    inputs: {
      activeInput: [1, "active", "activeInput"],
      interval: [1, "interval"],
      role: [1, "role"]
    },
    exportAs: ["cCarouselItem"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 1,
    template: function CarouselItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵconditionalCreate(0, CarouselItemComponent_Conditional_0_Template, 1, 0);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.active() ? 0 : -1);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselItemComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel-item',
      exportAs: 'cCarouselItem',
      host: {
        class: 'carousel-item',
        '[class.active]': 'active()',
        '[attr.role]': 'role()'
      },
      template: "@if (active()) {\n  <ng-content />\n}\n",
      styles: [":host{display:block}\n"]
    }]
  }], () => [], {
    activeInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "active",
        required: false
      }]
    }],
    interval: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "interval",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
function toSlideLeft(fromState, toState) {
  return toState.left === true && toState.type === 'slide';
}
function toSlideRight(fromState, toState) {
  return toState.left === false && toState.type === 'slide';
}
function toFadeLeft(fromState, toState) {
  return toState.left === true && toState.type !== 'slide';
}
function toFadeRight(fromState, toState) {
  return toState.left === false && toState.type !== 'slide';
}
const slideAnimationLeft = animation(group([query(':leave', [animate('0.6s ease-in-out', style({
  transform: 'translateX(-100%)'
}))], {
  optional: true
}), query(':enter', [style({
  transform: 'translateX(100%)'
}), animate('0.6s ease-in-out', style('*'))], {
  optional: true
})]));
const slideAnimationRight = animation(group([query(':enter', [style({
  transform: 'translateX(-100%)'
}), animate('0.6s ease-in-out', style('*'))], {
  optional: true
}), query(':leave', [animate('0.6s ease-in-out', style({
  transform: 'translateX(100%)'
}))], {
  optional: true
})]));
const fadeAnimationLeft = animation(group([query(':leave', [animate('0.9s ease-in-out', style({
  zIndex: 0,
  opacity: 0
}))], {
  optional: true
}), query(':enter', [style({
  zIndex: 1,
  opacity: 1
}), animate('0.6s ease-in-out', style('*'))], {
  optional: true
})]));
const fadeAnimationRight = animation(group([query(':enter', [style({
  zIndex: 1,
  opacity: 1
}), animate('0.6s ease-in-out', style('*'))], {
  optional: true
}), query(':leave', [animate('0.9s ease-in-out', style({
  zIndex: 0,
  opacity: 0
}))], {
  optional: true
})]));
const carouselPlay = trigger('carouselPlay', [state('*', style({
  transform: 'translateX(0)',
  display: 'block',
  opacity: 1
})), transition(toFadeLeft, useAnimation(fadeAnimationLeft)), transition(toFadeRight, useAnimation(fadeAnimationRight)), transition(toSlideLeft, useAnimation(slideAnimationLeft)), transition(toSlideRight, useAnimation(slideAnimationRight))]);
class CarouselInnerComponent {
  #carouselState = inject(CarouselState);
  activeIndex = signal(undefined, ...(ngDevMode ? [{
    debugName: "activeIndex"
  }] : []));
  animate = signal(true, ...(ngDevMode ? [{
    debugName: "animate"
  }] : []));
  interval = signal(0, ...(ngDevMode ? [{
    debugName: "interval"
  }] : []));
  slide = signal({
    left: true
  }, ...(ngDevMode ? [{
    debugName: "slide"
  }] : []));
  transition = signal('crossfade', ...(ngDevMode ? [{
    debugName: "transition"
  }] : []));
  slideType = computed(() => {
    return {
      left: this.slide().left,
      type: this.transition()
    };
  }, ...(ngDevMode ? [{
    debugName: "slideType"
  }] : []));
  ariaLive = computed(() => {
    return this.interval() ? 'off' : 'polite';
  }, ...(ngDevMode ? [{
    debugName: "ariaLive"
  }] : []));
  contentItems = contentChildren(CarouselItemComponent, ...(ngDevMode ? [{
    debugName: "contentItems"
  }] : []));
  #prevContentItems = signal([], ...(ngDevMode ? [{
    debugName: "#prevContentItems"
  }] : []));
  ngAfterContentInit() {
    this.setItems();
  }
  ngAfterContentChecked() {
    this.setItems();
    const state = this.#carouselState?.state;
    const nextIndex = state?.activeItemIndex;
    const nextDirection = state?.direction;
    if (this.activeIndex() !== nextIndex) {
      this.animate.set(state?.animate ?? false);
      this.activeIndex.set(state?.activeItemIndex);
      this.interval.set(state?.interval ?? 0);
      this.slide.set({
        left: nextDirection === 'next'
      });
      this.transition.set(state?.transition ?? 'slide');
    }
  }
  setItems() {
    const contentItems = this.contentItems();
    if (this.#prevContentItems() !== contentItems) {
      this.#prevContentItems.set([...contentItems]);
      this.#carouselState.setItems(contentItems);
    }
  }
  static ɵfac = function CarouselInnerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CarouselInnerComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CarouselInnerComponent,
    selectors: [["c-carousel-inner"]],
    contentQueries: function CarouselInnerComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentItems, CarouselItemComponent, 4);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "carousel-inner"],
    hostVars: 3,
    hostBindings: function CarouselInnerComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵsyntheticHostProperty("@carouselPlay", ctx.slideType())("@.disabled", !ctx.animate());
        i0.ɵɵattribute("aria-live", ctx.ariaLive());
      }
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function CarouselInnerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"],
    data: {
      animation: [carouselPlay]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselInnerComponent, [{
    type: Component,
    args: [{
      selector: 'c-carousel-inner',
      animations: [carouselPlay],
      template: '<ng-content />',
      host: {
        class: 'carousel-inner',
        '[@carouselPlay]': 'slideType()',
        '[@.disabled]': '!animate()',
        '[attr.aria-live]': 'ariaLive()'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, {
    contentItems: [{
      type: i0.ContentChildren,
      args: [i0.forwardRef(() => CarouselItemComponent), {
        isSignal: true
      }]
    }]
  });
})();
class CarouselModule {
  static forRoot() {
    return {
      ngModule: CarouselModule,
      providers: []
    };
  }
  static ɵfac = function CarouselModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CarouselModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CarouselModule,
    imports: [CarouselComponent, CarouselCaptionComponent, CarouselControlComponent, CarouselIndicatorsComponent, CarouselInnerComponent, CarouselItemComponent],
    exports: [CarouselComponent, CarouselCaptionComponent, CarouselControlComponent, CarouselIndicatorsComponent, CarouselInnerComponent, CarouselItemComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [CarouselService, CarouselState, CarouselConfig]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselModule, [{
    type: NgModule,
    args: [{
      imports: [CarouselComponent, CarouselCaptionComponent, CarouselControlComponent, CarouselIndicatorsComponent, CarouselInnerComponent, CarouselItemComponent],
      providers: [CarouselService, CarouselState, CarouselConfig],
      exports: [CarouselComponent, CarouselCaptionComponent, CarouselControlComponent, CarouselIndicatorsComponent, CarouselInnerComponent, CarouselItemComponent]
    }]
  }], null, null);
})();
class DropdownDividerDirective {
  static ɵfac = function DropdownDividerDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownDividerDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropdownDividerDirective,
    selectors: [["", "cDropdownDivider", ""]],
    hostAttrs: [1, "dropdown-divider"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownDividerDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownDivider]',
      host: {
        class: 'dropdown-divider'
      }
    }]
  }], null, null);
})();
class DropdownHeaderDirective {
  static ɵfac = function DropdownHeaderDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownHeaderDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropdownHeaderDirective,
    selectors: [["", "cDropdownHeader", ""]],
    hostAttrs: [1, "dropdown-header"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownHeaderDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownHeader]',
      host: {
        class: 'dropdown-header'
      }
    }]
  }], null, null);
})();
class DropdownService {
  dropdownState = new BehaviorSubject({});
  dropdownState$ = this.dropdownState.asObservable();
  toggle(state) {
    this.dropdownState.next(state);
  }
  static ɵfac = function DropdownService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DropdownService,
    factory: DropdownService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownService, [{
    type: Injectable
  }], null, null);
})();
class DropdownMenuDirective {
  #destroyRef = inject(DestroyRef);
  elementRef = inject(ElementRef);
  #dropdownService = inject(DropdownService);
  #focusKeyManager;
  /**
   * Set alignment of dropdown menu.
   * @return 'start' | 'end'
   */
  alignment = input(...(ngDevMode ? [undefined, {
    debugName: "alignment"
  }] : []));
  /**
   * Toggle the visibility of dropdown menu component.
   * @return boolean
   */
  visibleInput = input(false, ...(ngDevMode ? [{
    debugName: "visibleInput",
    transform: booleanAttribute,
    alias: 'visible'
  }] : [{
    transform: booleanAttribute,
    alias: 'visible'
  }]));
  visible = linkedSignal(...(ngDevMode ? [{
    debugName: "visible",
    source: this.visibleInput,
    computation: value => value
  }] : [{
    source: this.visibleInput,
    computation: value => value
  }]));
  hostClasses = computed(() => {
    const alignment = this.alignment();
    const visible = this.visible();
    return {
      'dropdown-menu': true,
      [`dropdown-menu-${alignment}`]: !!alignment,
      show: visible
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  hostStyles = computed(() => {
    // workaround for popper position calculate (see also: dropdown.component)
    const visible = this.visible();
    return {
      visibility: visible ? null : '',
      display: visible ? null : ''
    };
  }, ...(ngDevMode ? [{
    debugName: "hostStyles"
  }] : []));
  onKeyDown($event) {
    if (!this.visible()) {
      return;
    }
    if (['Space', 'ArrowDown'].includes($event.code)) {
      $event.preventDefault();
    }
    this.#focusKeyManager.onKeydown($event);
  }
  onKeyUp($event) {
    if (!this.visible()) {
      return;
    }
    if (['Tab'].includes($event.key)) {
      if (this.#focusKeyManager.activeItem) {
        $event.shiftKey ? this.#focusKeyManager.setPreviousItemActive() : this.#focusKeyManager.setNextItemActive();
      } else {
        this.#focusKeyManager.setFirstItemActive();
      }
    }
  }
  dropdownItemsContent = contentChildren(forwardRef(() => DropdownItemDirective), ...(ngDevMode ? [{
    debugName: "dropdownItemsContent",
    descendants: true
  }] : [{
    descendants: true
  }]));
  items$ = toObservable(this.dropdownItemsContent);
  ngAfterContentInit() {
    this.focusKeyManagerInit();
    this.items$.pipe(tap(change => {
      this.focusKeyManagerInit();
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
  }
  ngOnInit() {
    this.#dropdownService.dropdownState$.pipe(tap(state => {
      if ('visible' in state) {
        this.visible.update(visible => state.visible === 'toggle' ? !visible : state.visible);
        if (!this.visible()) {
          this.#focusKeyManager?.setActiveItem(-1);
        }
      }
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
  }
  focusKeyManagerInit() {
    this.#focusKeyManager = new FocusKeyManager(this.dropdownItemsContent()).withHomeAndEnd().withPageUpDown().withWrap().skipPredicate(dropdownItem => dropdownItem.disabled === true);
  }
  static ɵfac = function DropdownMenuDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownMenuDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropdownMenuDirective,
    selectors: [["", "cDropdownMenu", ""]],
    contentQueries: function DropdownMenuDirective_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.dropdownItemsContent, DropdownItemDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "dropdown-menu"],
    hostVars: 4,
    hostBindings: function DropdownMenuDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown", function DropdownMenuDirective_keydown_HostBindingHandler($event) {
          return ctx.onKeyDown($event);
        })("keyup", function DropdownMenuDirective_keyup_HostBindingHandler($event) {
          return ctx.onKeyUp($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵstyleMap(ctx.hostStyles());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      alignment: [1, "alignment"],
      visibleInput: [1, "visible", "visibleInput"]
    },
    exportAs: ["cDropdownMenu"],
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: ThemeDirective,
      inputs: ["dark", "dark"]
    }])]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownMenuDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownMenu]',
      exportAs: 'cDropdownMenu',
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['dark']
      }],
      host: {
        class: 'dropdown-menu',
        '[class]': 'hostClasses()',
        '[style]': 'hostStyles()',
        '(keydown)': 'onKeyDown($event)',
        '(keyup)': 'onKeyUp($event)'
      }
    }]
  }], null, {
    alignment: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "alignment",
        required: false
      }]
    }],
    visibleInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    dropdownItemsContent: [{
      type: i0.ContentChildren,
      args: [forwardRef(() => DropdownItemDirective), {
        ...{
          descendants: true
        },
        isSignal: true
      }]
    }]
  });
})();

// lightweight injection token
class DropdownToken {}
class DropdownToggleDirective {
  // injections
  #destroyRef = inject(DestroyRef);
  elementRef = inject(ElementRef);
  #dropdownService = inject(DropdownService);
  dropdown = inject(DropdownToken, {
    optional: true
  });
  /**
   * Reference to dropdown component.
   * @return DropdownComponent | undefined
   * @default undefined
   */
  dropdownComponent = input(...(ngDevMode ? [undefined, {
    debugName: "dropdownComponent"
  }] : []));
  /**
   * Disables the toggler.
   * @return boolean
   * @default false
   */
  disabled = input(false, ...(ngDevMode ? [{
    debugName: "disabled",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Enables pseudo element caret on toggler.
   * @return boolean
   */
  caret = input(true, ...(ngDevMode ? [{
    debugName: "caret"
  }] : []));
  /**
   * Create split button dropdowns with virtually the same markup as single button dropdowns,
   * but with the addition of `.dropdown-toggle-split` class for proper spacing around the dropdown caret.
   * @return boolean
   * @default false
   */
  split = input(false, ...(ngDevMode ? [{
    debugName: "split",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  hostClasses = computed(() => {
    return {
      'dropdown-toggle': this.caret(),
      'dropdown-toggle-split': this.split(),
      disabled: this.disabled()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  #ariaExpanded = signal(false, ...(ngDevMode ? [{
    debugName: "#ariaExpanded"
  }] : []));
  get ariaExpanded() {
    return this.#ariaExpanded();
  }
  onClick($event) {
    $event.preventDefault();
    !this.disabled() && this.#dropdownService.toggle({
      visible: 'toggle',
      dropdown: this.dropdown
    });
  }
  ngAfterViewInit() {
    const dropdownComponent = this.dropdownComponent();
    if (dropdownComponent) {
      this.dropdown = dropdownComponent;
      this.#dropdownService = dropdownComponent?.dropdownService;
    }
    if (this.dropdown) {
      const dropdown = this.dropdown;
      dropdown?.visibleChange?.subscribe(visible => {
        this.#ariaExpanded.set(visible);
      });
    }
  }
  static ɵfac = function DropdownToggleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownToggleDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropdownToggleDirective,
    selectors: [["", "cDropdownToggle", ""]],
    hostVars: 3,
    hostBindings: function DropdownToggleDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function DropdownToggleDirective_click_HostBindingHandler($event) {
          return ctx.onClick($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("aria-expanded", ctx.ariaExpanded);
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      dropdownComponent: [1, "dropdownComponent"],
      disabled: [1, "disabled"],
      caret: [1, "caret"],
      split: [1, "split"]
    },
    exportAs: ["cDropdownToggle"],
    features: [i0.ɵɵProvidersFeature([{
      provide: DropdownToken,
      useExisting: forwardRef(() => DropdownComponent)
    }])]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownToggleDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownToggle]',
      providers: [{
        provide: DropdownToken,
        useExisting: forwardRef(() => DropdownComponent)
      }],
      exportAs: 'cDropdownToggle',
      host: {
        '[class]': 'hostClasses()',
        '[attr.aria-expanded]': 'ariaExpanded',
        '(click)': 'onClick($event)'
      }
    }]
  }], null, {
    dropdownComponent: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "dropdownComponent",
        required: false
      }]
    }],
    disabled: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "disabled",
        required: false
      }]
    }],
    caret: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "caret",
        required: false
      }]
    }],
    split: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "split",
        required: false
      }]
    }]
  });
})();
class DropdownComponent {
  #destroyRef = inject(DestroyRef);
  #document = inject(DOCUMENT);
  #elementRef = inject(ElementRef);
  #renderer = inject(Renderer2);
  #ngZone = inject(NgZone);
  #changeDetectorRef = inject(ChangeDetectorRef);
  dropdownService = inject(DropdownService);
  constructor() {
    this.dropdownStateSubscribe();
  }
  /**
   * Set alignment of dropdown menu.
   * @return {'start' | 'end' | { xs: 'start' | 'end' } | { sm: 'start' | 'end' } | { md: 'start' | 'end' } | { lg: 'start' | 'end' } | { xl: 'start' | 'end'} | { xxl: 'start' | 'end'}}
   */
  alignment = input(...(ngDevMode ? [undefined, {
    debugName: "alignment"
  }] : []));
  /**
   * Automatically close dropdown when clicking outside the dropdown menu.
   */
  autoClose = input(true, ...(ngDevMode ? [{
    debugName: "autoClose"
  }] : []));
  /**
   * Sets a specified  direction and location of the dropdown menu.
   * @return 'dropup' | 'dropend' | 'dropstart'
   */
  direction = input(...(ngDevMode ? [undefined, {
    debugName: "direction"
  }] : []));
  /**
   * Describes the placement of your component after Popper.js has applied all the modifiers
   * that may have flipped or altered the originally provided placement property.
   * @return Placement
   */
  placement = input('bottom-start', ...(ngDevMode ? [{
    debugName: "placement"
  }] : []));
  /**
   * If you want to disable dynamic positioning set this property to `false`.
   * @return boolean
   * @default true
   */
  popper = input(true, ...(ngDevMode ? [{
    debugName: "popper",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Optional popper Options object, placement prop takes precedence over
   * @return Partial<Options>
   */
  popperOptionsInput = input({}, ...(ngDevMode ? [{
    debugName: "popperOptionsInput",
    alias: 'popperOptions'
  }] : [{
    alias: 'popperOptions'
  }]));
  #popperOptionsEffect = effect(() => {
    this.popperOptions = {
      ...untracked(this.#popperOptions),
      ...this.popperOptionsInput()
    };
  }, ...(ngDevMode ? [{
    debugName: "#popperOptionsEffect"
  }] : []));
  set popperOptions(value) {
    this.#popperOptions.update(popperOptions => ({
      ...popperOptions,
      ...value
    }));
  }
  get popperOptions() {
    let placement = this.placement();
    switch (this.direction()) {
      case 'dropup':
        {
          placement = 'top-start';
          break;
        }
      case 'dropend':
        {
          placement = 'right-start';
          break;
        }
      case 'dropstart':
        {
          placement = 'left-start';
          break;
        }
      case 'center':
        {
          placement = 'bottom';
          break;
        }
      case 'dropup-center':
        {
          placement = 'top';
          break;
        }
    }
    if (this.alignment() === 'end') {
      placement = 'bottom-end';
    }
    this.#popperOptions.update(value => ({
      ...value,
      placement: placement
    }));
    return this.#popperOptions();
  }
  #popperOptions = signal({
    placement: this.placement(),
    modifiers: [],
    strategy: 'absolute'
  }, ...(ngDevMode ? [{
    debugName: "#popperOptions"
  }] : []));
  /**
   * Set the dropdown variant to a btn-group, dropdown, input-group, and nav-item.
   */
  variant = input('dropdown', ...(ngDevMode ? [{
    debugName: "variant"
  }] : []));
  /**
   * Toggle the visibility of dropdown menu component.
   * @return boolean
   * @default false
   */
  visibleInput = input(false, ...(ngDevMode ? [{
    debugName: "visibleInput",
    transform: booleanAttribute,
    alias: 'visible'
  }] : [{
    transform: booleanAttribute,
    alias: 'visible'
  }]));
  visible = linkedSignal(...(ngDevMode ? [{
    debugName: "visible",
    source: this.visibleInput,
    computation: value => value
  }] : [{
    source: this.visibleInput,
    computation: value => value
  }]));
  #visibleEffect = effect(() => {
    const visible = this.visible();
    this.activeTrap = visible;
    visible ? this.createPopperInstance() : this.destroyPopperInstance();
    this.setVisibleState(visible);
    this.visibleChange?.emit(visible);
  }, ...(ngDevMode ? [{
    debugName: "#visibleEffect"
  }] : []));
  visibleChange = output();
  dropdownContext = {
    $implicit: this.visible()
  };
  _toggler = contentChild(DropdownToggleDirective, ...(ngDevMode ? [{
    debugName: "_toggler"
  }] : []));
  _menu = contentChild(DropdownMenuDirective, ...(ngDevMode ? [{
    debugName: "_menu"
  }] : []));
  _menuElementRef = contentChild(DropdownMenuDirective, ...(ngDevMode ? [{
    debugName: "_menuElementRef",
    read: ElementRef
  }] : [{
    read: ElementRef
  }]));
  activeTrap = false;
  popperInstance;
  listeners = [];
  hostClasses = computed(() => {
    const direction = this.direction();
    const variant = this.variant();
    return {
      dropdown: (variant === 'dropdown' || variant === 'nav-item') && !direction,
      [`${direction}`]: !!direction,
      [`${variant}`]: !!variant,
      dropup: direction === 'dropup' || direction === 'dropup-center',
      show: this.visible()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  // todo: find better solution
  hostStyle = computed(() => {
    return this.variant() === 'input-group' ? {
      display: 'contents'
    } : {};
  }, ...(ngDevMode ? [{
    debugName: "hostStyle"
  }] : []));
  clickedTarget;
  onHostClick($event) {
    this.clickedTarget = $event.target;
  }
  dropdownStateSubscribe() {
    this.dropdownService.dropdownState$.pipe(filter(state => {
      return this === state.dropdown;
    }), takeUntilDestroyed(this.#destroyRef)).subscribe(state => {
      if ('visible' in state) {
        state?.visible === 'toggle' ? this.toggleDropdown() : this.visible.set(state.visible);
      }
    });
  }
  toggleDropdown() {
    this.visible.update(visible => !visible);
  }
  onClick(event) {
    if (!this._toggler()?.elementRef.nativeElement.contains(event.target?.closest('[cDropdownToggle]'))) {
      this.toggleDropdown();
    }
  }
  #togglerEffect = effect(() => {
    const variant = this.variant();
    const _toggler = this._toggler();
    if (variant === 'nav-item' && _toggler) {
      this.#renderer.addClass(_toggler.elementRef.nativeElement, 'nav-link');
    }
  }, ...(ngDevMode ? [{
    debugName: "#togglerEffect"
  }] : []));
  ngOnInit() {
    this.setVisibleState(this.visible());
  }
  ngOnDestroy() {
    this.clearListeners();
    this.destroyPopperInstance();
  }
  setVisibleState(value) {
    this.dropdownService.toggle({
      visible: value,
      dropdown: this
    });
  }
  // todo: turn off popper in navbar-nav
  createPopperInstance() {
    const _toggler = this._toggler();
    const _menu = this._menu();
    if (_toggler && _menu) {
      this.#ngZone.runOutsideAngular(() => {
        // workaround for popper position calculate (see also: dropdown-menu.component)
        _menu.elementRef.nativeElement.style.visibility = 'hidden';
        _menu.elementRef.nativeElement.style.display = 'block';
        if (this.popper()) {
          this.popperInstance = createPopper(_toggler.elementRef.nativeElement, _menu.elementRef.nativeElement, {
            ...this.popperOptions
          });
        }
        this.#ngZone.run(() => {
          this.setListeners();
          this.#changeDetectorRef.markForCheck();
          this.#changeDetectorRef.detectChanges();
        });
      });
    }
  }
  destroyPopperInstance() {
    this.clearListeners();
    this.popperInstance?.destroy();
    this.popperInstance = undefined;
    this.#changeDetectorRef.markForCheck();
  }
  setListeners() {
    this.listeners.push(this.#renderer.listen(this.#document, 'click', event => {
      const target = event.target;
      if (this._menuElementRef()?.nativeElement.contains(event.target)) {
        this.clickedTarget = target;
      }
      if (this._toggler()?.elementRef.nativeElement.contains(event.target)) {
        return;
      }
      const autoClose = this.autoClose();
      if (autoClose === true) {
        this.setVisibleState(false);
        return;
      }
      if (this.clickedTarget === target && autoClose === 'inside') {
        this.setVisibleState(false);
        return;
      }
      if (this.clickedTarget !== target && autoClose === 'outside') {
        this.setVisibleState(false);
        return;
      }
    }));
    this.listeners.push(this.#renderer.listen(this.#elementRef.nativeElement, 'keyup', event => {
      if (event.key === 'Escape' && this.autoClose() !== false) {
        event.stopPropagation();
        this.setVisibleState(false);
        return;
      }
    }));
    this.listeners.push(this.#renderer.listen(this.#document, 'keyup', event => {
      if (event.key === 'Tab' && this.autoClose() !== false && !this.#elementRef.nativeElement.contains(event.target)) {
        this.setVisibleState(false);
        return;
      }
    }));
  }
  clearListeners() {
    this.listeners.forEach(unListen => {
      unListen();
    });
    // @ts-ignore
    this.listeners.fill(undefined);
    this.listeners = [];
  }
  static ɵfac = function DropdownComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DropdownComponent,
    selectors: [["c-dropdown"]],
    contentQueries: function DropdownComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx._toggler, DropdownToggleDirective, 5);
        i0.ɵɵcontentQuerySignal(dirIndex, ctx._menu, DropdownMenuDirective, 5);
        i0.ɵɵcontentQuerySignal(dirIndex, ctx._menuElementRef, DropdownMenuDirective, 5, ElementRef);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance(3);
      }
    },
    hostVars: 4,
    hostBindings: function DropdownComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function DropdownComponent_click_HostBindingHandler($event) {
          return ctx.onHostClick($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵstyleMap(ctx.hostStyle());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      alignment: [1, "alignment"],
      autoClose: [1, "autoClose"],
      direction: [1, "direction"],
      placement: [1, "placement"],
      popper: [1, "popper"],
      popperOptionsInput: [1, "popperOptions", "popperOptionsInput"],
      variant: [1, "variant"],
      visibleInput: [1, "visible", "visibleInput"]
    },
    outputs: {
      visibleChange: "visibleChange"
    },
    exportAs: ["cDropdown"],
    features: [i0.ɵɵProvidersFeature([DropdownService]), i0.ɵɵHostDirectivesFeature([{
      directive: ThemeDirective,
      inputs: ["dark", "dark"]
    }])],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function DropdownComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [".dropdown[_nghost-%COMP%]:not(.btn-group), .dropdown   [_nghost-%COMP%]:not(.btn-group), .dropup[_nghost-%COMP%]:not(.btn-group), .dropup   [_nghost-%COMP%]:not(.btn-group){display:block}.dropstart[_nghost-%COMP%]:not(.btn-group), .dropstart   [_nghost-%COMP%]:not(.btn-group), .dropend[_nghost-%COMP%]:not(.btn-group), .dropend   [_nghost-%COMP%]:not(.btn-group){display:inline-flex}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:first-child  :first-child, html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:first-child  :first-child, .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:first-child  :first-child{border-top-right-radius:0;border-bottom-right-radius:0}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu), html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu), .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu):not(:only-of-type), html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu):not(:only-of-type), .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu):not(:only-of-type){border-top-right-radius:0;border-bottom-right-radius:0}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:last-child  :first-child, html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:last-child  :first-child, .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:last-child  :first-child{border-top-left-radius:0;border-bottom-left-radius:0}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:last-child  :first-child:not(:only-of-type), html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:last-child  :first-child:not(:only-of-type), .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:last-child  :first-child:not(:only-of-type){border-top-right-radius:0;border-bottom-right-radius:0}html:not([dir=rtl]).input-group   [_nghost-%COMP%]:last-child  :not(:first-child):not(.dropdown-menu), html:not([dir=rtl])   .input-group   [_nghost-%COMP%]:last-child  :not(:first-child):not(.dropdown-menu), .input-group   html:not([dir=rtl])   [_nghost-%COMP%]:last-child  :not(:first-child):not(.dropdown-menu){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]{direction:rtl}[dir=rtl]   .input-group   [_nghost-%COMP%]:first-child  :first-child{border-top-left-radius:0;border-bottom-left-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]:first-child  :not(:first-child):not(.dropdown-menu):not(:only-of-type){border-top-left-radius:0;border-bottom-left-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]:last-child  :first-child{border-top-right-radius:0;border-bottom-right-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]:last-child  :first-child:not(:only-of-type){border-top-left-radius:0;border-bottom-left-radius:0}[dir=rtl]   .input-group   [_nghost-%COMP%]:last-child  :not(:first-child):not(.dropdown-menu){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownComponent, [{
    type: Component,
    args: [{
      selector: 'c-dropdown',
      template: '<ng-content />',
      exportAs: 'cDropdown',
      providers: [DropdownService],
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['dark']
      }],
      host: {
        '[class]': 'hostClasses()',
        '[style]': 'hostStyle()',
        '(click)': 'onHostClick($event)'
      },
      styles: [":host-context(.dropdown,.dropup):not(.btn-group){display:block}:host-context(.dropstart,.dropend):not(.btn-group){display:inline-flex}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:first-child::ng-deep :first-child{border-top-right-radius:0;border-bottom-right-radius:0}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:first-child::ng-deep :not(:first-child):not(.dropdown-menu){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:first-child::ng-deep :not(:first-child):not(.dropdown-menu):not(:only-of-type){border-top-right-radius:0;border-bottom-right-radius:0}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:last-child::ng-deep :first-child{border-top-left-radius:0;border-bottom-left-radius:0}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:last-child::ng-deep :first-child:not(:only-of-type){border-top-right-radius:0;border-bottom-right-radius:0}:host-context(html:not([dir=rtl])) :host-context(.input-group) :host:last-child::ng-deep :not(:first-child):not(.dropdown-menu){margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl] .input-group) :host{direction:rtl}:host-context([dir=rtl] .input-group) :host:first-child::ng-deep :first-child{border-top-left-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl] .input-group) :host:first-child::ng-deep :not(:first-child):not(.dropdown-menu){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}:host-context([dir=rtl] .input-group) :host:first-child::ng-deep :not(:first-child):not(.dropdown-menu):not(:only-of-type){border-top-left-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl] .input-group) :host:last-child::ng-deep :first-child{border-top-right-radius:0;border-bottom-right-radius:0}:host-context([dir=rtl] .input-group) :host:last-child::ng-deep :first-child:not(:only-of-type){border-top-left-radius:0;border-bottom-left-radius:0}:host-context([dir=rtl] .input-group) :host:last-child::ng-deep :not(:first-child):not(.dropdown-menu){margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0}\n"]
    }]
  }], () => [], {
    alignment: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "alignment",
        required: false
      }]
    }],
    autoClose: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "autoClose",
        required: false
      }]
    }],
    direction: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "direction",
        required: false
      }]
    }],
    placement: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "placement",
        required: false
      }]
    }],
    popper: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "popper",
        required: false
      }]
    }],
    popperOptionsInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "popperOptions",
        required: false
      }]
    }],
    variant: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "variant",
        required: false
      }]
    }],
    visibleInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    visibleChange: [{
      type: i0.Output,
      args: ["visibleChange"]
    }],
    _toggler: [{
      type: i0.ContentChild,
      args: [i0.forwardRef(() => DropdownToggleDirective), {
        isSignal: true
      }]
    }],
    _menu: [{
      type: i0.ContentChild,
      args: [i0.forwardRef(() => DropdownMenuDirective), {
        isSignal: true
      }]
    }],
    _menuElementRef: [{
      type: i0.ContentChild,
      args: [i0.forwardRef(() => DropdownMenuDirective), {
        ...{
          read: ElementRef
        },
        isSignal: true
      }]
    }]
  });
})();
class DropdownItemDirective {
  #elementRef = inject(ElementRef);
  #dropdownService = inject(DropdownService);
  dropdown = inject(DropdownComponent, {
    optional: true
  });
  /**
   * Set active state to a dropdown-item.
   * @return boolean
   * @default undefined
   */
  active = input(...(ngDevMode ? [undefined, {
    debugName: "active"
  }] : []));
  /**
   * Configure dropdown-item close dropdown behavior.
   * @return boolean
   * @default true
   */
  autoClose = input(true, ...(ngDevMode ? [{
    debugName: "autoClose"
  }] : []));
  /**
   * Disables a dropdown-item.
   * @return boolean
   * @default undefined
   */
  disabledInput = input(false, ...(ngDevMode ? [{
    debugName: "disabledInput",
    transform: booleanAttribute,
    alias: 'disabled'
  }] : [{
    transform: booleanAttribute,
    alias: 'disabled'
  }]));
  #disabled = linkedSignal(...(ngDevMode ? [{
    debugName: "#disabled",
    source: this.disabledInput,
    computation: value => value
  }] : [{
    source: this.disabledInput,
    computation: value => value
  }]));
  set disabled(value) {
    this.#disabled.set(value);
  }
  get disabled() {
    return this.#disabled();
  }
  role = input('list-item', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  tabIndexInput = input('0', ...(ngDevMode ? [{
    debugName: "tabIndexInput",
    alias: 'tabIndex'
  }] : [{
    alias: 'tabIndex'
  }]));
  tabIndex = linkedSignal(...(ngDevMode ? [{
    debugName: "tabIndex",
    source: this.tabIndexInput,
    computation: value => this.disabled ? '-1' : value
  }] : [{
    source: this.tabIndexInput,
    computation: value => this.disabled ? '-1' : value
  }]));
  focus(origin) {
    this.#elementRef?.nativeElement?.focus();
  }
  getLabel() {
    return this.#elementRef?.nativeElement?.textContent.trim();
  }
  ariaCurrent = computed(() => {
    return this.active() ? 'true' : null;
  }, ...(ngDevMode ? [{
    debugName: "ariaCurrent"
  }] : []));
  hostClasses = computed(() => {
    return {
      'dropdown-item': true,
      active: this.active(),
      disabled: this.disabled
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  onClick($event) {
    this.handleInteraction();
  }
  onKeyUp($event) {
    if ($event.key === 'Enter') {
      this.handleInteraction();
    }
  }
  handleInteraction() {
    if (this.autoClose()) {
      this.#dropdownService.toggle({
        visible: 'toggle',
        dropdown: this.dropdown
      });
    }
  }
  static ɵfac = function DropdownItemDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownItemDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropdownItemDirective,
    selectors: [["", "cDropdownItem", ""]],
    hostAttrs: [1, "dropdown-item"],
    hostVars: 6,
    hostBindings: function DropdownItemDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function DropdownItemDirective_click_HostBindingHandler($event) {
          return ctx.onClick($event);
        })("keyup", function DropdownItemDirective_keyup_HostBindingHandler($event) {
          return ctx.onKeyUp($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("tabindex", ctx.tabIndex())("aria-current", ctx.ariaCurrent())("aria-disabled", ctx.disabled || null)("role", ctx.role());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      active: [1, "active"],
      autoClose: [1, "autoClose"],
      disabledInput: [1, "disabled", "disabledInput"],
      role: [1, "role"],
      tabIndexInput: [1, "tabIndex", "tabIndexInput"]
    },
    exportAs: ["cDropdownItem"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownItemDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownItem]',
      exportAs: 'cDropdownItem',
      host: {
        class: 'dropdown-item',
        '[class]': 'hostClasses()',
        '[attr.tabindex]': 'tabIndex()',
        '[attr.aria-current]': 'ariaCurrent()',
        '[attr.aria-disabled]': 'disabled || null',
        '[attr.role]': 'role()',
        '(click)': 'onClick($event)',
        '(keyup)': 'onKeyUp($event)'
      }
    }]
  }], null, {
    active: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "active",
        required: false
      }]
    }],
    autoClose: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "autoClose",
        required: false
      }]
    }],
    disabledInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "disabled",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }],
    tabIndexInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "tabIndex",
        required: false
      }]
    }]
  });
})();
class DropdownItemPlainDirective {
  static ɵfac = function DropdownItemPlainDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownItemPlainDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropdownItemPlainDirective,
    selectors: [["", "cDropdownItemPlain", ""]],
    hostAttrs: [1, "dropdown-item-text"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownItemPlainDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownItemPlain]',
      host: {
        class: 'dropdown-item-text'
      }
    }]
  }], null, null);
})();
class DropdownCloseDirective {
  #dropdownService = inject(DropdownService);
  dropdown = inject(DropdownComponent, {
    optional: true
  });
  /**
   * Disables a dropdown-close directive.
   * @return boolean
   * @default false
   */
  disabledInput = input(false, ...(ngDevMode ? [{
    debugName: "disabledInput",
    transform: booleanAttribute,
    alias: 'disabled'
  }] : [{
    transform: booleanAttribute,
    alias: 'disabled'
  }]));
  disabled = linkedSignal(...(ngDevMode ? [{
    debugName: "disabled",
    source: this.disabledInput,
    computation: value => value || null
  }] : [{
    source: this.disabledInput,
    computation: value => value || null
  }]));
  dropdownComponent = input(...(ngDevMode ? [undefined, {
    debugName: "dropdownComponent"
  }] : []));
  ngAfterViewInit() {
    const dropdownComponent = this.dropdownComponent();
    if (dropdownComponent) {
      this.dropdown = dropdownComponent;
      this.#dropdownService = dropdownComponent?.dropdownService;
    }
  }
  tabIndexInput = input(null, ...(ngDevMode ? [{
    debugName: "tabIndexInput",
    alias: 'tabIndex'
  }] : [{
    alias: 'tabIndex'
  }]));
  tabIndex = linkedSignal(...(ngDevMode ? [{
    debugName: "tabIndex",
    source: this.tabIndexInput,
    computation: value => this.disabled() ? '-1' : value
  }] : [{
    source: this.tabIndexInput,
    computation: value => this.disabled() ? '-1' : value
  }]));
  onClick($event) {
    this.handleToggle();
  }
  onKeyUp($event) {
    if ($event.key === 'Enter') {
      this.handleToggle();
    }
  }
  handleToggle() {
    if (!this.disabled()) {
      this.#dropdownService.toggle({
        visible: false,
        dropdown: this.dropdown
      });
    }
  }
  static ɵfac = function DropdownCloseDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownCloseDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropdownCloseDirective,
    selectors: [["", "cDropdownClose", ""]],
    hostVars: 4,
    hostBindings: function DropdownCloseDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function DropdownCloseDirective_click_HostBindingHandler($event) {
          return ctx.onClick($event);
        })("keyup", function DropdownCloseDirective_keyup_HostBindingHandler($event) {
          return ctx.onKeyUp($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("aria-disabled", ctx.disabled() || null)("tabindex", ctx.tabIndex());
        i0.ɵɵclassProp("disabled", ctx.disabled());
      }
    },
    inputs: {
      disabledInput: [1, "disabled", "disabledInput"],
      dropdownComponent: [1, "dropdownComponent"],
      tabIndexInput: [1, "tabIndex", "tabIndexInput"]
    },
    exportAs: ["cDropdownClose"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownCloseDirective, [{
    type: Directive,
    args: [{
      selector: '[cDropdownClose]',
      exportAs: 'cDropdownClose',
      host: {
        '[class.disabled]': 'disabled()',
        '[attr.aria-disabled]': 'disabled() || null',
        '[attr.tabindex]': 'tabIndex()',
        '(click)': 'onClick($event)',
        '(keyup)': 'onKeyUp($event)'
      }
    }]
  }], null, {
    disabledInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "disabled",
        required: false
      }]
    }],
    dropdownComponent: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "dropdownComponent",
        required: false
      }]
    }],
    tabIndexInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "tabIndex",
        required: false
      }]
    }]
  });
})();
class DropdownModule {
  static ɵfac = function DropdownModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropdownModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DropdownModule,
    imports: [DropdownComponent, DropdownCloseDirective, DropdownDividerDirective, DropdownHeaderDirective, DropdownItemDirective, DropdownItemPlainDirective, DropdownMenuDirective, DropdownToggleDirective],
    exports: [DropdownComponent, DropdownCloseDirective, DropdownDividerDirective, DropdownHeaderDirective, DropdownItemDirective, DropdownItemPlainDirective, DropdownMenuDirective, DropdownToggleDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [DropdownService]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownModule, [{
    type: NgModule,
    args: [{
      imports: [DropdownComponent, DropdownCloseDirective, DropdownDividerDirective, DropdownHeaderDirective, DropdownItemDirective, DropdownItemPlainDirective, DropdownMenuDirective, DropdownToggleDirective],
      exports: [DropdownComponent, DropdownCloseDirective, DropdownDividerDirective, DropdownHeaderDirective, DropdownItemDirective, DropdownItemPlainDirective, DropdownMenuDirective, DropdownToggleDirective],
      providers: [DropdownService]
    }]
  }], null, null);
})();
class FooterComponent {
  /**
   * Place footer in non-static positions. [docs]
   * @type Positions
   */
  position = input(...(ngDevMode ? [undefined, {
    debugName: "position"
  }] : []));
  /**
   * Default role for footer. [docs]
   * @return string
   * @default 'contentinfo'
   */
  role = input('contentinfo', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  hostClasses = computed(() => {
    const position = this.position();
    return {
      footer: true,
      [`footer-${position}`]: !!position
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function FooterComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FooterComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FooterComponent,
    selectors: [["c-footer"], ["", "cFooter", ""]],
    hostAttrs: [1, "footer"],
    hostVars: 3,
    hostBindings: function FooterComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      position: [1, "position"],
      role: [1, "role"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function FooterComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterComponent, [{
    type: Component,
    args: [{
      selector: 'c-footer, [cFooter]',
      template: '<ng-content />',
      host: {
        class: 'footer',
        '[class]': 'hostClasses()',
        '[attr.role]': 'role()'
      }
    }]
  }], null, {
    position: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "position",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class FooterModule {
  static ɵfac = function FooterModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FooterModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: FooterModule,
    imports: [FooterComponent],
    exports: [FooterComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterModule, [{
    type: NgModule,
    args: [{
      imports: [FooterComponent],
      exports: [FooterComponent]
    }]
  }], null, null);
})();
class FormDirective {
  /**
   * Mark a form as validated. If you set it `true`, all validation styles will be applied to the form. [docs]
   * @return boolean
   * @default false
   */
  validated = input(false, ...(ngDevMode ? [{
    debugName: "validated",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  static ɵfac = function FormDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormDirective,
    selectors: [["form", "cForm", ""]],
    hostVars: 2,
    hostBindings: function FormDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("was-validated", ctx.validated());
      }
    },
    inputs: {
      validated: [1, "validated"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormDirective, [{
    type: Directive,
    args: [{
      selector: 'form[cForm]',
      host: {
        '[class.was-validated]': 'validated()'
      }
    }]
  }], null, {
    validated: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "validated",
        required: false
      }]
    }]
  });
})();
class FormCheckLabelDirective {
  static ɵfac = function FormCheckLabelDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormCheckLabelDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormCheckLabelDirective,
    selectors: [["label", "cFormCheckLabel", ""]],
    hostAttrs: [1, "form-check-label"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormCheckLabelDirective, [{
    type: Directive,
    args: [{
      selector: 'label[cFormCheckLabel]',
      host: {
        class: 'form-check-label'
      }
    }]
  }], null, null);
})();
class FormCheckComponent {
  static ngAcceptInputType_inline;
  static ngAcceptInputType_reverse;
  static ngAcceptInputType_switch;
  /**
   * Group checkboxes or radios on the same horizontal row.
   * @default false
   */
  inline = input(false, ...(ngDevMode ? [{
    debugName: "inline",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Put checkboxes or radios on the opposite side.
   * @default false
   * @since 4.4.7
   */
  reverse = input(false, ...(ngDevMode ? [{
    debugName: "reverse",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Size the component large or extra large. Works only with `[switch]="true"` [docs]
   * @default undefined
   */
  sizing = input(...(ngDevMode ? [undefined, {
    debugName: "sizing"
  }] : []));
  /**
   * Render a toggle switch on for checkbox.
   * @returns boolean
   * @default false
   */
  switch = input(false, ...(ngDevMode ? [{
    debugName: "switch",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  formCheckLabel = contentChild(FormCheckLabelDirective, ...(ngDevMode ? [{
    debugName: "formCheckLabel"
  }] : []));
  hostClasses = computed(() => {
    const sizing = this.sizing();
    const isSwitch = this.switch();
    return {
      'form-check': !!this.formCheckLabel(),
      'form-switch': isSwitch,
      [`form-switch-${sizing}`]: isSwitch && !!sizing,
      'form-check-inline': this.inline(),
      'form-check-reverse': this.reverse()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function FormCheckComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormCheckComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FormCheckComponent,
    selectors: [["c-form-check"]],
    contentQueries: function FormCheckComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.formCheckLabel, FormCheckLabelDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 2,
    hostBindings: function FormCheckComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      inline: [1, "inline"],
      reverse: [1, "reverse"],
      sizing: [1, "sizing"],
      switch: [1, "switch"]
    },
    exportAs: ["cFormCheck"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function FormCheckComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormCheckComponent, [{
    type: Component,
    args: [{
      selector: 'c-form-check',
      template: '<ng-content />',
      exportAs: 'cFormCheck',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    inline: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "inline",
        required: false
      }]
    }],
    reverse: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "reverse",
        required: false
      }]
    }],
    sizing: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "sizing",
        required: false
      }]
    }],
    switch: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "switch",
        required: false
      }]
    }],
    formCheckLabel: [{
      type: i0.ContentChild,
      args: [i0.forwardRef(() => FormCheckLabelDirective), {
        isSignal: true
      }]
    }]
  });
})();
class FormControlDirective {
  #hostElement = inject(ElementRef);
  /**
   * Size the component small or large.
   * @default undefined
   */
  sizing = input(...(ngDevMode ? [undefined, {
    debugName: "sizing"
  }] : []));
  /**
   * Set component validation state to valid.
   * @default undefined
   */
  valid = input(...(ngDevMode ? [undefined, {
    debugName: "valid"
  }] : []));
  /**
   * Specifies the type of input element.
   */
  type = input('text', ...(ngDevMode ? [{
    debugName: "type"
  }] : []));
  /**
   * Render the component styled as plain text. Removes the default form field styling and preserve the correct margin and padding. Recommend to use alongside `readonly`
   * @default false
   */
  plaintext = input(false, ...(ngDevMode ? [{
    debugName: "plaintext",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  hostClasses = computed(() => {
    const type = this.type();
    const isRange = type === 'range';
    const plaintext = this.plaintext();
    const sizing = this.sizing();
    const valid = this.valid();
    return {
      'form-control': !isRange && !plaintext,
      'form-control-plaintext': !isRange && plaintext,
      'form-control-color': type === 'color',
      'form-range': isRange,
      [`form-control-${sizing}`]: !!sizing && !isRange,
      'is-valid': valid === true,
      'is-invalid': valid === false
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  get hostTag() {
    return this.#hostElement.nativeElement.tagName;
  }
  ngOnInit() {
    const hostTag = this.hostTag.toLowerCase();
    if (hostTag !== 'input' && hostTag !== 'textarea') {
      console.warn(`CoreUI [cFormControl] works with '<input>' and '<textarea>' - not with '<${hostTag}>'`);
    }
  }
  static ɵfac = function FormControlDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormControlDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormControlDirective,
    selectors: [["input", "cFormControl", ""], ["textarea", "cFormControl", ""]],
    hostVars: 3,
    hostBindings: function FormControlDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("type", ctx.type());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      sizing: [1, "sizing"],
      valid: [1, "valid"],
      type: [1, "type"],
      plaintext: [1, "plaintext"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormControlDirective, [{
    type: Directive,
    args: [{
      selector: 'input[cFormControl], textarea[cFormControl]',
      host: {
        '[class]': 'hostClasses()',
        '[attr.type]': 'type()'
      }
    }]
  }], null, {
    sizing: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "sizing",
        required: false
      }]
    }],
    valid: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "valid",
        required: false
      }]
    }],
    type: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "type",
        required: false
      }]
    }],
    plaintext: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "plaintext",
        required: false
      }]
    }]
  });
})();
class FormCheckInputDirective {
  static ngAcceptInputType_indeterminate;
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  /**
   * Specifies the type of component.
   * @default 'checkbox'
   */
  type = input('checkbox', ...(ngDevMode ? [{
    debugName: "type"
  }] : []));
  /**
   * Set component indeterminate state.
   * @default false
   */
  indeterminateInput = input(false, ...(ngDevMode ? [{
    debugName: "indeterminateInput",
    transform: booleanAttribute,
    alias: 'indeterminate'
  }] : [{
    transform: booleanAttribute,
    alias: 'indeterminate'
  }]));
  #indeterminate = linkedSignal(this.indeterminateInput, ...(ngDevMode ? [{
    debugName: "#indeterminate"
  }] : []));
  #indeterminateEffect = effect(() => {
    if (this.type() === 'checkbox') {
      const indeterminate = this.#indeterminate();
      const htmlInputElement = this.#hostElement.nativeElement;
      if (indeterminate) {
        this.#renderer.setProperty(htmlInputElement, 'checked', false);
      }
      this.#renderer.setProperty(htmlInputElement, 'indeterminate', indeterminate);
    }
  }, ...(ngDevMode ? [{
    debugName: "#indeterminateEffect"
  }] : []));
  get indeterminate() {
    return this.#indeterminate();
  }
  /**
   * Set component validation state to valid.
   * @default undefined
   */
  valid = input(...(ngDevMode ? [undefined, {
    debugName: "valid"
  }] : []));
  hostClasses = computed(() => {
    const valid = this.valid();
    return {
      'form-check-input': true,
      'is-valid': valid === true,
      'is-invalid': valid === false
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  get checked() {
    return this.#hostElement?.nativeElement?.checked;
  }
  static ɵfac = function FormCheckInputDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormCheckInputDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormCheckInputDirective,
    selectors: [["input", "cFormCheckInput", ""]],
    hostAttrs: [1, "form-check-input"],
    hostVars: 3,
    hostBindings: function FormCheckInputDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("type", ctx.type());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      type: [1, "type"],
      indeterminateInput: [1, "indeterminate", "indeterminateInput"],
      valid: [1, "valid"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormCheckInputDirective, [{
    type: Directive,
    args: [{
      selector: 'input[cFormCheckInput]',
      host: {
        class: 'form-check-input',
        '[class]': 'hostClasses()',
        '[attr.type]': 'type()'
      }
    }]
  }], null, {
    type: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "type",
        required: false
      }]
    }],
    indeterminateInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "indeterminate",
        required: false
      }]
    }],
    valid: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "valid",
        required: false
      }]
    }]
  });
})();
class FormFeedbackComponent {
  /**
   * If your form layout allows it, you can display validation feedback in a styled tooltip.
   * @default false
   */
  tooltip = input(false, ...(ngDevMode ? [{
    debugName: "tooltip",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Set component validation state to valid.
   * @default undefined
   */
  valid = input(...(ngDevMode ? [undefined, {
    debugName: "valid"
  }] : []));
  hostClasses = computed(() => {
    const status = this.valid() === true ? 'valid' : 'invalid';
    const type = this.tooltip() ? 'tooltip' : 'feedback';
    return {
      [`${status}-${type}`]: true
      // 'valid-feedback': valid === true && !tooltip,
      // 'valid-tooltip': valid === true && tooltip,
      // 'invalid-feedback': valid !== true && !tooltip,
      // 'invalid-tooltip': valid !== true && tooltip
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function FormFeedbackComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormFeedbackComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: FormFeedbackComponent,
    selectors: [["c-form-feedback"]],
    hostVars: 2,
    hostBindings: function FormFeedbackComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      tooltip: [1, "tooltip"],
      valid: [1, "valid"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function FormFeedbackComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFeedbackComponent, [{
    type: Component,
    args: [{
      selector: 'c-form-feedback',
      template: '<ng-content />',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    tooltip: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "tooltip",
        required: false
      }]
    }],
    valid: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "valid",
        required: false
      }]
    }]
  });
})();
class FormFloatingDirective {
  /**
   * Enable floating labels
   * @dafault boolean
   */
  floating = input(true, ...(ngDevMode ? [{
    debugName: "floating",
    transform: booleanAttribute,
    alias: 'cFormFloating'
  }] : [{
    transform: booleanAttribute,
    alias: 'cFormFloating'
  }]));
  static ɵfac = function FormFloatingDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormFloatingDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormFloatingDirective,
    selectors: [["", "cFormFloating", ""]],
    hostVars: 2,
    hostBindings: function FormFloatingDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("form-floating", ctx.floating());
      }
    },
    inputs: {
      floating: [1, "cFormFloating", "floating"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFloatingDirective, [{
    type: Directive,
    args: [{
      selector: '[cFormFloating]',
      host: {
        '[class.form-floating]': 'floating()'
      }
    }]
  }], null, {
    floating: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cFormFloating",
        required: false
      }]
    }]
  });
})();
class FormLabelDirective {
  /**
   * For horizontal forms set labels to 'col' and make them vertically centered with their associated form controls.
   * @default ''
   */
  col = input('', ...(ngDevMode ? [{
    debugName: "col",
    alias: 'cLabel'
  }] : [{
    alias: 'cLabel'
  }]));
  /**
   * Size the label small or large.
   * @default ''
   */
  sizing = input(...(ngDevMode ? [undefined, {
    debugName: "sizing"
  }] : []));
  hostClasses = computed(() => {
    const col = this.col();
    const sizing = this.sizing();
    return {
      'form-label': true,
      'col-form-label': col === 'col',
      [`col-form-label-${sizing}`]: !!sizing && col === 'col'
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function FormLabelDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormLabelDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormLabelDirective,
    selectors: [["", "cLabel", ""]],
    hostAttrs: [1, "form-label"],
    hostVars: 2,
    hostBindings: function FormLabelDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      col: [1, "cLabel", "col"],
      sizing: [1, "sizing"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormLabelDirective, [{
    type: Directive,
    args: [{
      selector: '[cLabel]',
      host: {
        class: 'form-label',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    col: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cLabel",
        required: false
      }]
    }],
    sizing: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "sizing",
        required: false
      }]
    }]
  });
})();
class FormSelectDirective {
  /**
   * Size the component small or large.
   * @default undefined
   */
  sizing = input(...(ngDevMode ? [undefined, {
    debugName: "sizing"
  }] : []));
  /**
   * Set component validation state to valid.
   * @default undefined
   */
  valid = input(...(ngDevMode ? [undefined, {
    debugName: "valid"
  }] : []));
  hostClasses = computed(() => {
    const sizing = this.sizing();
    const valid = this.valid();
    return {
      'form-select': true,
      [`form-select-${sizing}`]: !!sizing,
      'is-valid': valid === true,
      'is-invalid': valid === false
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function FormSelectDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormSelectDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormSelectDirective,
    selectors: [["select", "cSelect", ""]],
    hostAttrs: [1, "form-select"],
    hostVars: 2,
    hostBindings: function FormSelectDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      sizing: [1, "sizing"],
      valid: [1, "valid"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormSelectDirective, [{
    type: Directive,
    args: [{
      selector: 'select[cSelect]',
      host: {
        class: 'form-select',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    sizing: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "sizing",
        required: false
      }]
    }],
    valid: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "valid",
        required: false
      }]
    }]
  });
})();
class FormTextDirective {
  static ɵfac = function FormTextDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormTextDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FormTextDirective,
    selectors: [["", "cFormText", ""]],
    hostAttrs: [1, "form-text"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormTextDirective, [{
    type: Directive,
    args: [{
      selector: '[cFormText]',
      host: {
        class: 'form-text'
      }
    }]
  }], null, null);
})();
class InputGroupComponent {
  /**
   * Size the component small or large.
   */
  sizing = input(...(ngDevMode ? [undefined, {
    debugName: "sizing"
  }] : []));
  hostClasses = computed(() => {
    const sizing = this.sizing();
    return {
      'input-group': true,
      [`input-group-${sizing}`]: !!sizing
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function InputGroupComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InputGroupComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: InputGroupComponent,
    selectors: [["c-input-group"]],
    hostAttrs: [1, "input-group"],
    hostVars: 2,
    hostBindings: function InputGroupComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      sizing: [1, "sizing"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function InputGroupComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InputGroupComponent, [{
    type: Component,
    args: [{
      selector: 'c-input-group',
      template: '<ng-content />',
      host: {
        class: 'input-group',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    sizing: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "sizing",
        required: false
      }]
    }]
  });
})();
class InputGroupTextDirective {
  static ɵfac = function InputGroupTextDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InputGroupTextDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: InputGroupTextDirective,
    selectors: [["", "cInputGroupText", ""]],
    hostAttrs: [1, "input-group-text"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InputGroupTextDirective, [{
    type: Directive,
    args: [{
      selector: '[cInputGroupText]',
      host: {
        class: 'input-group-text'
      }
    }]
  }], null, null);
})();
class FormModule {
  static ɵfac = function FormModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FormModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: FormModule,
    imports: [FormDirective, FormCheckComponent, FormCheckLabelDirective, FormCheckInputDirective, FormControlDirective, FormFeedbackComponent, FormFloatingDirective, FormLabelDirective, FormSelectDirective, FormTextDirective, InputGroupComponent, InputGroupTextDirective],
    exports: [FormDirective, FormCheckComponent, FormCheckLabelDirective, FormCheckInputDirective, FormControlDirective, FormFeedbackComponent, FormFloatingDirective, FormLabelDirective, FormSelectDirective, FormTextDirective, InputGroupComponent, InputGroupTextDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormModule, [{
    type: NgModule,
    args: [{
      imports: [FormDirective, FormCheckComponent, FormCheckLabelDirective, FormCheckInputDirective, FormControlDirective, FormFeedbackComponent, FormFloatingDirective, FormLabelDirective, FormSelectDirective, FormTextDirective, InputGroupComponent, InputGroupTextDirective],
      exports: [FormDirective, FormCheckComponent, FormCheckLabelDirective, FormCheckInputDirective, FormControlDirective, FormFeedbackComponent, FormFloatingDirective, FormLabelDirective, FormSelectDirective, FormTextDirective, InputGroupComponent, InputGroupTextDirective]
    }]
  }], null, null);
})();
class ContainerComponent {
  /**
   * Set container 100% wide until a breakpoint.
   */
  breakpoint = input('', ...(ngDevMode ? [{
    debugName: "breakpoint"
  }] : []));
  /**
   * Set container 100% wide, spanning the entire width of the viewport.
   * @return boolean
   */
  fluid = input(false, ...(ngDevMode ? [{
    debugName: "fluid",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  hostClasses = computed(() => {
    const breakpoint = this.breakpoint();
    const fluid = this.fluid();
    return {
      container: !fluid && !breakpoint,
      'container-fluid': !!fluid,
      [`container-${breakpoint}`]: !!breakpoint
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function ContainerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ContainerComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ContainerComponent,
    selectors: [["c-container"], ["", "cContainer", ""]],
    hostVars: 2,
    hostBindings: function ContainerComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      breakpoint: [1, "breakpoint"],
      fluid: [1, "fluid"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ContainerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContainerComponent, [{
    type: Component,
    args: [{
      selector: 'c-container, [cContainer]',
      template: '<ng-content />',
      host: {
        '[class]': 'hostClasses()'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, {
    breakpoint: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "breakpoint",
        required: false
      }]
    }],
    fluid: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "fluid",
        required: false
      }]
    }]
  });
})();
class ColDirective {
  static ngAcceptInputType_cCol;
  static ngAcceptInputType_xs;
  static ngAcceptInputType_sm;
  static ngAcceptInputType_md;
  static ngAcceptInputType_lg;
  static ngAcceptInputType_xl;
  static ngAcceptInputType_xxl;
  /**
   * The number of columns/offset/order on extra small devices (<576px).
   * @return { 'auto' | number |  boolean }
   */
  cCol = input(false, ...(ngDevMode ? [{
    debugName: "cCol",
    transform: this.coerceInput
  }] : [{
    transform: this.coerceInput
  }]));
  xs = input(false, ...(ngDevMode ? [{
    debugName: "xs",
    transform: this.coerceInput
  }] : [{
    transform: this.coerceInput
  }]));
  /**
   * The number of columns/offset/order on small devices (<768px).
   * @return { 'auto' | number |  boolean }
   */
  sm = input(false, ...(ngDevMode ? [{
    debugName: "sm",
    transform: this.coerceInput
  }] : [{
    transform: this.coerceInput
  }]));
  /**
   * The number of columns/offset/order on medium devices (<992px).
   * @return { 'auto' | number |  boolean }
   */
  md = input(false, ...(ngDevMode ? [{
    debugName: "md",
    transform: this.coerceInput
  }] : [{
    transform: this.coerceInput
  }]));
  /**
   * The number of columns/offset/order on large devices (<1200px).
   * @return { 'auto' | number |  boolean }
   */
  lg = input(false, ...(ngDevMode ? [{
    debugName: "lg",
    transform: this.coerceInput
  }] : [{
    transform: this.coerceInput
  }]));
  /**
   * The number of columns/offset/order on X-Large devices (<1400px).
   * @return { 'auto' | number |  boolean }
   */
  xl = input(false, ...(ngDevMode ? [{
    debugName: "xl",
    transform: this.coerceInput
  }] : [{
    transform: this.coerceInput
  }]));
  /**
   * The number of columns/offset/order on XX-Large devices (≥1400px).
   * @return { 'auto' | number |  boolean }
   */
  xxl = input(false, ...(ngDevMode ? [{
    debugName: "xxl",
    transform: this.coerceInput
  }] : [{
    transform: this.coerceInput
  }]));
  breakpoints = computed(() => {
    return {
      xs: this.xs() || this.cCol(),
      sm: this.sm(),
      md: this.md(),
      lg: this.lg(),
      xl: this.xl(),
      xxl: this.xxl()
    };
  }, ...(ngDevMode ? [{
    debugName: "breakpoints"
  }] : []));
  offset = input(...(ngDevMode ? [undefined, {
    debugName: "offset"
  }] : []));
  order = input(...(ngDevMode ? [undefined, {
    debugName: "order"
  }] : []));
  hostClasses = computed(() => {
    const classes = {
      col: true
    };
    const breakpoints = this.breakpoints();
    const offsetInput = this.offset();
    const orderInput = this.order();
    Object.keys(BreakpointInfix).forEach(breakpoint => {
      const value = breakpoints[breakpoint];
      const infix = breakpoint === 'xs' ? '' : `-${breakpoint}`;
      classes[`col${infix}`] = value === true;
      classes[`col${infix}-${value}`] = typeof value === 'number' || typeof value === 'string';
    });
    if (typeof offsetInput === 'object') {
      const offset = {
        ...offsetInput
      };
      Object.entries(offset).forEach(entry => {
        const [breakpoint, value] = [...entry];
        const infix = breakpoint === 'xs' ? '' : `-${breakpoint}`;
        classes[`offset${infix}-${value}`] = value >= 0 && value <= 11;
      });
    } else {
      const offset = numberAttribute(offsetInput);
      classes[`offset-${offset}`] = typeof offset === 'number' && offset > 0 && offset <= 11;
    }
    if (typeof orderInput === 'object') {
      const order = {
        ...orderInput
      };
      Object.entries(order).forEach(entry => {
        const [breakpoint, value] = [...entry];
        const infix = breakpoint === 'xs' ? '' : `-${breakpoint}`;
        classes[`order${infix}-${value}`] = !!value;
      });
    } else {
      const order = orderInput;
      classes[`order-${order}`] = !!order;
    }
    // if there is no 'col' class, add one
    classes['col'] = !Object.entries(classes).filter(i => i[0].startsWith('col-') && i[1]).length || breakpoints['xs'] === true;
    return classes;
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  coerceInput(value) {
    if (value === 'auto') {
      return value;
    }
    if (value === '' || value === undefined || value === null) {
      return booleanAttribute(value);
    }
    if (typeof value === 'boolean') {
      return value;
    }
    return numberAttribute(value);
  }
  static ɵfac = function ColDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ColDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ColDirective,
    selectors: [["", "cCol", ""]],
    hostVars: 2,
    hostBindings: function ColDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      cCol: [1, "cCol"],
      xs: [1, "xs"],
      sm: [1, "sm"],
      md: [1, "md"],
      lg: [1, "lg"],
      xl: [1, "xl"],
      xxl: [1, "xxl"],
      offset: [1, "offset"],
      order: [1, "order"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColDirective, [{
    type: Directive,
    args: [{
      selector: '[cCol]',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    cCol: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cCol",
        required: false
      }]
    }],
    xs: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "xs",
        required: false
      }]
    }],
    sm: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "sm",
        required: false
      }]
    }],
    md: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "md",
        required: false
      }]
    }],
    lg: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "lg",
        required: false
      }]
    }],
    xl: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "xl",
        required: false
      }]
    }],
    xxl: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "xxl",
        required: false
      }]
    }],
    offset: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "offset",
        required: false
      }]
    }],
    order: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "order",
        required: false
      }]
    }]
  });
})();
class ColComponent extends ColDirective {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵColComponent_BaseFactory;
    return function ColComponent_Factory(__ngFactoryType__) {
      return (ɵColComponent_BaseFactory || (ɵColComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ColComponent)))(__ngFactoryType__ || ColComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ColComponent,
    selectors: [["c-col"]],
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ColComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColComponent, [{
    type: Component,
    args: [{
      selector: 'c-col',
      template: '<ng-content />',
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class RowDirective {
  /**
   * The number of columns/offset/order on extra small devices (<576px).
   * @return { cols: 'auto' | number }
   */
  xs = input(...(ngDevMode ? [undefined, {
    debugName: "xs"
  }] : []));
  /**
   * The number of columns/offset/order on small devices (<768px).
   * @return { cols: 'auto' | number }
   */
  sm = input(...(ngDevMode ? [undefined, {
    debugName: "sm"
  }] : []));
  /**
   * The number of columns/offset/order on medium devices (<992px).
   * @return { cols: 'auto' | number }
   */
  md = input(...(ngDevMode ? [undefined, {
    debugName: "md"
  }] : []));
  /**
   * The number of columns/offset/order on large devices (<1200px).
   * @return { cols: 'auto' | number }
   */
  lg = input(...(ngDevMode ? [undefined, {
    debugName: "lg"
  }] : []));
  /**
   * The number of columns/offset/order on X-Large devices (<1400px).
   * @return { cols: 'auto' | number }
   */
  xl = input(...(ngDevMode ? [undefined, {
    debugName: "xl"
  }] : []));
  /**
   * The number of columns/offset/order on XX-Large devices (≥1400px).
   * @return { cols: 'auto' | number }
   */
  xxl = input(...(ngDevMode ? [undefined, {
    debugName: "xxl"
  }] : []));
  hostClasses = computed(() => {
    const cols = this.xs();
    const classes = {
      row: true,
      [`row-cols-${cols}`]: !!cols
    };
    Object.keys(BreakpointInfix).forEach(breakpoint => {
      // @ts-ignore
      const value = this[breakpoint]();
      if (typeof value === 'number' || typeof value === 'string') {
        const infix = breakpoint === 'xs' ? '' : `-${breakpoint}`;
        classes[`row-cols${infix}-${value}`] = !!value;
      }
    });
    return classes;
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function RowDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RowDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: RowDirective,
    selectors: [["", "cRow", ""]],
    hostAttrs: [1, "row"],
    hostVars: 2,
    hostBindings: function RowDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      xs: [1, "xs"],
      sm: [1, "sm"],
      md: [1, "md"],
      lg: [1, "lg"],
      xl: [1, "xl"],
      xxl: [1, "xxl"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RowDirective, [{
    type: Directive,
    args: [{
      selector: '[cRow]',
      host: {
        class: 'row',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    xs: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "xs",
        required: false
      }]
    }],
    sm: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "sm",
        required: false
      }]
    }],
    md: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "md",
        required: false
      }]
    }],
    lg: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "lg",
        required: false
      }]
    }],
    xl: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "xl",
        required: false
      }]
    }],
    xxl: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "xxl",
        required: false
      }]
    }]
  });
})();
class RowComponent extends RowDirective {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵRowComponent_BaseFactory;
    return function RowComponent_Factory(__ngFactoryType__) {
      return (ɵRowComponent_BaseFactory || (ɵRowComponent_BaseFactory = i0.ɵɵgetInheritedFactory(RowComponent)))(__ngFactoryType__ || RowComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: RowComponent,
    selectors: [["c-row"]],
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function RowComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RowComponent, [{
    type: Component,
    args: [{
      selector: 'c-row',
      template: '<ng-content />'
    }]
  }], null, null);
})();
class GutterDirective {
  /**
   * Define padding between columns to space and align content responsively in the Bootstrap grid system.
   */
  gutter = input({}, ...(ngDevMode ? [{
    debugName: "gutter"
  }] : []));
  hostClasses = computed(() => {
    let gutterClass;
    const gutterInput = this.gutter();
    if (typeof gutterInput === 'number') {
      gutterClass = GutterDirective.getGutterClasses({
        g: gutterInput
      });
      return gutterClass;
    }
    {
      const {
        g,
        gx,
        gy
      } = {
        ...gutterInput
      };
      gutterClass = GutterDirective.getGutterClasses({
        g,
        gx,
        gy
      });
    }
    Object.keys(BreakpointInfix).forEach(key => {
      // @ts-ignore
      const gutter = gutterInput[key] ? {
        ...gutterInput[key]
      } : undefined;
      if (gutter) {
        const classes = GutterDirective.getGutterClasses(gutter, key);
        gutterClass = {
          ...gutterClass,
          ...classes
        };
      }
    });
    return gutterClass;
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static getGutterClasses(gutter, breakpoint) {
    const {
      g,
      gx,
      gy
    } = {
      ...gutter
    };
    const infix = breakpoint ? `-${breakpoint}` : '';
    return {
      [`g${infix}-${g}`]: typeof g === 'number',
      [`gx${infix}-${gx}`]: typeof gx === 'number',
      [`gy${infix}-${gy}`]: typeof gy === 'number'
    };
  }
  static ɵfac = function GutterDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GutterDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: GutterDirective,
    selectors: [["", "gutter", ""]],
    hostVars: 2,
    hostBindings: function GutterDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      gutter: [1, "gutter"]
    },
    exportAs: ["gutter"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GutterDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[gutter]',
      exportAs: 'gutter',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    gutter: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "gutter",
        required: false
      }]
    }]
  });
})();
class GridModule {
  static ɵfac = function GridModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GridModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: GridModule,
    imports: [ColComponent, ColDirective, ContainerComponent, GutterDirective, RowComponent, RowDirective],
    exports: [ColComponent, ColDirective, ContainerComponent, GutterDirective, RowComponent, RowDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GridModule, [{
    type: NgModule,
    args: [{
      imports: [ColComponent, ColDirective, ContainerComponent, GutterDirective, RowComponent, RowDirective],
      exports: [ColComponent, ColDirective, ContainerComponent, GutterDirective, RowComponent, RowDirective]
    }]
  }], null, null);
})();
class HeaderComponent {
  /**
   * Defines optional container wrapping children elements.
   */
  container = input(...(ngDevMode ? [undefined, {
    debugName: "container"
  }] : []));
  /**
   * Place header in non-static positions.
   */
  position = input(...(ngDevMode ? [undefined, {
    debugName: "position"
  }] : []));
  /**
   * Default role for header. [docs]
   * @type string
   * @default 'banner'
   */
  role = input('banner', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  hostClasses = computed(() => {
    return !!this.container() ? this.containerClasses() : this.headerClasses();
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  headerClasses = computed(() => {
    const position = this.position();
    return {
      header: true,
      [`header-${position}`]: !!position
    };
  }, ...(ngDevMode ? [{
    debugName: "headerClasses"
  }] : []));
  containerClasses = computed(() => {
    const container = this.container();
    return {
      container: container === true,
      [`container-${container}`]: typeof container === 'string'
    };
  }, ...(ngDevMode ? [{
    debugName: "containerClasses"
  }] : []));
  static ɵfac = function HeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderComponent,
    selectors: [["c-header"], ["", "c-header", ""]],
    hostVars: 3,
    hostBindings: function HeaderComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      container: [1, "container"],
      position: [1, "position"],
      role: [1, "role"]
    },
    exportAs: ["cHeader"],
    ngContentSelectors: _c2,
    decls: 2,
    vars: 1,
    consts: [[3, "ngClass"]],
    template: function HeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c2);
        i0.ɵɵconditionalCreate(0, HeaderComponent_Conditional_0_Template, 2, 1, "div", 0)(1, HeaderComponent_Conditional_1_Template, 1, 0);
      }
      if (rf & 2) {
        i0.ɵɵconditional(!!ctx.container() ? 0 : 1);
      }
    },
    dependencies: [NgClass],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-header, [c-header]',
      imports: [NgClass],
      exportAs: 'cHeader',
      host: {
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()'
      },
      template: "@if (!!container()) {\n  <div [ngClass]=\"headerClasses()\">\n    <ng-content />\n  </div>\n} @else {\n  <ng-content />\n}\n"
    }]
  }], null, {
    container: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "container",
        required: false
      }]
    }],
    position: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "position",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class HeaderBrandComponent {
  /**
   * Default role for header-brand. [docs]
   * @return string
   * @default 'button'
   */
  role = input('button', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  static ɵfac = function HeaderBrandComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderBrandComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderBrandComponent,
    selectors: [["c-header-brand"]],
    hostAttrs: [1, "header-brand"],
    hostVars: 1,
    hostBindings: function HeaderBrandComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
      }
    },
    inputs: {
      role: [1, "role"]
    },
    exportAs: ["cHeaderBrand"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function HeaderBrandComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderBrandComponent, [{
    type: Component,
    args: [{
      selector: 'c-header-brand',
      template: '<ng-content />',
      exportAs: 'cHeaderBrand',
      host: {
        '[attr.role]': 'role()',
        class: 'header-brand'
      }
    }]
  }], null, {
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class HeaderDividerComponent {
  static ɵfac = function HeaderDividerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderDividerComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderDividerComponent,
    selectors: [["c-header-divider"], ["", "cHeaderDivider", ""]],
    hostAttrs: [1, "header-divider"],
    decls: 0,
    vars: 0,
    template: function HeaderDividerComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderDividerComponent, [{
    type: Component,
    args: [{
      selector: 'c-header-divider, [cHeaderDivider]',
      template: ``,
      host: {
        class: 'header-divider'
      }
    }]
  }], null, null);
})();
class HeaderNavComponent {
  /**
   * Default role for header-nav. [docs]
   * @return string
   * @default 'navigation'
   */
  role = input('navigation', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  static ɵfac = function HeaderNavComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderNavComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderNavComponent,
    selectors: [["c-header-nav"]],
    hostAttrs: [1, "header-nav"],
    hostVars: 1,
    hostBindings: function HeaderNavComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
      }
    },
    inputs: {
      role: [1, "role"]
    },
    exportAs: ["cHeaderNav"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function HeaderNavComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderNavComponent, [{
    type: Component,
    args: [{
      selector: 'c-header-nav',
      template: '<ng-content />',
      exportAs: 'cHeaderNav',
      host: {
        '[attr.role]': 'role()',
        class: 'header-nav'
      }
    }]
  }], null, {
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class HeaderTextComponent {
  static ɵfac = function HeaderTextComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderTextComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: HeaderTextComponent,
    selectors: [["c-header-text"], ["", "cHeaderText", ""]],
    hostAttrs: [1, "header-text"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function HeaderTextComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderTextComponent, [{
    type: Component,
    args: [{
      selector: 'c-header-text, [cHeaderText]',
      template: '<ng-content />',
      host: {
        class: 'header-text'
      }
    }]
  }], null, null);
})();
class HeaderTogglerDirective {
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  /**
   * Default type for header-toggler button. [docs]
   * @return string
   * @default 'button'
   */
  type = input('button', ...(ngDevMode ? [{
    debugName: "type"
  }] : []));
  /**
   * Default aria-label attr for header-toggler. [docs]
   * @type string
   * @default 'Toggle navigation'
   */
  ariaLabel = input('Toggle navigation', ...(ngDevMode ? [{
    debugName: "ariaLabel"
  }] : []));
  addDefaultIcon() {
    const span = this.#renderer.createElement('span');
    this.#renderer.addClass(span, 'header-toggler-icon');
    this.#renderer.appendChild(this.#hostElement.nativeElement, span);
  }
  ngAfterContentInit() {
    const hasContent = this.#hostElement.nativeElement.childNodes.length > 0;
    if (!hasContent) {
      this.addDefaultIcon();
    }
  }
  static ɵfac = function HeaderTogglerDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderTogglerDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: HeaderTogglerDirective,
    selectors: [["", "cHeaderToggler", ""]],
    hostAttrs: [1, "header-toggler"],
    hostVars: 2,
    hostBindings: function HeaderTogglerDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("type", ctx.type())("aria-label", ctx.ariaLabel());
      }
    },
    inputs: {
      type: [1, "type"],
      ariaLabel: [1, "ariaLabel"]
    },
    exportAs: ["cHeaderToggler"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderTogglerDirective, [{
    type: Directive,
    args: [{
      selector: '[cHeaderToggler]',
      exportAs: 'cHeaderToggler',
      host: {
        '[attr.type]': 'type()',
        '[attr.aria-label]': 'ariaLabel()',
        class: 'header-toggler'
      }
    }]
  }], null, {
    type: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "type",
        required: false
      }]
    }],
    ariaLabel: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "ariaLabel",
        required: false
      }]
    }]
  });
})();
class HeaderModule {
  static ɵfac = function HeaderModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: HeaderModule,
    imports: [HeaderComponent, HeaderBrandComponent, HeaderDividerComponent, HeaderNavComponent, HeaderTextComponent, HeaderTogglerDirective],
    exports: [HeaderComponent, HeaderBrandComponent, HeaderDividerComponent, HeaderNavComponent, HeaderTextComponent, HeaderTogglerDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderModule, [{
    type: NgModule,
    args: [{
      imports: [HeaderComponent, HeaderBrandComponent, HeaderDividerComponent, HeaderNavComponent, HeaderTextComponent, HeaderTogglerDirective],
      exports: [HeaderComponent, HeaderBrandComponent, HeaderDividerComponent, HeaderNavComponent, HeaderTextComponent, HeaderTogglerDirective]
    }]
  }], null, null);
})();
class ImgDirective {
  /**
   * Set the horizontal aligment.
   * @type {'' | 'start' | 'end' | 'center'}
   */
  align = input('', ...(ngDevMode ? [{
    debugName: "align"
  }] : []));
  /**
   * Make image responsive.
   * @type boolean
   */
  fluid = input(false, ...(ngDevMode ? [{
    debugName: "fluid",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Make image rounded.
   * @type boolean
   */
  rounded = input(false, ...(ngDevMode ? [{
    debugName: "rounded",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Give an image a rounded 1px border appearance.
   * @type boolean
   */
  thumbnail = input(false, ...(ngDevMode ? [{
    debugName: "thumbnail",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Color for image placeholder.
   */
  placeholderColor = input('transparent', ...(ngDevMode ? [{
    debugName: "placeholderColor"
  }] : []));
  hostStyles = computed(() => {
    return {
      backgroundColor: this.placeholderColor()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostStyles"
  }] : []));
  hostClasses = computed(() => {
    const align = this.align();
    return {
      [`float-${align}`]: align === 'start' || align === 'end',
      'd-block': align === 'center',
      'mx-auto': align === 'center',
      'img-fluid': this.fluid(),
      rounded: this.rounded(),
      'img-thumbnail': this.thumbnail()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function ImgDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ImgDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ImgDirective,
    selectors: [["", "cImg", ""]],
    hostVars: 4,
    hostBindings: function ImgDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵstyleMap(ctx.hostStyles());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      align: [1, "align"],
      fluid: [1, "fluid"],
      rounded: [1, "rounded"],
      thumbnail: [1, "thumbnail"],
      placeholderColor: [1, "placeholderColor"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgDirective, [{
    type: Directive,
    args: [{
      selector: '[cImg]',
      host: {
        '[class]': 'hostClasses()',
        '[style]': 'hostStyles()'
      }
    }]
  }], null, {
    align: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "align",
        required: false
      }]
    }],
    fluid: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "fluid",
        required: false
      }]
    }],
    rounded: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "rounded",
        required: false
      }]
    }],
    thumbnail: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "thumbnail",
        required: false
      }]
    }],
    placeholderColor: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "placeholderColor",
        required: false
      }]
    }]
  });
})();
class ImgModule {
  static ɵfac = function ImgModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ImgModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ImgModule,
    imports: [ImgDirective],
    exports: [ImgDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgModule, [{
    type: NgModule,
    args: [{
      imports: [ImgDirective],
      exports: [ImgDirective]
    }]
  }], null, null);
})();
class ListGroupDirective {
  static ngAcceptInputType_flush;
  /**
   * Remove some borders and rounded corners to render list group items edge-to-edge in a parent component (e.g., `<CCard>`).
   * @type boolean
   */
  flush = input(false, ...(ngDevMode ? [{
    debugName: "flush",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Specify horizontal layout type.
   */
  horizontal = input(...(ngDevMode ? [undefined, {
    debugName: "horizontal"
  }] : []));
  hostClasses = computed(() => {
    const horizontal = this.horizontal();
    return {
      'list-group': true,
      'list-group-horizontal': horizontal === true || horizontal === '',
      [`list-group-horizontal-${horizontal}`]: !!horizontal && typeof horizontal !== 'boolean',
      'list-group-flush': this.flush()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function ListGroupDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListGroupDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ListGroupDirective,
    selectors: [["", "cListGroup", ""]],
    hostAttrs: [1, "list-group"],
    hostVars: 2,
    hostBindings: function ListGroupDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      flush: [1, "flush"],
      horizontal: [1, "horizontal"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListGroupDirective, [{
    type: Directive,
    args: [{
      selector: '[cListGroup]',
      host: {
        class: 'list-group',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    flush: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "flush",
        required: false
      }]
    }],
    horizontal: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "horizontal",
        required: false
      }]
    }]
  });
})();
class ListGroupItemDirective {
  static ngAcceptInputType_active;
  static ngAcceptInputType_disabled;
  hostElement = inject(ElementRef);
  /**
   * Toggle the active state for the component.
   * @type InputSignalWithTransform<boolean, unknown>
   */
  active = input(false, ...(ngDevMode ? [{
    debugName: "active",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @type InputSignal<boolean | undefined>
   */
  color = input(...(ngDevMode ? [undefined, {
    debugName: "color"
  }] : []));
  /**
   * Set disabled attr for the host element. [docs]
   * @type boolean
   */
  disabled = input(false, ...(ngDevMode ? [{
    debugName: "disabled",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * The tabindex attribute specifies the tab order of an element (when the "tab" button is used for navigating).
   */
  tabindex = input(undefined, ...(ngDevMode ? [{
    debugName: "tabindex",
    transform: numberAttribute
  }] : [{
    transform: numberAttribute
  }]));
  hostClasses = computed(() => {
    const host = this.hostElement.nativeElement;
    const color = this.color();
    return {
      'list-group-item': true,
      'list-group-item-action': host.nodeName === 'A' || host.nodeName === 'BUTTON',
      active: this.active(),
      disabled: this._disabled(),
      [`list-group-item-${color}`]: !!color
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  _disabled = computed(() => this.disabled(), ...(ngDevMode ? [{
    debugName: "_disabled"
  }] : []));
  ariaDisabled = computed(() => {
    return this._disabled() ? true : null;
  }, ...(ngDevMode ? [{
    debugName: "ariaDisabled"
  }] : []));
  attrDisabled = computed(() => {
    return this._disabled() ? '' : null;
  }, ...(ngDevMode ? [{
    debugName: "attrDisabled"
  }] : []));
  tabIndex = computed(() => {
    return this._disabled() ? '-1' : this.tabindex() ?? null;
  }, ...(ngDevMode ? [{
    debugName: "tabIndex"
  }] : []));
  ariaCurrent = computed(() => {
    return this.active() || null;
  }, ...(ngDevMode ? [{
    debugName: "ariaCurrent"
  }] : []));
  static ɵfac = function ListGroupItemDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListGroupItemDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ListGroupItemDirective,
    selectors: [["", "cListGroupItem", ""], ["c-list-group-item"]],
    hostVars: 6,
    hostBindings: function ListGroupItemDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-disabled", ctx.ariaDisabled())("aria-current", ctx.ariaCurrent())("disabled", ctx.attrDisabled())("tabindex", ctx.tabIndex());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      active: [1, "active"],
      color: [1, "color"],
      disabled: [1, "disabled"],
      tabindex: [1, "tabindex"]
    },
    exportAs: ["cListGroupItem"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListGroupItemDirective, [{
    type: Directive,
    args: [{
      selector: '[cListGroupItem], c-list-group-item',
      exportAs: 'cListGroupItem',
      host: {
        '[class]': 'hostClasses()',
        '[attr.aria-disabled]': 'ariaDisabled()',
        '[attr.aria-current]': 'ariaCurrent()',
        '[attr.disabled]': 'attrDisabled()',
        '[attr.tabindex]': 'tabIndex()'
      }
    }]
  }], null, {
    active: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "active",
        required: false
      }]
    }],
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    disabled: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "disabled",
        required: false
      }]
    }],
    tabindex: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "tabindex",
        required: false
      }]
    }]
  });
})();
class ListGroupModule {
  static ɵfac = function ListGroupModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListGroupModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ListGroupModule,
    imports: [ListGroupDirective, ListGroupItemDirective],
    exports: [ListGroupDirective, ListGroupItemDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListGroupModule, [{
    type: NgModule,
    args: [{
      exports: [ListGroupDirective, ListGroupItemDirective],
      imports: [ListGroupDirective, ListGroupItemDirective]
    }]
  }], null, null);
})();
class NavLinkDirective {
  static ngAcceptInputType_disabled;
  /**
   * Sets .nav-link class to the host. [docs]
   * @default true
   */
  cNavLink = input(true, ...(ngDevMode ? [{
    debugName: "cNavLink",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Toggle the active state for the component. [docs]
   * @default undefined
   */
  active = input(...(ngDevMode ? [undefined, {
    debugName: "active"
  }] : []));
  /**
   * Set disabled attr for the host element. [docs]
   * @default false
   */
  disabled = input(false, ...(ngDevMode ? [{
    debugName: "disabled",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * The tabindex attribute specifies the tab order of an element (when the "tab" button is used for navigating).
   */
  tabindex = input(undefined, ...(ngDevMode ? [{
    debugName: "tabindex",
    transform: numberAttribute
  }] : [{
    transform: numberAttribute
  }]));
  ariaCurrent = computed(() => {
    return this.active() ? 'page' : null;
  }, ...(ngDevMode ? [{
    debugName: "ariaCurrent"
  }] : []));
  ariaDisabled = null;
  attrDisabled = null;
  attrTabindex = null;
  styleCursor = null;
  #disabledEffect = effect(() => {
    const disabled = this.disabled();
    this.ariaDisabled = disabled || null;
    this.attrDisabled = disabled ? '' : null;
    this.attrTabindex = disabled ? -1 : this.tabindex() ?? null;
    this.styleCursor = disabled ? null : 'pointer';
  }, ...(ngDevMode ? [{
    debugName: "#disabledEffect"
  }] : []));
  hostClasses = computed(() => {
    return {
      'nav-link': this.cNavLink(),
      disabled: this.disabled(),
      active: this.active()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function NavLinkDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavLinkDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: NavLinkDirective,
    selectors: [["", "cNavLink", ""]],
    hostVars: 8,
    hostBindings: function NavLinkDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-current", ctx.ariaCurrent())("aria-disabled", ctx.ariaDisabled)("disabled", ctx.attrDisabled)("tabindex", ctx.attrTabindex);
        i0.ɵɵclassMap(ctx.hostClasses());
        i0.ɵɵstyleProp("cursor", ctx.styleCursor);
      }
    },
    inputs: {
      cNavLink: [1, "cNavLink"],
      active: [1, "active"],
      disabled: [1, "disabled"],
      tabindex: [1, "tabindex"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavLinkDirective, [{
    type: Directive,
    args: [{
      selector: '[cNavLink]',
      host: {
        '[class]': 'hostClasses()',
        '[attr.aria-current]': 'ariaCurrent()',
        '[attr.aria-disabled]': 'ariaDisabled',
        '[attr.disabled]': 'attrDisabled',
        '[attr.tabindex]': 'attrTabindex',
        '[style.cursor]': 'styleCursor'
      }
    }]
  }], null, {
    cNavLink: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cNavLink",
        required: false
      }]
    }],
    active: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "active",
        required: false
      }]
    }],
    disabled: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "disabled",
        required: false
      }]
    }],
    tabindex: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "tabindex",
        required: false
      }]
    }]
  });
})();
class NavItemComponent {
  static ɵfac = function NavItemComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavItemComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NavItemComponent,
    selectors: [["c-nav-item"]],
    hostAttrs: [1, "nav-item"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function NavItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:list-item;text-align:match-parent;text-align:-webkit-match-parent}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavItemComponent, [{
    type: Component,
    args: [{
      selector: 'c-nav-item',
      template: '<ng-content />',
      host: {
        class: 'nav-item'
      },
      styles: [":host{display:list-item;text-align:match-parent;text-align:-webkit-match-parent}\n"]
    }]
  }], null, null);
})();
class NavComponent {
  /**
   * Specify a layout type for component.
   * @default undefined
   */
  layout = input(...(ngDevMode ? [undefined, {
    debugName: "layout"
  }] : []));
  /**
   * Set the nav variant to tabs or pills.
   * @default undefined
   */
  variant = input(...(ngDevMode ? [undefined, {
    debugName: "variant"
  }] : []));
  hostClasses = computed(() => {
    const layout = this.layout();
    const variant = this.variant();
    return {
      nav: true,
      [`nav-${layout}`]: !!layout,
      [`nav-${variant}`]: !!variant
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function NavComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NavComponent,
    selectors: [["c-nav"]],
    hostAttrs: [1, "nav"],
    hostVars: 2,
    hostBindings: function NavComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      layout: [1, "layout"],
      variant: [1, "variant"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function NavComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]   .nav-link[_ngcontent-%COMP%]:focus{outline:0}.nav-underline-border[_nghost-%COMP%]{column-gap:0}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavComponent, [{
    type: Component,
    args: [{
      selector: 'c-nav',
      template: '<ng-content />',
      host: {
        class: 'nav',
        '[class]': 'hostClasses()'
      },
      styles: [":host .nav-link:focus{outline:0}:host.nav-underline-border{column-gap:0}\n"]
    }]
  }], null, {
    layout: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "layout",
        required: false
      }]
    }],
    variant: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "variant",
        required: false
      }]
    }]
  });
})();
class NavModule {
  static ɵfac = function NavModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: NavModule,
    imports: [NavComponent, NavItemComponent, NavLinkDirective],
    exports: [NavComponent, NavItemComponent, NavLinkDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavModule, [{
    type: NgModule,
    args: [{
      imports: [NavComponent, NavItemComponent, NavLinkDirective],
      exports: [NavComponent, NavItemComponent, NavLinkDirective]
    }]
  }], null, null);
})();

// todo: fix container prop issue not rendering children
// todo: workaround -  use <c-container> component directly in template
class NavbarComponent {
  #breakpointObserver = inject(BreakpointObserver);
  #document = inject(DOCUMENT);
  #hostElement = inject(ElementRef);
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @type Colors
   */
  color = input(...(ngDevMode ? [undefined, {
    debugName: "color"
  }] : []));
  /**
   * Defines optional container wrapping children elements.
   */
  container = input(...(ngDevMode ? [undefined, {
    debugName: "container"
  }] : []));
  /**
   * Defines the responsive breakpoint to determine when content collapses.
   */
  expand = input(...(ngDevMode ? [undefined, {
    debugName: "expand"
  }] : []));
  /**
   * Place component in non-static positions.
   */
  placement = input(...(ngDevMode ? [undefined, {
    debugName: "placement"
  }] : []));
  role = input('navigation', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  collapse = contentChild(CollapseDirective, ...(ngDevMode ? [{
    debugName: "collapse"
  }] : []));
  hostClasses = computed(() => {
    const color = this.color();
    const expand = this.expand();
    const expandClassSuffix = expand === true ? '' : `-${expand}`;
    const placement = this.placement();
    return {
      navbar: true,
      [`navbar-expand${expandClassSuffix}`]: !!expand,
      [`bg-${color}`]: !!color,
      [`${placement}`]: !!placement
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  containerClass = computed(() => {
    const container = this.container();
    return `container${container !== true ? '-' + container : ''}`;
  }, ...(ngDevMode ? [{
    debugName: "containerClass"
  }] : []));
  computedStyle = signal('', ...(ngDevMode ? [{
    debugName: "computedStyle"
  }] : []));
  #afterEveryRenderFn = afterEveryRender({
    read: () => {
      const expand = this.expand();
      if (typeof expand === 'string') {
        const computedStyle = this.#document.defaultView?.getComputedStyle(this.#hostElement.nativeElement)?.getPropertyValue(`--cui-breakpoint-${expand}`) ?? false;
        computedStyle && this.computedStyle.set(computedStyle);
      }
    }
  });
  breakpoint = computed(() => {
    const expand = this.expand();
    if (typeof expand === 'string') {
      return this.computedStyle();
    }
    return false;
  }, ...(ngDevMode ? [{
    debugName: "breakpoint"
  }] : []));
  #observer;
  ngAfterContentInit() {
    const breakpoint = this.breakpoint();
    if (breakpoint) {
      const onBreakpoint = `(min-width: ${breakpoint})`;
      this.#observer = this.#breakpointObserver.observe([onBreakpoint]).pipe().subscribe(result => {
        const collapse = this.collapse();
        if (collapse) {
          const animate = collapse.animate();
          collapse.animate.set(false);
          collapse.toggle(false);
          setTimeout(() => {
            collapse.toggle(result.matches);
            setTimeout(() => {
              collapse.animate.set(animate);
            });
          });
        }
      });
    }
  }
  ngOnDestroy() {
    this.#observer?.unsubscribe();
  }
  static ɵfac = function NavbarComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavbarComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NavbarComponent,
    selectors: [["c-navbar"]],
    contentQueries: function NavbarComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.collapse, CollapseDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 3,
    hostBindings: function NavbarComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      color: [1, "color"],
      container: [1, "container"],
      expand: [1, "expand"],
      placement: [1, "placement"],
      role: [1, "role"]
    },
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: ThemeDirective,
      inputs: ["colorScheme", "colorScheme"]
    }])],
    ngContentSelectors: _c2,
    decls: 5,
    vars: 1,
    consts: [["withContainerTemplate", ""], ["noContainerTemplate", ""], [4, "ngTemplateOutlet"], [3, "ngClass"]],
    template: function NavbarComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c2);
        i0.ɵɵtemplate(0, NavbarComponent_ng_container_0_Template, 1, 0, "ng-container", 2)(1, NavbarComponent_ng_template_1_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, NavbarComponent_ng_template_3_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const withContainerTemplate_r2 = i0.ɵɵreference(2);
        const noContainerTemplate_r3 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.container() ? withContainerTemplate_r2 : noContainerTemplate_r3);
      }
    },
    dependencies: [NgClass, NgTemplateOutlet],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarComponent, [{
    type: Component,
    args: [{
      selector: 'c-navbar',
      imports: [NgClass, NgTemplateOutlet],
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['colorScheme']
      }],
      host: {
        '[class]': 'hostClasses()',
        '[attr.role]': 'role()'
      },
      template: "<ng-container *ngTemplateOutlet=\"container() ? withContainerTemplate : noContainerTemplate\" />\n\n<ng-template #withContainerTemplate>\n  <div [ngClass]=\"containerClass()\">\n    <ng-content />\n  </div>\n</ng-template>\n\n<ng-template #noContainerTemplate>\n  <ng-content />\n</ng-template>\n"
    }]
  }], null, {
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    container: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "container",
        required: false
      }]
    }],
    expand: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "expand",
        required: false
      }]
    }],
    placement: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "placement",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }],
    collapse: [{
      type: i0.ContentChild,
      args: [i0.forwardRef(() => CollapseDirective), {
        isSignal: true
      }]
    }]
  });
})();
class NavbarBrandDirective {
  role = input('button', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  static ɵfac = function NavbarBrandDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavbarBrandDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: NavbarBrandDirective,
    selectors: [["", "cNavbarBrand", ""]],
    hostAttrs: [1, "navbar-brand"],
    hostVars: 1,
    hostBindings: function NavbarBrandDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
      }
    },
    inputs: {
      role: [1, "role"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarBrandDirective, [{
    type: Directive,
    args: [{
      selector: '[cNavbarBrand]',
      host: {
        class: 'navbar-brand',
        '[attr.role]': 'role()'
      }
    }]
  }], null, {
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class NavbarNavComponent {
  /**
   * Enable vertical scrolling of a collapsed navbar toggleable contents.
   * @type boolean
   */
  scroll = input(false, ...(ngDevMode ? [{
    debugName: "scroll",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  hostClasses = computed(() => {
    return {
      'navbar-nav': true,
      'navbar-nav-scroll': this.scroll()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function NavbarNavComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavbarNavComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NavbarNavComponent,
    selectors: [["c-navbar-nav"]],
    hostVars: 2,
    hostBindings: function NavbarNavComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      scroll: [1, "scroll"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function NavbarNavComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarNavComponent, [{
    type: Component,
    args: [{
      selector: 'c-navbar-nav',
      template: '<ng-content />',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    scroll: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "scroll",
        required: false
      }]
    }]
  });
})();
class NavbarTextComponent {
  static ɵfac = function NavbarTextComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavbarTextComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NavbarTextComponent,
    selectors: [["c-navbar-text"]],
    hostAttrs: [1, "navbar-text"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function NavbarTextComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarTextComponent, [{
    type: Component,
    args: [{
      selector: 'c-navbar-text',
      template: '<ng-content />',
      host: {
        class: 'navbar-text'
      }
    }]
  }], null, null);
})();
class NavbarTogglerDirective {
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  constructor() {
    afterNextRender({
      read: () => {
        const hasContent = this.#hostElement.nativeElement.childNodes.length;
        if (!hasContent) {
          this.addDefaultIcon();
        }
      }
    });
  }
  /**
   * Reference to navbar collapse element (via # template variable) . [docs]
   * @type string
   * @default 'button'
   */
  collapseRef = input(undefined, ...(ngDevMode ? [{
    debugName: "collapseRef",
    alias: 'cNavbarToggler'
  }] : [{
    alias: 'cNavbarToggler'
  }]));
  /**
   * Default type for navbar-toggler. [docs]
   * @type string
   * @default 'button'
   */
  type = input('button', ...(ngDevMode ? [{
    debugName: "type"
  }] : []));
  /**
   * Default aria-label attr for navbar-toggler. [docs]
   * @type string
   * @default 'Toggle navigation'
   */
  ariaLabel = input('Toggle navigation', ...(ngDevMode ? [{
    debugName: "ariaLabel"
  }] : []));
  handleClick($event) {
    const collapseRef = this.collapseRef();
    collapseRef?.toggle(!collapseRef?.visible());
  }
  addDefaultIcon() {
    const span = this.#renderer.createElement('span');
    this.#renderer.addClass(span, 'navbar-toggler-icon');
    this.#renderer.appendChild(this.#hostElement.nativeElement, span);
  }
  static ɵfac = function NavbarTogglerDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavbarTogglerDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: NavbarTogglerDirective,
    selectors: [["", "cNavbarToggler", ""]],
    hostAttrs: [1, "navbar-toggler"],
    hostVars: 2,
    hostBindings: function NavbarTogglerDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function NavbarTogglerDirective_click_HostBindingHandler($event) {
          return ctx.handleClick($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("aria-label", ctx.ariaLabel())("type", ctx.type());
      }
    },
    inputs: {
      collapseRef: [1, "cNavbarToggler", "collapseRef"],
      type: [1, "type"],
      ariaLabel: [1, "ariaLabel"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarTogglerDirective, [{
    type: Directive,
    args: [{
      selector: '[cNavbarToggler]',
      host: {
        '[attr.aria-label]': 'ariaLabel()',
        '[attr.type]': 'type()',
        class: 'navbar-toggler',
        '(click)': 'handleClick($event)'
      }
    }]
  }], () => [], {
    collapseRef: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cNavbarToggler",
        required: false
      }]
    }],
    type: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "type",
        required: false
      }]
    }],
    ariaLabel: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "ariaLabel",
        required: false
      }]
    }]
  });
})();
class NavbarModule {
  static ɵfac = function NavbarModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavbarModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: NavbarModule,
    imports: [NavbarBrandDirective, NavbarComponent, NavbarNavComponent, NavbarTextComponent, NavbarTogglerDirective],
    exports: [NavbarBrandDirective, NavbarComponent, NavbarNavComponent, NavbarTextComponent, NavbarTogglerDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavbarModule, [{
    type: NgModule,
    args: [{
      exports: [NavbarBrandDirective, NavbarComponent, NavbarNavComponent, NavbarTextComponent, NavbarTogglerDirective],
      imports: [NavbarBrandDirective, NavbarComponent, NavbarNavComponent, NavbarTextComponent, NavbarTogglerDirective]
    }]
  }], null, null);
})();
class ModalBodyComponent {
  static ɵfac = function ModalBodyComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalBodyComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ModalBodyComponent,
    selectors: [["c-modal-body"]],
    hostAttrs: [1, "modal-body"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ModalBodyComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalBodyComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal-body',
      template: '<ng-content />',
      host: {
        class: 'modal-body'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class ModalContentComponent {
  static ɵfac = function ModalContentComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalContentComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ModalContentComponent,
    selectors: [["c-modal-content"]],
    hostAttrs: [1, "modal-content"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ModalContentComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalContentComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal-content',
      template: '<ng-content />',
      host: {
        class: 'modal-content'
      }
    }]
  }], null, null);
})();
class ModalDialogComponent {
  /**
   * Align the modal in the center or top of the screen.
   * @default undefined
   */
  alignment = input(...(ngDevMode ? [undefined, {
    debugName: "alignment"
  }] : []));
  /**
   * Set modal to covers the entire user viewport.
   * @return {boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'}
   */
  fullscreen = input(...(ngDevMode ? [undefined, {
    debugName: "fullscreen"
  }] : []));
  /**
   * Does the modal dialog itself scroll, or does the whole dialog scroll within the window.
   * @default false
   * @return {boolean}
   */
  scrollable = input(false, ...(ngDevMode ? [{
    debugName: "scrollable",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Size the component small, large, or extra large.
   * @default undefined
   * @return {'sm' | 'lg' | 'xl'}
   */
  size = input(...(ngDevMode ? [undefined, {
    debugName: "size"
  }] : []));
  hostClasses = computed(() => {
    const fullscreen = this.fullscreen();
    const size = this.size();
    return {
      'modal-dialog': true,
      'modal-dialog-centered': this.alignment() === 'center',
      'modal-fullscreen': fullscreen === true,
      [`modal-fullscreen-${fullscreen}-down`]: typeof fullscreen === 'string',
      'modal-dialog-scrollable': this.scrollable(),
      [`modal-${size}`]: !!size
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function ModalDialogComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalDialogComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ModalDialogComponent,
    selectors: [["c-modal-dialog"]],
    hostAttrs: [1, "modal-dialog"],
    hostVars: 2,
    hostBindings: function ModalDialogComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      alignment: [1, "alignment"],
      fullscreen: [1, "fullscreen"],
      scrollable: [1, "scrollable"],
      size: [1, "size"]
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ModalDialogComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}.modal-dialog-centered[_nghost-%COMP%]{display:flex}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalDialogComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal-dialog',
      template: '<ng-content />',
      host: {
        class: 'modal-dialog',
        '[class]': 'hostClasses()'
      },
      styles: [":host{display:block}:host.modal-dialog-centered{display:flex}\n"]
    }]
  }], null, {
    alignment: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "alignment",
        required: false
      }]
    }],
    fullscreen: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "fullscreen",
        required: false
      }]
    }],
    scrollable: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "scrollable",
        required: false
      }]
    }],
    size: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "size",
        required: false
      }]
    }]
  });
})();
class ModalService {
  #modalState = new Subject();
  modalState$ = this.#modalState.asObservable();
  toggle(action) {
    this.#modalState.next(action);
  }
  static ɵfac = function ModalService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ModalService,
    factory: ModalService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class ModalToggleDirective {
  #modalService = inject(ModalService);
  /**
   * Html id attr of modal to dismiss.
   * @default undefined
   */
  toggle = input(undefined, ...(ngDevMode ? [{
    debugName: "toggle",
    alias: 'cModalToggle'
  }] : [{
    alias: 'cModalToggle'
  }]));
  dismiss($event) {
    $event.preventDefault();
    this.#modalService.toggle({
      show: 'toggle',
      id: this.toggle()
    });
  }
  static ɵfac = function ModalToggleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalToggleDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ModalToggleDirective,
    selectors: [["", "cModalToggle", ""]],
    hostBindings: function ModalToggleDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function ModalToggleDirective_click_HostBindingHandler($event) {
          return ctx.dismiss($event);
        });
      }
    },
    inputs: {
      toggle: [1, "cModalToggle", "toggle"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalToggleDirective, [{
    type: Directive,
    args: [{
      selector: '[cModalToggle]',
      host: {
        '(click)': 'dismiss($event)'
      }
    }]
  }], null, {
    toggle: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cModalToggle",
        required: false
      }]
    }]
  });
})();
class ModalFooterComponent {
  static ɵfac = function ModalFooterComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalFooterComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ModalFooterComponent,
    selectors: [["c-modal-footer"]],
    hostAttrs: [1, "modal-footer"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ModalFooterComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalFooterComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal-footer',
      template: '<ng-content />',
      host: {
        class: 'modal-footer'
      }
    }]
  }], null, null);
})();
class ModalHeaderComponent {
  static ɵfac = function ModalHeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalHeaderComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ModalHeaderComponent,
    selectors: [["c-modal-header"]],
    hostAttrs: [1, "modal-header"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ModalHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal-header',
      template: '<ng-content />',
      host: {
        class: 'modal-header'
      }
    }]
  }], null, null);
})();
class ModalTitleDirective {
  static ɵfac = function ModalTitleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalTitleDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ModalTitleDirective,
    selectors: [["", "cModalTitle", ""]],
    hostAttrs: [1, "modal-title"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalTitleDirective, [{
    type: Directive,
    args: [{
      selector: '[cModalTitle]',
      host: {
        class: 'modal-title'
      }
    }]
  }], null, null);
})();
class ModalComponent {
  static ngAcceptInputType_ariaModalInput;
  static ngAcceptInputType_scrollable;
  static ngAcceptInputType_visibleInput;
  #document = inject(DOCUMENT);
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  #modalService = inject(ModalService);
  #backdropService = inject(BackdropService);
  #destroyRef = inject(DestroyRef);
  #focusMonitor = inject(FocusMonitor);
  /**
   * Align the modal in the center or top of the screen.
   * @return {'top' | 'center'}
   * @default 'top'
   */
  alignment = input('top', ...(ngDevMode ? [{
    debugName: "alignment"
  }] : []));
  /**
   * Apply a backdrop on body while modal is open.
   * @return boolean | 'static'
   * @default true
   */
  backdrop = input(true, ...(ngDevMode ? [{
    debugName: "backdrop"
  }] : []));
  /**
   * Set modal to cover the entire user viewport.
   * @return {boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'}
   * @default undefined
   */
  fullscreen = input(...(ngDevMode ? [undefined, {
    debugName: "fullscreen"
  }] : []));
  /**
   * Closes the modal when escape key is pressed.
   * @return boolean
   * @default true
   */
  keyboard = input(true, ...(ngDevMode ? [{
    debugName: "keyboard",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  attrId = input(undefined, ...(ngDevMode ? [{
    debugName: "attrId",
    alias: 'id'
  }] : [{
    alias: 'id'
  }]));
  get id() {
    return this.attrId();
  }
  /**
   * Size the component small, large, or extra large.
   * @return {'sm' | 'lg' | 'xl'}
   * @default undefined
   */
  size = input(...(ngDevMode ? [undefined, {
    debugName: "size"
  }] : []));
  /**
   * Remove animation to create modal that simply appear rather than fade in to view.
   */
  transition = input(true, ...(ngDevMode ? [{
    debugName: "transition",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Default role for modal
   * @return string
   * @default 'dialog'
   */
  role = input('dialog', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  /**
   * Set aria-modal html attr for modal
   * @type boolean
   * @default null
   */
  ariaModalInput = input(false, ...(ngDevMode ? [{
    debugName: "ariaModalInput",
    transform: booleanAttribute,
    alias: 'ariaModal'
  }] : [{
    transform: booleanAttribute,
    alias: 'ariaModal'
  }]));
  ariaModal = computed(() => {
    return this.visible() || this.ariaModalInput() ? true : null;
  }, ...(ngDevMode ? [{
    debugName: "ariaModal"
  }] : []));
  /**
   * Create a scrollable modal that allows scrolling the modal body.
   * @return boolean
   * @default false
   */
  scrollable = input(false, ...(ngDevMode ? [{
    debugName: "scrollable",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Toggle the visibility of modal component.
   * @return boolean
   * @default false
   */
  visibleInput = input(false, ...(ngDevMode ? [{
    debugName: "visibleInput",
    transform: booleanAttribute,
    alias: 'visible'
  }] : [{
    transform: booleanAttribute,
    alias: 'visible'
  }]));
  visible = linkedSignal(this.visibleInput, ...(ngDevMode ? [{
    debugName: "visible"
  }] : []));
  #visibleInputEffect = effect(() => {
    const visible = this.visible();
    untracked(() => {
      this.setBodyStyles(visible);
      this.setBackdrop(this.backdrop() !== false && visible);
      this.visibleChange?.emit(visible);
    });
  }, ...(ngDevMode ? [{
    debugName: "#visibleInputEffect"
  }] : []));
  #activeElement = signal(null, ...(ngDevMode ? [{
    debugName: "#activeElement"
  }] : []));
  #visibleEffect = effect(() => {
    const visible = this.visible();
    const afterViewInit = this.#afterViewInit();
    untracked(() => {
      if (visible && afterViewInit) {
        this.#activeElement.set(this.#document.activeElement);
        // this.#activeElement()?.blur();
        setTimeout(() => {
          const focusable = this.modalContentRef()?.nativeElement.querySelectorAll('[tabindex]:not([tabindex="-1"]), button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled])');
          if (focusable?.length) {
            this.#focusMonitor.focusVia(focusable[0], 'keyboard');
          }
        });
      } else {
        const activeElement = this.#activeElement();
        if (activeElement && this.#document.contains(activeElement)) {
          this.#focusMonitor.focusVia(activeElement, 'keyboard');
          setTimeout(() => {
            // this.#activeElement()?.focus();
            this.#activeElement.set(null);
          });
        }
      }
    });
  }, ...(ngDevMode ? [{
    debugName: "#visibleEffect"
  }] : []));
  /**
   * Event triggered on modal dismiss.
   * @return boolean
   */
  visibleChange = output();
  // @ViewChild(ModalContentComponent, { read: ElementRef }) modalContent!: ElementRef;
  // @ViewChild('modalContentRef', { read: ElementRef }) modalContentRef!: ElementRef;
  // readonly modalContentRef = viewChild(ModalContentComponent, { read: ElementRef });
  modalContentRef = viewChild('modalContentRef', ...(ngDevMode ? [{
    debugName: "modalContentRef",
    read: ElementRef
  }] : [{
    read: ElementRef
  }]));
  #activeBackdrop;
  // private inBoundingClientRect!: boolean;
  hostClasses = computed(() => {
    return {
      modal: true,
      fade: this.transition(),
      show: this.show
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  get ariaHidden() {
    return this.visible() ? null : true;
  }
  animateTrigger = computed(() => {
    return this.visible() ? 'visible' : 'hidden';
  }, ...(ngDevMode ? [{
    debugName: "animateTrigger"
  }] : []));
  get show() {
    return this.visible() && this.#show();
  }
  set show(value) {
    this.#show.set(value);
  }
  #show = signal(true, ...(ngDevMode ? [{
    debugName: "#show"
  }] : []));
  animateStart(event) {
    if (event.toState === 'visible') {
      this.#backdropService.hideScrollbar();
      this.#renderer.setStyle(this.#hostElement.nativeElement, 'display', 'block');
    } else {
      if (!this.transition()) {
        this.#renderer.setStyle(this.#hostElement.nativeElement, 'display', 'none');
      }
    }
  }
  animateDone(event) {
    setTimeout(() => {
      if (event.toState === 'hidden') {
        this.#renderer.setStyle(this.#hostElement.nativeElement, 'display', 'none');
        this.#backdropService.resetScrollbar();
      }
    });
    this.show = this.visible();
  }
  onKeyUpHandler(event) {
    if (event.key === 'Escape' && this.keyboard() && this.visible()) {
      if (this.backdrop() === 'static') {
        this.setStaticBackdrop();
      } else {
        this.#modalService.toggle({
          show: false,
          modal: this
        });
      }
    }
  }
  mouseDownTarget = null;
  onMouseDownHandler($event) {
    this.mouseDownTarget = $event.target;
  }
  onClickHandler($event) {
    if (this.mouseDownTarget !== $event.target) {
      this.mouseDownTarget = null;
      return;
    }
    const targetElement = $event.target;
    if (targetElement === this.#hostElement.nativeElement) {
      if (this.backdrop() === 'static') {
        this.setStaticBackdrop();
        return;
      }
      this.#modalService.toggle({
        show: false,
        modal: this
      });
    }
  }
  ngOnInit() {
    this.stateToggleSubscribe();
  }
  #afterViewInit = signal(false, ...(ngDevMode ? [{
    debugName: "#afterViewInit"
  }] : []));
  ngAfterViewInit() {
    this.#afterViewInit.set(true);
  }
  ngOnDestroy() {
    this.#modalService.toggle({
      show: false,
      modal: this
    });
    this.#afterViewInit.set(false);
  }
  stateToggleSubscribe() {
    this.#modalService.modalState$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(action => {
      if (this === action.modal || this.id === action.id) {
        if ('show' in action) {
          this.visible.update(visible => action?.show === 'toggle' ? !visible : action.show);
        }
      } else {
        if (this.visible()) {
          this.visible.set(false);
        }
      }
    });
  }
  setBackdrop(setBackdrop) {
    this.#activeBackdrop = setBackdrop ? this.#backdropService.setBackdrop('modal') : this.#backdropService.clearBackdrop(this.#activeBackdrop);
  }
  setBodyStyles(open) {
    if (open) {
      if (this.backdrop() === true) {
        this.#renderer.addClass(this.#document.body, 'modal-open');
      }
    } else {
      this.#renderer.removeClass(this.#document.body, 'modal-open');
    }
  }
  setStaticBackdrop() {
    if (this.transition()) {
      this.#renderer.addClass(this.#hostElement.nativeElement, 'modal-static');
      this.#renderer.setStyle(this.#hostElement.nativeElement, 'overflow-y', 'hidden');
      setTimeout(() => {
        this.#renderer.removeClass(this.#hostElement.nativeElement, 'modal-static');
        this.#renderer.removeStyle(this.#hostElement.nativeElement, 'overflow-y');
      }, 300);
    }
  }
  static ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ModalComponent,
    selectors: [["c-modal"]],
    viewQuery: function ModalComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.modalContentRef, _c6, 5, ElementRef);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "modal"],
    hostVars: 8,
    hostBindings: function ModalComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵsyntheticHostListener("@showHide.start", function ModalComponent_animation_showHide_start_HostBindingHandler($event) {
          return ctx.animateStart($event);
        })("@showHide.done", function ModalComponent_animation_showHide_done_HostBindingHandler($event) {
          return ctx.animateDone($event);
        });
        i0.ɵɵlistener("mousedown", function ModalComponent_mousedown_HostBindingHandler($event) {
          return ctx.onMouseDownHandler($event);
        })("click", function ModalComponent_click_HostBindingHandler($event) {
          return ctx.onClickHandler($event);
        })("keyup", function ModalComponent_keyup_HostBindingHandler($event) {
          return ctx.onKeyUpHandler($event);
        }, i0.ɵɵresolveDocument);
      }
      if (rf & 2) {
        i0.ɵɵsyntheticHostProperty("@showHide", ctx.animateTrigger());
        i0.ɵɵattribute("role", ctx.role())("inert", ctx.ariaHidden)("id", ctx.id)("aria-modal", ctx.ariaModal())("tabindex", -1);
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      alignment: [1, "alignment"],
      backdrop: [1, "backdrop"],
      fullscreen: [1, "fullscreen"],
      keyboard: [1, "keyboard"],
      attrId: [1, "id", "attrId"],
      size: [1, "size"],
      transition: [1, "transition"],
      role: [1, "role"],
      ariaModalInput: [1, "ariaModal", "ariaModalInput"],
      scrollable: [1, "scrollable"],
      visibleInput: [1, "visible", "visibleInput"]
    },
    outputs: {
      visibleChange: "visibleChange"
    },
    exportAs: ["cModal"],
    ngContentSelectors: _c0,
    decls: 5,
    vars: 6,
    consts: [["modalContentRef", ""], [3, "alignment", "fullscreen", "scrollable", "size"], [2, "display", "contents", 3, "cdkTrapFocus", "cdkTrapFocusAutoCapture"]],
    template: function ModalComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "c-modal-dialog", 1)(1, "c-modal-content")(2, "div", 2, 0);
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("alignment", ctx.alignment())("fullscreen", ctx.fullscreen())("scrollable", ctx.scrollable())("size", ctx.size());
        const isVisible_r1 = ctx.visible();
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("cdkTrapFocus", isVisible_r1)("cdkTrapFocusAutoCapture", isVisible_r1);
      }
    },
    dependencies: [ModalDialogComponent, ModalContentComponent, A11yModule, i1$1.CdkTrapFocus],
    encapsulation: 2,
    data: {
      animation: [trigger('showHide', [state('visible', style({
        // display: 'block'
      })), state('hidden', style({
        // display: 'none'
      })), transition('visible <=> *', [animate('150ms')])])]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalComponent, [{
    type: Component,
    args: [{
      selector: 'c-modal',
      animations: [trigger('showHide', [state('visible', style({
        // display: 'block'
      })), state('hidden', style({
        // display: 'none'
      })), transition('visible <=> *', [animate('150ms')])])],
      exportAs: 'cModal',
      imports: [ModalDialogComponent, ModalContentComponent, A11yModule],
      host: {
        class: 'modal',
        '[class]': 'hostClasses()',
        '[attr.role]': 'role()',
        '[attr.inert]': 'ariaHidden',
        '[attr.id]': 'id',
        '[attr.aria-modal]': 'ariaModal()',
        '[attr.tabindex]': '-1',
        '[@showHide]': 'animateTrigger()',
        '(@showHide.start)': 'animateStart($event)',
        '(@showHide.done)': 'animateDone($event)',
        '(mousedown)': 'onMouseDownHandler($event)',
        '(click)': 'onClickHandler($event)',
        '(document:keyup)': 'onKeyUpHandler($event)'
      },
      template: "<c-modal-dialog\n  [alignment]=\"alignment()\"\n  [fullscreen]=\"fullscreen()\"\n  [scrollable]=\"scrollable()\"\n  [size]=\"size()\">\n  <c-modal-content>\n    @let isVisible = visible();\n    <div [cdkTrapFocus]=\"isVisible\" [cdkTrapFocusAutoCapture]=\"isVisible\" style=\"display: contents;\" #modalContentRef>\n      <ng-content />\n    </div>\n  </c-modal-content>\n</c-modal-dialog>\n"
    }]
  }], null, {
    alignment: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "alignment",
        required: false
      }]
    }],
    backdrop: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "backdrop",
        required: false
      }]
    }],
    fullscreen: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "fullscreen",
        required: false
      }]
    }],
    keyboard: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "keyboard",
        required: false
      }]
    }],
    attrId: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "id",
        required: false
      }]
    }],
    size: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "size",
        required: false
      }]
    }],
    transition: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "transition",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }],
    ariaModalInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "ariaModal",
        required: false
      }]
    }],
    scrollable: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "scrollable",
        required: false
      }]
    }],
    visibleInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    visibleChange: [{
      type: i0.Output,
      args: ["visibleChange"]
    }],
    modalContentRef: [{
      type: i0.ViewChild,
      args: ['modalContentRef', {
        ...{
          read: ElementRef
        },
        isSignal: true
      }]
    }]
  });
})();
class ModalModule {
  static ɵfac = function ModalModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ModalModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ModalModule,
    imports: [ModalBodyComponent, ModalComponent, ModalContentComponent, ModalDialogComponent, ModalFooterComponent, ModalHeaderComponent, ModalTitleDirective, ModalToggleDirective],
    exports: [ModalBodyComponent, ModalComponent, ModalContentComponent, ModalDialogComponent, ModalFooterComponent, ModalHeaderComponent, ModalTitleDirective, ModalToggleDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [ModalService],
    imports: [ModalComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalModule, [{
    type: NgModule,
    args: [{
      exports: [ModalBodyComponent, ModalComponent, ModalContentComponent, ModalDialogComponent, ModalFooterComponent, ModalHeaderComponent, ModalTitleDirective, ModalToggleDirective],
      imports: [ModalBodyComponent, ModalComponent, ModalContentComponent, ModalDialogComponent, ModalFooterComponent, ModalHeaderComponent, ModalTitleDirective, ModalToggleDirective],
      providers: [ModalService]
    }]
  }], null, null);
})();
class OffcanvasService {
  offcanvasState = new Subject();
  offcanvasState$ = this.offcanvasState.asObservable();
  toggle(action) {
    this.offcanvasState.next(action);
  }
  static ɵfac = function OffcanvasService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || OffcanvasService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: OffcanvasService,
    factory: OffcanvasService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
let nextId$1 = 0;
class OffcanvasComponent {
  #document = inject(DOCUMENT);
  #platformId = inject(PLATFORM_ID);
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  #offcanvasService = inject(OffcanvasService);
  #backdropService = inject(BackdropService);
  #breakpointObserver = inject(BreakpointObserver);
  #destroyRef = inject(DestroyRef);
  /**
   * Apply a backdrop on body while offcanvas is open.
   * @return boolean | 'static'
   * @default true
   */
  backdrop = input(true, ...(ngDevMode ? [{
    debugName: "backdrop"
  }] : []));
  /**
   * Closes the offcanvas when escape key is pressed [docs]
   * @return boolean
   * @default true
   */
  keyboard = input(true, ...(ngDevMode ? [{
    debugName: "keyboard",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Components placement, there’s no default placement.
   * @return {'start' | 'end' | 'top' | 'bottom'}
   * @default 'start'
   */
  placement = input('start', ...(ngDevMode ? [{
    debugName: "placement"
  }] : []));
  /**
   * Responsive offcanvas property hides content outside the viewport from a specified breakpoint and down.
   * @return boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
   * @default true
   * @since 4.3.10
   */
  responsive = input(true, ...(ngDevMode ? [{
    debugName: "responsive"
  }] : []));
  id = input(`offcanvas-${this.placement()}-${nextId$1++}`, ...(ngDevMode ? [{
    debugName: "id"
  }] : []));
  /**
   * Default role for offcanvas. [docs]
   * @return string
   * @default 'dialog'
   */
  role = input('dialog', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  /**
   * Set aria-modal html attr for offcanvas. [docs]
   * @return boolean
   * @default true
   */
  ariaModal = input(true, ...(ngDevMode ? [{
    debugName: "ariaModal",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  #activeBackdrop;
  #backdropClickSubscription;
  #layoutChangeSubscription;
  /**
   * Allow body scrolling while offcanvas is visible.
   * @return boolean
   * @default false
   */
  scroll = input(false, ...(ngDevMode ? [{
    debugName: "scroll",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Toggle the visibility of offcanvas component.
   * @return boolean
   * @default false
   */
  visibleInput = input(false, ...(ngDevMode ? [{
    debugName: "visibleInput",
    transform: booleanAttribute,
    alias: 'visible'
  }] : [{
    transform: booleanAttribute,
    alias: 'visible'
  }]));
  visible = linkedSignal(...(ngDevMode ? [{
    debugName: "visible",
    source: this.visibleInput,
    computation: value => value
  }] : [{
    source: this.visibleInput,
    computation: value => value
  }]));
  visibleEffect = effect(() => {
    const visible = this.visible();
    if (visible) {
      this.setBackdrop(this.backdrop());
      this.setFocus();
    } else {
      this.setBackdrop(false);
    }
    this.layoutChangeSubscribe(visible);
    this.visibleChange?.emit(visible);
  }, ...(ngDevMode ? [{
    debugName: "visibleEffect"
  }] : []));
  /**
   * Event triggered on visible change.
   * @return <boolean>
   */
  visibleChange = output();
  hostClasses = computed(() => {
    const responsive = this.responsive();
    const placement = this.placement();
    const visible = this.visible();
    return {
      offcanvas: typeof responsive === 'boolean',
      [`offcanvas-${responsive}`]: typeof responsive !== 'boolean',
      [`offcanvas-${placement}`]: !!placement,
      show: visible
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  ariaHidden = computed(() => {
    return this.visible() ? null : true;
  }, ...(ngDevMode ? [{
    debugName: "ariaHidden"
  }] : []));
  get tabIndex() {
    return '-1';
  }
  get show() {
    return this.visible();
  }
  set show(value) {
    this.visible.set(value);
  }
  get responsiveBreakpoint() {
    const responsive = this.responsive();
    if (typeof responsive !== 'string') {
      return false;
    }
    const element = this.#document.documentElement;
    const breakpointValue = this.#document.defaultView?.getComputedStyle(element)?.getPropertyValue(`--cui-breakpoint-${responsive.trim()}`) ?? false;
    return breakpointValue ? `${parseFloat(breakpointValue.trim()) - 0.02}px` : false;
  }
  animateStart(event) {
    if (event.toState === 'visible') {
      if (!this.scroll()) {
        this.#backdropService.hideScrollbar();
      }
      this.#renderer.addClass(this.#hostElement.nativeElement, 'showing');
    } else {
      this.#renderer.addClass(this.#hostElement.nativeElement, 'hiding');
    }
  }
  animateDone(event) {
    setTimeout(() => {
      if (event.toState === 'visible') {
        this.#renderer.removeClass(this.#hostElement.nativeElement, 'showing');
      }
      if (event.toState === 'hidden') {
        this.#renderer.removeClass(this.#hostElement.nativeElement, 'hiding');
        this.#renderer.removeStyle(this.#document.body, 'overflow');
        this.#renderer.removeStyle(this.#document.body, 'paddingRight');
      }
    });
    this.show = this.visible();
  }
  onKeyDownHandler(event) {
    if (event.key === 'Escape' && this.keyboard() && this.visible() && this.backdrop() !== 'static') {
      this.#offcanvasService.toggle({
        show: false,
        id: this.id()
      });
    }
  }
  ngOnInit() {
    this.stateToggleSubscribe();
    setTimeout(() => {
      // hotfix to avoid offcanvas flicker on the first render
      this.#renderer.setStyle(this.#hostElement.nativeElement, 'display', 'flex');
    });
  }
  ngOnDestroy() {
    this.#offcanvasService.toggle({
      show: false,
      id: this.id()
    });
  }
  setFocus() {
    if (isPlatformBrowser(this.#platformId)) {
      setTimeout(() => this.#hostElement.nativeElement.focus());
    }
  }
  stateToggleSubscribe() {
    this.#offcanvasService.offcanvasState$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(action => {
      if (this === action.offcanvas || this.id() === action.id) {
        if ('show' in action) {
          this.visible.update(value => action?.show === 'toggle' ? !value : action.show);
        }
      }
    });
  }
  backdropClickSubscribe(subscribe = true) {
    if (subscribe) {
      this.#backdropClickSubscription = this.#backdropService.backdropClick$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(clicked => {
        this.#offcanvasService.toggle({
          show: !clicked,
          id: this.id()
        });
      });
    } else {
      this.#backdropClickSubscription?.unsubscribe();
    }
  }
  setBackdrop(setBackdrop) {
    this.#activeBackdrop = !!setBackdrop ? this.#backdropService.setBackdrop('offcanvas') : this.#backdropService.clearBackdrop(this.#activeBackdrop);
    setBackdrop === true ? this.backdropClickSubscribe() : this.backdropClickSubscribe(false);
  }
  layoutChangeSubscribe(subscribe = true) {
    if (subscribe) {
      if (!this.responsiveBreakpoint) {
        return;
      }
      const responsiveBreakpoint = `(max-width: ${this.responsiveBreakpoint})`;
      const layoutChanges = this.#breakpointObserver.observe([responsiveBreakpoint]);
      this.#layoutChangeSubscription = layoutChanges.pipe(filter(breakpointState => !breakpointState.matches), takeUntilDestroyed(this.#destroyRef)).subscribe(breakpointState => {
        this.visible.set(breakpointState.matches);
      });
    } else {
      this.#layoutChangeSubscription?.unsubscribe();
    }
  }
  static ɵfac = function OffcanvasComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || OffcanvasComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: OffcanvasComponent,
    selectors: [["c-offcanvas"]],
    hostAttrs: ["ngSkipHydration", "true"],
    hostVars: 8,
    hostBindings: function OffcanvasComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵsyntheticHostListener("@showHide.start", function OffcanvasComponent_animation_showHide_start_HostBindingHandler($event) {
          return ctx.animateStart($event);
        })("@showHide.done", function OffcanvasComponent_animation_showHide_done_HostBindingHandler($event) {
          return ctx.animateDone($event);
        });
        i0.ɵɵlistener("keydown", function OffcanvasComponent_keydown_HostBindingHandler($event) {
          return ctx.onKeyDownHandler($event);
        }, i0.ɵɵresolveDocument);
      }
      if (rf & 2) {
        i0.ɵɵsyntheticHostProperty("@showHide", ctx.visible() ? "visible" : "hidden");
        i0.ɵɵattribute("id", ctx.id())("inert", ctx.ariaHidden() || null)("role", ctx.role())("aria-modal", ctx.ariaModal())("tabindex", ctx.tabIndex);
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      backdrop: [1, "backdrop"],
      keyboard: [1, "keyboard"],
      placement: [1, "placement"],
      responsive: [1, "responsive"],
      id: [1, "id"],
      role: [1, "role"],
      ariaModal: [1, "ariaModal"],
      scroll: [1, "scroll"],
      visibleInput: [1, "visible", "visibleInput"]
    },
    outputs: {
      visibleChange: "visibleChange"
    },
    exportAs: ["cOffcanvas"],
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: ThemeDirective,
      inputs: ["dark", "dark"]
    }])],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [["cdkTrapFocus", "", "cdkTrapFocusAutoCapture", ""]],
    template: function OffcanvasComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
    },
    dependencies: [A11yModule, i1$1.CdkTrapFocus],
    styles: ["[_nghost-%COMP%]{display:none}"],
    data: {
      animation: [trigger('showHide', [state('visible', style({
        // visibility: 'visible'
      })), state('hidden', style({
        // visibility: 'hidden'
      })), transition('visible <=> *', [animate('300ms')])])]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasComponent, [{
    type: Component,
    args: [{
      selector: 'c-offcanvas',
      animations: [trigger('showHide', [state('visible', style({
        // visibility: 'visible'
      })), state('hidden', style({
        // visibility: 'hidden'
      })), transition('visible <=> *', [animate('300ms')])])],
      exportAs: 'cOffcanvas',
      imports: [A11yModule],
      hostDirectives: [{
        directive: ThemeDirective,
        inputs: ['dark']
      }],
      host: {
        ngSkipHydration: 'true',
        '[@showHide]': 'this.visible() ? "visible" : "hidden"',
        '[attr.id]': 'id()',
        '[attr.inert]': 'ariaHidden() || null',
        '[attr.role]': 'role()',
        '[attr.aria-modal]': 'ariaModal()',
        '[attr.tabindex]': 'tabIndex',
        '[class]': 'hostClasses()',
        '(@showHide.start)': 'animateStart($event)',
        '(@showHide.done)': 'animateDone($event)',
        '(document:keydown)': 'onKeyDownHandler($event)'
      },
      template: "<div cdkTrapFocus cdkTrapFocusAutoCapture>\n  <ng-content />\n</div>\n\n",
      styles: [":host{display:none}\n"]
    }]
  }], null, {
    backdrop: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "backdrop",
        required: false
      }]
    }],
    keyboard: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "keyboard",
        required: false
      }]
    }],
    placement: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "placement",
        required: false
      }]
    }],
    responsive: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "responsive",
        required: false
      }]
    }],
    id: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "id",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }],
    ariaModal: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "ariaModal",
        required: false
      }]
    }],
    scroll: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "scroll",
        required: false
      }]
    }],
    visibleInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    visibleChange: [{
      type: i0.Output,
      args: ["visibleChange"]
    }]
  });
})();
class OffcanvasBodyComponent {
  static ɵfac = function OffcanvasBodyComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || OffcanvasBodyComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: OffcanvasBodyComponent,
    selectors: [["c-offcanvas-body"]],
    hostAttrs: [1, "offcanvas-body"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function OffcanvasBodyComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasBodyComponent, [{
    type: Component,
    args: [{
      selector: 'c-offcanvas-body',
      template: '<ng-content />',
      host: {
        class: 'offcanvas-body'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class OffcanvasHeaderComponent {
  static ɵfac = function OffcanvasHeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || OffcanvasHeaderComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: OffcanvasHeaderComponent,
    selectors: [["c-offcanvas-header"]],
    hostAttrs: [1, "offcanvas-header"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function OffcanvasHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-offcanvas-header',
      template: '<ng-content />',
      host: {
        class: 'offcanvas-header'
      }
    }]
  }], null, null);
})();
class OffcanvasTitleDirective {
  static ɵfac = function OffcanvasTitleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || OffcanvasTitleDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: OffcanvasTitleDirective,
    selectors: [["", "cOffcanvasTitle", ""]],
    hostAttrs: [1, "offcanvas-title"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasTitleDirective, [{
    type: Directive,
    args: [{
      selector: '[cOffcanvasTitle]',
      host: {
        class: 'offcanvas-title'
      }
    }]
  }], null, null);
})();
class OffcanvasToggleDirective {
  #offcanvasService = inject(OffcanvasService);
  /**
   * Html id attr of offcanvas to toggle.
   * @return string
   */
  id = input(undefined, ...(ngDevMode ? [{
    debugName: "id",
    alias: 'cOffcanvasToggle'
  }] : [{
    alias: 'cOffcanvasToggle'
  }]));
  toggleOpen($event) {
    $event.preventDefault();
    this.#offcanvasService.toggle({
      show: 'toggle',
      id: this.id()
    });
  }
  static ɵfac = function OffcanvasToggleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || OffcanvasToggleDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: OffcanvasToggleDirective,
    selectors: [["", "cOffcanvasToggle", ""]],
    hostBindings: function OffcanvasToggleDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function OffcanvasToggleDirective_click_HostBindingHandler($event) {
          return ctx.toggleOpen($event);
        });
      }
    },
    inputs: {
      id: [1, "cOffcanvasToggle", "id"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasToggleDirective, [{
    type: Directive,
    args: [{
      selector: '[cOffcanvasToggle]',
      host: {
        '(click)': 'toggleOpen($event)'
      }
    }]
  }], null, {
    id: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cOffcanvasToggle",
        required: false
      }]
    }]
  });
})();
class OffcanvasModule {
  static ɵfac = function OffcanvasModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || OffcanvasModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: OffcanvasModule,
    imports: [OffcanvasBodyComponent, OffcanvasComponent, OffcanvasHeaderComponent, OffcanvasTitleDirective, OffcanvasToggleDirective],
    exports: [OffcanvasBodyComponent, OffcanvasComponent, OffcanvasHeaderComponent, OffcanvasTitleDirective, OffcanvasToggleDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [OffcanvasService, BackdropService],
    imports: [OffcanvasComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffcanvasModule, [{
    type: NgModule,
    args: [{
      exports: [OffcanvasBodyComponent, OffcanvasComponent, OffcanvasHeaderComponent, OffcanvasTitleDirective, OffcanvasToggleDirective],
      imports: [OffcanvasBodyComponent, OffcanvasComponent, OffcanvasHeaderComponent, OffcanvasTitleDirective, OffcanvasToggleDirective],
      providers: [OffcanvasService, BackdropService]
    }]
  }], null, null);
})();
class PageLinkDirective {
  static ngAcceptInputType_disabled;
  disabled = input(false, ...(ngDevMode ? [{
    debugName: "disabled",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  hostClasses = computed(() => {
    return {
      'page-link': true,
      disabled: this.disabled()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function PageLinkDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PageLinkDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: PageLinkDirective,
    selectors: [["", "cPageLink", ""]],
    hostAttrs: [1, "page-link"],
    hostVars: 2,
    hostBindings: function PageLinkDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      disabled: [1, "disabled"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageLinkDirective, [{
    type: Directive,
    args: [{
      selector: '[cPageLink]',
      host: {
        class: 'page-link',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    disabled: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "disabled",
        required: false
      }]
    }]
  });
})();
class PageItemDirective {
  static ngAcceptInputType_disabled;
  #renderer = inject(Renderer2);
  /**
   * Toggle the active state for the component.
   * @return boolean
   */
  active = input(...(ngDevMode ? [undefined, {
    debugName: "active"
  }] : []));
  /**
   * Toggle the disabled state for the component.
   * @return boolean
   */
  disabled = input(false, ...(ngDevMode ? [{
    debugName: "disabled",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  ariaCurrent = computed(() => {
    return this.active() ? 'page' : null;
  }, ...(ngDevMode ? [{
    debugName: "ariaCurrent"
  }] : []));
  hostClasses = computed(() => {
    return {
      'page-item': true,
      disabled: this.disabled(),
      active: this.active()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  pageLinkElementRef = contentChild(PageLinkDirective, ...(ngDevMode ? [{
    debugName: "pageLinkElementRef",
    read: ElementRef
  }] : [{
    read: ElementRef
  }]));
  pageLinkElementRefEffect = effect(() => {
    const pageLinkElementRef = this.pageLinkElementRef();
    const disabled = this.disabled();
    if (!pageLinkElementRef) {
      return;
    }
    const pageLinkElement = pageLinkElementRef.nativeElement;
    if (disabled) {
      this.#renderer.setAttribute(pageLinkElement, 'aria-disabled', 'true');
      this.#renderer.setAttribute(pageLinkElement, 'tabindex', '-1');
    } else {
      this.#renderer.removeAttribute(pageLinkElement, 'aria-disabled');
      this.#renderer.removeAttribute(pageLinkElement, 'tabindex');
    }
  }, ...(ngDevMode ? [{
    debugName: "pageLinkElementRefEffect"
  }] : []));
  static ɵfac = function PageItemDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PageItemDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: PageItemDirective,
    selectors: [["", "cPageItem", ""]],
    contentQueries: function PageItemDirective_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.pageLinkElementRef, PageLinkDirective, 5, ElementRef);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "page-item"],
    hostVars: 3,
    hostBindings: function PageItemDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-current", ctx.ariaCurrent());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      active: [1, "active"],
      disabled: [1, "disabled"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageItemDirective, [{
    type: Directive,
    args: [{
      selector: '[cPageItem]',
      host: {
        class: 'page-item',
        '[class]': 'hostClasses()',
        '[attr.aria-current]': 'ariaCurrent()'
      }
    }]
  }], null, {
    active: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "active",
        required: false
      }]
    }],
    disabled: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "disabled",
        required: false
      }]
    }],
    pageLinkElementRef: [{
      type: i0.ContentChild,
      args: [i0.forwardRef(() => PageLinkDirective), {
        ...{
          read: ElementRef
        },
        isSignal: true
      }]
    }]
  });
})();
class PageItemComponent extends PageItemDirective {
  static ɵfac = /* @__PURE__ */(() => {
    let ɵPageItemComponent_BaseFactory;
    return function PageItemComponent_Factory(__ngFactoryType__) {
      return (ɵPageItemComponent_BaseFactory || (ɵPageItemComponent_BaseFactory = i0.ɵɵgetInheritedFactory(PageItemComponent)))(__ngFactoryType__ || PageItemComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PageItemComponent,
    selectors: [["c-page-item"]],
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function PageItemComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: [_c7]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageItemComponent, [{
    type: Component,
    args: [{
      selector: 'c-page-item',
      template: '<ng-content />',
      styles: [":host{display:list-item;text-align:-webkit-match-parent;text-align:match-parent}\n"]
    }]
  }], null, null);
})();
class PaginationComponent {
  /**
   * Set the alignment of pagination components.
   * @values 'start', 'center', 'end'
   */
  align = input('', ...(ngDevMode ? [{
    debugName: "align"
  }] : []));
  /**
   * Size the component small or large.
   * @values 'sm', 'lg'
   */
  size = input(...(ngDevMode ? [undefined, {
    debugName: "size"
  }] : []));
  /**
   * Default role for pagination. [docs]
   * @return string
   * @default 'navigation'
   */
  role = input('navigation', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  paginationClass = computed(() => {
    const size = this.size();
    const align = this.align();
    return {
      pagination: true,
      [`pagination-${size}`]: !!size,
      [`justify-content-${align}`]: !!align
    };
  }, ...(ngDevMode ? [{
    debugName: "paginationClass"
  }] : []));
  static ɵfac = function PaginationComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PaginationComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PaginationComponent,
    selectors: [["c-pagination"]],
    hostVars: 1,
    hostBindings: function PaginationComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
      }
    },
    inputs: {
      align: [1, "align"],
      size: [1, "size"],
      role: [1, "role"]
    },
    ngContentSelectors: _c0,
    decls: 2,
    vars: 1,
    consts: [[3, "ngClass"]],
    template: function PaginationComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "ul", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.paginationClass());
      }
    },
    dependencies: [NgClass],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationComponent, [{
    type: Component,
    args: [{
      selector: 'c-pagination',
      imports: [NgClass],
      host: {
        '[attr.role]': 'role()'
      },
      template: "<ul [ngClass]=\"paginationClass()\">\n  <ng-content />\n</ul>\n"
    }]
  }], null, {
    align: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "align",
        required: false
      }]
    }],
    size: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "size",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class PaginationModule {
  static ɵfac = function PaginationModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PaginationModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PaginationModule,
    imports: [PageItemComponent, PageItemDirective, PageLinkDirective, PaginationComponent],
    exports: [PageItemComponent, PageItemDirective, PageLinkDirective, PaginationComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationModule, [{
    type: NgModule,
    args: [{
      exports: [PageItemComponent, PageItemDirective, PageLinkDirective, PaginationComponent],
      imports: [PageItemComponent, PageItemDirective, PageLinkDirective, PaginationComponent]
    }]
  }], null, null);
})();
class PlaceholderDirective {
  /**
   * placeholder toggler
   * @type boolean
   * @default false
   */
  visible = input(false, ...(ngDevMode ? [{
    debugName: "visible",
    transform: booleanAttribute,
    alias: 'cPlaceholder'
  }] : [{
    transform: booleanAttribute,
    alias: 'cPlaceholder'
  }]));
  /**
   * Size the placeholder xs, small, large.
   */
  size = input(undefined, ...(ngDevMode ? [{
    debugName: "size",
    alias: 'cPlaceholderSize'
  }] : [{
    alias: 'cPlaceholderSize'
  }]));
  ariaHidden = computed(() => {
    return this.visible() ? null : true;
  }, ...(ngDevMode ? [{
    debugName: "ariaHidden"
  }] : []));
  hostClasses = computed(() => {
    const size = this.size();
    return {
      placeholder: this.visible(),
      [`placeholder-${size}`]: !!size
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function PlaceholderDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PlaceholderDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: PlaceholderDirective,
    selectors: [["", "cPlaceholder", ""]],
    hostVars: 3,
    hostBindings: function PlaceholderDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-hidden", ctx.ariaHidden());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      visible: [1, "cPlaceholder", "visible"],
      size: [1, "cPlaceholderSize", "size"]
    },
    exportAs: ["cPlaceholder"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlaceholderDirective, [{
    type: Directive,
    args: [{
      selector: '[cPlaceholder]',
      exportAs: 'cPlaceholder',
      host: {
        '[class]': 'hostClasses()',
        '[attr.aria-hidden]': 'ariaHidden()'
      }
    }]
  }], null, {
    visible: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cPlaceholder",
        required: false
      }]
    }],
    size: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cPlaceholderSize",
        required: false
      }]
    }]
  });
})();
class PlaceholderAnimationDirective {
  /**
   * Animation type for placeholder
   * @type 'glow' | 'wave'
   * @default undefined
   */
  animation = input(undefined, ...(ngDevMode ? [{
    debugName: "animation",
    alias: 'cPlaceholderAnimation'
  }] : [{
    alias: 'cPlaceholderAnimation'
  }]));
  placeholder = contentChild(PlaceholderDirective, ...(ngDevMode ? [{
    debugName: "placeholder"
  }] : []));
  hostClasses = computed(() => {
    const animation = this.animation();
    return {
      [`placeholder-${animation}`]: this.placeholder()?.visible() && !!animation
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function PlaceholderAnimationDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PlaceholderAnimationDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: PlaceholderAnimationDirective,
    selectors: [["", "cPlaceholderAnimation", ""]],
    contentQueries: function PlaceholderAnimationDirective_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.placeholder, PlaceholderDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 2,
    hostBindings: function PlaceholderAnimationDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      animation: [1, "cPlaceholderAnimation", "animation"]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlaceholderAnimationDirective, [{
    type: Directive,
    args: [{
      selector: '[cPlaceholderAnimation]',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    animation: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cPlaceholderAnimation",
        required: false
      }]
    }],
    placeholder: [{
      type: i0.ContentChild,
      args: [i0.forwardRef(() => PlaceholderDirective), {
        isSignal: true
      }]
    }]
  });
})();
class PlaceholderModule {
  static ɵfac = function PlaceholderModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PlaceholderModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PlaceholderModule,
    imports: [PlaceholderDirective, PlaceholderAnimationDirective],
    exports: [PlaceholderDirective, PlaceholderAnimationDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlaceholderModule, [{
    type: NgModule,
    args: [{
      imports: [PlaceholderDirective, PlaceholderAnimationDirective],
      exports: [PlaceholderDirective, PlaceholderAnimationDirective]
    }]
  }], null, null);
})();
class PopoverComponent {
  renderer = inject(Renderer2);
  /**
   * Content of popover
   * @return {string | TemplateRef}
   */
  content = input('', ...(ngDevMode ? [{
    debugName: "content"
  }] : []));
  #contentEffect = effect(() => {
    this.updateView(this.content());
  }, ...(ngDevMode ? [{
    debugName: "#contentEffect"
  }] : []));
  /**
   * Toggle the visibility of popover component.
   * @return boolean
   */
  visible = input(false, ...(ngDevMode ? [{
    debugName: "visible",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  id = input(...(ngDevMode ? [undefined, {
    debugName: "id"
  }] : []));
  role = input('tooltip', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  viewContainerRef = viewChild('popoverTemplate', ...(ngDevMode ? [{
    debugName: "viewContainerRef",
    read: ViewContainerRef
  }] : [{
    read: ViewContainerRef
  }]));
  textNode;
  hostClasses = computed(() => {
    return {
      popover: true,
      fade: true,
      show: this.visible(),
      'bs-popover-auto': true
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  ngOnDestroy() {
    this.clear();
  }
  clear() {
    this.viewContainerRef()?.clear();
    if (!!this.textNode) {
      this.renderer.removeChild(this.textNode.parentNode, this.textNode);
    }
  }
  updateView(content) {
    this.clear();
    if (!content) {
      return;
    }
    if (content instanceof TemplateRef) {
      this.viewContainerRef()?.createEmbeddedView(content);
    } else {
      const textNodeContent = this.renderer.createText(content);
      this.textNode = this.renderer.createElement('div');
      this.renderer.addClass(this.textNode, 'popover-body');
      this.renderer.appendChild(this.textNode, textNodeContent);
      const element = this.viewContainerRef()?.element.nativeElement;
      this.renderer.appendChild(element.parentNode, this.textNode);
    }
  }
  static ɵfac = function PopoverComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PopoverComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PopoverComponent,
    selectors: [["c-popover"]],
    viewQuery: function PopoverComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.viewContainerRef, _c8, 5, ViewContainerRef);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "popover", "fade", "bs-popover-auto"],
    hostVars: 4,
    hostBindings: function PopoverComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role())("id", ctx.id());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      content: [1, "content"],
      visible: [1, "visible"],
      id: [1, "id"],
      role: [1, "role"]
    },
    decls: 4,
    vars: 3,
    consts: [["popoverTemplate", ""], ["data-popper-arrow", "", 3, "ngClass"]],
    template: function PopoverComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementContainer(2, null, 0);
        i0.ɵɵelementContainerEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c9, !!ctx.content()));
      }
    },
    dependencies: [NgClass],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverComponent, [{
    type: Component,
    args: [{
      selector: 'c-popover',
      imports: [NgClass],
      host: {
        class: 'popover fade bs-popover-auto',
        '[class]': 'hostClasses()',
        '[attr.role]': 'role()',
        '[attr.id]': 'id()'
      },
      template: "<ng-container>\n  <div [ngClass]=\"{'popover-arrow': !!content()}\" data-popper-arrow></div>\n  <ng-container #popoverTemplate />\n</ng-container>\n"
    }]
  }], null, {
    content: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "content",
        required: false
      }]
    }],
    visible: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    id: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "id",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }],
    viewContainerRef: [{
      type: i0.ViewChild,
      args: ['popoverTemplate', {
        ...{
          read: ViewContainerRef
        },
        isSignal: true
      }]
    }]
  });
})();
class PopoverDirective {
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  #viewContainerRef = inject(ViewContainerRef);
  #listenersService = inject(ListenersService);
  #changeDetectorRef = inject(ChangeDetectorRef);
  #intersectionService = inject(IntersectionService);
  #destroyRef = inject(DestroyRef);
  #document = inject(DOCUMENT);
  /**
   * Content of popover
   * @return {string | TemplateRef}
   */
  content = input(undefined, ...(ngDevMode ? [{
    debugName: "content",
    alias: 'cPopover'
  }] : [{
    alias: 'cPopover'
  }]));
  #contentEffect = effect(() => {
    if (this.content()) {
      this.destroyTooltipElement();
    }
  }, ...(ngDevMode ? [{
    debugName: "#contentEffect"
  }] : []));
  /**
   * Optional popper Options object, takes precedence over cPopoverPlacement prop
   * @return Partial<Options>
   */
  popperOptions = input({}, ...(ngDevMode ? [{
    debugName: "popperOptions",
    alias: 'cPopoverOptions'
  }] : [{
    alias: 'cPopoverOptions'
  }]));
  #popperOptionsEffect = effect(() => {
    this._popperOptions = {
      ...this._popperOptions,
      placement: this.placement(),
      ...this.popperOptions()
    };
  }, ...(ngDevMode ? [{
    debugName: "#popperOptionsEffect"
  }] : []));
  popperOptionsComputed = computed(() => {
    return {
      placement: this.placement(),
      ...this._popperOptions
    };
  }, ...(ngDevMode ? [{
    debugName: "popperOptionsComputed"
  }] : []));
  /**
   * Describes the placement of your component after Popper.js has applied all the modifiers that may have flipped or altered the originally provided placement property.
   * @return: 'top' | 'bottom' | 'left' | 'right'
   * @default: 'top'
   */
  placement = input('top', ...(ngDevMode ? [{
    debugName: "placement",
    alias: 'cPopoverPlacement'
  }] : [{
    alias: 'cPopoverPlacement'
  }]));
  /**
   * ElementRefDirective for positioning the tooltip on reference element
   * @return: ElementRefDirective
   * @default: undefined
   */
  reference = input(undefined, ...(ngDevMode ? [{
    debugName: "reference",
    alias: 'cTooltipRef'
  }] : [{
    alias: 'cTooltipRef'
  }]));
  referenceRef = computed(() => this.reference()?.elementRef ?? this.#hostElement, ...(ngDevMode ? [{
    debugName: "referenceRef"
  }] : []));
  /**
   * Sets which event handlers you’d like provided to your toggle prop. You can specify one trigger or an array of them.
   * @return: Triggers | Triggers[]
   */
  trigger = input('hover', ...(ngDevMode ? [{
    debugName: "trigger",
    alias: 'cPopoverTrigger'
  }] : [{
    alias: 'cPopoverTrigger'
  }]));
  /**
   * Toggle the visibility of popover component.
   * @return boolean
   */
  visible = model(false, ...(ngDevMode ? [{
    debugName: "visible",
    alias: 'cPopoverVisible'
  }] : [{
    alias: 'cPopoverVisible'
  }]));
  #visibleEffect = afterRenderEffect({
    // this fixes RuntimeError: NG0500: During hydration Angular expected <abc> but found <xyz>.
    // Find more at https://angular.dev/errors/NG0500
    write: () => {
      this.visible() ? this.addTooltipElement() : this.removeTooltipElement();
    }
  });
  get ariaDescribedBy() {
    return this.tooltipId ? this.tooltipId : null;
  }
  tooltip;
  tooltipId;
  tooltipRef;
  popperInstance;
  _popperOptions = {
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 9]
      }
    }]
  };
  ngAfterViewInit() {
    this.intersectionServiceSubscribe();
  }
  ngOnDestroy() {
    this.clearListeners();
    this.destroyTooltipElement();
  }
  ngOnInit() {
    this.setListeners();
  }
  setListeners() {
    const config = {
      hostElement: this.#hostElement,
      trigger: this.trigger(),
      callbackToggle: () => {
        this.visible.update(visible => !visible);
      },
      callbackOff: () => {
        this.visible.set(false);
      },
      callbackOn: () => {
        this.visible.set(true);
      }
    };
    this.#listenersService.setListeners(config);
  }
  clearListeners() {
    this.#listenersService.clearListeners();
  }
  intersectionServiceSubscribe() {
    this.#intersectionService.createIntersectionObserver(this.referenceRef());
    this.#intersectionService.intersecting$.pipe(filter(next => next.hostElement === this.referenceRef()), debounceTime(100), finalize(() => {
      this.#intersectionService.unobserve(this.referenceRef());
    }), takeUntilDestroyed(this.#destroyRef)).subscribe(next => {
      this.visible.set(next.isIntersecting ? this.visible() : false);
    });
  }
  getUID(prefix) {
    let uid = prefix ?? 'random-id';
    do {
      uid = `${prefix}-${Math.floor(Math.random() * 1000000).toString(10)}`;
    } while (this.#document.getElementById(uid));
    return uid;
  }
  createTooltipElement() {
    if (!this.tooltipRef) {
      this.tooltipRef = this.#viewContainerRef.createComponent(PopoverComponent);
      // this.viewContainerRef.detach();
    }
  }
  destroyTooltipElement() {
    this.tooltip?.remove();
    this.tooltipRef?.destroy();
    // @ts-ignore
    this.tooltipRef = undefined;
    this.popperInstance?.destroy();
    this.#viewContainerRef?.detach();
    this.#viewContainerRef?.clear();
  }
  addTooltipElement() {
    if (!this.content()) {
      this.destroyTooltipElement();
      return;
    }
    if (!this.tooltipRef) {
      this.createTooltipElement();
    }
    this.tooltipRef?.setInput('content', this.content() ?? '');
    this.tooltip = this.tooltipRef?.location.nativeElement;
    this.#renderer.addClass(this.tooltip, 'd-none');
    this.#renderer.addClass(this.tooltip, 'fade');
    this.popperInstance?.destroy();
    this.#viewContainerRef.insert(this.tooltipRef.hostView);
    this.#renderer.appendChild(this.#document.body, this.tooltip);
    this.popperInstance = createPopper(this.referenceRef().nativeElement, this.tooltip, {
      ...this.popperOptionsComputed()
    });
    if (!this.visible()) {
      this.removeTooltipElement();
      return;
    }
    setTimeout(() => {
      this.tooltipId = this.getUID('popover');
      this.tooltipRef?.setInput('id', this.tooltipId);
      this.#renderer.removeClass(this.tooltip, 'd-none');
      this.tooltipRef?.setInput('visible', this.visible());
      this.popperInstance?.forceUpdate();
      this.#changeDetectorRef?.markForCheck();
    }, 100);
  }
  removeTooltipElement() {
    this.tooltipId = '';
    if (!this.tooltipRef) {
      return;
    }
    this.tooltipRef.setInput('visible', false);
    this.tooltipRef.setInput('id', undefined);
    this.#changeDetectorRef.markForCheck();
    setTimeout(() => {
      this.#viewContainerRef?.detach();
    }, 300);
  }
  static ɵfac = function PopoverDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PopoverDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: PopoverDirective,
    selectors: [["", "cPopover", ""]],
    hostVars: 1,
    hostBindings: function PopoverDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-describedby", ctx.ariaDescribedBy);
      }
    },
    inputs: {
      content: [1, "cPopover", "content"],
      popperOptions: [1, "cPopoverOptions", "popperOptions"],
      placement: [1, "cPopoverPlacement", "placement"],
      reference: [1, "cTooltipRef", "reference"],
      trigger: [1, "cPopoverTrigger", "trigger"],
      visible: [1, "cPopoverVisible", "visible"]
    },
    outputs: {
      visible: "cPopoverVisibleChange"
    },
    exportAs: ["cPopover"],
    features: [i0.ɵɵProvidersFeature([ListenersService, IntersectionService])]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverDirective, [{
    type: Directive,
    args: [{
      selector: '[cPopover]',
      exportAs: 'cPopover',
      providers: [ListenersService, IntersectionService],
      host: {
        '[attr.aria-describedby]': 'ariaDescribedBy'
      }
    }]
  }], null, {
    content: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cPopover",
        required: false
      }]
    }],
    popperOptions: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cPopoverOptions",
        required: false
      }]
    }],
    placement: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cPopoverPlacement",
        required: false
      }]
    }],
    reference: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTooltipRef",
        required: false
      }]
    }],
    trigger: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cPopoverTrigger",
        required: false
      }]
    }],
    visible: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cPopoverVisible",
        required: false
      }]
    }, {
      type: i0.Output,
      args: ["cPopoverVisibleChange"]
    }]
  });
})();
class PopoverModule {
  static ɵfac = function PopoverModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PopoverModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PopoverModule,
    imports: [PopoverDirective, PopoverComponent],
    exports: [PopoverDirective, PopoverComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverModule, [{
    type: NgModule,
    args: [{
      exports: [PopoverDirective, PopoverComponent],
      imports: [PopoverDirective, PopoverComponent]
    }]
  }], null, null);
})();
class ProgressService {
  stacked = signal(false, ...(ngDevMode ? [{
    debugName: "stacked"
  }] : []));
  value = signal(undefined, ...(ngDevMode ? [{
    debugName: "value"
  }] : []));
  precision = signal(0, ...(ngDevMode ? [{
    debugName: "precision"
  }] : []));
  min = signal(0, ...(ngDevMode ? [{
    debugName: "min"
  }] : []));
  max = signal(100, ...(ngDevMode ? [{
    debugName: "max"
  }] : []));
  percent = computed(() => {
    return +(((this.value() ?? 0) - this.min()) / (this.max() - this.min()) * 100).toFixed(this.precision());
  }, ...(ngDevMode ? [{
    debugName: "percent"
  }] : []));
  static ɵfac = function ProgressService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProgressService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProgressService,
    factory: ProgressService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressService, [{
    type: Injectable
  }], null, null);
})();
class ProgressBarDirective {
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  #progressService = inject(ProgressService);
  #valuesEffect = effect(() => {
    const host = this.#hostElement.nativeElement;
    const value = this.#progressService.value();
    const percent = this.#progressService.percent();
    const stacked = this.#progressService.stacked();
    if (value === undefined) {
      for (const name of ['aria-valuenow', 'aria-valuemax', 'aria-valuemin', 'role']) {
        this.#renderer.removeAttribute(host, name);
      }
    } else {
      const {
        min,
        max
      } = this.#progressService;
      this.#renderer.setAttribute(host, 'aria-valuenow', String(value));
      this.#renderer.setAttribute(host, 'aria-valuemin', String(min()));
      this.#renderer.setAttribute(host, 'aria-valuemax', String(max()));
      this.#renderer.setAttribute(host, 'role', this.role());
    }
    const tagName = host.tagName;
    if (percent >= 0 && (stacked && tagName === 'C-PROGRESS' || !stacked && tagName !== 'C-PROGRESS')) {
      this.#renderer.setStyle(host, 'width', `${percent}%`);
    } else {
      this.#renderer.removeStyle(host, 'width');
    }
  }, ...(ngDevMode ? [{
    debugName: "#valuesEffect"
  }] : []));
  /**
   * Use to animate the stripes right to left via CSS3 animations.
   * @return boolean
   */
  animated = input(undefined, ...(ngDevMode ? [{
    debugName: "animated",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @values 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light'
   */
  color = input(...(ngDevMode ? [undefined, {
    debugName: "color"
  }] : []));
  precision = input(0, ...(ngDevMode ? [{
    debugName: "precision",
    transform: numberAttribute
  }] : [{
    transform: numberAttribute
  }]));
  /**
   * The percent value the ProgressBar.
   * @return number
   * @default 0
   */
  value = input(0, ...(ngDevMode ? [{
    debugName: "value",
    transform: numberAttribute
  }] : [{
    transform: numberAttribute
  }]));
  /**
   * Set the progress bar variant to optional striped.
   * @values 'striped'
   * @default undefined
   */
  variant = input(...(ngDevMode ? [undefined, {
    debugName: "variant"
  }] : []));
  /**
   * The max value of the ProgressBar.
   * @return number
   * @default 100
   */
  max = input(100, ...(ngDevMode ? [{
    debugName: "max",
    transform: numberAttribute
  }] : [{
    transform: numberAttribute
  }]));
  /**
   * Set default html role attribute.
   * @return string
   */
  role = input('progressbar', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  #serviceEffect = effect(() => {
    this.#progressService.precision.set(this.precision());
    const max = this.max();
    this.#progressService.max.set(isNaN(max) || max <= 0 ? 100 : max);
    const value = this.value();
    this.#progressService.value.set(value && !isNaN(value) ? value : undefined);
  }, ...(ngDevMode ? [{
    debugName: "#serviceEffect"
  }] : []));
  static ɵfac = function ProgressBarDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProgressBarDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ProgressBarDirective,
    selectors: [["", "cProgressBar", ""]],
    inputs: {
      animated: [1, "animated"],
      color: [1, "color"],
      precision: [1, "precision"],
      value: [1, "value"],
      variant: [1, "variant"],
      max: [1, "max"],
      role: [1, "role"]
    },
    exportAs: ["cProgressBar"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressBarDirective, [{
    type: Directive,
    args: [{
      selector: '[cProgressBar]',
      exportAs: 'cProgressBar'
    }]
  }], null, {
    animated: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "animated",
        required: false
      }]
    }],
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    precision: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "precision",
        required: false
      }]
    }],
    value: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "value",
        required: false
      }]
    }],
    variant: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "variant",
        required: false
      }]
    }],
    max: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "max",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class ProgressBarComponent {
  #progressBarDirective = inject(ProgressBarDirective, {
    optional: true
  });
  hostClasses = computed(() => {
    const animated = this.#progressBarDirective?.animated();
    const color = this.#progressBarDirective?.color();
    const variant = this.#progressBarDirective?.variant();
    return {
      'progress-bar': true,
      'progress-bar-animated': !!animated,
      [`progress-bar-${variant}`]: !!variant,
      [`bg-${color}`]: !!color
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function ProgressBarComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProgressBarComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ProgressBarComponent,
    selectors: [["c-progress-bar"]],
    hostAttrs: [1, "progress-bar"],
    hostVars: 2,
    hostBindings: function ProgressBarComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: ProgressBarDirective,
      inputs: ["animated", "animated", "color", "color", "max", "max", "role", "role", "value", "value", "variant", "variant"]
    }])],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ProgressBarComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressBarComponent, [{
    type: Component,
    args: [{
      selector: 'c-progress-bar',
      template: '<ng-content />',
      hostDirectives: [{
        directive: ProgressBarDirective,
        inputs: ['animated', 'color', 'max', 'role', 'value', 'variant']
      }],
      host: {
        class: 'progress-bar',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, null);
})();
class ProgressStackedComponent {
  stacked = input(true, ...(ngDevMode ? [{
    debugName: "stacked"
  }] : []));
  static ɵfac = function ProgressStackedComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProgressStackedComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ProgressStackedComponent,
    selectors: [["c-progress-stacked"]],
    hostVars: 2,
    hostBindings: function ProgressStackedComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("progress-stacked", ctx.stacked());
      }
    },
    inputs: {
      stacked: [1, "stacked"]
    },
    exportAs: ["cProgressStacked"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ProgressStackedComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:flex}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressStackedComponent, [{
    type: Component,
    args: [{
      selector: 'c-progress-stacked',
      exportAs: 'cProgressStacked',
      template: '<ng-content />',
      host: {
        '[class.progress-stacked]': 'stacked()'
      },
      styles: [":host{display:flex}\n"]
    }]
  }], null, {
    stacked: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "stacked",
        required: false
      }]
    }]
  });
})();
class ProgressComponent {
  #hostElement = inject(ElementRef);
  progressBarDirective = inject(ProgressBarDirective, {
    optional: true
  });
  #stacked = inject(ProgressStackedComponent, {
    optional: true
  })?.stacked() ?? false;
  #progressService = inject(ProgressService);
  constructor() {
    this.#progressService.stacked.set(this.#stacked);
  }
  stacked = this.#progressService.stacked;
  percent = this.#progressService.percent;
  barValue = this.#progressService.value;
  contentProgressBars = contentChildren(ProgressBarComponent, ...(ngDevMode ? [{
    debugName: "contentProgressBars"
  }] : []));
  /**
   * Sets the height of the component. If you set that value the inner `<CProgressBar>` will automatically resize accordingly.
   * @return number
   */
  height = input(0, ...(ngDevMode ? [{
    debugName: "height",
    transform: numberAttribute
  }] : [{
    transform: numberAttribute
  }]));
  /**
   * Displays thin progress.
   * @return boolean
   */
  thin = input(false, ...(ngDevMode ? [{
    debugName: "thin",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Change the default color to white.
   * @return boolean
   */
  white = input(false, ...(ngDevMode ? [{
    debugName: "white",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  hostClasses = computed(() => {
    return {
      progress: true,
      'progress-thin': this.thin(),
      'progress-white': this.white()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  hostStyle = computed(() => {
    const height = this.height();
    return !!height ? `${height}px` : this.#hostElement?.nativeElement?.style?.height ?? undefined;
  }, ...(ngDevMode ? [{
    debugName: "hostStyle"
  }] : []));
  static ɵfac = function ProgressComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProgressComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ProgressComponent,
    selectors: [["c-progress"]],
    contentQueries: function ProgressComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentProgressBars, ProgressBarComponent, 4);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "progress"],
    hostVars: 4,
    hostBindings: function ProgressComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
        i0.ɵɵstyleProp("height", ctx.hostStyle());
      }
    },
    inputs: {
      height: [1, "height"],
      thin: [1, "thin"],
      white: [1, "white"]
    },
    exportAs: ["cProgress"],
    features: [i0.ɵɵProvidersFeature([ProgressService]), i0.ɵɵHostDirectivesFeature([{
      directive: ProgressBarDirective,
      inputs: ["animated", "animated", "color", "color", "max", "max", "role", "role", "value", "value", "variant", "variant"]
    }])],
    ngContentSelectors: _c0,
    decls: 4,
    vars: 1,
    consts: [["defaultContent", ""], [3, "animated", "variant", "color", "value"], [4, "ngTemplateOutlet"]],
    template: function ProgressComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵconditionalCreate(0, ProgressComponent_Conditional_0_Template, 1, 1, "ng-container")(1, ProgressComponent_Conditional_1_Template, 2, 5, "c-progress-bar", 1);
        i0.ɵɵtemplate(2, ProgressComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        let tmp_1_0;
        i0.ɵɵconditional(((tmp_1_0 = ctx.contentProgressBars()) == null ? null : tmp_1_0.length) ? 0 : 1);
      }
    },
    dependencies: [ProgressBarComponent, NgTemplateOutlet],
    styles: [".progress-stacked.progress[_nghost-%COMP%], .progress-stacked   .progress[_nghost-%COMP%]{transition:var(--cui-progress-bar-transition)}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressComponent, [{
    type: Component,
    args: [{
      selector: 'c-progress',
      exportAs: 'cProgress',
      imports: [ProgressBarComponent, NgTemplateOutlet],
      hostDirectives: [{
        directive: ProgressBarDirective,
        inputs: ['animated', 'color', 'max', 'role', 'value', 'variant']
      }],
      host: {
        class: 'progress',
        '[class]': 'hostClasses()',
        '[style.height]': 'hostStyle()'
      },
      providers: [ProgressService],
      template: "@if (contentProgressBars()?.length) {\n  <ng-container *ngTemplateOutlet=\"defaultContent\" />\n} @else {\n  @let pbd = progressBarDirective;\n  <c-progress-bar [animated]=\"pbd?.animated()\" [variant]=\"pbd?.variant()\" [color]=\"pbd?.color()\" [value]=\"barValue()\">\n    <ng-container *ngTemplateOutlet=\"defaultContent\" />\n  </c-progress-bar>\n}\n\n<ng-template #defaultContent>\n  <ng-content />\n</ng-template>\n\n",
      styles: [":host-context(.progress-stacked).progress{transition:var(--cui-progress-bar-transition)}\n"]
    }]
  }], () => [], {
    contentProgressBars: [{
      type: i0.ContentChildren,
      args: [i0.forwardRef(() => ProgressBarComponent), {
        isSignal: true
      }]
    }],
    height: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "height",
        required: false
      }]
    }],
    thin: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "thin",
        required: false
      }]
    }],
    white: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "white",
        required: false
      }]
    }]
  });
})();
class ProgressModule {
  static ɵfac = function ProgressModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProgressModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ProgressModule,
    imports: [ProgressComponent, ProgressBarComponent, ProgressBarDirective, ProgressStackedComponent],
    exports: [ProgressComponent, ProgressBarComponent, ProgressBarDirective, ProgressStackedComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressModule, [{
    type: NgModule,
    args: [{
      exports: [ProgressComponent, ProgressBarComponent, ProgressBarDirective, ProgressStackedComponent],
      imports: [ProgressComponent, ProgressBarComponent, ProgressBarDirective, ProgressStackedComponent]
    }]
  }], null, null);
})();
class SidebarService {
  sidebarState = new BehaviorSubject({});
  sidebarState$ = this.sidebarState.asObservable();
  toggle(action) {
    this.sidebarState.next(action);
  }
  static ɵfac = function SidebarService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SidebarService,
    factory: SidebarService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class SidebarBackdropService {
  #document = inject(DOCUMENT);
  #sidebarService = inject(SidebarService);
  #backdrop;
  renderer;
  #clickListener = () => {
    /* empty */
  };
  setBackdrop(sidebar) {
    const backdrop = this.#document.getElementsByClassName('sidebar-backdrop');
    // console.log(`sidebar-${this.id}`, ' setBackdrop', backdrop);
    if (backdrop.length === 0) {
      this.#backdrop = this.renderer.createElement('div');
      this.renderer.addClass(this.#backdrop, 'sidebar-backdrop');
      this.renderer.appendChild(this.#document.body, this.#backdrop);
      this.#clickListener = this.renderer.listen(this.#backdrop, 'click', e => {
        // console.log(`sidebar-${this.id}`, ' backdrop click', e);
        this.#sidebarService.toggle({
          toggle: 'visible',
          sidebar
        });
      });
    }
    // console.log(this.backdrop, sidebar.sidebarState.mobile, sidebar.sidebarState.show);
    if (this.#backdrop && sidebar.sidebarState.mobile && sidebar.sidebarState.visible) {
      this.renderer.addClass(this.#backdrop, 'fade');
      this.renderer.addClass(this.#backdrop, 'show');
      // this.renderer.removeClass(this.backdrop, 'd-none');
    } else {
      this.renderer.removeClass(this.#backdrop, 'show');
      this.renderer.removeClass(this.#backdrop, 'fade');
      // this.renderer.addClass(this.backdrop, 'd-none');
    }
  }
  clearBackdrop() {
    if (this.#backdrop) {
      // clear backdrop click Listener
      this.#clickListener();
      // this.renderer.listen(this.backdrop, 'click', (e): void => {} );
      this.renderer.removeChild(this.#document.body, this.#backdrop);
      // @ts-ignore
      this.#backdrop = undefined;
    }
  }
  static ɵfac = function SidebarBackdropService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarBackdropService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SidebarBackdropService,
    factory: SidebarBackdropService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarBackdropService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class SidebarComponent {
  #document = inject(DOCUMENT);
  #renderer = inject(Renderer2);
  #breakpointObserver = inject(BreakpointObserver);
  #sidebarService = inject(SidebarService);
  #backdropService = inject(SidebarBackdropService);
  #onMobile = false;
  #layoutChangeSubscription;
  #stateToggleSubscription;
  state = signal({
    sidebar: this
  }, ...(ngDevMode ? [{
    debugName: "state"
  }] : []));
  #stateInitial = {
    narrow: false,
    visible: false,
    unfoldable: false
  };
  /**
   * Sets if the color of text should be colored for a light or dark background.
   * @return 'dark' | 'light'
   */
  colorScheme = input(...(ngDevMode ? [undefined, {
    debugName: "colorScheme"
  }] : []));
  /**
   * Sets html attribute id.
   * @return string
   */
  id = input(...(ngDevMode ? [undefined, {
    debugName: "id"
  }] : []));
  /**
   * Make sidebar narrow.
   * @return boolean
   * @default false
   */
  narrowInput = input(false, ...(ngDevMode ? [{
    debugName: "narrowInput",
    transform: booleanAttribute,
    alias: 'narrow'
  }] : [{
    transform: booleanAttribute,
    alias: 'narrow'
  }]));
  #narrow = linkedSignal(this.narrowInput, ...(ngDevMode ? [{
    debugName: "#narrow"
  }] : []));
  set narrow(value) {
    this.#narrow.set(value);
  }
  get narrow() {
    return this.#narrow();
  }
  /**
   * Set sidebar to overlaid variant.
   * @return boolean
   * @default false
   */
  overlaid = input(false, ...(ngDevMode ? [{
    debugName: "overlaid",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Components placement, there’s no default placement.
   * @return 'start' | 'end'
   */
  placement = input(...(ngDevMode ? [undefined, {
    debugName: "placement"
  }] : []));
  /**
   * Place sidebar in non-static positions.
   * @return 'fixed' | 'sticky'
   * @default 'fixed'
   */
  position = input('fixed', ...(ngDevMode ? [{
    debugName: "position"
  }] : []));
  /**
   * Size the component small, large, or extra large.
   * @return 'sm' | 'lg' | 'xl'
   */
  size = input(...(ngDevMode ? [undefined, {
    debugName: "size"
  }] : []));
  /**
   * Expand narrowed sidebar on hover.
   * @type boolean
   * @default false
   */
  unfoldableInput = input(false, ...(ngDevMode ? [{
    debugName: "unfoldableInput",
    transform: booleanAttribute,
    alias: 'unfoldable'
  }] : [{
    transform: booleanAttribute,
    alias: 'unfoldable'
  }]));
  unfoldable = linkedSignal(...(ngDevMode ? [{
    debugName: "unfoldable",
    source: this.unfoldableInput,
    computation: value => value
  }] : [{
    source: this.unfoldableInput,
    computation: value => value
  }]));
  /**
   * Toggle the visibility of sidebar component.
   * @type boolean
   * @default false
   */
  visibleInput = input(false, ...(ngDevMode ? [{
    debugName: "visibleInput",
    transform: booleanAttribute,
    alias: 'visible'
  }] : [{
    transform: booleanAttribute,
    alias: 'visible'
  }]));
  #visible = linkedSignal(this.visibleInput, ...(ngDevMode ? [{
    debugName: "#visible"
  }] : []));
  #visibleEffect = effect(() => {
    this.visibleChange?.emit(this.#visible());
  }, ...(ngDevMode ? [{
    debugName: "#visibleEffect"
  }] : []));
  set visible(value) {
    this.#visible.set(value);
  }
  get visible() {
    return this.#visible();
  }
  /**
   * Event emitted on visibility change.
   * @return boolean
   */
  visibleChange = output();
  set sidebarState(value) {
    const newState = value;
    if ('toggle' in newState) {
      if (newState.toggle === 'visible') {
        newState.visible = !this.state().visible;
        this.#visible.set(newState.visible);
      } else if (newState.toggle === 'unfoldable') {
        newState.unfoldable = !this.state().unfoldable;
        this.unfoldable.set(newState.unfoldable);
      }
    } else {
      this.#visible.update(visible => (newState.visible ?? visible) && !this.overlaid());
    }
    this.state.update(state => ({
      ...state,
      ...newState
    }));
    this.state().mobile && this.state().visible ? this.#backdropService.setBackdrop(this) : this.#backdropService.clearBackdrop();
  }
  get sidebarState() {
    return {
      ...this.state()
    };
  }
  get getMobileBreakpoint() {
    const element = this.#document.documentElement;
    const mobileBreakpoint = this.#document.defaultView?.getComputedStyle(element)?.getPropertyValue('--cui-mobile-breakpoint') ?? 'md';
    const breakpointValue = this.#document.defaultView?.getComputedStyle(element)?.getPropertyValue(`--cui-breakpoint-${mobileBreakpoint.trim()}`) ?? '768px';
    return `${parseFloat(breakpointValue.trim()) - 0.02}px`;
  }
  constructor() {
    this.#backdropService.renderer = this.#renderer;
  }
  hostClasses = computed(() => {
    const {
      mobile,
      visible
    } = {
      ...this.sidebarState
    };
    const unfoldable = this.unfoldable();
    const placement = this.placement();
    const colorScheme = this.colorScheme();
    const size = this.size();
    return {
      sidebar: true,
      'sidebar-fixed': this.position() === 'fixed' && !mobile,
      'sidebar-narrow': this.#narrow() && !unfoldable,
      'sidebar-narrow-unfoldable': unfoldable,
      'sidebar-overlaid': this.overlaid(),
      [`sidebar-${placement}`]: !!placement,
      [`sidebar-${colorScheme}`]: !!colorScheme,
      [`sidebar-${size}`]: !!size,
      show: visible,
      // show: visible && this.#onMobile, //todo: check
      hide: !visible
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  ngOnInit() {
    this.setInitialState();
    this.layoutChangeSubscribe();
    this.stateToggleSubscribe();
  }
  ngOnDestroy() {
    this.stateToggleSubscribe(false);
    this.layoutChangeSubscribe(false);
  }
  ngOnChanges(changes) {
    const oldStateMap = new Map(Object.entries(this.state()));
    const newStateMap = new Map();
    newStateMap.set('sidebar', this);
    const propList = ['visible', 'unfoldable', 'narrow'];
    for (const propName in changes) {
      if (propList.includes(propName)) {
        if (changes[propName] && !changes[propName].firstChange) {
          const value = booleanAttribute(changes[propName].currentValue);
          if (oldStateMap.get(propName) !== value) {
            newStateMap.set(propName, value);
          }
        }
      }
    }
    if (newStateMap.size > 1) {
      const state = Object.fromEntries(newStateMap.entries());
      this.#sidebarService.toggle(state);
    }
  }
  setInitialState() {
    this.#stateInitial = {
      narrow: this.#narrow(),
      visible: this.#visible(),
      unfoldable: this.unfoldable()
    };
    this.#sidebarService.toggle({
      ...this.#stateInitial,
      sidebar: this
    });
  }
  stateToggleSubscribe(subscribe = true) {
    if (subscribe) {
      this.#stateToggleSubscription = this.#sidebarService.sidebarState$.subscribe(state => {
        if (this === state.sidebar || this.id() === state.id) {
          this.sidebarState = {
            ...state
          };
        }
      });
    } else {
      this.#stateToggleSubscription?.unsubscribe();
    }
  }
  layoutChangeSubscribe(subscribe = true) {
    const onMobile = `(max-width: ${this.getMobileBreakpoint})`;
    if (subscribe) {
      const layoutChanges = this.#breakpointObserver.observe([onMobile]);
      this.#layoutChangeSubscription = layoutChanges.subscribe(result => {
        const isOnMobile = result.breakpoints[onMobile];
        const isUnfoldable = isOnMobile ? false : this.unfoldable();
        if (this.#onMobile !== isOnMobile) {
          this.#onMobile = isOnMobile;
          this.#sidebarService.toggle({
            mobile: isOnMobile,
            unfoldable: isUnfoldable,
            visible: isOnMobile ? !isOnMobile : this.#stateInitial.visible,
            sidebar: this
          });
        }
      });
    } else {
      this.#layoutChangeSubscription?.unsubscribe();
    }
  }
  static ɵfac = function SidebarComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarComponent,
    selectors: [["c-sidebar"]],
    hostAttrs: [1, "sidebar"],
    hostVars: 3,
    hostBindings: function SidebarComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("inert", !ctx.sidebarState.visible || null);
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      colorScheme: [1, "colorScheme"],
      id: [1, "id"],
      narrowInput: [1, "narrow", "narrowInput"],
      overlaid: [1, "overlaid"],
      placement: [1, "placement"],
      position: [1, "position"],
      size: [1, "size"],
      unfoldableInput: [1, "unfoldable", "unfoldableInput"],
      visibleInput: [1, "visible", "visibleInput"]
    },
    outputs: {
      visibleChange: "visibleChange"
    },
    exportAs: ["cSidebar"],
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function SidebarComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar',
      exportAs: 'cSidebar',
      template: '<ng-content />',
      host: {
        class: 'sidebar',
        '[class]': 'hostClasses()',
        '[attr.inert]': '!this.sidebarState.visible || null'
      }
    }]
  }], () => [], {
    colorScheme: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "colorScheme",
        required: false
      }]
    }],
    id: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "id",
        required: false
      }]
    }],
    narrowInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "narrow",
        required: false
      }]
    }],
    overlaid: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "overlaid",
        required: false
      }]
    }],
    placement: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "placement",
        required: false
      }]
    }],
    position: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "position",
        required: false
      }]
    }],
    size: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "size",
        required: false
      }]
    }],
    unfoldableInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "unfoldable",
        required: false
      }]
    }],
    visibleInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    visibleChange: [{
      type: i0.Output,
      args: ["visibleChange"]
    }]
  });
})();
class SidebarBrandComponent {
  brandFull = input(...(ngDevMode ? [undefined, {
    debugName: "brandFull"
  }] : []));
  brandNarrow = input(...(ngDevMode ? [undefined, {
    debugName: "brandNarrow"
  }] : []));
  routerLink = input(...(ngDevMode ? [undefined, {
    debugName: "routerLink"
  }] : []));
  brandImg = computed(() => Boolean(this.brandFull() || this.brandNarrow()), ...(ngDevMode ? [{
    debugName: "brandImg"
  }] : []));
  static ɵfac = function SidebarBrandComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarBrandComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarBrandComponent,
    selectors: [["c-sidebar-brand"]],
    hostAttrs: [1, "sidebar-brand"],
    inputs: {
      brandFull: [1, "brandFull"],
      brandNarrow: [1, "brandNarrow"],
      routerLink: [1, "routerLink"]
    },
    ngContentSelectors: _c0,
    decls: 2,
    vars: 1,
    consts: [[3, "routerLink"], [3, "cHtmlAttr", "ngClass"]],
    template: function SidebarBrandComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵconditionalCreate(0, SidebarBrandComponent_Conditional_0_Template, 3, 3, "a", 0)(1, SidebarBrandComponent_Conditional_1_Template, 1, 0);
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.brandImg() ? 0 : 1);
      }
    },
    dependencies: [RouterLink, HtmlAttributesDirective, NgClass],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarBrandComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-brand',
      imports: [RouterLink, HtmlAttributesDirective, NgClass],
      host: {
        class: 'sidebar-brand'
      },
      template: "@if (brandImg()) {\n  <a [routerLink]=\"routerLink()\">\n    @if (brandFull()) {\n      <img [cHtmlAttr]=\"brandFull()\" [ngClass]=\"'sidebar-brand-full'\">\n    }\n    @if (brandNarrow()) {\n      <img [cHtmlAttr]=\"brandNarrow()\" [ngClass]=\"'sidebar-brand-narrow'\">\n    }\n  </a>\n} @else {\n  <ng-content />\n}\n"
    }]
  }], null, {
    brandFull: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "brandFull",
        required: false
      }]
    }],
    brandNarrow: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "brandNarrow",
        required: false
      }]
    }],
    routerLink: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "routerLink",
        required: false
      }]
    }]
  });
})();

/**
 * Allows the sidebar to be toggled/folded via click on host element.
 */
class SidebarToggleDirective {
  #sidebarService = inject(SidebarService);
  /**
   * Id of sidebar for toggle action.
   * @return string
   */
  id = input(undefined, ...(ngDevMode ? [{
    debugName: "id",
    alias: 'cSidebarToggle'
  }] : [{
    alias: 'cSidebarToggle'
  }]));
  /**
   * Sidebar property name for toggle action.
   *
   * @return 'visible' | 'unfoldable'
   * @default 'visible'
   */
  toggle = input('visible', ...(ngDevMode ? [{
    debugName: "toggle"
  }] : []));
  toggleOpen($event) {
    $event.preventDefault();
    this.#sidebarService.toggle({
      toggle: this.toggle(),
      id: this.id()
    });
  }
  static ɵfac = function SidebarToggleDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarToggleDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SidebarToggleDirective,
    selectors: [["", "cSidebarToggle", ""]],
    hostBindings: function SidebarToggleDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function SidebarToggleDirective_click_HostBindingHandler($event) {
          return ctx.toggleOpen($event);
        });
      }
    },
    inputs: {
      id: [1, "cSidebarToggle", "id"],
      toggle: [1, "toggle"]
    },
    exportAs: ["cSidebarToggle"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarToggleDirective, [{
    type: Directive,
    args: [{
      selector: '[cSidebarToggle]',
      exportAs: 'cSidebarToggle',
      host: {
        '(click)': 'toggleOpen($event)'
      }
    }]
  }], null, {
    id: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cSidebarToggle",
        required: false
      }]
    }],
    toggle: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "toggle",
        required: false
      }]
    }]
  });
})();
class SidebarTogglerDirective {
  role = input('button', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  get getStyles() {
    return {
      appearance: 'button',
      'align-items': 'flex-start',
      cursor: 'pointer'
    };
  }
  static ɵfac = function SidebarTogglerDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarTogglerDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SidebarTogglerDirective,
    selectors: [["", "cSidebarToggler", ""]],
    hostAttrs: [1, "sidebar-toggler"],
    hostVars: 3,
    hostBindings: function SidebarTogglerDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
        i0.ɵɵstyleMap(ctx.getStyles);
      }
    },
    inputs: {
      role: [1, "role"]
    },
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: SidebarToggleDirective,
      inputs: ["cSidebarToggle", "cSidebarToggler", "toggle", "toggle"]
    }])]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarTogglerDirective, [{
    type: Directive,
    args: [{
      selector: '[cSidebarToggler]',
      hostDirectives: [{
        directive: SidebarToggleDirective,
        inputs: ['cSidebarToggle: cSidebarToggler', 'toggle']
      }],
      host: {
        '[attr.role]': 'role()',
        class: 'sidebar-toggler',
        '[style]': 'getStyles'
      }
    }]
  }], null, {
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class SidebarHeaderComponent {
  static ɵfac = function SidebarHeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarHeaderComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarHeaderComponent,
    selectors: [["c-sidebar-header"]],
    hostAttrs: [1, "sidebar-header"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function SidebarHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-header',
      template: '<ng-content />',
      host: {
        class: 'sidebar-header'
      }
    }]
  }], null, null);
})();
class SidebarFooterComponent {
  static ɵfac = function SidebarFooterComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarFooterComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarFooterComponent,
    selectors: [["c-sidebar-footer"]],
    hostAttrs: [1, "sidebar-footer"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function SidebarFooterComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarFooterComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-footer',
      template: '<ng-content />',
      host: {
        class: 'sidebar-footer'
      }
    }]
  }], null, null);
})();
class SidebarNavService {
  static ɵfac = function SidebarNavService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SidebarNavService,
    factory: SidebarNavService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavService, [{
    type: Injectable
  }], null, null);
})();
class SidebarNavHelper {
  itemType(item) {
    if (item.divider) {
      return 'divider';
    } else if (item.title) {
      return 'title';
    } else if (item.children && item.children.length > 0) {
      return 'group';
    } else if (item.label) {
      return 'label';
    } else if (!Object.keys(item).length) {
      return 'empty';
    } else {
      return 'link';
    }
  }
  isActive(router, item) {
    return router.isActive(item.url, false);
  }
  hasBadge = item => Boolean(item.badge);
  hasIcon = item => Boolean(item.icon) || item.icon === '';
  hasIconComponent = item => Boolean(item.iconComponent);
  getIconClass(item) {
    const classes = {
      'nav-icon': true
    };
    const icon = item.icon;
    // @ts-ignore
    classes[icon] = this.hasIcon(item);
    return classes;
  }
  static ɵfac = function SidebarNavHelper_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavHelper)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SidebarNavHelper,
    factory: SidebarNavHelper.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavHelper, [{
    type: Injectable
  }], null, null);
})();
class SidebarNavGroupService {
  sidebarNavGroupState = new BehaviorSubject({});
  sidebarNavGroupState$ = this.sidebarNavGroupState.asObservable();
  toggle(action) {
    this.sidebarNavGroupState.next(action);
  }
  static ɵfac = function SidebarNavGroupService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavGroupService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SidebarNavGroupService,
    factory: SidebarNavGroupService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavGroupService, [{
    type: Injectable
  }], null, null);
})();
class SidebarNavIconPipe {
  transform(item, args) {
    const icon = item.icon;
    return {
      'nav-icon': true,
      [`${icon}`]: !!icon
    };
  }
  static ɵfac = function SidebarNavIconPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavIconPipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "cSidebarNavIcon",
    type: SidebarNavIconPipe,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavIconPipe, [{
    type: Pipe,
    args: [{
      name: 'cSidebarNavIcon'
    }]
  }], null, null);
})();
class SidebarNavBadgePipe {
  transform(item, args) {
    const badge = item.badge;
    return {
      badge: true,
      'ms-auto': true,
      'badge-sm': !badge.size,
      [`badge-${badge.size}`]: !!badge.size,
      [`bg-${badge.color}`]: !!badge.color,
      [`${badge.class}`]: !!badge.class
    };
  }
  static ɵfac = function SidebarNavBadgePipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavBadgePipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "cSidebarNavBadge",
    type: SidebarNavBadgePipe,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavBadgePipe, [{
    type: Pipe,
    args: [{
      name: 'cSidebarNavBadge'
    }]
  }], null, null);
})();
class SidebarNavLinkPipe {
  transform(item) {
    const disabled = item?.attributes?.disabled;
    return {
      'nav-link': true,
      disabled,
      'btn-link': disabled,
      [`nav-link-${item.variant}`]: !!item.variant
    };
  }
  static ɵfac = function SidebarNavLinkPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavLinkPipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "cSidebarNavLink",
    type: SidebarNavLinkPipe,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavLinkPipe, [{
    type: Pipe,
    args: [{
      name: 'cSidebarNavLink'
    }]
  }], null, null);
})();
class SidebarNavLinkContentComponent {
  helper = inject(SidebarNavHelper);
  item = input({}, ...(ngDevMode ? [{
    debugName: "item"
  }] : []));
  static ɵfac = function SidebarNavLinkContentComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavLinkContentComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarNavLinkContentComponent,
    selectors: [["c-sidebar-nav-link-content"]],
    inputs: {
      item: [1, "item"]
    },
    features: [i0.ɵɵProvidersFeature([SidebarNavHelper])],
    decls: 2,
    vars: 2,
    template: function SidebarNavLinkContentComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵdeclareLet(0);
        i0.ɵɵconditionalCreate(1, SidebarNavLinkContentComponent_Conditional_1_Template, 2, 1, "ng-container");
      }
      if (rf & 2) {
        const itemLinkContent_r2 = i0.ɵɵstoreLet(ctx.item());
        i0.ɵɵadvance();
        i0.ɵɵconditional(itemLinkContent_r2 ? 1 : -1);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavLinkContentComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-link-content',
      template: `
    @let itemLinkContent = item();
    @if (itemLinkContent) {
      <ng-container>{{ itemLinkContent?.name ?? '' }}</ng-container>
    }
  `,
      providers: [SidebarNavHelper]
    }]
  }], null, {
    item: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "item",
        required: false
      }]
    }]
  });
})();
class SidebarNavLinkComponent {
  router = inject(Router);
  item = input(...(ngDevMode ? [undefined, {
    debugName: "item"
  }] : []));
  linkClick = output();
  linkType;
  href;
  linkActive;
  url;
  navigationEndObservable;
  navSubscription;
  constructor() {
    const router = this.router;
    this.navigationEndObservable = router.events.pipe(filter(event => {
      return event instanceof NavigationEnd;
    }), takeUntilDestroyed());
  }
  ngOnInit() {
    const item = this.item() ?? {};
    this.url = typeof item.url === 'string' ? item.url : this.router.serializeUrl(this.router.createUrlTree(item.url ?? ['']));
    this.linkType = this.getLinkType();
    this.href = this.isDisabled() ? '' : item.href || this.url;
    this.linkActive = this.router.url.split(/[?#(;]/)[0] === this.href.split(/[?#(;]/)[0];
    this.navSubscription = this.navigationEndObservable.subscribe(event => {
      const itemUrlArray = this.href.split(/[?#(;]/)[0].split('/');
      const urlArray = event.urlAfterRedirects.split(/[?#(;]/)[0].split('/');
      this.linkActive = itemUrlArray.every((value, index) => value === urlArray[index]);
    });
  }
  ngOnDestroy() {
    this.navSubscription?.unsubscribe();
  }
  getLinkType() {
    return this.isDisabled() ? 'disabled' : this.isExternalLink() ? 'external' : 'link';
  }
  isDisabled() {
    return this.item()?.attributes?.['disabled'];
  }
  isExternalLink() {
    const item = this.item() ?? {};
    const linkPath = Array.isArray(item.url) ? item.url[0] : item.url;
    return !!item.href || linkPath?.substring(0, 4) === 'http';
  }
  linkClicked() {
    this.linkClick?.emit();
  }
  static ɵfac = function SidebarNavLinkComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavLinkComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarNavLinkComponent,
    selectors: [["c-sidebar-nav-link"]],
    inputs: {
      item: [1, "item"]
    },
    outputs: {
      linkClick: "linkClick"
    },
    features: [i0.ɵɵProvidersFeature([SidebarNavHelper])],
    decls: 6,
    vars: 3,
    consts: [["iconTemplate", ""], [3, "cHtmlAttr", "ngClass"], [3, "cHtmlAttr", "href", "ngClass"], ["routerLinkActive", "active", 3, "cHtmlAttr", "fragment", "ngClass", "preserveFragment", "queryParamsHandling", "queryParams", "replaceUrl", "routerLinkActiveOptions", "routerLink", "skipLocationChange", "state", "target"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "item"], [3, "ngClass"], [3, "click", "cHtmlAttr", "href", "ngClass"], ["routerLinkActive", "active", 3, "click", "cHtmlAttr", "fragment", "ngClass", "preserveFragment", "queryParamsHandling", "queryParams", "replaceUrl", "routerLinkActiveOptions", "routerLink", "skipLocationChange", "state", "target"], [1, "nav-icon"], [3, "cIcon", "customClasses", "name"]],
    template: function SidebarNavLinkComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵdeclareLet(0);
        i0.ɵɵconditionalCreate(1, SidebarNavLinkComponent_Case_1_Template, 5, 11, "a", 1)(2, SidebarNavLinkComponent_Case_2_Template, 5, 12, "a", 2)(3, SidebarNavLinkComponent_Case_3_Template, 5, 23, "a", 3);
        i0.ɵɵtemplate(4, SidebarNavLinkComponent_ng_template_4_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        let tmp_2_0;
        i0.ɵɵstoreLet(ctx.item() ?? i0.ɵɵpureFunction0(2, _c3));
        i0.ɵɵadvance();
        i0.ɵɵconditional((tmp_2_0 = ctx.linkType) === "disabled" ? 1 : tmp_2_0 === "external" ? 2 : 3);
      }
    },
    dependencies: [RouterModule, i1.RouterLink, i1.RouterLinkActive, HtmlAttributesDirective, IconDirective, SidebarNavLinkContentComponent, NgTemplateOutlet, NgClass, SidebarNavLinkPipe, SidebarNavBadgePipe, SidebarNavIconPipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavLinkComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-link',
      providers: [SidebarNavHelper],
      imports: [RouterModule, HtmlAttributesDirective, IconDirective, SidebarNavLinkContentComponent, SidebarNavLinkPipe, SidebarNavBadgePipe, SidebarNavIconPipe, NgTemplateOutlet, NgClass],
      template: "@let linkItem = item() ?? {};\n\n@switch (linkType) {\n  @case ('disabled') {\n    <a [cHtmlAttr]=\"linkItem.attributes ?? {}\" [ngClass]=\"linkItem | cSidebarNavLink\">\n      <ng-container *ngTemplateOutlet=\"iconTemplate; context: {$implicit: linkItem}\" />\n      <c-sidebar-nav-link-content [item]=\"linkItem\" />\n      @if (linkItem.badge) {\n        <span [ngClass]=\"linkItem | cSidebarNavBadge\">{{ linkItem.badge?.text }}</span>\n      }\n    </a>\n  }\n  @case ('external') {\n    <a (click)=\"linkClicked()\" [cHtmlAttr]=\"linkItem.attributes ?? {}\" [href]=\"href\" [ngClass]=\"linkItem | cSidebarNavLink\">\n      <ng-container *ngTemplateOutlet=\"iconTemplate; context: {$implicit: linkItem}\" />\n      <c-sidebar-nav-link-content [item]=\"linkItem\" />\n      @if (linkItem.badge) {\n        <span [ngClass]=\"linkItem | cSidebarNavBadge\">{{ linkItem.badge?.text }}</span>\n      }\n    </a>\n  }\n  @default {\n    <a (click)=\"linkClicked()\"\n       [cHtmlAttr]=\"linkItem.attributes ?? {}\"\n       [fragment]=\"linkItem.linkProps?.fragment\"\n       [ngClass]=\"linkItem | cSidebarNavLink\"\n       [preserveFragment]=\"linkItem.linkProps?.preserveFragment ?? false\"\n       [queryParamsHandling]=\"linkItem.linkProps?.queryParamsHandling\"\n       [queryParams]=\"linkItem.linkProps?.queryParams ?? null\"\n       [replaceUrl]=\"linkItem.linkProps?.replaceUrl ?? false\"\n       [routerLinkActiveOptions]=\"linkItem.linkProps?.routerLinkActiveOptions ?? { exact: false }\"\n       [routerLink]=\"linkItem.url\"\n       [skipLocationChange]=\"linkItem.linkProps?.skipLocationChange ?? false\"\n       [state]=\"linkItem.linkProps?.state ?? {}\"\n       [target]=\"linkItem.attributes?.['target']\"\n       routerLinkActive=\"active\"\n    >\n      <!--    [class.active]=\"linkActive\"-->\n      <ng-container *ngTemplateOutlet=\"iconTemplate ; context: {$implicit: linkItem}\" />\n      <c-sidebar-nav-link-content [item]=\"linkItem\" />\n      @if (linkItem.badge) {\n        <span [ngClass]=\"linkItem | cSidebarNavBadge\">{{ linkItem.badge?.text }}</span>\n      }\n    </a>\n  }\n}\n<ng-template #iconTemplate let-item>\n  <!--  <i *ngIf=\"item?.icon\" [ngClass]=\"item | cSidebarNavIcon\"></i>-->\n  @if (item?.icon) {\n    <span class=\"nav-icon\">\n      <span [ngClass]=\"item.icon ?? ''\"></span>\n    </span>\n  }\n  @if (item?.iconComponent) {\n    <svg\n      [cIcon]=\"item.iconComponent?.content\"\n      [customClasses]=\"item | cSidebarNavIcon\"\n      [name]=\"item.iconComponent?.name\"\n    ></svg>\n  }\n  @if (!item?.icon && !item?.iconComponent) {\n    <span [ngClass]=\"item | cSidebarNavIcon\"></span>\n  }\n</ng-template>\n"
    }]
  }], () => [], {
    item: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "item",
        required: false
      }]
    }],
    linkClick: [{
      type: i0.Output,
      args: ["linkClick"]
    }]
  });
})();
class SidebarNavLabelComponent {
  helper = inject(SidebarNavHelper);
  item = input({}, ...(ngDevMode ? [{
    debugName: "item"
  }] : []));
  itemClass = computed(() => {
    const classes = {
      'c-nav-label': true,
      'c-active': true
    };
    const itemClass = this.item().class;
    if (itemClass) {
      classes[itemClass] = !!itemClass;
    }
    return classes;
  }, ...(ngDevMode ? [{
    debugName: "itemClass"
  }] : []));
  labelIconClass = computed(() => {
    const item = this.item();
    const iconClasses = this.helper.getIconClass(item);
    const variant = `text-${item.label?.variant}`;
    iconClasses[variant] = !!item.label?.variant;
    const labelClass = item.label?.class ?? '';
    iconClasses[labelClass] = !!labelClass;
    return iconClasses;
  }, ...(ngDevMode ? [{
    debugName: "labelIconClass"
  }] : []));
  static ɵfac = function SidebarNavLabelComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavLabelComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarNavLabelComponent,
    selectors: [["c-sidebar-nav-label"]],
    inputs: {
      item: [1, "item"]
    },
    decls: 6,
    vars: 8,
    consts: [[3, "cHtmlAttr", "ngClass", "href"], [3, "ngClass"]],
    template: function SidebarNavLabelComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵdeclareLet(0);
        i0.ɵɵelementStart(1, "a", 0);
        i0.ɵɵconditionalCreate(2, SidebarNavLabelComponent_Conditional_2_Template, 1, 1, "i", 1);
        i0.ɵɵelementContainerStart(3);
        i0.ɵɵtext(4);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵconditionalCreate(5, SidebarNavLabelComponent_Conditional_5_Template, 3, 4, "span", 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        const labelItem_r3 = i0.ɵɵstoreLet(ctx.item());
        i0.ɵɵadvance();
        i0.ɵɵproperty("href", i0.ɵɵinterpolate(labelItem_r3.url), i0.ɵɵsanitizeUrl)("cHtmlAttr", labelItem_r3.attributes)("ngClass", ctx.itemClass());
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.helper.hasIcon(labelItem_r3) ? 2 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(labelItem_r3.name);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.helper.hasBadge(labelItem_r3) ? 5 : -1);
      }
    },
    dependencies: [HtmlAttributesDirective, NgClass, SidebarNavBadgePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavLabelComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-label',
      imports: [HtmlAttributesDirective, SidebarNavBadgePipe, NgClass],
      template: "@let labelItem = item();\n<a [cHtmlAttr]=\"labelItem.attributes\"\n   [ngClass]=\"itemClass()\"\n   href=\"{{labelItem.url}}\">\n  @if (helper.hasIcon(labelItem)) {\n    <i [ngClass]=\"labelIconClass()\"></i>\n  }\n  <ng-container>{{ labelItem.name }}</ng-container>\n  @if (helper.hasBadge(labelItem)) {\n    <span [ngClass]=\"labelItem | cSidebarNavBadge\">{{ labelItem.badge?.text ?? '' }}</span>\n  }\n</a>\n"
    }]
  }], null, {
    item: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "item",
        required: false
      }]
    }]
  });
})();
class SidebarNavTitleComponent {
  #elementRef = inject(ElementRef);
  #renderer = inject(Renderer2);
  item = input(...(ngDevMode ? [undefined, {
    debugName: "item"
  }] : []));
  #itemEffect = effect(() => {
    const item = this.item();
    if (item?.name) {
      const nativeElement = this.#elementRef.nativeElement;
      const name = this.#renderer.createText(item.name);
      if (item?.class) {
        const classes = item.class;
        this.#renderer.addClass(nativeElement, classes);
      }
      if (item?.wrapper) {
        const wrapper = this.#renderer.createElement(item.wrapper.element);
        this.addAttribs(item.wrapper.attributes, wrapper);
        this.#renderer.appendChild(wrapper, name);
        this.#renderer.appendChild(nativeElement, wrapper);
      } else {
        this.#renderer.appendChild(nativeElement, name);
      }
    }
  }, ...(ngDevMode ? [{
    debugName: "#itemEffect"
  }] : []));
  addAttribs(attribs, element) {
    if (attribs) {
      for (const attr in attribs) {
        if (attr === 'style' && typeof attribs[attr] === 'object') {
          this.setStyle(attribs[attr], element);
        } else if (attr === 'class') {
          this.addClass(attribs[attr], element);
        } else {
          this.setAttrib(attr, attribs[attr], element);
        }
      }
    }
  }
  setStyle(styles, el) {
    for (const style in styles) {
      if (style) {
        this.#renderer.setStyle(el, style, styles[style]);
      }
    }
  }
  addClass(classes, el) {
    const classArray = Array.isArray(classes) ? classes : classes.split(' ');
    classArray.filter(element => element.length > 0).forEach(element => {
      this.#renderer.addClass(el, element);
    });
  }
  setAttrib(key, value, el) {
    this.#renderer.setAttribute(el, key, value);
  }
  static ɵfac = function SidebarNavTitleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavTitleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarNavTitleComponent,
    selectors: [["c-sidebar-nav-title"]],
    inputs: {
      item: [1, "item"]
    },
    decls: 0,
    vars: 0,
    template: function SidebarNavTitleComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavTitleComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-title',
      template: ''
    }]
  }], null, {
    item: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "item",
        required: false
      }]
    }]
  });
})();
class SidebarNavDividerComponent {
  item = input(...(ngDevMode ? [undefined, {
    debugName: "item"
  }] : []));
  static ɵfac = function SidebarNavDividerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavDividerComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarNavDividerComponent,
    selectors: [["c-sidebar-nav-divider"]],
    inputs: {
      item: [1, "item"]
    },
    decls: 0,
    vars: 0,
    template: function SidebarNavDividerComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavDividerComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-divider',
      template: ``
    }]
  }], null, {
    item: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "item",
        required: false
      }]
    }]
  });
})();
class SidebarNavItemClassPipe {
  helper = inject(SidebarNavHelper);
  // transform(item: any, ...args: any[]): any {
  transform(item, args) {
    const itemType = this.helper.itemType(item);
    let itemClass;
    if (['divider', 'title'].includes(itemType)) {
      itemClass = `nav-${itemType}`;
    } else if (itemType === 'group') {
      // itemClass = 'c-sidebar-nav-group' ;
      itemClass = '';
    } else {
      itemClass = 'nav-item';
    }
    return item.class ? `${itemClass} ${item.class}` : itemClass;
  }
  static ɵfac = function SidebarNavItemClassPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavItemClassPipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "cSidebarNavItemClass",
    type: SidebarNavItemClassPipe,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavItemClassPipe, [{
    type: Pipe,
    args: [{
      name: 'cSidebarNavItemClass'
    }]
  }], null, null);
})();
class SidebarNavGroupComponent {
  #router = inject(Router);
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  #sidebarNavGroupService = inject(SidebarNavGroupService);
  helper = inject(SidebarNavHelper);
  constructor() {
    const router = this.#router;
    this.navigationEndObservable = router.events.pipe(filter(event => event instanceof NavigationEnd));
  }
  item;
  dropdownMode = 'path';
  show;
  compact;
  get hostClasses() {
    return {
      'nav-group': true,
      show: this.open
    };
  }
  sidebarNav;
  navigationEndObservable;
  navSubscription;
  navGroupSubscription;
  open;
  navItems = [];
  display = {
    display: 'block'
  };
  ngOnInit() {
    this.navItems = [...this.item.children];
    this.navSubscription = this.navigationEndObservable.subscribe(event => {
      if (this.dropdownMode !== 'none') {
        const samePath = this.samePath(event.url);
        this.openGroup(samePath);
      }
    });
    if (this.samePath(this.#router.routerState.snapshot.url)) {
      this.openGroup(true);
    }
    this.navGroupSubscription = this.#sidebarNavGroupService.sidebarNavGroupState$.subscribe(next => {
      if (this.dropdownMode === 'close' && next.sidebarNavGroup && next.sidebarNavGroup !== this) {
        if (next.sidebarNavGroup.item.url.startsWith(this.item.url)) {
          return;
        }
        if (this.samePath(this.#router.routerState.snapshot.url)) {
          this.openGroup(true);
          return;
        }
        this.openGroup(false);
      }
    });
  }
  samePath(url) {
    // console.log('item:', this.item.name, this.item.url, 'url:', url);
    const itemArray = this.item.url?.split('/');
    const urlArray = url.split('/');
    return itemArray?.every((value, index) => {
      // console.log(value === urlArray[index], 'value:', value, 'index:', index, urlArray[index], url);
      return value === urlArray[index];
    });
  }
  openGroup(open) {
    this.open = open;
  }
  toggleGroup($event) {
    $event.preventDefault();
    this.openGroup(!this.open);
    if (this.open) {
      this.#sidebarNavGroupService.toggle({
        open: this.open,
        sidebarNavGroup: this
      });
    }
  }
  ngOnDestroy() {
    this.navSubscription?.unsubscribe();
  }
  onAnimationStart($event) {
    this.display = {
      display: 'block'
    };
    setTimeout(() => {
      const host = this.sidebarNav?.nativeElement;
      if ($event.toState === 'open' && host) {
        this.#renderer.setStyle(host, 'height', `${host['scrollHeight']}px`);
      }
    });
  }
  onAnimationDone($event) {
    setTimeout(() => {
      const host = this.sidebarNav?.nativeElement;
      if ($event.toState === 'open' && host) {
        this.#renderer.setStyle(host, 'height', 'auto');
      }
      if ($event.toState === 'closed') {
        setTimeout(() => {
          this.display = null;
        });
      }
    });
  }
  static ɵfac = function SidebarNavGroupComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavGroupComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarNavGroupComponent,
    selectors: [["c-sidebar-nav-group"]],
    viewQuery: function SidebarNavGroupComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(SidebarNavComponent, 5, ElementRef);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sidebarNav = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function SidebarNavGroupComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses);
      }
    },
    inputs: {
      item: "item",
      dropdownMode: "dropdownMode",
      show: "show",
      compact: [2, "compact", "compact", booleanAttribute]
    },
    features: [i0.ɵɵProvidersFeature([SidebarNavHelper, SidebarNavGroupService])],
    decls: 8,
    vars: 13,
    consts: [["iconTemplate", ""], ["href", "", 1, "nav-link", "nav-group-toggle", 3, "click", "cHtmlAttr"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngClass"], [3, "compact", "dropdownMode", "groupItems", "navItems", "ngStyle"], [1, "nav-icon"], [3, "cIcon", "customClasses", "name"]],
    template: function SidebarNavGroupComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "a", 1);
        i0.ɵɵlistener("click", function SidebarNavGroupComponent_Template_a_click_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.toggleGroup($event));
        });
        i0.ɵɵtemplate(1, SidebarNavGroupComponent_ng_container_1_Template, 1, 0, "ng-container", 2);
        i0.ɵɵelementContainerStart(2);
        i0.ɵɵtext(3);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵconditionalCreate(4, SidebarNavGroupComponent_Conditional_4_Template, 3, 4, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "c-sidebar-nav", 4);
        i0.ɵɵlistener("@openClose.done", function SidebarNavGroupComponent_Template_c_sidebar_nav_animation_openClose_done_5_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onAnimationDone($event));
        })("@openClose.start", function SidebarNavGroupComponent_Template_c_sidebar_nav_animation_openClose_start_5_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onAnimationStart($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, SidebarNavGroupComponent_ng_template_6_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const iconTemplate_r4 = i0.ɵɵreference(7);
        i0.ɵɵproperty("cHtmlAttr", ctx.item.attributes);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngTemplateOutlet", iconTemplate_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(11, _c10, ctx.item));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.item.name);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.helper.hasBadge(ctx.item) ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("@openClose", ctx.open ? "open" : "closed")("compact", ctx.compact)("dropdownMode", ctx.dropdownMode)("groupItems", true)("navItems", ctx.navItems)("ngStyle", ctx.display);
      }
    },
    dependencies: () => [HtmlAttributesDirective, IconDirective, NgTemplateOutlet, NgClass, SidebarNavComponent, NgStyle, SidebarNavIconPipe, SidebarNavBadgePipe],
    styles: [".nav-group-toggle[_ngcontent-%COMP%]{cursor:pointer}.nav-group-items[_ngcontent-%COMP%]{display:block}"],
    data: {
      animation: [trigger('openClose', [state('open', style({
        height: '*'
      })), state('closed', style({
        height: '0px'
      })), transition('open <=> closed', [animate('.15s ease')])])]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavGroupComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav-group',
      providers: [SidebarNavHelper, SidebarNavGroupService],
      imports: [HtmlAttributesDirective, IconDirective, NgTemplateOutlet, NgClass, SidebarNavIconPipe, SidebarNavBadgePipe, forwardRef(() => SidebarNavComponent), NgStyle],
      animations: [trigger('openClose', [state('open', style({
        height: '*'
      })), state('closed', style({
        height: '0px'
      })), transition('open <=> closed', [animate('.15s ease')])])],
      template: "<a (click)=\"toggleGroup($event)\"\n   [cHtmlAttr]=\"item.attributes\"\n   class=\"nav-link nav-group-toggle\"\n   href>\n  <ng-container *ngTemplateOutlet=\"iconTemplate ; context: {$implicit: item}\" />\n  <ng-container>{{ item.name }}</ng-container>\n  @if (helper.hasBadge(item)) {\n    <span [ngClass]=\"item | cSidebarNavBadge\">{{ item.badge.text }}</span>\n  }\n</a>\n<c-sidebar-nav\n  (@openClose.done)=\"onAnimationDone($event)\"\n  (@openClose.start)=\"onAnimationStart($event)\"\n  [@openClose]=\"open ? 'open' : 'closed'\"\n  [compact]=\"compact\"\n  [dropdownMode]=\"dropdownMode\"\n  [groupItems]=\"true\"\n  [navItems]=\"navItems\"\n  [ngStyle]=\"display\"\n/>\n\n<ng-template #iconTemplate let-item>\n  <!--  <i *ngIf=\"item?.icon\" [ngClass]=\"item | cSidebarNavIcon\"></i>-->\n  @if (item?.icon) {\n    <span class=\"nav-icon\">\n    <span [ngClass]=\"item.icon ?? ''\"></span>\n  </span>\n  }\n  @if (item?.iconComponent) {\n    <svg\n      [cIcon]=\"item.iconComponent?.content\"\n      [customClasses]=\"item | cSidebarNavIcon\"\n      [name]=\"item.iconComponent?.name\"\n    />\n  }\n  @if (!item?.icon && !item?.iconComponent) {\n    <span [ngClass]=\"item | cSidebarNavIcon\"></span>\n  }\n</ng-template>\n",
      styles: [".nav-group-toggle{cursor:pointer}.nav-group-items{display:block}\n"]
    }]
  }], () => [], {
    item: [{
      type: Input
    }],
    dropdownMode: [{
      type: Input
    }],
    show: [{
      type: Input
    }],
    compact: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }],
    sidebarNav: [{
      type: ViewChild,
      args: [forwardRef(() => SidebarNavComponent), {
        read: ElementRef
      }]
    }]
  });
})();
class SidebarNavComponent {
  sidebar = inject(SidebarComponent, {
    optional: true
  });
  helper = inject(SidebarNavHelper);
  router = inject(Router);
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  #sidebarService = inject(SidebarService);
  navItems = [];
  dropdownMode = 'path';
  groupItems;
  compact;
  get hostClasses() {
    return {
      'sidebar-nav': !this.groupItems,
      'nav-group-items': this.groupItems,
      compact: this.groupItems && this.compact
    };
  }
  // @HostBinding('class.nav-group-items')
  // get sidebarNavGroupItemsClass(): boolean {
  //   return !!this.groupItems;
  // }
  role = 'navigation';
  navItemsArray = [];
  ngOnChanges(changes) {
    this.navItemsArray = Array.isArray(this.navItems) ? this.navItems.slice() : [];
  }
  hideMobile() {
    // todo: proper scrollIntoView() after NavigationEnd
    if (this.sidebar && this.sidebar.sidebarState.mobile) {
      this.#sidebarService.toggle({
        toggle: 'visible',
        sidebar: this.sidebar
      });
    }
  }
  static ɵfac = function SidebarNavComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarNavComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SidebarNavComponent,
    selectors: [["c-sidebar-nav"]],
    hostVars: 3,
    hostBindings: function SidebarNavComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role);
        i0.ɵɵclassMap(ctx.hostClasses);
      }
    },
    inputs: {
      navItems: "navItems",
      dropdownMode: "dropdownMode",
      groupItems: [2, "groupItems", "groupItems", booleanAttribute],
      compact: [2, "compact", "compact", booleanAttribute],
      role: "role"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c0,
    decls: 3,
    vars: 0,
    consts: [["rla", "routerLinkActive"], ["routerLinkActive", "show", 3, "dropdownMode", "item", "ngClass", "routerLinkActiveOptions", "compact"], [3, "cHtmlAttr", "item", "ngClass"], [3, "item", "ngClass"], [3, "linkClick", "item", "ngClass"]],
    template: function SidebarNavComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵrepeaterCreate(0, SidebarNavComponent_For_1_Template, 6, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
        i0.ɵɵprojection(2);
      }
      if (rf & 2) {
        i0.ɵɵrepeater(ctx.navItemsArray);
      }
    },
    dependencies: () => [NgClass, HtmlAttributesDirective, SidebarNavLinkComponent, SidebarNavLabelComponent, SidebarNavTitleComponent, SidebarNavDividerComponent, SidebarNavGroupComponent, RouterModule, i1.RouterLinkActive, SidebarNavItemClassPipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarNavComponent, [{
    type: Component,
    args: [{
      selector: 'c-sidebar-nav',
      imports: [NgClass, HtmlAttributesDirective, SidebarNavLinkComponent, SidebarNavLabelComponent, SidebarNavTitleComponent, SidebarNavDividerComponent, forwardRef(() => SidebarNavGroupComponent), SidebarNavItemClassPipe, RouterModule],
      template: "@for (item of navItemsArray; track item) {\n  @switch (helper.itemType(item)) {\n    @case ('group') {\n      <c-sidebar-nav-group\n        #rla=\"routerLinkActive\"\n        [dropdownMode]=\"dropdownMode\"\n        [item]=\"item\"\n        [ngClass]=\"item | cSidebarNavItemClass\"\n        [routerLinkActiveOptions]=\"{exact: true}\"\n        routerLinkActive=\"show\"\n        [compact]=\"compact\"\n      />\n    }\n    @case ('divider') {\n      <c-sidebar-nav-divider\n        [cHtmlAttr]=\"item.attributes ?? {}\"\n        [item]=\"item\"\n        [ngClass]=\"item | cSidebarNavItemClass\"\n      />\n    }\n    @case ('title') {\n      <c-sidebar-nav-title\n        [cHtmlAttr]=\"item.attributes ?? {}\"\n        [item]=\"item\"\n        [ngClass]=\"item | cSidebarNavItemClass\"\n      />\n    }\n    @case ('label') {\n      <c-sidebar-nav-label\n        [item]=\"item\"\n        [ngClass]=\"item | cSidebarNavItemClass\"\n      />\n    }\n    @case ('empty') {\n      <ng-container />\n    }\n    @default {\n      <c-sidebar-nav-link\n        (linkClick)=\"hideMobile()\"\n        [item]=\"item\"\n        [ngClass]=\"item | cSidebarNavItemClass\"\n      />\n    }\n  }\n}\n<ng-content />\n"
    }]
  }], null, {
    navItems: [{
      type: Input
    }],
    dropdownMode: [{
      type: Input
    }],
    groupItems: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    compact: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }, {
      type: Input
    }]
  });
})();
class SidebarModule {
  static ɵfac = function SidebarModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SidebarModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SidebarModule,
    imports: [SidebarComponent, SidebarBrandComponent, SidebarFooterComponent, SidebarHeaderComponent, SidebarNavComponent, SidebarNavBadgePipe, SidebarNavDividerComponent, SidebarNavGroupComponent, SidebarNavIconPipe, SidebarNavItemClassPipe, SidebarNavLabelComponent, SidebarNavLinkComponent, SidebarNavLinkContentComponent, SidebarNavLinkPipe, SidebarNavTitleComponent, SidebarToggleDirective, SidebarTogglerDirective],
    exports: [SidebarComponent, SidebarToggleDirective, SidebarTogglerDirective, SidebarBrandComponent, SidebarNavComponent, SidebarHeaderComponent, SidebarFooterComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [SidebarService, SidebarNavHelper, SidebarNavGroupService],
    imports: [SidebarNavComponent, SidebarNavGroupComponent, SidebarNavLinkComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SidebarModule, [{
    type: NgModule,
    args: [{
      imports: [SidebarComponent, SidebarBrandComponent, SidebarFooterComponent, SidebarHeaderComponent, SidebarNavComponent, SidebarNavBadgePipe, SidebarNavDividerComponent, SidebarNavGroupComponent, SidebarNavIconPipe, SidebarNavItemClassPipe, SidebarNavLabelComponent, SidebarNavLinkComponent, SidebarNavLinkContentComponent, SidebarNavLinkPipe, SidebarNavTitleComponent, SidebarToggleDirective, SidebarTogglerDirective],
      exports: [SidebarComponent, SidebarToggleDirective, SidebarTogglerDirective, SidebarBrandComponent, SidebarNavComponent, SidebarHeaderComponent, SidebarFooterComponent],
      providers: [SidebarService, SidebarNavHelper, SidebarNavGroupService]
    }]
  }], null, null);
})();
class SpinnerComponent {
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @type Colors
   */
  color = input(...(ngDevMode ? [undefined, {
    debugName: "color"
  }] : []));
  /**
   * Label for accessibility.
   * @type string
   * @default 'Loading...'
   */
  label = input('Loading...', ...(ngDevMode ? [{
    debugName: "label"
  }] : []));
  /**
   * Size the component small.
   * @return string
   * @values 'sm'
   */
  size = input(...(ngDevMode ? [undefined, {
    debugName: "size"
  }] : []));
  /**
   * Set the button variant to an outlined button or a ghost button.
   * @values 'border' | 'grow'
   * @default 'border'
   */
  variant = input('border', ...(ngDevMode ? [{
    debugName: "variant"
  }] : []));
  /**
   * Default role attr for Spinner. [docs]
   * @type string
   * @default 'status'
   */
  role = input('status', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  hostClasses = computed(() => {
    const color = this.color();
    const size = this.size();
    const variant = this.variant();
    return {
      [`spinner-${variant}`]: true,
      [`text-${color}`]: !!color,
      [`spinner-${variant}-${size}`]: !!size
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function SpinnerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SpinnerComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SpinnerComponent,
    selectors: [["c-spinner"]],
    hostVars: 3,
    hostBindings: function SpinnerComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      color: [1, "color"],
      label: [1, "label"],
      size: [1, "size"],
      variant: [1, "variant"],
      role: [1, "role"]
    },
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [[1, "visually-hidden"]],
    template: function SpinnerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0, 0, null, SpinnerComponent_ProjectionFallback_0_Template, 2, 1);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerComponent, [{
    type: Component,
    args: [{
      selector: 'c-spinner',
      host: {
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()'
      },
      template: "<ng-content>\n  <span class=\"visually-hidden\">{{ label() }}</span>\n</ng-content>\n"
    }]
  }], null, {
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    label: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "label",
        required: false
      }]
    }],
    size: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "size",
        required: false
      }]
    }],
    variant: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "variant",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }]
  });
})();
class SpinnerModule {
  static ɵfac = function SpinnerModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SpinnerModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SpinnerModule,
    imports: [SpinnerComponent],
    exports: [SpinnerComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerModule, [{
    type: NgModule,
    args: [{
      exports: [SpinnerComponent],
      imports: [SpinnerComponent]
    }]
  }], null, null);
})();
class TableColorDirective {
  /**
   * Use contextual color for tables, table rows or individual cells.
   * @return Colors
   */
  color = input(undefined, ...(ngDevMode ? [{
    debugName: "color",
    alias: 'cTableColor'
  }] : [{
    alias: 'cTableColor'
  }]));
  hostClasses = computed(() => {
    const color = this.color();
    return {
      [`table-${color}`]: !!color
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function TableColorDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TableColorDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TableColorDirective,
    selectors: [["", "cTableColor", ""]],
    hostVars: 2,
    hostBindings: function TableColorDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      color: [1, "cTableColor", "color"]
    },
    exportAs: ["cTableColor"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableColorDirective, [{
    type: Directive,
    args: [{
      selector: '[cTableColor]',
      exportAs: 'cTableColor',
      host: {
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTableColor",
        required: false
      }]
    }]
  });
})();
class TableActiveDirective {
  /**
   * Highlight a table row or cell
   * @return boolean
   */
  active = input(false, ...(ngDevMode ? [{
    debugName: "active",
    alias: "cTableActive",
    transform: booleanAttribute
  }] : [{
    alias: "cTableActive",
    transform: booleanAttribute
  }]));
  static ɵfac = function TableActiveDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TableActiveDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TableActiveDirective,
    selectors: [["", "cTableActive", ""]],
    hostVars: 2,
    hostBindings: function TableActiveDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("table-active", ctx.active());
      }
    },
    inputs: {
      active: [1, "cTableActive", "active"]
    },
    exportAs: ["cTableActive"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableActiveDirective, [{
    type: Directive,
    args: [{
      selector: '[cTableActive]',
      exportAs: 'cTableActive',
      host: {
        '[class.table-active]': 'active()'
      }
    }]
  }], null, {
    active: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTableActive",
        required: false
      }]
    }]
  });
})();
class TableDirective {
  static ngAcceptInputType_bordered;
  static ngAcceptInputType_borderless;
  static ngAcceptInputType_hover;
  static ngAcceptInputType_small;
  static ngAcceptInputType_striped;
  static ngAcceptInputType_stripedColumns;
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  /**
   * Set the vertical alignment.
   * @return string
   * @values 'bottom' | 'middle' | 'top'
   */
  align = input(...(ngDevMode ? [undefined, {
    debugName: "align"
  }] : []));
  /**
   * Sets the border color of the component to one of CoreUI’s themed colors.
   * @return Colors
   */
  borderColor = input(...(ngDevMode ? [undefined, {
    debugName: "borderColor"
  }] : []));
  /**
   * Add borders on all sides of the table and cells.
   * @return boolean
   */
  bordered = input(false, ...(ngDevMode ? [{
    debugName: "bordered",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Remove borders on all sides of the table and cells.
   * @return boolean
   */
  borderless = input(false, ...(ngDevMode ? [{
    debugName: "borderless",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Put the `<caption>` on the top of the table.
   * @return 'top'
   * @values 'top'
   */
  caption = input(...(ngDevMode ? [undefined, {
    debugName: "caption"
  }] : []));
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @return Colors
   */
  color = input(...(ngDevMode ? [undefined, {
    debugName: "color"
  }] : []));
  /**
   * Enable a hover state on table rows within table body.
   * @return boolean
   */
  hover = input(false, ...(ngDevMode ? [{
    debugName: "hover",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Make table responsive across all viewports or pick a maximum breakpoint with which to have a responsive table up to.
   * @values: {boolean | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'}
   */
  responsive = input(...(ngDevMode ? [undefined, {
    debugName: "responsive"
  }] : []));
  /**
   * Make table more compact by cutting all cell `padding` in half.
   * @return boolean
   */
  small = input(false, ...(ngDevMode ? [{
    debugName: "small",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Add zebra-striping to any table row within the table body.
   * @return boolean
   */
  striped = input(false, ...(ngDevMode ? [{
    debugName: "striped",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Add zebra-striping to any table column.
   * @return boolean
   * @since 4.2.4
   */
  stripedColumns = input(false, ...(ngDevMode ? [{
    debugName: "stripedColumns",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  hostClasses = computed(() => {
    const align = this.align();
    const caption = this.caption();
    const borderColor = this.borderColor();
    const bordered = this.bordered();
    const borderless = this.borderless();
    const color = this.color();
    const hover = this.hover();
    const small = this.small();
    const striped = this.striped();
    const stripedColumns = this.stripedColumns();
    return {
      table: true,
      [`align-${align}`]: !!align,
      [`caption-${caption}`]: !!caption,
      [`border-${borderColor}`]: !!borderColor,
      'table-bordered': bordered,
      'table-borderless': borderless,
      [`table-${color}`]: !!color,
      'table-hover': hover,
      'table-sm': small,
      'table-striped': striped,
      'table-striped-columns': stripedColumns
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  #responsiveWrapperEffect = afterRenderEffect({
    // this fixes RuntimeError: NG0500: During hydration Angular expected <abc> but found <xyz>.
    // Find more at https://angular.dev/errors/NG0500
    write: () => {
      const responsive = this.responsive();
      if (!!responsive) {
        const nativeElement = this.#hostElement.nativeElement;
        const wrapper = this.#renderer.createElement('div');
        const className = responsive === true ? 'table-responsive' : `table-responsive-${responsive}`;
        this.#renderer.addClass(wrapper, className);
        const parentNode = this.#renderer.parentNode(nativeElement);
        this.#renderer.appendChild(parentNode, wrapper);
        this.#renderer.insertBefore(parentNode, wrapper, nativeElement);
        this.#renderer.appendChild(wrapper, nativeElement);
      }
    }
  });
  static ɵfac = function TableDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TableDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TableDirective,
    selectors: [["table", "cTable", ""]],
    hostAttrs: [1, "table"],
    hostVars: 2,
    hostBindings: function TableDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      align: [1, "align"],
      borderColor: [1, "borderColor"],
      bordered: [1, "bordered"],
      borderless: [1, "borderless"],
      caption: [1, "caption"],
      color: [1, "color"],
      hover: [1, "hover"],
      responsive: [1, "responsive"],
      small: [1, "small"],
      striped: [1, "striped"],
      stripedColumns: [1, "stripedColumns"]
    },
    exportAs: ["cTable"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableDirective, [{
    type: Directive,
    args: [{
      selector: 'table[cTable]',
      exportAs: 'cTable',
      host: {
        class: 'table',
        '[class]': 'hostClasses()'
      }
    }]
  }], null, {
    align: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "align",
        required: false
      }]
    }],
    borderColor: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "borderColor",
        required: false
      }]
    }],
    bordered: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "bordered",
        required: false
      }]
    }],
    borderless: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "borderless",
        required: false
      }]
    }],
    caption: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "caption",
        required: false
      }]
    }],
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    hover: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "hover",
        required: false
      }]
    }],
    responsive: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "responsive",
        required: false
      }]
    }],
    small: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "small",
        required: false
      }]
    }],
    striped: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "striped",
        required: false
      }]
    }],
    stripedColumns: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "stripedColumns",
        required: false
      }]
    }]
  });
})();
class TableModule {
  static ɵfac = function TableModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TableModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TableModule,
    imports: [TableDirective, TableColorDirective, TableActiveDirective],
    exports: [TableDirective, TableColorDirective, TableActiveDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableModule, [{
    type: NgModule,
    args: [{
      exports: [TableDirective, TableColorDirective, TableActiveDirective],
      imports: [TableDirective, TableColorDirective, TableActiveDirective]
    }]
  }], null, null);
})();
class TabService {
  activeTabPaneIdx = new Subject();
  activeTabPaneIdx$ = this.activeTabPaneIdx.asObservable();
  setActiveTabIdx(tabContentState) {
    this.activeTabPaneIdx.next(tabContentState);
  }
  static ɵfac = function TabService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TabService,
    factory: TabService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class TabPaneComponent {
  #changeDetectorRef = inject(ChangeDetectorRef);
  #tabService = inject(TabService);
  constructor() {
    this.subscribeTabService();
  }
  tabPaneIdx;
  tabContent;
  #tabServiceSubscription;
  set active(value) {
    const newValue = booleanAttribute(value);
    if (this.#active !== newValue) {
      this.#active = newValue;
      this.#changeDetectorRef.markForCheck();
    }
  }
  get active() {
    return this.#active;
  }
  #active = false;
  get hostClasses() {
    return {
      'tab-pane': true,
      fade: true,
      show: this.active,
      active: this.active
    };
  }
  role = 'tabpanel';
  ngOnDestroy() {
    this.subscribeTabService(false);
  }
  subscribeTabService(subscribe = true) {
    if (subscribe) {
      this.#tabServiceSubscription = this.#tabService.activeTabPaneIdx$.subscribe(tabContentState => {
        if (tabContentState.tabContent === this.tabContent) {
          this.active = tabContentState.activeIdx === this.tabPaneIdx;
        }
      });
    } else {
      this.#tabServiceSubscription?.unsubscribe();
    }
  }
  static ɵfac = function TabPaneComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabPaneComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TabPaneComponent,
    selectors: [["c-tab-pane"]],
    hostAttrs: [1, "tab-pane"],
    hostVars: 3,
    hostBindings: function TabPaneComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role);
        i0.ɵɵclassMap(ctx.hostClasses);
      }
    },
    inputs: {
      role: "role"
    },
    exportAs: ["cTabPane"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function TabPaneComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabPaneComponent, [{
    type: Component,
    args: [{
      selector: 'c-tab-pane',
      template: '<ng-content />',
      exportAs: 'cTabPane',
      host: {
        class: 'tab-pane'
      },
      styles: [":host{display:block}\n"]
    }]
  }], () => [], {
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }],
    role: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['attr.role']
    }]
  });
})();
class TabContentComponent {
  #changeDetectorRef = inject(ChangeDetectorRef);
  #tabService = inject(TabService);
  /**
   * Set active tabPane index
   * @type number
   */
  set activeTabPaneIdx(value) {
    const newValue = value;
    if (this.#activeTabPaneIdx != newValue) {
      this.#activeTabPaneIdx = newValue;
      this.activeTabPaneIdxChange?.emit(newValue);
      this.#changeDetectorRef.markForCheck();
      this.#changeDetectorRef.detectChanges();
    }
  }
  get activeTabPaneIdx() {
    return this.#activeTabPaneIdx;
  }
  #activeTabPaneIdx = -1;
  /**
   * Event emitted on the active tab pane index change.
   */
  activeTabPaneIdxChange = output();
  panes;
  #tabServiceSubscription;
  ngAfterContentInit() {
    this.subscribeTabService();
  }
  ngAfterContentChecked() {
    this.panes?.forEach((tabPane, index) => {
      tabPane.tabContent = this;
      tabPane.tabPaneIdx = index;
    });
    this.refreshTabPaneActive(this.activeTabPaneIdx);
    this.#tabService.setActiveTabIdx({
      tabContent: this,
      activeIdx: this.activeTabPaneIdx
    });
  }
  ngOnChanges(changes) {
    if (changes['activeTabPaneIdx']?.currentValue) {
      this.#tabService.setActiveTabIdx({
        tabContent: this,
        activeIdx: changes['activeTabPaneIdx'].currentValue
      });
    }
  }
  ngOnDestroy() {
    this.subscribeTabService(false);
  }
  subscribeTabService(subscribe = true) {
    if (subscribe) {
      this.#tabServiceSubscription = this.#tabService.activeTabPaneIdx$.subscribe(tabContentState => {
        if (this === tabContentState.tabContent) {
          this.activeTabPaneIdx = tabContentState.activeIdx;
        }
      });
    } else {
      this.#tabServiceSubscription?.unsubscribe();
    }
  }
  refreshTabPaneActive(idx) {
    // hack for active state pane refresh todo?
    this.panes?.forEach((tabPane, index) => {
      tabPane.active = idx === index;
    });
  }
  static ɵfac = function TabContentComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabContentComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TabContentComponent,
    selectors: [["c-tab-content"]],
    contentQueries: function TabContentComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TabPaneComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.panes = _t);
      }
    },
    hostAttrs: [1, "tab-content"],
    inputs: {
      activeTabPaneIdx: [2, "activeTabPaneIdx", "activeTabPaneIdx", numberAttribute]
    },
    outputs: {
      activeTabPaneIdxChange: "activeTabPaneIdxChange"
    },
    exportAs: ["cTabContent"],
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function TabContentComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"],
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabContentComponent, [{
    type: Component,
    args: [{
      selector: 'c-tab-content',
      template: '<ng-content />',
      changeDetection: ChangeDetectionStrategy.OnPush,
      exportAs: 'cTabContent',
      host: {
        class: 'tab-content'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, {
    activeTabPaneIdx: [{
      type: Input,
      args: [{
        transform: numberAttribute
      }]
    }],
    activeTabPaneIdxChange: [{
      type: i0.Output,
      args: ["activeTabPaneIdxChange"]
    }],
    panes: [{
      type: ContentChildren,
      args: [TabPaneComponent]
    }]
  });
})();
class TabContentRefDirective {
  #changeDetectorRef = inject(ChangeDetectorRef);
  #tabService = inject(TabService);
  constructor() {
    this.subscribeTabService();
  }
  #tabServiceSubscription;
  /**
   * Template Ref
   * @type TemplateRef
   */
  tabContentRef;
  /**
   * Set active state of tab content
   * @type boolean
   * @default false
   */
  set active(value) {
    const newValue = value;
    if (this.#active !== newValue) {
      this.#active = newValue;
      this.#changeDetectorRef.detectChanges();
    }
  }
  get active() {
    return this.#active;
  }
  #active = false;
  /**
   * Set disabled state of tab content
   * @type boolean
   */
  set disabled(value) {
    this.#disabled = value;
  }
  get disabled() {
    return this.#disabled || this.tabPaneIdx >= this.tabContentRef?.panes?.length;
  }
  #disabled = false;
  /**
   * c-tab-pane index respectively
   * @type number
   */
  tabPaneIdx = -1;
  get hostClasses() {
    return {
      active: this.active,
      disabled: this.disabled
    };
  }
  get isDisabled() {
    return this.disabled || null;
  }
  get attrDisabled() {
    return this.disabled ? '' : null;
  }
  get ariaSelected() {
    return this.active;
  }
  role = 'tab';
  get getTabindex() {
    return this.disabled ? '-1' : null;
  }
  ngOnChanges(changes) {
    if (changes['active']?.currentValue) {
      this.setActiveTabPane();
    }
  }
  toggleOpen($event) {
    $event.preventDefault();
    this.setActiveTabPane();
  }
  setActiveTabPane() {
    setTimeout(() => {
      if (this.tabPaneIdx < this.tabContentRef.panes.length) {
        this.active = true;
        this.#tabService.setActiveTabIdx({
          tabContent: this.tabContentRef,
          activeIdx: this.tabPaneIdx
        });
      } else {
        this.active = false;
      }
    });
  }
  ngOnDestroy() {
    this.subscribeTabService(false);
  }
  subscribeTabService(subscribe = true) {
    if (subscribe) {
      this.#tabServiceSubscription = this.#tabService.activeTabPaneIdx$.subscribe(tabContentState => {
        if (tabContentState.tabContent === this.tabContentRef) {
          this.active = tabContentState.activeIdx === this.tabPaneIdx;
        }
      });
    } else {
      this.#tabServiceSubscription?.unsubscribe();
    }
  }
  static ɵfac = function TabContentRefDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabContentRefDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TabContentRefDirective,
    selectors: [["", "cTabContent", ""]],
    hostVars: 7,
    hostBindings: function TabContentRefDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function TabContentRefDirective_click_HostBindingHandler($event) {
          return ctx.toggleOpen($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("aria-disabled", ctx.isDisabled)("disabled", ctx.attrDisabled)("aria-selected", ctx.ariaSelected)("role", ctx.role)("tabindex", ctx.getTabindex);
        i0.ɵɵclassMap(ctx.hostClasses);
      }
    },
    inputs: {
      tabContentRef: [0, "cTabContent", "tabContentRef"],
      active: [2, "active", "active", booleanAttribute],
      disabled: [2, "disabled", "disabled", booleanAttribute],
      tabPaneIdx: [2, "tabPaneIdx", "tabPaneIdx", numberAttribute],
      role: "role"
    },
    features: [i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabContentRefDirective, [{
    type: Directive,
    args: [{
      selector: '[cTabContent]'
    }]
  }], () => [], {
    tabContentRef: [{
      type: Input,
      args: ['cTabContent']
    }],
    active: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    disabled: [{
      type: Input,
      args: [{
        transform: booleanAttribute
      }]
    }],
    tabPaneIdx: [{
      type: Input,
      args: [{
        transform: numberAttribute
      }]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['attr.aria-disabled']
    }],
    attrDisabled: [{
      type: HostBinding,
      args: ['attr.disabled']
    }],
    ariaSelected: [{
      type: HostBinding,
      args: ['attr.aria-selected']
    }],
    role: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['attr.role']
    }],
    getTabindex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }],
    toggleOpen: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();
class TabsModule {
  static ɵfac = function TabsModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabsModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TabsModule,
    imports: [TabContentComponent, TabContentRefDirective, TabPaneComponent],
    exports: [TabContentComponent, TabPaneComponent, TabContentRefDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [TabService]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsModule, [{
    type: NgModule,
    args: [{
      imports: [TabContentComponent, TabContentRefDirective, TabPaneComponent],
      exports: [TabContentComponent, TabPaneComponent, TabContentRefDirective],
      providers: [TabService]
    }]
  }], null, null);
})();
class TabsService {
  activeItem = signal(undefined, ...(ngDevMode ? [{
    debugName: "activeItem"
  }] : []));
  activeItemKey = signal(undefined, ...(ngDevMode ? [{
    debugName: "activeItemKey"
  }] : []));
  id = signal(undefined, ...(ngDevMode ? [{
    debugName: "id"
  }] : []));
  static ɵfac = function TabsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabsService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TabsService,
    factory: TabsService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsService, [{
    type: Injectable
  }], null, null);
})();
let nextId = 0;
class TabsComponent {
  tabsService = inject(TabsService);
  /**
   * The active item key.
   * @type <string | number | undefined>
   */
  activeItemKey = model(...(ngDevMode ? [undefined, {
    debugName: "activeItemKey"
  }] : []));
  /**
   * The id attribute
   * @type string
   */
  tabsId = `tabs-${nextId++}`;
  id = input(this.tabsId, ...(ngDevMode ? [{
    debugName: "id"
  }] : []));
  #activeItemEffect = effect(() => {
    this.tabsService.id.set(this.id());
    this.tabsService.activeItemKey.set(this.activeItemKey());
  }, ...(ngDevMode ? [{
    debugName: "#activeItemEffect"
  }] : []));
  #tabsServiceEffect = effect(() => {
    this.activeItemKey.set(this.tabsService.activeItemKey());
  }, ...(ngDevMode ? [{
    debugName: "#tabsServiceEffect"
  }] : []));
  static ɵfac = function TabsComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabsComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TabsComponent,
    selectors: [["c-tabs"]],
    hostAttrs: [1, "tabs"],
    hostVars: 1,
    hostBindings: function TabsComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵdomProperty("id", ctx.id());
      }
    },
    inputs: {
      activeItemKey: [1, "activeItemKey"],
      id: [1, "id"]
    },
    outputs: {
      activeItemKey: "activeItemKeyChange"
    },
    exportAs: ["cTabs"],
    features: [i0.ɵɵProvidersFeature([TabsService])],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function TabsComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsComponent, [{
    type: Component,
    args: [{
      exportAs: 'cTabs',
      selector: 'c-tabs',
      imports: [],
      template: '<ng-content />',
      providers: [TabsService],
      host: {
        '[id]': 'id()',
        class: 'tabs'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, {
    activeItemKey: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "activeItemKey",
        required: false
      }]
    }, {
      type: i0.Output,
      args: ["activeItemKeyChange"]
    }],
    id: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "id",
        required: false
      }]
    }]
  });
})();
class TabDirective {
  #injector = inject(Injector);
  #destroyRef = inject(DestroyRef);
  #elementRef = inject(ElementRef);
  #tabsService = inject(TabsService);
  /**
   * Disabled attribute
   * @return boolean
   * @default false
   */
  disabledInput = input(false, ...(ngDevMode ? [{
    debugName: "disabledInput",
    transform: booleanAttribute,
    alias: 'disabled'
  }] : [{
    transform: booleanAttribute,
    alias: 'disabled'
  }]));
  #disabled = linkedSignal(this.disabledInput, ...(ngDevMode ? [{
    debugName: "#disabled"
  }] : []));
  attrDisabled = computed(() => this.#disabled() || null, ...(ngDevMode ? [{
    debugName: "attrDisabled"
  }] : []));
  set disabled(value) {
    this.#disabled.set(value);
  }
  get disabled() {
    return this.#disabled();
  }
  /**
   * Item key.
   * @type string | number
   * @required
   */
  itemKey = input.required(...(ngDevMode ? [{
    debugName: "itemKey"
  }] : []));
  /**
   * Element id attribute
   * @type string
   * @default undefined
   */
  id = input(...(ngDevMode ? [undefined, {
    debugName: "id"
  }] : []));
  /**
   * aria-controls attribute
   * @type string
   * @default undefined
   */
  ariaControls = input(undefined, ...(ngDevMode ? [{
    debugName: "ariaControls",
    alias: 'aria-controls'
  }] : [{
    alias: 'aria-controls'
  }]));
  isActive = signal(false, ...(ngDevMode ? [{
    debugName: "isActive"
  }] : []));
  hostClasses = computed(() => {
    return {
      'nav-link': true,
      active: this.isActive(),
      disabled: this.#disabled()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  propId = computed(() => this.id() ?? `${this.#tabsService.id()}-tab-${this.itemKey()}`, ...(ngDevMode ? [{
    debugName: "propId"
  }] : []));
  attrAriaControls = computed(() => this.ariaControls() ?? `${this.#tabsService.id()}-panel-${this.itemKey()}`, ...(ngDevMode ? [{
    debugName: "attrAriaControls"
  }] : []));
  #disabledSignalEffect = effect(() => {
    const disabled = this.#disabled();
    if (!disabled) {
      const click$ = fromEvent(this.#elementRef.nativeElement, 'click');
      const focusIn$ = fromEvent(this.#elementRef.nativeElement, 'focusin');
      merge(focusIn$, click$).pipe(filter($event => !disabled), tap($event => {
        this.#tabsService.activeItemKey.set(untracked(this.itemKey));
      }), takeWhile(() => !disabled), takeUntilDestroyed(this.#destroyRef)).subscribe();
    }
  }, ...(ngDevMode ? [{
    debugName: "#disabledSignalEffect"
  }] : []));
  focus(origin) {
    this.#elementRef.nativeElement.focus();
  }
  ngOnInit() {
    runInInjectionContext(this.#injector, () => {
      effect(() => {
        const isActive = !this.#disabled() && this.#tabsService.activeItemKey() === this.itemKey();
        this.isActive.set(isActive);
      });
    });
  }
  static ɵfac = function TabDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TabDirective,
    selectors: [["button", "cTab", ""]],
    hostAttrs: ["type", "button", "role", "tab"],
    hostVars: 7,
    hostBindings: function TabDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵdomProperty("id", ctx.propId())("tabIndex", ctx.isActive() ? 0 : -1);
        i0.ɵɵattribute("aria-selected", ctx.isActive())("aria-controls", ctx.attrAriaControls())("disabled", ctx.attrDisabled() || null);
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      disabledInput: [1, "disabled", "disabledInput"],
      itemKey: [1, "itemKey"],
      id: [1, "id"],
      ariaControls: [1, "aria-controls", "ariaControls"]
    },
    exportAs: ["cTab"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabDirective, [{
    type: Directive,
    args: [{
      exportAs: 'cTab',
      selector: 'button[cTab]',
      host: {
        '[class]': 'hostClasses()',
        type: 'button',
        role: 'tab',
        '[attr.aria-selected]': 'isActive()',
        '[attr.aria-controls]': 'attrAriaControls()',
        '[attr.disabled]': 'attrDisabled() || null',
        '[id]': 'propId()',
        '[tabindex]': 'isActive() ? 0 : -1'
      }
    }]
  }], null, {
    disabledInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "disabled",
        required: false
      }]
    }],
    itemKey: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "itemKey",
        required: true
      }]
    }],
    id: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "id",
        required: false
      }]
    }],
    ariaControls: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "aria-controls",
        required: false
      }]
    }]
  });
})();
class TabsListComponent {
  #destroyRef = inject(DestroyRef);
  #elementRef = inject(ElementRef);
  tabsService = inject(TabsService);
  #rtlService = inject(RtlService);
  #isRtl = signal(false, ...(ngDevMode ? [{
    debugName: "#isRtl"
  }] : []));
  constructor() {
    afterEveryRender({
      read: () => {
        this.#isRtl.set(this.#rtlService.isRTL(this.#elementRef.nativeElement));
      }
    });
  }
  /**
   * Specify a layout type for component.
   * @type 'fill' | 'justified' | undefined
   * @default undefined
   */
  layout = input(...(ngDevMode ? [undefined, {
    debugName: "layout"
  }] : []));
  /**
   * Set the variant to tabs, pills or underline.
   * @type 'pills' | 'tabs' | 'underline' | 'underline-border' | undefined
   * @default undefined
   */
  variant = input(...(ngDevMode ? [undefined, {
    debugName: "variant"
  }] : []));
  /**
   * Set the role to tab list.
   * @default 'tablist'
   */
  role = input('tablist', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  hostClasses = computed(() => {
    const layout = this.layout();
    const variant = this.variant();
    return {
      nav: true,
      [`nav-${layout}`]: layout,
      [`nav-${variant}`]: variant
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  tabs = contentChildren(TabDirective, ...(ngDevMode ? [{
    debugName: "tabs"
  }] : []));
  #focusKeyManager;
  #tabsEffect = effect(() => {
    const tabs = this.tabs();
    if (tabs.length === 0) {
      return;
    }
    const isRtl = this.#isRtl();
    this.#focusKeyManager = new FocusKeyManager(tabs).skipPredicate(tab => tab.disabled === true).withHorizontalOrientation(isRtl ? 'rtl' : 'ltr').withHomeAndEnd().withWrap();
    this.#focusKeyManager.change.pipe(tap(value => {
      this.tabsService.activeItemKey.set(this.#focusKeyManager.activeItem?.itemKey());
      this.tabsService.activeItem.set(this.#focusKeyManager.activeItem);
    }), takeUntilDestroyed(this.#destroyRef)).subscribe();
    untracked(() => {
      setTimeout(() => {
        const activeItem = tabs.find(tab => tab.isActive()) ?? tabs.find(tab => !tab.disabled);
        const activeItemIndex = tabs.findIndex(tab => tab === activeItem);
        this.#focusKeyManager?.updateActiveItem(activeItemIndex < 0 ? 0 : activeItemIndex);
        this.tabsService.activeItemKey.set(this.#focusKeyManager.activeItem?.itemKey());
        this.tabsService.activeItem.set(this.#focusKeyManager.activeItem);
      });
    });
  }, ...(ngDevMode ? [{
    debugName: "#tabsEffect"
  }] : []));
  #tabsServiceEffect = effect(() => {
    const activeItemIndex = this.tabs().findIndex(tab => untracked(tab.isActive) && untracked(tab.itemKey) === this.tabsService.activeItemKey());
    this.#focusKeyManager?.updateActiveItem(activeItemIndex < 0 ? 0 : activeItemIndex);
  }, ...(ngDevMode ? [{
    debugName: "#tabsServiceEffect"
  }] : []));
  onKeyDown($event) {
    if (['ArrowLeft', 'ArrowRight'].includes($event.key)) {
      this.#focusKeyManager.onKeydown($event);
      return;
    }
    if (['Tab'].includes($event.key)) {
      this.#focusKeyManager?.tabOut.next();
    }
    return;
  }
  static ɵfac = function TabsListComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabsListComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TabsListComponent,
    selectors: [["c-tabs-list"]],
    contentQueries: function TabsListComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.tabs, TabDirective, 4);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 3,
    hostBindings: function TabsListComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown", function TabsListComponent_keydown_HostBindingHandler($event) {
          return ctx.onKeyDown($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      layout: [1, "layout"],
      variant: [1, "variant"],
      role: [1, "role"]
    },
    exportAs: ["cTabsList"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function TabsListComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsListComponent, [{
    type: Component,
    args: [{
      exportAs: 'cTabsList',
      selector: 'c-tabs-list',
      template: '<ng-content />',
      host: {
        '[attr.role]': 'role()',
        '[class]': 'hostClasses()',
        '(keydown)': 'onKeyDown($event)'
      }
    }]
  }], () => [], {
    layout: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "layout",
        required: false
      }]
    }],
    variant: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "variant",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }],
    tabs: [{
      type: i0.ContentChildren,
      args: [i0.forwardRef(() => TabDirective), {
        isSignal: true
      }]
    }]
  });
})();
class TabsContentComponent {
  static ɵfac = function TabsContentComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabsContentComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TabsContentComponent,
    selectors: [["c-tabs-content"]],
    hostAttrs: [1, "tab-content"],
    exportAs: ["cTabsContent"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function TabsContentComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsContentComponent, [{
    type: Component,
    args: [{
      exportAs: 'cTabsContent',
      selector: 'c-tabs-content',
      template: '<ng-content />',
      host: {
        class: 'tab-content'
      }
    }]
  }], null, null);
})();
class TabPanelComponent {
  tabsService = inject(TabsService);
  /**
   * aria-labelledby attribute
   * @type string
   * @default undefined
   */
  ariaLabelledBy = input(undefined, ...(ngDevMode ? [{
    debugName: "ariaLabelledBy",
    alias: 'aria-labelledby'
  }] : [{
    alias: 'aria-labelledby'
  }]));
  /**
   * Element id attribute
   * @type string
   * @default undefined
   */
  id = input(...(ngDevMode ? [undefined, {
    debugName: "id"
  }] : []));
  /**
   * Item key.
   * @type string | number
   * @required
   */
  itemKey = input.required(...(ngDevMode ? [{
    debugName: "itemKey"
  }] : []));
  /**
   * Element role.
   * @type string
   * @default 'tabpanel'
   */
  role = input('tabpanel', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  /**
   * tabindex attribute.
   * @type number
   * @default 0
   */
  tabindex = input(0, ...(ngDevMode ? [{
    debugName: "tabindex",
    transform: numberAttribute
  }] : [{
    transform: numberAttribute
  }]));
  /**
   * Enable fade in transition.
   * @type boolean
   * @default true
   */
  transition = input(true, ...(ngDevMode ? [{
    debugName: "transition"
  }] : []));
  /**
   * visible change output
   * @type OutputEmitterRef<VisibleChangeEvent>
   */
  visibleChange = output();
  show = signal(false, ...(ngDevMode ? [{
    debugName: "show"
  }] : []));
  visible = computed(() => {
    const visible = this.tabsService.activeItemKey() === this.itemKey() && !this.tabsService.activeItem()?.disabled;
    this.visibleChange?.emit({
      itemKey: this.itemKey(),
      visible
    });
    return visible;
  }, ...(ngDevMode ? [{
    debugName: "visible"
  }] : []));
  propId = computed(() => this.id() ?? `${this.tabsService.id()}-panel-${this.itemKey()}`, ...(ngDevMode ? [{
    debugName: "propId"
  }] : []));
  attrAriaLabelledBy = computed(() => this.ariaLabelledBy() ?? `${this.tabsService.id()}-tab-${this.itemKey()}`, ...(ngDevMode ? [{
    debugName: "attrAriaLabelledBy"
  }] : []));
  hostClasses = computed(() => ({
    'tab-pane': true,
    active: this.show(),
    fade: this.transition(),
    show: this.show(),
    invisible: this.tabsService.activeItem()?.disabled
  }), ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  onAnimationDone($event) {
    this.show.set(this.visible());
  }
  static ɵfac = function TabPanelComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TabPanelComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TabPanelComponent,
    selectors: [["c-tab-panel"]],
    hostVars: 8,
    hostBindings: function TabPanelComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵsyntheticHostListener("@fadeInOut.done", function TabPanelComponent_animation_fadeInOut_done_HostBindingHandler($event) {
          return ctx.onAnimationDone($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵdomProperty("tabIndex", ctx.visible() ? ctx.tabindex() : -1)("id", ctx.propId());
        i0.ɵɵsyntheticHostProperty("@.disabled", !ctx.transition())("@fadeInOut", ctx.visible() ? "show" : "hide");
        i0.ɵɵattribute("aria-labelledby", ctx.attrAriaLabelledBy())("role", ctx.role());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      ariaLabelledBy: [1, "aria-labelledby", "ariaLabelledBy"],
      id: [1, "id"],
      itemKey: [1, "itemKey"],
      role: [1, "role"],
      tabindex: [1, "tabindex"],
      transition: [1, "transition"]
    },
    outputs: {
      visibleChange: "visibleChange"
    },
    exportAs: ["cTabPanel"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function TabPanelComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    data: {
      animation: [trigger('fadeInOut', [state('show', style({
        opacity: 1
      })), state('hide', style({
        opacity: 0
      })), state('void', style({
        opacity: 1
      })), transition('* => *', [query('@*', [animateChild()], {
        optional: true
      }), animate('150ms linear')])])]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabPanelComponent, [{
    type: Component,
    args: [{
      exportAs: 'cTabPanel',
      selector: 'c-tab-panel',
      template: '<ng-content />',
      host: {
        '[class]': 'hostClasses()',
        '[tabindex]': 'visible() ? tabindex() : -1',
        '[attr.aria-labelledby]': 'attrAriaLabelledBy()',
        '[id]': 'propId()',
        '[attr.role]': 'role()',
        '[@.disabled]': '!transition()',
        '[@fadeInOut]': 'visible() ? "show" : "hide"',
        '(@fadeInOut.done)': 'onAnimationDone($event)'
      },
      animations: [trigger('fadeInOut', [state('show', style({
        opacity: 1
      })), state('hide', style({
        opacity: 0
      })), state('void', style({
        opacity: 1
      })), transition('* => *', [query('@*', [animateChild()], {
        optional: true
      }), animate('150ms linear')])])]
    }]
  }], null, {
    ariaLabelledBy: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "aria-labelledby",
        required: false
      }]
    }],
    id: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "id",
        required: false
      }]
    }],
    itemKey: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "itemKey",
        required: true
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }],
    tabindex: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "tabindex",
        required: false
      }]
    }],
    transition: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "transition",
        required: false
      }]
    }],
    visibleChange: [{
      type: i0.Output,
      args: ["visibleChange"]
    }]
  });
})();
class Tabs2Module {
  static ɵfac = function Tabs2Module_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || Tabs2Module)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: Tabs2Module,
    imports: [TabsComponent, TabsListComponent, TabDirective, TabsContentComponent, TabPanelComponent],
    exports: [TabsComponent, TabsListComponent, TabDirective, TabsContentComponent, TabPanelComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [TabsService]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Tabs2Module, [{
    type: NgModule,
    args: [{
      imports: [TabsComponent, TabsListComponent, TabDirective, TabsContentComponent, TabPanelComponent],
      exports: [TabsComponent, TabsListComponent, TabDirective, TabsContentComponent, TabPanelComponent],
      providers: [TabsService]
    }]
  }], null, null);
})();
class ToasterService {
  #toasterState = new BehaviorSubject({});
  toasterState$ = this.#toasterState.asObservable();
  setState(state) {
    this.#toasterState.next({
      ...state
    });
  }
  static ɵfac = function ToasterService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToasterService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ToasterService,
    factory: ToasterService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToasterService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class ToastComponent {
  changeDetectorRef = inject(ChangeDetectorRef);
  hostElement = inject(ElementRef);
  renderer = inject(Renderer2);
  toasterService = inject(ToasterService);
  dynamic = input(...(ngDevMode ? [undefined, {
    debugName: "dynamic"
  }] : []));
  placementInput = input(undefined, ...(ngDevMode ? [{
    debugName: "placementInput",
    alias: 'placement'
  }] : [{
    alias: 'placement'
  }]));
  get placement() {
    return this.placementInput();
  }
  /**
   * Auto hide the toast.
   * @return boolean
   */
  autohide = input(true, ...(ngDevMode ? [{
    debugName: "autohide"
  }] : []));
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @return Colors
   */
  color = input('', ...(ngDevMode ? [{
    debugName: "color"
  }] : []));
  /**
   * Delay hiding the toast (ms).
   * @return number
   */
  delay = input(5000, ...(ngDevMode ? [{
    debugName: "delay",
    transform: numberAttribute
  }] : [{
    transform: numberAttribute
  }]));
  /**
   * Apply fade transition to the toast.
   * @return boolean
   */
  fade = input(true, ...(ngDevMode ? [{
    debugName: "fade"
  }] : []));
  /**
   * Toggle the visibility of component.
   * @return boolean
   */
  visibleInput = input(false, ...(ngDevMode ? [{
    debugName: "visibleInput",
    transform: booleanAttribute,
    alias: 'visible'
  }] : [{
    transform: booleanAttribute,
    alias: 'visible'
  }]));
  #visible = linkedSignal(this.visibleInput, ...(ngDevMode ? [{
    debugName: "#visible"
  }] : []));
  #visibleEffect = effect(() => {
    const newValue = this.#visible();
    newValue ? this.setTimer() : this.clearTimer();
    this.visibleChange?.emit(newValue);
    this.changeDetectorRef.markForCheck();
  }, ...(ngDevMode ? [{
    debugName: "#visibleEffect"
  }] : []));
  set visible(value) {
    this.#visible.set(value);
  }
  get visible() {
    return this.#visible();
  }
  /**
   * @ignore
   */
  index = input(0, ...(ngDevMode ? [{
    debugName: "index",
    transform: numberAttribute
  }] : [{
    transform: numberAttribute
  }]));
  /**
   * Event emitted on visibility change. [docs]
   * @return <boolean>
   */
  visibleChange = output();
  /**
   * Event emitted on timer tick. [docs]
   * @return number
   */
  timer = output();
  timerId;
  clockId;
  clockTimerId;
  _clock;
  get clock() {
    return this._clock;
  }
  set clock(value) {
    this._clock = value;
    this.timer?.emit(this._clock);
    this.changeDetectorRef.markForCheck();
  }
  animationDisabled = computed(() => {
    return !this.fade();
  }, ...(ngDevMode ? [{
    debugName: "animationDisabled"
  }] : []));
  get animateType() {
    return this.visible ? 'show' : 'hide';
  }
  hostClasses = computed(() => {
    const color = this.color();
    return {
      toast: true,
      show: true,
      [`bg-${color}`]: !!color,
      'border-0': !!color
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  ngOnInit() {
    if (this.visible) {
      this.toasterService.setState({
        toast: this,
        show: this.visible,
        placement: this.placement
      });
      this.clearTimer();
      this.setTimer();
    }
  }
  ngOnDestroy() {
    this.clearTimer();
  }
  setTimer() {
    this.clearTimer();
    if (this.autohide() && this.visible) {
      this.timerId = this.delay() > 0 ? setTimeout(() => this.onClose(), this.delay()) : undefined;
      this.setClock();
    }
  }
  clearTimer() {
    this.clearClock();
    clearTimeout(this.timerId);
    this.timerId = undefined;
  }
  onClose() {
    this.clearTimer();
    this.toasterService.setState({
      toast: this,
      show: false,
      placement: this.placement
    });
  }
  setClock() {
    this.clearClock();
    this.clock = 0;
    this.clockId = setInterval(() => {
      this.clock += 1;
      this.changeDetectorRef.markForCheck();
    }, 1000);
    this.clockTimerId = setTimeout(() => {
      this.clearClock();
    }, this.delay());
  }
  clearClock() {
    clearTimeout(this.clockTimerId);
    clearInterval(this.clockId);
    this.clockId = undefined;
  }
  static ɵfac = function ToastComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToastComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ToastComponent,
    selectors: [["c-toast"]],
    hostAttrs: [1, "toast", "show"],
    hostVars: 4,
    hostBindings: function ToastComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("mouseover", function ToastComponent_mouseover_HostBindingHandler() {
          return ctx.clearTimer();
        })("mouseout", function ToastComponent_mouseout_HostBindingHandler() {
          return ctx.setTimer();
        });
      }
      if (rf & 2) {
        i0.ɵɵsyntheticHostProperty("@fadeInOut", ctx.animateType)("@.disabled", ctx.animationDisabled());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      dynamic: [1, "dynamic"],
      placementInput: [1, "placement", "placementInput"],
      autohide: [1, "autohide"],
      color: [1, "color"],
      delay: [1, "delay"],
      fade: [1, "fade"],
      visibleInput: [1, "visible", "visibleInput"],
      index: [1, "index"]
    },
    outputs: {
      visibleChange: "visibleChange",
      timer: "timer"
    },
    exportAs: ["cToast"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ToastComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block;overflow:hidden}"],
    data: {
      animation: [trigger('fadeInOut', [state('show', style({
        opacity: 1,
        height: '*',
        padding: '*',
        border: '*',
        margin: '*'
      })), state('hide', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), state('void', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), transition('show => hide', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-out'
        }
      }), transition('hide => show', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-in'
        }
      }), transition('show => void', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-out'
        }
      }), transition('void => show', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-in'
        }
      })])]
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastComponent, [{
    type: Component,
    args: [{
      selector: 'c-toast',
      template: '<ng-content />',
      exportAs: 'cToast',
      animations: [trigger('fadeInOut', [state('show', style({
        opacity: 1,
        height: '*',
        padding: '*',
        border: '*',
        margin: '*'
      })), state('hide', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), state('void', style({
        opacity: 0,
        height: 0,
        padding: 0,
        border: 0,
        margin: 0
      })), transition('show => hide', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-out'
        }
      }), transition('hide => show', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-in'
        }
      }), transition('show => void', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-out'
        }
      }), transition('void => show', [animate('{{ time }} {{ easing }}')], {
        params: {
          time: '300ms',
          easing: 'ease-in'
        }
      })])],
      host: {
        class: 'toast show',
        '[class]': 'hostClasses()',
        '(mouseover)': 'clearTimer()',
        '(mouseout)': 'setTimer()',
        '[@fadeInOut]': 'animateType',
        '[@.disabled]': 'animationDisabled()'
      },
      styles: [":host{display:block;overflow:hidden}\n"]
    }]
  }], null, {
    dynamic: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "dynamic",
        required: false
      }]
    }],
    placementInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "placement",
        required: false
      }]
    }],
    autohide: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "autohide",
        required: false
      }]
    }],
    color: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "color",
        required: false
      }]
    }],
    delay: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "delay",
        required: false
      }]
    }],
    fade: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "fade",
        required: false
      }]
    }],
    visibleInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    index: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "index",
        required: false
      }]
    }],
    visibleChange: [{
      type: i0.Output,
      args: ["visibleChange"]
    }],
    timer: [{
      type: i0.Output,
      args: ["timer"]
    }]
  });
})();
class ToastBodyComponent {
  toast = inject(ToastComponent, {
    optional: true
  });
  static ɵfac = function ToastBodyComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToastBodyComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ToastBodyComponent,
    selectors: [["c-toast-body"]],
    hostAttrs: [1, "toast-body"],
    exportAs: ["cToastBody"],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function ToastBodyComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["[_nghost-%COMP%]{display:block}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastBodyComponent, [{
    type: Component,
    args: [{
      selector: 'c-toast-body',
      template: '<ng-content />',
      exportAs: 'cToastBody',
      host: {
        class: 'toast-body'
      },
      styles: [":host{display:block}\n"]
    }]
  }], null, null);
})();
class ToastCloseDirective {
  #toasterService = inject(ToasterService);
  cToastClose = input(...(ngDevMode ? [undefined, {
    debugName: "cToastClose"
  }] : []));
  toggleOpen($event) {
    $event.preventDefault();
    this.#toasterService.setState({
      show: false,
      toast: this.cToastClose()
    });
  }
  static ɵfac = function ToastCloseDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToastCloseDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ToastCloseDirective,
    selectors: [["", "cToastClose", ""]],
    hostBindings: function ToastCloseDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function ToastCloseDirective_click_HostBindingHandler($event) {
          return ctx.toggleOpen($event);
        });
      }
    },
    inputs: {
      cToastClose: [1, "cToastClose"]
    },
    exportAs: ["cToastClose"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastCloseDirective, [{
    type: Directive,
    args: [{
      selector: '[cToastClose]',
      exportAs: 'cToastClose',
      host: {
        '(click)': 'toggleOpen($event)'
      }
    }]
  }], null, {
    cToastClose: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cToastClose",
        required: false
      }]
    }]
  });
})();
class ToastHeaderComponent {
  #toast = inject(ToastComponent, {
    optional: true
  });
  toast = signal(this.#toast ?? undefined, ...(ngDevMode ? [{
    debugName: "toast"
  }] : []));
  /**
   * Add close button to a toast header
   * @return boolean
   */
  closeButton = input(true, ...(ngDevMode ? [{
    debugName: "closeButton"
  }] : []));
  static ɵfac = function ToastHeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToastHeaderComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ToastHeaderComponent,
    selectors: [["c-toast-header"]],
    hostAttrs: [1, "toast-header"],
    inputs: {
      closeButton: [1, "closeButton"]
    },
    exportAs: ["cToastHeader"],
    ngContentSelectors: _c0,
    decls: 3,
    vars: 1,
    consts: [["aria-label", "close", "cButtonClose", "", 1, "ms-auto", 3, "cToastClose", "style"], ["aria-label", "close", "cButtonClose", "", 1, "ms-auto", 3, "cToastClose"]],
    template: function ToastHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵprojection(1);
        i0.ɵɵconditionalCreate(2, ToastHeaderComponent_Conditional_2_Template, 1, 4, "button", 0);
        i0.ɵɵelementContainerEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.closeButton() ? 2 : -1);
      }
    },
    dependencies: [ToastCloseDirective, ButtonCloseDirective],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'c-toast-header',
      exportAs: 'cToastHeader',
      imports: [ToastCloseDirective, ButtonCloseDirective],
      host: {
        class: 'toast-header'
      },
      template: "<ng-container>\n  <ng-content />\n  @if (closeButton()) {\n    <button [cToastClose]=\"toast()\" [style]=\"{outline: 0}\" aria-label=\"close\" cButtonClose class=\"ms-auto\"></button>\n  }\n</ng-container>\n"
    }]
  }], null, {
    closeButton: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "closeButton",
        required: false
      }]
    }]
  });
})();
class ToasterHostDirective {
  viewContainerRef = inject(ViewContainerRef);
  static ɵfac = function ToasterHostDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToasterHostDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ToasterHostDirective,
    selectors: [["", "cToasterHost", ""]],
    exportAs: ["cToasterHost"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToasterHostDirective, [{
    type: Directive,
    args: [{
      selector: '[cToasterHost]',
      exportAs: 'cToasterHost'
    }]
  }], null, null);
})();
var ToasterPlacement;
(function (ToasterPlacement) {
  ToasterPlacement["Static"] = "static";
  ToasterPlacement["TopStart"] = "top-start";
  ToasterPlacement["TopCenter"] = "top-center";
  ToasterPlacement["TopEnd"] = "top-end";
  ToasterPlacement["MiddleStart"] = "middle-start";
  ToasterPlacement["MiddleCenter"] = "middle-center";
  ToasterPlacement["MiddleEnd"] = "middle-end";
  ToasterPlacement["BottomStart"] = "bottom-start";
  ToasterPlacement["BottomCenter"] = "bottom-center";
  ToasterPlacement["BottomEnd"] = "bottom-end";
})(ToasterPlacement || (ToasterPlacement = {}));
class ToasterComponent {
  #hostElement = inject(ElementRef);
  #renderer = inject(Renderer2);
  #toasterService = inject(ToasterService);
  #destroyRef = inject(DestroyRef);
  placements = Object.values(ToasterPlacement);
  toastsDynamic = [];
  /**
   * Toaster placement
   * @return TToasterPlacement
   */
  placementInput = input(ToasterPlacement.TopEnd, ...(ngDevMode ? [{
    debugName: "placementInput",
    alias: 'placement'
  }] : [{
    alias: 'placement'
  }]));
  get placement() {
    return this.placementInput();
  }
  /**
   * Toaster position
   * @return (string | 'absolute' | 'fixed' | 'static')
   */
  position = input('absolute', ...(ngDevMode ? [{
    debugName: "position"
  }] : []));
  toasterHost = viewChild.required(ToasterHostDirective);
  contentToasts = contentChildren(ToastComponent, ...(ngDevMode ? [{
    debugName: "contentToasts",
    read: ViewContainerRef
  }] : [{
    read: ViewContainerRef
  }]));
  #contentToastsEffect = effect(() => {
    // Ensure that the contentToasts is available before accessing it
    // temp fix for: ASSERTION ERROR: Unexpected state: no hydration info available for a given TNode, which represents a view container. [Expected=> null != undefined <=Actual]
    this.contentToasts();
  }, ...(ngDevMode ? [{
    debugName: "#contentToastsEffect"
  }] : []));
  hostClasses = computed(() => {
    const placement = this.placement;
    const position = this.position();
    return {
      toaster: true,
      'toast-container': true,
      [`position-${position}`]: !!position,
      'top-0': placement.includes('top'),
      'top-50': placement.includes('middle'),
      'bottom-0': placement.includes('bottom'),
      'start-0': placement.includes('start'),
      'start-50': placement.includes('center'),
      'end-0': placement.includes('end'),
      'translate-middle-x': placement.includes('center') && !placement.includes('middle'),
      'translate-middle-y': placement.includes('middle') && !placement.includes('center'),
      'translate-middle': placement.includes('middle') && placement.includes('center')
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  ngOnInit() {
    this.stateToasterSubscribe();
  }
  addToast(toast, props, options) {
    const componentRef = this.toasterHost().viewContainerRef.createComponent(toast, options);
    this.toastsDynamic.push(componentRef);
    const index = this.toastsDynamic.indexOf(componentRef);
    for (const [key, value] of Object.entries(props)) {
      componentRef.setInput(key, value);
    }
    componentRef.setInput('placement', this.placement);
    componentRef.setInput('dynamic', true);
    componentRef.setInput('index', index);
    componentRef.setInput('visible', true);
    componentRef.instance['visibleChange']?.emit(true);
    componentRef.changeDetectorRef?.detectChanges();
    return componentRef;
  }
  removeToast(state) {
    this.toastsDynamic?.forEach(item => {
      if (state.toast?.dynamic() && item.instance === state.toast) {
        item.setInput('visible', false);
        item.instance['visibleChange'].emit(false);
        item.destroy();
      }
    });
    this.contentToasts()?.forEach(item => {
      if (state.toast && item.element.nativeElement === state.toast.hostElement.nativeElement) {
        if (!state.toast.dynamic()) {
          state.toast.visible = false;
        }
      }
    });
  }
  stateToasterSubscribe() {
    this.#toasterService.toasterState$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(state => {
      if (state.show === false) {
        this.removeToast(state);
      }
      // if (state.show === true && state.toast?.dynamic() === undefined) {
      //   /* empty */
      // }
    });
  }
  static ɵfac = function ToasterComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToasterComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ToasterComponent,
    selectors: [["c-toaster"]],
    contentQueries: function ToasterComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentToasts, ToastComponent, 4, ViewContainerRef);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    viewQuery: function ToasterComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.toasterHost, ToasterHostDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "toaster", "toast-container"],
    hostVars: 2,
    hostBindings: function ToasterComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      placementInput: [1, "placement", "placementInput"],
      position: [1, "position"]
    },
    exportAs: ["cToaster"],
    features: [i0.ɵɵProvidersFeature([ToasterService])],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [["cToasterHost", ""]],
    template: function ToasterComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, ToasterComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
        i0.ɵɵprojection(1);
      }
    },
    dependencies: [ToasterHostDirective],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToasterComponent, [{
    type: Component,
    args: [{
      selector: 'c-toaster',
      exportAs: 'cToaster',
      imports: [ToasterHostDirective],
      host: {
        class: 'toaster toast-container',
        '[class]': 'hostClasses()'
      },
      providers: [ToasterService],
      template: "<ng-template cToasterHost />\n<ng-content />\n"
    }]
  }], null, {
    placementInput: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "placement",
        required: false
      }]
    }],
    position: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "position",
        required: false
      }]
    }],
    toasterHost: [{
      type: i0.ViewChild,
      args: [i0.forwardRef(() => ToasterHostDirective), {
        isSignal: true
      }]
    }],
    contentToasts: [{
      type: i0.ContentChildren,
      args: [i0.forwardRef(() => ToastComponent), {
        ...{
          read: ViewContainerRef
        },
        isSignal: true
      }]
    }]
  });
})();
class ToastModule {
  static ɵfac = function ToastModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ToastModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ToastModule,
    imports: [ToastBodyComponent, ToastComponent, ToastCloseDirective, ToastHeaderComponent, ToasterComponent, ToasterHostDirective],
    exports: [ToastBodyComponent, ToastComponent, ToastCloseDirective, ToastHeaderComponent, ToasterComponent, ToasterHostDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [ToasterService]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastModule, [{
    type: NgModule,
    args: [{
      imports: [ToastBodyComponent, ToastComponent, ToastCloseDirective, ToastHeaderComponent, ToasterComponent, ToasterHostDirective],
      providers: [ToasterService],
      exports: [ToastBodyComponent, ToastComponent, ToastCloseDirective, ToastHeaderComponent, ToasterComponent, ToasterHostDirective]
    }]
  }], null, null);
})();
class TooltipComponent {
  renderer = inject(Renderer2);
  /**
   * Content of tooltip
   * @type {string | TemplateRef}
   */
  content = input('', ...(ngDevMode ? [{
    debugName: "content"
  }] : []));
  #contentEffect = effect(() => {
    this.updateView(this.content());
  }, ...(ngDevMode ? [{
    debugName: "#contentEffect"
  }] : []));
  /**
   * Toggle the visibility of popover component.
   * @type boolean
   */
  visible = input(false, ...(ngDevMode ? [{
    debugName: "visible",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  id = input(...(ngDevMode ? [undefined, {
    debugName: "id"
  }] : []));
  role = input('tooltip', ...(ngDevMode ? [{
    debugName: "role"
  }] : []));
  viewContainerRef = viewChild('tooltipTemplate', ...(ngDevMode ? [{
    debugName: "viewContainerRef",
    read: ViewContainerRef
  }] : [{
    read: ViewContainerRef
  }]));
  textNode;
  hostClasses = computed(() => {
    return {
      tooltip: true,
      fade: true,
      show: this.visible(),
      'bs-tooltip-auto': true
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  ngOnDestroy() {
    this.clear();
  }
  clear() {
    this.viewContainerRef()?.clear();
    if (!!this.textNode) {
      this.renderer.removeChild(this.textNode.parentNode, this.textNode);
    }
  }
  updateView(content) {
    this.clear();
    if (!content) {
      return;
    }
    if (content instanceof TemplateRef) {
      this.viewContainerRef()?.createEmbeddedView(content);
    } else {
      this.textNode = this.renderer.createText(content);
      const element = this.viewContainerRef()?.element.nativeElement;
      this.renderer.appendChild(element.parentNode, this.textNode);
    }
  }
  static ɵfac = function TooltipComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TooltipComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TooltipComponent,
    selectors: [["c-tooltip"]],
    viewQuery: function TooltipComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.viewContainerRef, _c14, 5, ViewContainerRef);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "tooltip", "fade", "bs-tooltip-auto"],
    hostVars: 4,
    hostBindings: function TooltipComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.role())("id", ctx.id());
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      content: [1, "content"],
      visible: [1, "visible"],
      id: [1, "id"],
      role: [1, "role"]
    },
    decls: 5,
    vars: 0,
    consts: [["tooltipTemplate", ""], ["data-popper-arrow", "", 1, "tooltip-arrow"], [1, "tooltip-inner"]],
    template: function TooltipComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵdomElementContainerStart(0);
        i0.ɵɵdomElement(1, "div", 1);
        i0.ɵɵdomElementStart(2, "div", 2);
        i0.ɵɵdomElementContainer(3, null, 0);
        i0.ɵɵdomElementEnd();
        i0.ɵɵdomElementContainerEnd();
      }
    },
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipComponent, [{
    type: Component,
    args: [{
      selector: 'c-tooltip',
      host: {
        class: 'tooltip fade bs-tooltip-auto',
        '[class]': 'hostClasses()',
        '[attr.role]': 'role()',
        '[attr.id]': 'id()'
      },
      template: "<ng-container>\n  <div class=\"tooltip-arrow\" data-popper-arrow></div>\n  <div class=\"tooltip-inner\">\n    <ng-container #tooltipTemplate />\n  </div>\n</ng-container>\n"
    }]
  }], null, {
    content: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "content",
        required: false
      }]
    }],
    visible: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "visible",
        required: false
      }]
    }],
    id: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "id",
        required: false
      }]
    }],
    role: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "role",
        required: false
      }]
    }],
    viewContainerRef: [{
      type: i0.ViewChild,
      args: ['tooltipTemplate', {
        ...{
          read: ViewContainerRef
        },
        isSignal: true
      }]
    }]
  });
})();
class TooltipDirective {
  #renderer = inject(Renderer2);
  #hostElement = inject(ElementRef);
  #viewContainerRef = inject(ViewContainerRef);
  #listenersService = inject(ListenersService);
  #changeDetectorRef = inject(ChangeDetectorRef);
  #intersectionService = inject(IntersectionService);
  #destroyRef = inject(DestroyRef);
  #document = inject(DOCUMENT);
  /**
   * Content of tooltip
   * @return {string | TemplateRef}
   */
  content = input(undefined, ...(ngDevMode ? [{
    debugName: "content",
    alias: 'cTooltip'
  }] : [{
    alias: 'cTooltip'
  }]));
  #contentEffect = effect(() => {
    if (this.content()) {
      this.destroyTooltipElement();
    }
  }, ...(ngDevMode ? [{
    debugName: "#contentEffect"
  }] : []));
  /**
   * Optional popper Options object, takes precedence over cPopoverPlacement prop
   * @return Partial<Options>
   */
  popperOptions = input({}, ...(ngDevMode ? [{
    debugName: "popperOptions",
    alias: 'cTooltipOptions'
  }] : [{
    alias: 'cTooltipOptions'
  }]));
  #popperOptionsEffect = effect(() => {
    this._popperOptions = {
      ...this._popperOptions,
      placement: this.placement(),
      ...this.popperOptions()
    };
  }, ...(ngDevMode ? [{
    debugName: "#popperOptionsEffect"
  }] : []));
  popperOptionsComputed = computed(() => {
    return {
      placement: this.placement(),
      ...this._popperOptions
    };
  }, ...(ngDevMode ? [{
    debugName: "popperOptionsComputed"
  }] : []));
  /**
   * Describes the placement of your component after Popper.js has applied all the modifiers that may have flipped or altered the originally provided placement property.
   * @return: 'top' | 'bottom' | 'left' | 'right'
   * @default: 'top'
   */
  placement = input('top', ...(ngDevMode ? [{
    debugName: "placement",
    alias: 'cTooltipPlacement'
  }] : [{
    alias: 'cTooltipPlacement'
  }]));
  /**
   * ElementRefDirective for positioning the tooltip on reference element
   * @return: ElementRefDirective
   * @default: undefined
   */
  reference = input(undefined, ...(ngDevMode ? [{
    debugName: "reference",
    alias: 'cTooltipRef'
  }] : [{
    alias: 'cTooltipRef'
  }]));
  referenceRef = computed(() => this.reference()?.elementRef ?? this.#hostElement, ...(ngDevMode ? [{
    debugName: "referenceRef"
  }] : []));
  /**
   * Sets which event handlers you’d like provided to your toggle prop. You can specify one trigger or an array of them.
   * @return: 'Triggers | Triggers[]
   */
  trigger = input('hover', ...(ngDevMode ? [{
    debugName: "trigger",
    alias: 'cTooltipTrigger'
  }] : [{
    alias: 'cTooltipTrigger'
  }]));
  /**
   * Toggle the visibility of tooltip component.
   * @return boolean
   */
  visible = model(false, ...(ngDevMode ? [{
    debugName: "visible",
    alias: 'cTooltipVisible'
  }] : [{
    alias: 'cTooltipVisible'
  }]));
  #visibleEffect = afterRenderEffect({
    // this fixes RuntimeError: NG0500: During hydration Angular expected <abc> but found <xyz>.
    // Find more at https://angular.dev/errors/NG0500
    write: () => {
      this.visible() ? this.addTooltipElement() : this.removeTooltipElement();
    }
  });
  get ariaDescribedBy() {
    return this.tooltipId ? this.tooltipId : null;
  }
  tooltip;
  tooltipId;
  tooltipRef;
  popperInstance;
  _popperOptions = {
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 5]
      }
    }]
  };
  ngAfterViewInit() {
    this.intersectionServiceSubscribe();
  }
  ngOnDestroy() {
    this.clearListeners();
    this.destroyTooltipElement();
  }
  ngOnInit() {
    this.setListeners();
  }
  setListeners() {
    const config = {
      hostElement: this.#hostElement,
      trigger: this.trigger(),
      callbackToggle: () => {
        this.visible.update(value => !value);
      },
      callbackOff: () => {
        this.visible.set(false);
      },
      callbackOn: () => {
        this.visible.set(true);
      }
    };
    this.#listenersService.setListeners(config);
  }
  clearListeners() {
    this.#listenersService.clearListeners();
  }
  intersectionServiceSubscribe() {
    this.#intersectionService.createIntersectionObserver(this.referenceRef());
    this.#intersectionService.intersecting$.pipe(filter(next => next.hostElement === this.referenceRef()), debounceTime(100), finalize(() => {
      this.#intersectionService.unobserve(this.referenceRef());
    }), takeUntilDestroyed(this.#destroyRef)).subscribe(next => {
      this.visible.set(next.isIntersecting ? this.visible() : false);
    });
  }
  getUID(prefix) {
    let uid = prefix ?? 'random-id';
    do {
      uid = `${prefix}-${Math.floor(Math.random() * 1000000).toString(10)}`;
    } while (this.#document.getElementById(uid));
    return uid;
  }
  createTooltipElement() {
    if (!this.tooltipRef) {
      this.tooltipRef = this.#viewContainerRef.createComponent(TooltipComponent);
      // this.viewContainerRef.detach();
    }
  }
  destroyTooltipElement() {
    this.tooltip?.remove();
    this.tooltipRef?.destroy();
    // @ts-ignore
    this.tooltipRef = undefined;
    this.popperInstance?.destroy();
    this.#viewContainerRef?.detach();
    this.#viewContainerRef?.clear();
  }
  addTooltipElement() {
    if (!this.content()) {
      this.destroyTooltipElement();
      return;
    }
    if (!this.tooltipRef) {
      this.createTooltipElement();
    }
    this.tooltipRef?.setInput('content', this.content() ?? '');
    this.tooltip = this.tooltipRef?.location.nativeElement;
    this.#renderer.addClass(this.tooltip, 'd-none');
    this.#renderer.addClass(this.tooltip, 'fade');
    this.popperInstance?.destroy();
    this.#viewContainerRef.insert(this.tooltipRef.hostView);
    this.#renderer.appendChild(this.#document.body, this.tooltip);
    this.popperInstance = createPopper(this.referenceRef().nativeElement, this.tooltip, {
      ...this.popperOptionsComputed()
    });
    if (!this.visible()) {
      this.removeTooltipElement();
      return;
    }
    setTimeout(() => {
      this.tooltipId = this.getUID('tooltip');
      this.tooltipRef?.setInput('id', this.tooltipId);
      this.#renderer.removeClass(this.tooltip, 'd-none');
      this.tooltipRef?.setInput('visible', this.visible());
      this.popperInstance?.forceUpdate();
      this.#changeDetectorRef?.markForCheck();
    }, 100);
  }
  removeTooltipElement() {
    this.tooltipId = '';
    if (!this.tooltipRef) {
      return;
    }
    this.tooltipRef.setInput('visible', false);
    this.tooltipRef.setInput('id', undefined);
    this.#changeDetectorRef.markForCheck();
    setTimeout(() => {
      this.#viewContainerRef?.detach();
    }, 300);
  }
  static ɵfac = function TooltipDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TooltipDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TooltipDirective,
    selectors: [["", "cTooltip", ""]],
    hostVars: 1,
    hostBindings: function TooltipDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-describedby", ctx.ariaDescribedBy);
      }
    },
    inputs: {
      content: [1, "cTooltip", "content"],
      popperOptions: [1, "cTooltipOptions", "popperOptions"],
      placement: [1, "cTooltipPlacement", "placement"],
      reference: [1, "cTooltipRef", "reference"],
      trigger: [1, "cTooltipTrigger", "trigger"],
      visible: [1, "cTooltipVisible", "visible"]
    },
    outputs: {
      visible: "cTooltipVisibleChange"
    },
    exportAs: ["cTooltip"],
    features: [i0.ɵɵProvidersFeature([ListenersService, IntersectionService])]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipDirective, [{
    type: Directive,
    args: [{
      selector: '[cTooltip]',
      exportAs: 'cTooltip',
      providers: [ListenersService, IntersectionService],
      host: {
        '[attr.aria-describedby]': 'ariaDescribedBy'
      }
    }]
  }], null, {
    content: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTooltip",
        required: false
      }]
    }],
    popperOptions: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTooltipOptions",
        required: false
      }]
    }],
    placement: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTooltipPlacement",
        required: false
      }]
    }],
    reference: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTooltipRef",
        required: false
      }]
    }],
    trigger: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTooltipTrigger",
        required: false
      }]
    }],
    visible: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "cTooltipVisible",
        required: false
      }]
    }, {
      type: i0.Output,
      args: ["cTooltipVisibleChange"]
    }]
  });
})();
class TooltipModule {
  static ɵfac = function TooltipModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TooltipModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TooltipModule,
    imports: [TooltipComponent, TooltipDirective],
    exports: [TooltipComponent, TooltipDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipModule, [{
    type: NgModule,
    args: [{
      exports: [TooltipComponent, TooltipDirective],
      imports: [TooltipComponent, TooltipDirective]
    }]
  }], null, null);
})();
class WidgetStatAComponent extends CardComponent {
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @type Colors
   */
  // override readonly color = input<Colors>();
  /**
   * Title of the widget to display
   * @type string
   */
  title = input(...(ngDevMode ? [undefined, {
    debugName: "title"
  }] : []));
  /**
   * Value for your widget to display
   * @type string
   */
  value = input(...(ngDevMode ? [undefined, {
    debugName: "value"
  }] : []));
  templates = {};
  contentTemplates = contentChildren(TemplateIdDirective, ...(ngDevMode ? [{
    debugName: "contentTemplates",
    descendants: true
  }] : [{
    descendants: true
  }]));
  #contentTemplatesEffect = effect(() => {
    this.contentTemplates().forEach(child => {
      this.templates[child.id] = child.templateRef;
    });
  }, ...(ngDevMode ? [{
    debugName: "#contentTemplatesEffect"
  }] : []));
  hostClasses = computed(() => {
    const color = this.color();
    return {
      card: true,
      [`bg-${color}`]: !!color,
      'text-white': !!color
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  get bodyClasses() {
    return {
      'pb-0': true,
      'd-flex': true,
      'justify-content-between': true,
      'align-items-start': true
    };
  }
  static ɵfac = /* @__PURE__ */(() => {
    let ɵWidgetStatAComponent_BaseFactory;
    return function WidgetStatAComponent_Factory(__ngFactoryType__) {
      return (ɵWidgetStatAComponent_BaseFactory || (ɵWidgetStatAComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WidgetStatAComponent)))(__ngFactoryType__ || WidgetStatAComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: WidgetStatAComponent,
    selectors: [["c-widget-stat-a"]],
    contentQueries: function WidgetStatAComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "card"],
    hostVars: 2,
    hostBindings: function WidgetStatAComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      title: [1, "title"],
      value: [1, "value"]
    },
    exportAs: ["cWidgetStatA"],
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c16,
    decls: 15,
    vars: 5,
    consts: [["defaultWidgetTitleTemplate", ""], ["defaultWidgetValueTemplate", ""], ["defaultWidgetChartTemplate", ""], ["defaultWidgetActionTemplate", ""], [3, "ngClass"], [1, "fs-4", "fw-semibold"], [4, "ngTemplateOutlet"]],
    template: function WidgetStatAComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c15);
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "c-card-body", 4)(2, "div");
        i0.ɵɵconditionalCreate(3, WidgetStatAComponent_Conditional_3_Template, 2, 1, "div", 5);
        i0.ɵɵconditionalCreate(4, WidgetStatAComponent_Conditional_4_Template, 2, 1, "div");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, WidgetStatAComponent_ng_container_5_Template, 1, 0, "ng-container", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, WidgetStatAComponent_ng_container_6_Template, 1, 0, "ng-container", 6);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(7, WidgetStatAComponent_ng_template_7_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(9, WidgetStatAComponent_ng_template_9_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(11, WidgetStatAComponent_ng_template_11_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(13, WidgetStatAComponent_ng_template_13_Template, 1, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const defaultWidgetChartTemplate_r4 = i0.ɵɵreference(12);
        const defaultWidgetActionTemplate_r5 = i0.ɵɵreference(14);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", ctx.bodyClasses);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!!ctx.value() || (ctx.templates == null ? null : ctx.templates["widgetValueTemplate"]) ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!!ctx.title() || (ctx.templates == null ? null : ctx.templates["widgetTitleTemplate"]) ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngTemplateOutlet", (ctx.templates == null ? null : ctx.templates["widgetActionTemplate"]) || defaultWidgetActionTemplate_r5);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngTemplateOutlet", (ctx.templates == null ? null : ctx.templates["widgetChartTemplate"]) || defaultWidgetChartTemplate_r4);
      }
    },
    dependencies: [CardBodyComponent, NgClass, NgTemplateOutlet],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatAComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-a',
      exportAs: 'cWidgetStatA',
      imports: [CardBodyComponent, NgClass, NgTemplateOutlet],
      host: {
        class: 'card',
        '[class]': 'hostClasses()'
      },
      template: "<ng-container>\n  <c-card-body [ngClass]=\"bodyClasses\">\n    <div>\n      @if (!!value() || templates?.['widgetValueTemplate']) {\n        <div class=\"fs-4 fw-semibold\">\n          <ng-container *ngTemplateOutlet=\"templates?.['widgetValueTemplate'] || defaultWidgetValueTemplate\" />\n        </div>\n      }\n      @if (!!title() || templates?.['widgetTitleTemplate']) {\n        <div>\n          <ng-container *ngTemplateOutlet=\"templates?.['widgetTitleTemplate'] || defaultWidgetTitleTemplate\" />\n        </div>\n      }\n    </div>\n    <ng-container *ngTemplateOutlet=\"templates?.['widgetActionTemplate'] || defaultWidgetActionTemplate\" />\n  </c-card-body>\n  <ng-container *ngTemplateOutlet=\"templates?.['widgetChartTemplate'] || defaultWidgetChartTemplate\" />\n</ng-container>\n\n<ng-template #defaultWidgetTitleTemplate>\n  {{ title() }}\n</ng-template>\n\n<ng-template #defaultWidgetValueTemplate>\n  {{ value() }}\n</ng-template>\n\n<ng-template #defaultWidgetChartTemplate>\n  <ng-content select=\".chart-wrapper\" />\n</ng-template>\n\n<ng-template #defaultWidgetActionTemplate>\n  <ng-content />\n</ng-template>\n"
    }]
  }], null, {
    title: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "title",
        required: false
      }]
    }],
    value: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "value",
        required: false
      }]
    }],
    contentTemplates: [{
      type: i0.ContentChildren,
      args: [i0.forwardRef(() => TemplateIdDirective), {
        ...{
          descendants: true
        },
        isSignal: true
      }]
    }]
  });
})();
class WidgetStatBComponent extends CardComponent {
  constructor() {
    super();
  }
  /**
   * Sets the color context of the component to one of CoreUI themed colors.
   * @type Colors
   */
  // override readonly color: InputSignal<Colors | undefined> = input();
  /**
   * Sets the text-color context of the component to one of CoreUI themed colors.
   * via TextColorDirective
   * @type TextColors
   */
  // override readonly textColor: InputSignal<TextColors | undefined> = input();
  /**
   * Title of the widget to display
   * @type string
   */
  title = input(...(ngDevMode ? [undefined, {
    debugName: "title"
  }] : []));
  /**
   * Helper text for your widget.
   * @type string
   */
  text = input(...(ngDevMode ? [undefined, {
    debugName: "text"
  }] : []));
  /**
   * Value for your widget to display
   * @type string
   */
  value = input(...(ngDevMode ? [undefined, {
    debugName: "value"
  }] : []));
  /**
   * Invert colors from their default dark shade.
   * @type boolean
   */
  inverse = input(false, ...(ngDevMode ? [{
    debugName: "inverse",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  hostClasses = computed(() => {
    const color = this.color();
    const textColor = this.textColor();
    return {
      card: true,
      [`bg-${color}`]: !!color,
      [`text-${textColor}`]: !!textColor,
      'text-white': this.inverse()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostClasses"
  }] : []));
  static ɵfac = function WidgetStatBComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WidgetStatBComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: WidgetStatBComponent,
    selectors: [["c-widget-stat-b"]],
    hostAttrs: [1, "card"],
    hostVars: 2,
    hostBindings: function WidgetStatBComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      title: [1, "title"],
      text: [1, "text"],
      value: [1, "value"],
      inverse: [1, "inverse"]
    },
    exportAs: ["cWidgetStatB"],
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 5,
    vars: 3,
    consts: [[1, "fs-4", "fw-semibold"], [3, "ngClass"]],
    template: function WidgetStatBComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "c-card-body");
        i0.ɵɵconditionalCreate(1, WidgetStatBComponent_Conditional_1_Template, 2, 1, "div", 0);
        i0.ɵɵconditionalCreate(2, WidgetStatBComponent_Conditional_2_Template, 2, 1, "div");
        i0.ɵɵprojection(3);
        i0.ɵɵconditionalCreate(4, WidgetStatBComponent_Conditional_4_Template, 2, 2, "small", 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(!!ctx.value() ? 1 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!!ctx.title() ? 2 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.text() ? 4 : -1);
      }
    },
    dependencies: [CardBodyComponent, NgClass],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatBComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-b',
      exportAs: 'cWidgetStatB',
      imports: [CardBodyComponent, NgClass],
      host: {
        class: 'card',
        '[class]': 'hostClasses()'
      },
      template: "<c-card-body>\n  @if (!!value()) {\n    <div class=\"fs-4 fw-semibold\">{{ value() }}</div>\n  }\n  @if (!!title()) {\n    <div>{{ title() }}</div>\n  }\n  <ng-content />\n  @if (text()) {\n    <small [ngClass]=\"inverse() ? 'text-white text-opacity-75' : 'text-body-secondary'\">\n      {{ text() }}\n    </small>\n  }\n</c-card-body>\n"
    }]
  }], () => [], {
    title: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "title",
        required: false
      }]
    }],
    text: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "text",
        required: false
      }]
    }],
    value: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "value",
        required: false
      }]
    }],
    inverse: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "inverse",
        required: false
      }]
    }]
  });
})();
class WidgetStatCComponent extends CardComponent {
  constructor() {
    super();
  }
  /**
   * Icon for your component.
   * @type string
   */
  icon = input(...(ngDevMode ? [undefined, {
    debugName: "icon"
  }] : []));
  /**
   * Title of the widget to display
   * @type string
   */
  title = input(...(ngDevMode ? [undefined, {
    debugName: "title"
  }] : []));
  /**
   * Value for your widget to display
   * @type string|number
   */
  value = input(...(ngDevMode ? [undefined, {
    debugName: "value"
  }] : []));
  /**
   * Invert colors from their default dark shade.
   * @type boolean
   */
  inverse = input(false, ...(ngDevMode ? [{
    debugName: "inverse",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  templates = {};
  contentTemplates = contentChildren(TemplateIdDirective, ...(ngDevMode ? [{
    debugName: "contentTemplates",
    descendants: true
  }] : [{
    descendants: true
  }]));
  #contentTemplatesEffect = effect(() => {
    this.contentTemplates().forEach(child => {
      this.templates[child.id] = child.templateRef;
    });
  }, ...(ngDevMode ? [{
    debugName: "#contentTemplatesEffect"
  }] : []));
  hostExtendedClass = computed(() => {
    return {
      ...this.hostClasses(),
      'text-white': this.inverse()
    };
  }, ...(ngDevMode ? [{
    debugName: "hostExtendedClass"
  }] : []));
  titleClasses = computed(() => {
    const inverse = this.inverse();
    return {
      'text-body-secondary': !inverse,
      'text-white': inverse,
      'text-opacity-75': inverse,
      [`text-${this.textColor()}`]: !!this.textColor()
    };
  }, ...(ngDevMode ? [{
    debugName: "titleClasses"
  }] : []));
  valueClasses = computed(() => {
    return {
      'fs-4': !this.textColor(),
      'fw-semibold': true,
      ...this.titleClasses(),
      'text-opacity-75': false
    };
  }, ...(ngDevMode ? [{
    debugName: "valueClasses"
  }] : []));
  iconClasses = computed(() => {
    return {
      'mb-4': !this.textColor(),
      'text-end': true,
      ...this.titleClasses()
    };
  }, ...(ngDevMode ? [{
    debugName: "iconClasses"
  }] : []));
  static ɵfac = function WidgetStatCComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WidgetStatCComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: WidgetStatCComponent,
    selectors: [["c-widget-stat-c"]],
    contentQueries: function WidgetStatCComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostVars: 2,
    hostBindings: function WidgetStatCComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostExtendedClass());
      }
    },
    inputs: {
      icon: [1, "icon"],
      title: [1, "title"],
      value: [1, "value"],
      inverse: [1, "inverse"]
    },
    exportAs: ["cWidgetStatC"],
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 9,
    vars: 4,
    consts: [["defaultWidgetIconTemplate", ""], ["defaultWidgetProgressTemplate", ""], [3, "ngClass"], [4, "ngTemplateOutlet"]],
    template: function WidgetStatCComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "c-card-body");
        i0.ɵɵconditionalCreate(1, WidgetStatCComponent_Conditional_1_Template, 2, 2, "div", 2);
        i0.ɵɵconditionalCreate(2, WidgetStatCComponent_Conditional_2_Template, 2, 2, "div", 2);
        i0.ɵɵconditionalCreate(3, WidgetStatCComponent_Conditional_3_Template, 2, 2, "div", 2);
        i0.ɵɵconditionalCreate(4, WidgetStatCComponent_Conditional_4_Template, 1, 1, "ng-container");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, WidgetStatCComponent_ng_template_5_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(7, WidgetStatCComponent_ng_template_7_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.icon() || (ctx.templates == null ? null : ctx.templates["widgetIconTemplate"]) ? 1 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!!ctx.value() ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!!ctx.title() ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional((ctx.templates == null ? null : ctx.templates["widgetProgressTemplate"]) ? 4 : -1);
      }
    },
    dependencies: [CardBodyComponent, NgClass, NgTemplateOutlet],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatCComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-c',
      exportAs: 'cWidgetStatC',
      imports: [CardBodyComponent, NgClass, NgTemplateOutlet],
      host: {
        '[class]': 'hostExtendedClass()'
      },
      template: "<c-card-body>\n  @if (icon() || templates?.['widgetIconTemplate']) {\n    <div [ngClass]=\"iconClasses()\">\n      <ng-container *ngTemplateOutlet=\"templates?.['widgetIconTemplate'] || defaultWidgetIconTemplate\" />\n    </div>\n  }\n  @if (!!value()) {\n    <div [ngClass]=\"valueClasses()\">\n      {{ value() }}\n    </div>\n  }\n  @if (!!title()) {\n    <div [ngClass]=\"titleClasses()\">\n      {{ title() }}\n    </div>\n  }\n  @if (templates?.['widgetProgressTemplate']) {\n    <ng-container *ngTemplateOutlet=\"templates?.['widgetProgressTemplate'] || defaultWidgetProgressTemplate\" />\n  }\n</c-card-body>\n\n<ng-template #defaultWidgetIconTemplate>\n  {{ icon() }}\n</ng-template>\n\n<ng-template #defaultWidgetProgressTemplate>\n  <ng-content />\n</ng-template>\n"
    }]
  }], () => [], {
    icon: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "icon",
        required: false
      }]
    }],
    title: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "title",
        required: false
      }]
    }],
    value: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "value",
        required: false
      }]
    }],
    inverse: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "inverse",
        required: false
      }]
    }],
    contentTemplates: [{
      type: i0.ContentChildren,
      args: [i0.forwardRef(() => TemplateIdDirective), {
        ...{
          descendants: true
        },
        isSignal: true
      }]
    }]
  });
})();
class WidgetStatDComponent extends CardComponent {
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @type Colors
   */
  // override readonly color = input<Colors>();
  /**
   * Values and subtitles for your component.
   * @type WidgetStatDValue
   */
  values = input(...(ngDevMode ? [undefined, {
    debugName: "values"
  }] : []));
  headerClasses = computed(() => {
    return {
      'position-relative': true,
      'd-flex': true,
      'justify-content-center': true,
      'align-items-center': true,
      [`bg-${this.color()}`]: this.color()
    };
  }, ...(ngDevMode ? [{
    debugName: "headerClasses"
  }] : []));
  static ɵfac = /* @__PURE__ */(() => {
    let ɵWidgetStatDComponent_BaseFactory;
    return function WidgetStatDComponent_Factory(__ngFactoryType__) {
      return (ɵWidgetStatDComponent_BaseFactory || (ɵWidgetStatDComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WidgetStatDComponent)))(__ngFactoryType__ || WidgetStatDComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: WidgetStatDComponent,
    selectors: [["c-widget-stat-d"]],
    hostAttrs: [1, "card"],
    inputs: {
      values: [1, "values"]
    },
    exportAs: ["cWidgetStatD"],
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 5,
    vars: 1,
    consts: [[3, "ngClass"], ["cRow", "", 1, "text-center"], [1, "vr"], [1, "fs-5", "fw-semibold"], [1, "text-uppercase", "text-body-secondary", "small"]],
    template: function WidgetStatDComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "c-card-header", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "c-card-body", 1);
        i0.ɵɵrepeaterCreate(3, WidgetStatDComponent_For_4_Template, 6, 3, null, null, i0.ɵɵrepeaterTrackByIdentity);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.headerClasses());
        i0.ɵɵadvance(3);
        i0.ɵɵrepeater(ctx.values());
      }
    },
    dependencies: [CardHeaderComponent, CardBodyComponent, ColComponent, RowDirective, NgClass],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatDComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-d',
      exportAs: 'cWidgetStatD',
      imports: [CardHeaderComponent, CardBodyComponent, ColComponent, RowDirective, NgClass],
      host: {
        class: 'card'
      },
      template: "<c-card-header [ngClass]=\"headerClasses()\">\n  <ng-content />\n</c-card-header>\n<c-card-body cRow class=\"text-center\">\n  @for (item of values(); track item; let i = $index) {\n    @if (i % 2 !== 0) {\n      <div class=\"vr\"></div>\n    }\n    <c-col>\n      <div class=\"fs-5 fw-semibold\">{{ item.value }}</div>\n      <div class=\"text-uppercase text-body-secondary small\">{{ item.title }}</div>\n    </c-col>\n  }\n</c-card-body>\n"
    }]
  }], null, {
    values: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "values",
        required: false
      }]
    }]
  });
})();
class WidgetStatEComponent extends CardComponent {
  constructor() {
    super();
  }
  /**
   * Title of the widget to display
   * @type string
   */
  title = input(...(ngDevMode ? [undefined, {
    debugName: "title"
  }] : []));
  /**
   * Value for your widget to display
   * @type string | number
   */
  value = input(...(ngDevMode ? [undefined, {
    debugName: "value"
  }] : []));
  titleClasses = computed(() => {
    const textColor = this.textColor();
    return {
      'text-body-secondary': !textColor,
      small: true,
      'text-uppercase': true,
      'fw-semibold': true,
      [`text-${textColor}`]: !!textColor
    };
  }, ...(ngDevMode ? [{
    debugName: "titleClasses"
  }] : []));
  static ɵfac = function WidgetStatEComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WidgetStatEComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: WidgetStatEComponent,
    selectors: [["c-widget-stat-e"]],
    inputs: {
      title: [1, "title"],
      value: [1, "value"]
    },
    exportAs: ["cWidgetStatE"],
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 4,
    vars: 2,
    consts: [[1, "text-center"], [3, "ngClass"], [1, "fs-6", "fw-semibold", "py-3"]],
    template: function WidgetStatEComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "c-card-body", 0);
        i0.ɵɵconditionalCreate(1, WidgetStatEComponent_Conditional_1_Template, 2, 2, "div", 1);
        i0.ɵɵconditionalCreate(2, WidgetStatEComponent_Conditional_2_Template, 2, 1, "div", 2);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(!!ctx.title() ? 1 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!!ctx.value() ? 2 : -1);
      }
    },
    dependencies: [CardBodyComponent, NgClass],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatEComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-e',
      exportAs: 'cWidgetStatE',
      imports: [CardBodyComponent, NgClass],
      template: "<c-card-body class=\"text-center\">\n  @if (!!title()) {\n    <div [ngClass]=\"titleClasses()\">{{ title() }}</div>\n  }\n  @if (!!value()) {\n    <div class=\"fs-6 fw-semibold py-3\">{{ value() }}</div>\n  }\n  <ng-content />\n</c-card-body>\n"
    }]
  }], () => [], {
    title: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "title",
        required: false
      }]
    }],
    value: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "value",
        required: false
      }]
    }]
  });
})();
class WidgetStatFComponent extends CardComponent {
  /**
   * Sets the color context of the component to one of CoreUI’s themed colors.
   * @type Colors
   */
  // override readonly color = input<Colors>();
  /**
   * Sets the text-color context of the component to one of CoreUI’s themed colors.
   * @type Colors
   */
  // override readonly textColor = input<TextColors | 'white' | 'muted'>();
  /**
   * Footer for your widget
   * @type string
   */
  footer = input(...(ngDevMode ? [undefined, {
    debugName: "footer"
  }] : []));
  /**
   * Icon for your widget
   * @type string
   */
  icon = input(...(ngDevMode ? [undefined, {
    debugName: "icon"
  }] : []));
  /**
   * Set padding of your component.
   * @type boolean
   */
  padding = input(false, ...(ngDevMode ? [{
    debugName: "padding",
    transform: booleanAttribute
  }] : [{
    transform: booleanAttribute
  }]));
  /**
   * Title of the widget to display
   * @type string
   */
  title = input(...(ngDevMode ? [undefined, {
    debugName: "title"
  }] : []));
  /**
   * Value for your widget to display
   * @type string
   */
  value = input(...(ngDevMode ? [undefined, {
    debugName: "value"
  }] : []));
  templates = {};
  contentTemplates = contentChildren(TemplateIdDirective, ...(ngDevMode ? [{
    debugName: "contentTemplates",
    descendants: true
  }] : [{
    descendants: true
  }]));
  #contentTemplatesEffect = effect(() => {
    this.contentTemplates().forEach(child => {
      this.templates[child.id] = child.templateRef;
    });
  }, ...(ngDevMode ? [{
    debugName: "#contentTemplatesEffect"
  }] : []));
  cardBodyClasses = computed(() => {
    return {
      'd-flex': true,
      'align-items-center': true,
      'p-0': !this.padding()
    };
  }, ...(ngDevMode ? [{
    debugName: "cardBodyClasses"
  }] : []));
  iconClasses = computed(() => {
    const color = this.color();
    const padding = this.padding();
    return {
      'me-3': !this.textColor(),
      'text-white': true,
      [`bg-${color}`]: !!color,
      'p-3': padding,
      'p-4': !padding,
      'rounded-start-1': !padding
    };
  }, ...(ngDevMode ? [{
    debugName: "iconClasses"
  }] : []));
  titleClasses = computed(() => {
    const textColor = this.textColor();
    return {
      'text-body-secondary': !textColor,
      small: true,
      'text-uppercase': true,
      'fw-semibold': true,
      [`text-${textColor}`]: !!textColor
    };
  }, ...(ngDevMode ? [{
    debugName: "titleClasses"
  }] : []));
  valueClasses = computed(() => {
    const textColor = this.textColor();
    return {
      'fs-6': !textColor,
      'fw-semibold': true,
      [`text-${textColor}`]: !!textColor
    };
  }, ...(ngDevMode ? [{
    debugName: "valueClasses"
  }] : []));
  static ɵfac = /* @__PURE__ */(() => {
    let ɵWidgetStatFComponent_BaseFactory;
    return function WidgetStatFComponent_Factory(__ngFactoryType__) {
      return (ɵWidgetStatFComponent_BaseFactory || (ɵWidgetStatFComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WidgetStatFComponent)))(__ngFactoryType__ || WidgetStatFComponent);
    };
  })();
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: WidgetStatFComponent,
    selectors: [["c-widget-stat-f"]],
    contentQueries: function WidgetStatFComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuerySignal(dirIndex, ctx.contentTemplates, TemplateIdDirective, 5);
      }
      if (rf & 2) {
        i0.ɵɵqueryAdvance();
      }
    },
    hostAttrs: [1, "card"],
    hostVars: 2,
    hostBindings: function WidgetStatFComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses());
      }
    },
    inputs: {
      footer: [1, "footer"],
      icon: [1, "icon"],
      padding: [1, "padding"],
      title: [1, "title"],
      value: [1, "value"]
    },
    exportAs: ["cWidgetStatB"],
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 14,
    vars: 8,
    consts: [["defaultWidgetIconTemplate", ""], ["defaultFooterIconTemplate", ""], [3, "ngClass"], [4, "ngTemplateOutlet"]],
    template: function WidgetStatFComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "c-card-body", 2)(2, "div", 2);
        i0.ɵɵtemplate(3, WidgetStatFComponent_ng_container_3_Template, 1, 0, "ng-container", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div")(5, "div", 2);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 2);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()()();
        i0.ɵɵconditionalCreate(9, WidgetStatFComponent_Conditional_9_Template, 2, 1, "c-card-footer");
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(10, WidgetStatFComponent_ng_template_10_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(12, WidgetStatFComponent_ng_template_12_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const defaultWidgetIconTemplate_r3 = i0.ɵɵreference(11);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", ctx.cardBodyClasses());
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", ctx.iconClasses());
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngTemplateOutlet", (ctx.templates == null ? null : ctx.templates["widgetIconTemplate"]) || defaultWidgetIconTemplate_r3);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.valueClasses());
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(ctx.value());
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", ctx.titleClasses());
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(ctx.title());
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.footer() || (ctx.templates == null ? null : ctx.templates["widgetFooterTemplate"]) ? 9 : -1);
      }
    },
    dependencies: [CardBodyComponent, CardFooterComponent, NgClass, NgTemplateOutlet],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetStatFComponent, [{
    type: Component,
    args: [{
      selector: 'c-widget-stat-f',
      exportAs: 'cWidgetStatB',
      imports: [CardBodyComponent, CardFooterComponent, NgClass, NgTemplateOutlet],
      host: {
        class: 'card',
        '[class]': 'hostClasses()'
      },
      template: "<ng-container>\n  <c-card-body [ngClass]=\"cardBodyClasses()\">\n    <div [ngClass]=\"iconClasses()\">\n      <ng-container *ngTemplateOutlet=\"templates?.['widgetIconTemplate'] || defaultWidgetIconTemplate\" />\n    </div>\n    <div>\n      <div [ngClass]=\"valueClasses()\">{{ value() }}</div>\n      <div [ngClass]=\"titleClasses()\">{{ title() }}</div>\n    </div>\n  </c-card-body>\n  @if (footer() || templates?.['widgetFooterTemplate']) {\n    <c-card-footer>\n      <ng-container *ngTemplateOutlet=\"templates?.['widgetFooterTemplate'] || defaultFooterIconTemplate\" />\n    </c-card-footer>\n  }\n</ng-container>\n\n<ng-template #defaultWidgetIconTemplate>\n  <span>{{ icon() }}</span>\n</ng-template>\n\n<ng-template #defaultFooterIconTemplate>\n  <span>{{ footer() }}</span>\n</ng-template>\n"
    }]
  }], null, {
    footer: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "footer",
        required: false
      }]
    }],
    icon: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "icon",
        required: false
      }]
    }],
    padding: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "padding",
        required: false
      }]
    }],
    title: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "title",
        required: false
      }]
    }],
    value: [{
      type: i0.Input,
      args: [{
        isSignal: true,
        alias: "value",
        required: false
      }]
    }],
    contentTemplates: [{
      type: i0.ContentChildren,
      args: [i0.forwardRef(() => TemplateIdDirective), {
        ...{
          descendants: true
        },
        isSignal: true
      }]
    }]
  });
})();
class WidgetModule {
  static ɵfac = function WidgetModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || WidgetModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: WidgetModule,
    imports: [WidgetStatAComponent, WidgetStatBComponent, WidgetStatCComponent, WidgetStatDComponent, WidgetStatEComponent, WidgetStatFComponent],
    exports: [WidgetStatAComponent, WidgetStatBComponent, WidgetStatCComponent, WidgetStatDComponent, WidgetStatEComponent, WidgetStatFComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetModule, [{
    type: NgModule,
    args: [{
      imports: [WidgetStatAComponent, WidgetStatBComponent, WidgetStatCComponent, WidgetStatDComponent, WidgetStatEComponent, WidgetStatFComponent],
      exports: [WidgetStatAComponent, WidgetStatBComponent, WidgetStatCComponent, WidgetStatDComponent, WidgetStatEComponent, WidgetStatFComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of coreui-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionButtonDirective, AccordionComponent, AccordionItemComponent, AccordionModule, AlertComponent, AlertHeadingDirective, AlertLinkDirective, AlertModule, AlignDirective, AvatarComponent, AvatarModule, BackdropService, BadgeComponent, BadgeModule, BgColorDirective, BorderDirective, BreadcrumbComponent, BreadcrumbItemComponent, BreadcrumbModule, BreadcrumbRouterComponent, BreadcrumbRouterService, BreakpointInfix, ButtonCloseDirective, ButtonDirective, ButtonGroupComponent, ButtonGroupModule, ButtonModule, ButtonToolbarComponent, CalloutComponent, CalloutModule, CardBodyComponent, CardComponent, CardFooterComponent, CardGroupComponent, CardHeaderActionsComponent, CardHeaderComponent, CardImgDirective, CardImgOverlayComponent, CardLinkDirective, CardModule, CardSubtitleDirective, CardTextDirective, CardTitleDirective, CarouselCaptionComponent, CarouselComponent, CarouselConfig, CarouselControlComponent, CarouselIndicatorsComponent, CarouselInnerComponent, CarouselItemComponent, CarouselModule, ClassToggleService, ColComponent, ColDirective, CollapseDirective, CollapseModule, ColorModeService, ContainerComponent, DropdownCloseDirective, DropdownComponent, DropdownDividerDirective, DropdownHeaderDirective, DropdownItemDirective, DropdownItemPlainDirective, DropdownMenuDirective, DropdownModule, DropdownService, DropdownToggleDirective, ElementRefDirective, FooterComponent, FooterModule, FormCheckComponent, FormCheckInputDirective, FormCheckLabelDirective, FormControlDirective, FormDirective, FormFeedbackComponent, FormFloatingDirective, FormLabelDirective, FormModule, FormSelectDirective, FormTextDirective, GridModule, GutterDirective, HeaderBrandComponent, HeaderComponent, HeaderDividerComponent, HeaderModule, HeaderNavComponent, HeaderTextComponent, HeaderTogglerDirective, HtmlAttributesDirective, ImgDirective, ImgModule, InMemoryStorageService, InputGroupComponent, InputGroupTextDirective, IntersectionService, ListGroupDirective, ListGroupItemDirective, ListGroupModule, ListenersService, LocalStorageService, ModalBodyComponent, ModalComponent, ModalContentComponent, ModalDialogComponent, ModalFooterComponent, ModalHeaderComponent, ModalModule, ModalService, ModalTitleDirective, ModalToggleDirective, NavComponent, NavItemComponent, NavLinkDirective, NavModule, NavbarBrandDirective, NavbarComponent, NavbarModule, NavbarNavComponent, NavbarTextComponent, NavbarTogglerDirective, OffcanvasBodyComponent, OffcanvasComponent, OffcanvasHeaderComponent, OffcanvasModule, OffcanvasService, OffcanvasTitleDirective, OffcanvasToggleDirective, PageItemComponent, PageItemDirective, PageLinkDirective, PaginationComponent, PaginationModule, PlaceholderAnimationDirective, PlaceholderDirective, PlaceholderModule, PopoverComponent, PopoverDirective, PopoverModule, ProgressBarComponent, ProgressBarDirective, ProgressComponent, ProgressModule, ProgressStackedComponent, RoundedDirective, RowComponent, RowDirective, RtlService, ShadowOnScrollDirective, SharedModule, SidebarBrandComponent, SidebarComponent, SidebarFooterComponent, SidebarHeaderComponent, SidebarModule, SidebarNavComponent, SidebarNavHelper, SidebarService, SidebarToggleDirective, SidebarTogglerDirective, SpinnerComponent, SpinnerModule, TabContentComponent, TabContentRefDirective, TabDirective, TabPaneComponent, TabPanelComponent, TabService, TableActiveDirective, TableColorDirective, TableDirective, TableModule, Tabs2Module, TabsComponent, TabsContentComponent, TabsListComponent, TabsModule, TabsService, TemplateIdDirective, TextBgColorDirective, TextColorDirective, ThemeDirective, ToastBodyComponent, ToastCloseDirective, ToastComponent, ToastHeaderComponent, ToastModule, ToasterComponent, ToasterHostDirective, ToasterPlacement, ToasterService, TooltipComponent, TooltipDirective, TooltipModule, UIDService, UtilitiesModule, WidgetModule, WidgetStatAComponent, WidgetStatBComponent, WidgetStatCComponent, WidgetStatDComponent, WidgetStatEComponent, WidgetStatFComponent };
